(() => {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("j3CK3", function(module, exports) {

$parcel$export(module.exports, "initContentSliders", () => $ddfc5978d59f4a1b$export$51e87da2cc2899f4);

var $4Rg0O = parcelRequire("4Rg0O");

var $gITAg = parcelRequire("gITAg");

var $f5sus = parcelRequire("f5sus");

var $lwga2 = parcelRequire("lwga2");

var $5IiZx = parcelRequire("5IiZx");
// Hero slider
const $ddfc5978d59f4a1b$var$heroSlider = document.querySelector('.hero-slider-outer');
const $ddfc5978d59f4a1b$var$heroSlides = $ddfc5978d59f4a1b$var$heroSlider?.querySelectorAll('.hero-slide');
if ($ddfc5978d59f4a1b$var$heroSlider && $ddfc5978d59f4a1b$var$heroSlides.length > 1) {
    const embla = (0, $4Rg0O.default)($ddfc5978d59f4a1b$var$heroSlider, {
        loop: true,
        dragFree: true
    });
    setInterval(embla.scrollNext, 5000);
}
// Hero video
const $ddfc5978d59f4a1b$var$heroes = document.querySelectorAll('.hero, .landingpage-hero');
$ddfc5978d59f4a1b$var$heroes.forEach((hero)=>{
    const container = hero.dataset.video ? hero : hero.querySelector('[data-video]');
    if (!container) return;
    const videoUrl = container.dataset.video;
    const autoplay = container.dataset.autoplay === 'true';
    const button = container.closest('section').querySelector('.hero-play');
    const player = new (0, $lwga2.default)(container, {
        url: videoUrl,
        background: autoplay,
        dnt: true,
        controls: false,
        title: false,
        byline: false,
        portrait: false,
        loop: true
    });
    player.on('loaded', ()=>{
        resizeCoverVideos(hero);
    });
    button?.addEventListener('click', ()=>{
        button.style.display = 'none';
        player.play();
    });
});
// Cover videos, styling them with CSS is not enough
window.resizeCoverVideos = function(context) {
    const coverVideos = (context ?? document).querySelectorAll('.cover-video iframe');
    coverVideos.forEach((iframe)=>{
        const videoWidth = parseFloat(iframe.getAttribute('width'));
        const videoHeight = parseFloat(iframe.getAttribute('height'));
        const videoAspectRatio = videoWidth / videoHeight;
        const container = iframe.parentElement;
        const containerRect = container.getBoundingClientRect();
        const containerAspectRatio = containerRect.width / containerRect.height;
        if (videoAspectRatio > containerAspectRatio) {
            iframe.style.width = containerRect.height * videoAspectRatio + 'px';
            iframe.style.height = containerRect.height + 'px';
        } else {
            iframe.style.height = containerRect.width / videoAspectRatio + 'px';
            iframe.style.width = containerRect.width + 'px';
        }
        iframe.classList.add('resized');
    });
};
window.addEventListener('resize', ()=>resizeCoverVideos());
resizeCoverVideos();
// Gallery slider
const $ddfc5978d59f4a1b$var$galleryBlocks = document.querySelectorAll('.gallery');
$ddfc5978d59f4a1b$var$galleryBlocks.forEach((block)=>{
    const container = block.querySelector('.gallery-slider-outer');
    const slides = block.querySelectorAll('.gallery-slide-outer');
    const buttons = block.querySelectorAll('.gallery-nav-btn');
    if (slides.length > 1) {
        const embla = (0, $4Rg0O.default)(container, {
            align: 'start',
            loop: true
        });
        buttons.forEach((button, i)=>{
            button.addEventListener('click', ()=>embla.scrollTo(i));
        });
        embla.on('select', ()=>{
            const index = embla.selectedScrollSnap();
            buttons.forEach((button, i)=>button.classList.toggle('active', index === i));
        });
    }
});
function $ddfc5978d59f4a1b$export$51e87da2cc2899f4(context = document) {
    const contentSliders = context.querySelectorAll('.content-slider-outer');
    contentSliders.forEach((container)=>{
        const embla = (0, $4Rg0O.default)(container, {
            align: 'start'
        });
        const section = container.closest('section');
        const nav = section.querySelector('.slider-nav');
        const prevButton = section.querySelector('.slider-nav-prev');
        const nextButton = section.querySelector('.slider-nav-next');
        if (nav) {
            prevButton.addEventListener('click', embla.scrollPrev);
            nextButton.addEventListener('click', embla.scrollNext);
            embla.on('select', ()=>{
                prevButton.disabled = !embla.canScrollPrev();
                nextButton.disabled = !embla.canScrollNext();
            });
            embla.on('slidesInView', ()=>{
                nav.classList.toggle('hidden', !embla.canScrollNext() && !embla.canScrollPrev());
            });
        }
    });
}
$ddfc5978d59f4a1b$export$51e87da2cc2899f4();
// Logos slider
const $ddfc5978d59f4a1b$var$logosSliders = document.querySelectorAll('.logos-slider-outer');
$ddfc5978d59f4a1b$var$logosSliders.forEach((container)=>{
    const embla = (0, $4Rg0O.default)(container, {
        align: 'start'
    });
    const section = container.closest('section');
    const prevButton = section.querySelector('.slider-nav-prev');
    const nextButton = section.querySelector('.slider-nav-next');
    prevButton.addEventListener('click', embla.scrollPrev);
    nextButton.addEventListener('click', embla.scrollNext);
    embla.on('select', ()=>{
        prevButton.disabled = !embla.canScrollPrev();
        nextButton.disabled = !embla.canScrollNext();
    });
});
// User scroll class
const $ddfc5978d59f4a1b$var$headerWasWhite = document.body.classList.contains('header-white');
let $ddfc5978d59f4a1b$var$lastScrollTop = 0;
function $ddfc5978d59f4a1b$var$toggleHeaderScrollClass() {
    const currentScrollTop = window.scrollY || document.documentElement.scrollTop;
    const hasScrolledDown = currentScrollTop > 0 && currentScrollTop > $ddfc5978d59f4a1b$var$lastScrollTop;
    $ddfc5978d59f4a1b$var$lastScrollTop = currentScrollTop;
    document.body.classList.toggle('header-white', currentScrollTop > 0 || $ddfc5978d59f4a1b$var$headerWasWhite);
    document.body.classList.toggle('user-has-scrolled-down', hasScrolledDown);
    document.body.classList.toggle('user-has-scrolled-up', !hasScrolledDown);
}
window.addEventListener('scroll', $ddfc5978d59f4a1b$var$toggleHeaderScrollClass);
$ddfc5978d59f4a1b$var$toggleHeaderScrollClass();
// Header language switcher
const $ddfc5978d59f4a1b$var$headerLanguagesToggle = document.querySelector('.header-languages-toggle');
let $ddfc5978d59f4a1b$var$headerLanguagesAreOpen = false;
function $ddfc5978d59f4a1b$var$applyHeaderLanguageTabIndexes() {
    document.querySelectorAll('.header-languages-list a').forEach((link)=>{
        link.setAttribute('tabindex', $ddfc5978d59f4a1b$var$headerLanguagesAreOpen ? '0' : '-1');
    });
}
$ddfc5978d59f4a1b$var$headerLanguagesToggle?.addEventListener('click', ()=>{
    document.body.classList.toggle('languages-are-open');
    (0, $f5sus.reverseAriaExpanded)($ddfc5978d59f4a1b$var$headerLanguagesToggle);
    $ddfc5978d59f4a1b$var$headerLanguagesAreOpen = !$ddfc5978d59f4a1b$var$headerLanguagesAreOpen;
    $ddfc5978d59f4a1b$var$applyHeaderLanguageTabIndexes();
});
$ddfc5978d59f4a1b$var$applyHeaderLanguageTabIndexes();
// Header menu
const $ddfc5978d59f4a1b$var$headerMenuMobile = document.querySelector('.header-menu-mobile');
const $ddfc5978d59f4a1b$var$headerMenuToggle = document.querySelector('.header-menu-toggle');
const $ddfc5978d59f4a1b$var$smallmenuOverlay = document.querySelector('.smallmenu-overlay');
let $ddfc5978d59f4a1b$var$headerMenuIsOpen = false;
let $ddfc5978d59f4a1b$var$headerMenuFocusTrap = null;
function $ddfc5978d59f4a1b$var$openHeaderMenu() {
    document.body.classList.add('menu-is-open');
    $ddfc5978d59f4a1b$var$headerMenuToggle.setAttribute('aria-expanded', 'true');
    $ddfc5978d59f4a1b$var$headerMenuIsOpen = true;
    const focusableEls = [
        $ddfc5978d59f4a1b$var$headerMenuToggle,
        ...$ddfc5978d59f4a1b$var$headerMenuMobile.querySelectorAll('.smallmenu-topmenu > li > a, .smallmenu-topmenu > li > button')
    ];
    $ddfc5978d59f4a1b$var$headerMenuToggle.focus();
    $ddfc5978d59f4a1b$var$headerMenuFocusTrap = new (0, $f5sus.FocusTrap)($ddfc5978d59f4a1b$var$headerMenuMobile, focusableEls);
    $ddfc5978d59f4a1b$var$headerMenuFocusTrap.enable();
}
function $ddfc5978d59f4a1b$var$closeHeaderMenu() {
    document.body.classList.remove('menu-is-open');
    $ddfc5978d59f4a1b$var$headerMenuToggle.setAttribute('aria-expanded', 'false');
    $ddfc5978d59f4a1b$var$headerMenuIsOpen = false;
    $ddfc5978d59f4a1b$var$headerMenuToggle.focus();
    $ddfc5978d59f4a1b$var$headerMenuFocusTrap?.disable();
}
function $ddfc5978d59f4a1b$var$toggleHeaderMenu() {
    $ddfc5978d59f4a1b$var$headerMenuIsOpen ? $ddfc5978d59f4a1b$var$closeHeaderMenu() : $ddfc5978d59f4a1b$var$openHeaderMenu();
}
$ddfc5978d59f4a1b$var$headerMenuToggle.addEventListener('click', $ddfc5978d59f4a1b$var$toggleHeaderMenu);
$ddfc5978d59f4a1b$var$smallmenuOverlay.addEventListener('click', $ddfc5978d59f4a1b$var$closeHeaderMenu);
// Small menu submenus
const $ddfc5978d59f4a1b$var$smallmenuInner = document.querySelector('.smallmenu-inner');
const $ddfc5978d59f4a1b$var$smallmenuSubmenus = document.querySelectorAll('.smallmenu-submenu');
const $ddfc5978d59f4a1b$var$smallmenuSubmenuToggles = document.querySelectorAll('.smallmenu-submenu-toggle');
const $ddfc5978d59f4a1b$var$smallMenuSubmenuClosers = document.querySelectorAll('.smallmenu-submenu-close');
let $ddfc5978d59f4a1b$var$submenuFocusTraps = {};
function $ddfc5978d59f4a1b$var$openSubmenu(toggle) {
    const submenu = document.querySelector(toggle.dataset.target);
    const closer = submenu.querySelector('.smallmenu-submenu-close');
    $ddfc5978d59f4a1b$var$smallmenuSubmenus.forEach((otherSubmenu)=>{
        otherSubmenu.classList.remove('visible');
    });
    submenu.classList.add('visible');
    $ddfc5978d59f4a1b$var$smallmenuInner.classList.add('submenu-is-open');
    toggle.setAttribute('aria-expanded', 'true');
    closer.setAttribute('aria-expanded', 'true');
    closer.focus();
    if (!$ddfc5978d59f4a1b$var$submenuFocusTraps[submenu.id]) {
        const focusableEls = [
            closer,
            ...(0, $f5sus.FocusTrap).getFocusableEls(submenu)
        ];
        $ddfc5978d59f4a1b$var$submenuFocusTraps[submenu.id] = new (0, $f5sus.FocusTrap)(submenu, focusableEls);
    }
    $ddfc5978d59f4a1b$var$headerMenuFocusTrap.disable();
    $ddfc5978d59f4a1b$var$submenuFocusTraps[submenu.id].enable();
}
function $ddfc5978d59f4a1b$var$closeSubmenu(closer) {
    const submenu = closer.closest('.smallmenu-submenu');
    const toggle = document.querySelector(`[data-target="#${submenu.id}"]`);
    submenu.classList.remove('visible');
    $ddfc5978d59f4a1b$var$smallmenuInner.classList.remove('submenu-is-open');
    $ddfc5978d59f4a1b$var$smallmenuInner.classList.add('submenu-was-closed');
    closer.setAttribute('aria-expanded', 'false');
    toggle.setAttribute('aria-expanded', 'false');
    toggle.focus();
    $ddfc5978d59f4a1b$var$submenuFocusTraps[submenu.id].disable();
    $ddfc5978d59f4a1b$var$headerMenuFocusTrap.enable();
}
$ddfc5978d59f4a1b$var$smallmenuSubmenuToggles.forEach((toggle)=>{
    toggle.addEventListener('click', ()=>{
        $ddfc5978d59f4a1b$var$openSubmenu(toggle);
    });
});
$ddfc5978d59f4a1b$var$smallMenuSubmenuClosers.forEach((closer)=>{
    closer.addEventListener('click', ()=>{
        $ddfc5978d59f4a1b$var$closeSubmenu(closer);
    });
});
// Megamenus
const $ddfc5978d59f4a1b$var$flyouts = document.querySelectorAll('.flyout');
const $ddfc5978d59f4a1b$var$flyoutToggles = document.querySelectorAll('.flyout-toggle');
const $ddfc5978d59f4a1b$var$flyoutClosers = document.querySelectorAll('.flyout-close');
const $ddfc5978d59f4a1b$var$focusTraps = [];
function $ddfc5978d59f4a1b$var$closeCurrentFlyout() {
    document.body.classList.remove('flyout-is-open');
    $ddfc5978d59f4a1b$var$flyouts.forEach((menu)=>{
        menu.classList.remove('visible');
    });
    $ddfc5978d59f4a1b$var$flyoutToggles.forEach((toggle)=>{
        toggle.setAttribute('aria-expanded', 'false');
        toggle.classList.remove('active');
    });
    $ddfc5978d59f4a1b$var$focusTraps.forEach((trap)=>{
        trap.disable();
    });
}
$ddfc5978d59f4a1b$var$flyoutToggles.forEach((toggle, index)=>{
    const flyout = document.querySelector(toggle.dataset.target);
    if (!flyout) return;
    const closer = flyout.querySelector('.flyout-close');
    $ddfc5978d59f4a1b$var$focusTraps[index] = new (0, $f5sus.FocusTrap)(flyout, [
        closer,
        ...(0, $f5sus.FocusTrap).getFocusableEls(flyout)
    ]);
    toggle.addEventListener('click', ()=>{
        const flyoutIsOpen = flyout.classList.contains('visible');
        $ddfc5978d59f4a1b$var$closeCurrentFlyout();
        if (flyoutIsOpen) return;
        $ddfc5978d59f4a1b$var$closeHeaderMenu();
        flyout.classList.add('visible');
        document.body.classList.add('flyout-is-open');
        toggle.classList.add('active');
        toggle.setAttribute('aria-expanded', 'true');
        closer.setAttribute('aria-expanded', 'true');
        closer.focus();
        $ddfc5978d59f4a1b$var$focusTraps[index].enable();
    });
});
$ddfc5978d59f4a1b$var$flyoutClosers.forEach((closer, index)=>{
    closer.addEventListener('click', ()=>{
        const flyout = closer.closest('.flyout');
        const toggle = document.querySelector(`[data-target="#${flyout.id}"]`);
        $ddfc5978d59f4a1b$var$closeCurrentFlyout();
        toggle.focus();
    });
});
window.addEventListener('keydown', (e)=>{
    if (e.key === 'Escape') $ddfc5978d59f4a1b$var$closeCurrentFlyout();
});
// FAQ blocks
const $ddfc5978d59f4a1b$var$faqBlocks = document.querySelectorAll('.faq');
$ddfc5978d59f4a1b$var$faqBlocks.forEach((block)=>{
    const itemToggles = block.querySelectorAll('.faq-item-toggle');
    function openItem(toggle) {
        const item = toggle.closest('.faq-item');
        const content = item.querySelector('.faq-item-content');
        const isClosed = !item.classList.contains('open');
        if (isClosed) {
            item.classList.add('open');
            content.style.maxHeight = `${content.scrollHeight}px`;
            (0, $f5sus.reverseAriaExpanded)(toggle);
        }
    }
    function closeItem(toggle) {
        const item = toggle.closest('.faq-item');
        const content = item.querySelector('.faq-item-content');
        const isOpen = item.classList.contains('open');
        if (isOpen) {
            item.classList.remove('open');
            content.style.maxHeight = null;
            (0, $f5sus.reverseAriaExpanded)(toggle);
        }
    }
    itemToggles.forEach((toggle)=>{
        toggle.addEventListener('click', ()=>{
            const itemWasOpen = toggle.closest('.faq-item').classList.contains('open');
            itemToggles.forEach((otherToggle)=>{
                closeItem(otherToggle);
            });
            itemWasOpen ? closeItem(toggle) : openItem(toggle);
        });
    });
});
// Cache-proofing dynamic weather
const $ddfc5978d59f4a1b$var$dynamicWeatherContainers = document.querySelectorAll('.weather-dynamic');
if ($ddfc5978d59f4a1b$var$dynamicWeatherContainers.length) fetch(urls.ajax, {
    method: 'POST',
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
    },
    body: 'action=get_weather'
}).then((response)=>response.text()).then((html)=>{
    $ddfc5978d59f4a1b$var$dynamicWeatherContainers.forEach((container)=>{
        container.innerHTML = html;
    });
});
// Static map blocks
const $ddfc5978d59f4a1b$var$staticmapBlocks = document.querySelectorAll('.staticmap');
$ddfc5978d59f4a1b$var$staticmapBlocks.forEach((block)=>{
    const toggles = block.querySelectorAll('.staticmap-toggle');
    const hotspots = block.querySelectorAll('.staticmap-hotspot');
    toggles.forEach((toggle)=>{
        function showMarkerInfo(toggle) {
            const isMobile = window.matchMedia('(max-width: 60em)').matches;
            const target = block.querySelector(toggle.getAttribute('href'));
            toggles.forEach((t)=>t.classList.remove('active'));
            toggle.classList.add('active');
            hotspots.forEach((h)=>h.classList.remove('visible'));
            target.classList.add('visible');
            if (isMobile) target.scrollIntoView({
                behavior: 'smooth'
            });
        }
        toggle.addEventListener('click', (e)=>{
            e.preventDefault();
            showMarkerInfo(toggle);
        });
    });
});
// Routemaker links
const $ddfc5978d59f4a1b$var$routemakerLinks = document.querySelectorAll('[href*="viewer.routemaker.nl"]');
$ddfc5978d59f4a1b$var$routemakerLinks.forEach((link)=>{
    if (link.hasAttribute('download')) return; // Skip links with download attribute
    link.setAttribute('role', 'button');
    const dialog = document.createElement('dialog');
    dialog.classList.add('popup');
    const closeButton = document.createElement('button');
    closeButton.textContent = "\xd7";
    closeButton.classList.add('popup-close');
    closeButton.setAttribute('type', 'button');
    closeButton.setAttribute('aria-label', 'Sluiten');
    closeButton.addEventListener('click', ()=>dialog.close());
    dialog.appendChild(closeButton);
    const iframe = document.createElement('iframe');
    iframe.classList.add('popup-iframe');
    iframe.setAttribute('src', link.href);
    iframe.setAttribute('allow', 'fullscreen');
    iframe.setAttribute('loading', 'lazy');
    iframe.setAttribute('sandbox', 'allow-same-origin allow-scripts allow-popups allow-forms');
    dialog.appendChild(iframe);
    document.body.appendChild(dialog);
    link.addEventListener('click', (e)=>{
        e.preventDefault();
        dialog.showModal();
    });
});
// Dialog toggles
const $ddfc5978d59f4a1b$var$dialogToggles = document.querySelectorAll('[data-dialog]');
const $ddfc5978d59f4a1b$var$dialogClosers = document.querySelectorAll('[data-dialog-close]');
$ddfc5978d59f4a1b$var$dialogToggles.forEach((toggle)=>{
    const dialog = document.querySelector(toggle.dataset.dialog);
    toggle.addEventListener('click', ()=>{
        dialog.showModal();
        (0, $f5sus.reverseAriaExpanded)(toggle, true);
        document.documentElement.classList.add('no-scroll');
    });
    dialog.addEventListener('click', (e)=>{
        if (e.target === dialog) dialog.close();
    });
    dialog.addEventListener('close', ()=>{
        (0, $f5sus.reverseAriaExpanded)(toggle, false);
        document.documentElement.classList.remove('no-scroll');
    });
});
$ddfc5978d59f4a1b$var$dialogClosers.forEach((closer)=>{
    closer.addEventListener('click', ()=>{
        closer.closest('dialog').close();
    });
});
// Room dialog scroll buttons
const $ddfc5978d59f4a1b$var$roomDialogScrollButtons = document.querySelectorAll('.room-dialog-scroll');
$ddfc5978d59f4a1b$var$roomDialogScrollButtons.forEach((button)=>{
    const dialog = button.closest('dialog');
    const content = dialog.querySelector('.room-dialog-content');
    button.addEventListener('click', ()=>{
        content.scrollIntoView({
            behavior: 'smooth'
        });
    });
});
// Quote form location handling
const $ddfc5978d59f4a1b$var$locationAddButtons = document.querySelectorAll('[data-location-id]');
const $ddfc5978d59f4a1b$var$quoteForm = document.querySelector('#quote-form');
let $ddfc5978d59f4a1b$var$loadingLocations = false;
let $ddfc5978d59f4a1b$var$submitting = false;
function $ddfc5978d59f4a1b$var$getUserLocations() {
    const locationsCookie = (0, (/*@__PURE__*/$parcel$interopDefault($5IiZx))).get('quote_form_locations');
    return locationsCookie ? JSON.parse(locationsCookie) : [];
}
function $ddfc5978d59f4a1b$var$setUserLocations(locations) {
    (0, (/*@__PURE__*/$parcel$interopDefault($5IiZx))).set('quote_form_locations', JSON.stringify(locations), {
        expires: 7,
        sameSite: 'Lax'
    });
}
function $ddfc5978d59f4a1b$var$updateLocationDisplay(locations = null, force = false) {
    const locationsCounter = document.querySelector('.quote-locations-counter');
    const locationsContainer = document.querySelector('.form-locations');
    const locationsGrid = document.querySelector('.form-locations-grid');
    const locationIds = locations ?? $ddfc5978d59f4a1b$var$getUserLocations();
    locationsCounter.textContent = locationIds.length;
    if (!locationsContainer || locationIds.length === 0 && !force) return;
    locationsContainer.classList.add('loading');
    $ddfc5978d59f4a1b$var$loadingLocations = true;
    fetch(urls.ajax, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: 'action=get_quote_locations'
    }).then((response)=>response.text()).then((html)=>{
        locationsGrid.innerHTML = html;
        locationsContainer.classList.remove('loading');
        const removeButtons = locationsContainer.querySelectorAll('.form-location-remove');
        removeButtons.forEach((button)=>{
            button.addEventListener('click', ()=>{
                const locationId = parseInt(button.dataset.locationId);
                let locations = $ddfc5978d59f4a1b$var$getUserLocations();
                locations = locations.filter((id)=>id !== locationId);
                $ddfc5978d59f4a1b$var$setUserLocations(locations);
                const locationItem = button.closest('.form-location');
                setTimeout(()=>locationItem.remove(), 300);
                locationsCounter.textContent = locations.length;
            }, {
                once: true
            });
        });
        $ddfc5978d59f4a1b$var$loadingLocations = false;
    });
}
$ddfc5978d59f4a1b$var$locationAddButtons.forEach((button)=>{
    button.addEventListener('click', ()=>{
        const locationId = parseInt(button.dataset.locationId);
        let locations = $ddfc5978d59f4a1b$var$getUserLocations();
        if (!locations.includes(locationId)) {
            locations.push(locationId);
            $ddfc5978d59f4a1b$var$setUserLocations(locations);
            $ddfc5978d59f4a1b$var$updateLocationDisplay(locations);
        }
    });
});
$ddfc5978d59f4a1b$var$quoteForm?.addEventListener('submit', (e)=>{
    e.preventDefault();
    if ($ddfc5978d59f4a1b$var$submitting || $ddfc5978d59f4a1b$var$loadingLocations) return;
    $ddfc5978d59f4a1b$var$submitting = true;
    $ddfc5978d59f4a1b$var$quoteForm.querySelector('.form-messages').innerHTML = '';
    $ddfc5978d59f4a1b$var$quoteForm.classList.add('submitting');
    const formData = new FormData($ddfc5978d59f4a1b$var$quoteForm);
    const locationIds = $ddfc5978d59f4a1b$var$getUserLocations();
    locationIds.forEach((id)=>{
        formData.append('location_ids[]', id);
    });
    fetch(urls.ajax, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: new URLSearchParams(formData).toString()
    }).then((response)=>response.json()).then((result)=>{
        const message = `<div class="form-message ${result.success ? 'success' : 'error'}">${result.message}</div>`;
        $ddfc5978d59f4a1b$var$quoteForm.querySelector('.form-messages').innerHTML = message;
        $ddfc5978d59f4a1b$var$quoteForm.classList.remove('submitting');
        $ddfc5978d59f4a1b$var$submitting = false;
        if (!result.success) return;
        $ddfc5978d59f4a1b$var$quoteForm.reset();
        $ddfc5978d59f4a1b$var$setUserLocations([]);
        $ddfc5978d59f4a1b$var$updateLocationDisplay([], true);
    });
});
// Initial location display update
$ddfc5978d59f4a1b$var$updateLocationDisplay();
// Activity form submit
const $ddfc5978d59f4a1b$var$activityForm = document.querySelector('#activity-form');
let $ddfc5978d59f4a1b$var$activitySubmitting = false;
$ddfc5978d59f4a1b$var$activityForm?.addEventListener('submit', (e)=>{
    e.preventDefault();
    if ($ddfc5978d59f4a1b$var$activitySubmitting) return;
    $ddfc5978d59f4a1b$var$activitySubmitting = true;
    $ddfc5978d59f4a1b$var$activityForm.querySelector('.form-messages').innerHTML = '';
    $ddfc5978d59f4a1b$var$activityForm.classList.add('submitting');
    const formData = new FormData($ddfc5978d59f4a1b$var$activityForm);
    fetch(urls.ajax, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: new URLSearchParams(formData).toString()
    }).then((response)=>response.json()).then((result)=>{
        const message = `<div class="form-message ${result.success ? 'success' : 'error'}">${result.message}</div>`;
        $ddfc5978d59f4a1b$var$activityForm.querySelector('.form-messages').innerHTML = message;
        $ddfc5978d59f4a1b$var$activityForm.classList.remove('submitting');
        $ddfc5978d59f4a1b$var$activitySubmitting = false;
        if (!result.success) return;
        $ddfc5978d59f4a1b$var$activityForm.reset();
    });
});
// Fancybox
(0, $gITAg.Fancybox).bind('[data-fancybox]');

});
parcelRegister("4Rg0O", function(module, exports) {

$parcel$export(module.exports, "default", () => $3898885b5c8ce990$export$2e2bcd8739ae039);
function $3898885b5c8ce990$var$isNumber(subject) {
    return typeof subject === 'number';
}
function $3898885b5c8ce990$var$isString(subject) {
    return typeof subject === 'string';
}
function $3898885b5c8ce990$var$isBoolean(subject) {
    return typeof subject === 'boolean';
}
function $3898885b5c8ce990$var$isObject(subject) {
    return Object.prototype.toString.call(subject) === '[object Object]';
}
function $3898885b5c8ce990$var$mathAbs(n) {
    return Math.abs(n);
}
function $3898885b5c8ce990$var$mathSign(n) {
    return Math.sign(n);
}
function $3898885b5c8ce990$var$deltaAbs(valueB, valueA) {
    return $3898885b5c8ce990$var$mathAbs(valueB - valueA);
}
function $3898885b5c8ce990$var$factorAbs(valueB, valueA) {
    if (valueB === 0 || valueA === 0) return 0;
    if ($3898885b5c8ce990$var$mathAbs(valueB) <= $3898885b5c8ce990$var$mathAbs(valueA)) return 0;
    const diff = $3898885b5c8ce990$var$deltaAbs($3898885b5c8ce990$var$mathAbs(valueB), $3898885b5c8ce990$var$mathAbs(valueA));
    return $3898885b5c8ce990$var$mathAbs(diff / valueB);
}
function $3898885b5c8ce990$var$roundToTwoDecimals(num) {
    return Math.round(num * 100) / 100;
}
function $3898885b5c8ce990$var$arrayKeys(array) {
    return $3898885b5c8ce990$var$objectKeys(array).map(Number);
}
function $3898885b5c8ce990$var$arrayLast(array) {
    return array[$3898885b5c8ce990$var$arrayLastIndex(array)];
}
function $3898885b5c8ce990$var$arrayLastIndex(array) {
    return Math.max(0, array.length - 1);
}
function $3898885b5c8ce990$var$arrayIsLastIndex(array, index) {
    return index === $3898885b5c8ce990$var$arrayLastIndex(array);
}
function $3898885b5c8ce990$var$arrayFromNumber(n, startAt = 0) {
    return Array.from(Array(n), (_, i)=>startAt + i);
}
function $3898885b5c8ce990$var$objectKeys(object) {
    return Object.keys(object);
}
function $3898885b5c8ce990$var$objectsMergeDeep(objectA, objectB) {
    return [
        objectA,
        objectB
    ].reduce((mergedObjects, currentObject)=>{
        $3898885b5c8ce990$var$objectKeys(currentObject).forEach((key)=>{
            const valueA = mergedObjects[key];
            const valueB = currentObject[key];
            const areObjects = $3898885b5c8ce990$var$isObject(valueA) && $3898885b5c8ce990$var$isObject(valueB);
            mergedObjects[key] = areObjects ? $3898885b5c8ce990$var$objectsMergeDeep(valueA, valueB) : valueB;
        });
        return mergedObjects;
    }, {});
}
function $3898885b5c8ce990$var$isMouseEvent(evt, ownerWindow) {
    return typeof ownerWindow.MouseEvent !== 'undefined' && evt instanceof ownerWindow.MouseEvent;
}
function $3898885b5c8ce990$var$Alignment(align, viewSize) {
    const predefined = {
        start: start,
        center: center,
        end: end
    };
    function start() {
        return 0;
    }
    function center(n) {
        return end(n) / 2;
    }
    function end(n) {
        return viewSize - n;
    }
    function measure(n, index) {
        if ($3898885b5c8ce990$var$isString(align)) return predefined[align](n);
        return align(viewSize, n, index);
    }
    const self = {
        measure: measure
    };
    return self;
}
function $3898885b5c8ce990$var$EventStore() {
    let listeners = [];
    function add(node, type, handler, options = {
        passive: true
    }) {
        let removeListener;
        if ('addEventListener' in node) {
            node.addEventListener(type, handler, options);
            removeListener = ()=>node.removeEventListener(type, handler, options);
        } else {
            const legacyMediaQueryList = node;
            legacyMediaQueryList.addListener(handler);
            removeListener = ()=>legacyMediaQueryList.removeListener(handler);
        }
        listeners.push(removeListener);
        return self;
    }
    function clear() {
        listeners = listeners.filter((remove)=>remove());
    }
    const self = {
        add: add,
        clear: clear
    };
    return self;
}
function $3898885b5c8ce990$var$Animations(ownerDocument, ownerWindow, update, render) {
    const documentVisibleHandler = $3898885b5c8ce990$var$EventStore();
    const fixedTimeStep = 1000 / 60;
    let lastTimeStamp = null;
    let accumulatedTime = 0;
    let animationId = 0;
    function init() {
        documentVisibleHandler.add(ownerDocument, 'visibilitychange', ()=>{
            if (ownerDocument.hidden) reset();
        });
    }
    function destroy() {
        stop();
        documentVisibleHandler.clear();
    }
    function animate(timeStamp) {
        if (!animationId) return;
        if (!lastTimeStamp) {
            lastTimeStamp = timeStamp;
            update();
            update();
        }
        const timeElapsed = timeStamp - lastTimeStamp;
        lastTimeStamp = timeStamp;
        accumulatedTime += timeElapsed;
        while(accumulatedTime >= fixedTimeStep){
            update();
            accumulatedTime -= fixedTimeStep;
        }
        const alpha = accumulatedTime / fixedTimeStep;
        render(alpha);
        if (animationId) animationId = ownerWindow.requestAnimationFrame(animate);
    }
    function start() {
        if (animationId) return;
        animationId = ownerWindow.requestAnimationFrame(animate);
    }
    function stop() {
        ownerWindow.cancelAnimationFrame(animationId);
        lastTimeStamp = null;
        accumulatedTime = 0;
        animationId = 0;
    }
    function reset() {
        lastTimeStamp = null;
        accumulatedTime = 0;
    }
    const self = {
        init: init,
        destroy: destroy,
        start: start,
        stop: stop,
        update: update,
        render: render
    };
    return self;
}
function $3898885b5c8ce990$var$Axis(axis, contentDirection) {
    const isRightToLeft = contentDirection === 'rtl';
    const isVertical = axis === 'y';
    const scroll = isVertical ? 'y' : 'x';
    const cross = isVertical ? 'x' : 'y';
    const sign = !isVertical && isRightToLeft ? -1 : 1;
    const startEdge = getStartEdge();
    const endEdge = getEndEdge();
    function measureSize(nodeRect) {
        const { height: height, width: width } = nodeRect;
        return isVertical ? height : width;
    }
    function getStartEdge() {
        if (isVertical) return 'top';
        return isRightToLeft ? 'right' : 'left';
    }
    function getEndEdge() {
        if (isVertical) return 'bottom';
        return isRightToLeft ? 'left' : 'right';
    }
    function direction(n) {
        return n * sign;
    }
    const self = {
        scroll: scroll,
        cross: cross,
        startEdge: startEdge,
        endEdge: endEdge,
        measureSize: measureSize,
        direction: direction
    };
    return self;
}
function $3898885b5c8ce990$var$Limit(min = 0, max = 0) {
    const length = $3898885b5c8ce990$var$mathAbs(min - max);
    function reachedMin(n) {
        return n < min;
    }
    function reachedMax(n) {
        return n > max;
    }
    function reachedAny(n) {
        return reachedMin(n) || reachedMax(n);
    }
    function constrain(n) {
        if (!reachedAny(n)) return n;
        return reachedMin(n) ? min : max;
    }
    function removeOffset(n) {
        if (!length) return n;
        return n - length * Math.ceil((n - max) / length);
    }
    const self = {
        length: length,
        max: max,
        min: min,
        constrain: constrain,
        reachedAny: reachedAny,
        reachedMax: reachedMax,
        reachedMin: reachedMin,
        removeOffset: removeOffset
    };
    return self;
}
function $3898885b5c8ce990$var$Counter(max, start, loop) {
    const { constrain: constrain } = $3898885b5c8ce990$var$Limit(0, max);
    const loopEnd = max + 1;
    let counter = withinLimit(start);
    function withinLimit(n) {
        return !loop ? constrain(n) : $3898885b5c8ce990$var$mathAbs((loopEnd + n) % loopEnd);
    }
    function get() {
        return counter;
    }
    function set(n) {
        counter = withinLimit(n);
        return self;
    }
    function add(n) {
        return clone().set(get() + n);
    }
    function clone() {
        return $3898885b5c8ce990$var$Counter(max, get(), loop);
    }
    const self = {
        get: get,
        set: set,
        add: add,
        clone: clone
    };
    return self;
}
function $3898885b5c8ce990$var$DragHandler(axis, rootNode, ownerDocument, ownerWindow, target, dragTracker, location, animation, scrollTo, scrollBody, scrollTarget, index, eventHandler, percentOfView, dragFree, dragThreshold, skipSnaps, baseFriction, watchDrag) {
    const { cross: crossAxis, direction: direction } = axis;
    const focusNodes = [
        'INPUT',
        'SELECT',
        'TEXTAREA'
    ];
    const nonPassiveEvent = {
        passive: false
    };
    const initEvents = $3898885b5c8ce990$var$EventStore();
    const dragEvents = $3898885b5c8ce990$var$EventStore();
    const goToNextThreshold = $3898885b5c8ce990$var$Limit(50, 225).constrain(percentOfView.measure(20));
    const snapForceBoost = {
        mouse: 300,
        touch: 400
    };
    const freeForceBoost = {
        mouse: 500,
        touch: 600
    };
    const baseSpeed = dragFree ? 43 : 25;
    let isMoving = false;
    let startScroll = 0;
    let startCross = 0;
    let pointerIsDown = false;
    let preventScroll = false;
    let preventClick = false;
    let isMouse = false;
    function init(emblaApi) {
        if (!watchDrag) return;
        function downIfAllowed(evt) {
            if ($3898885b5c8ce990$var$isBoolean(watchDrag) || watchDrag(emblaApi, evt)) down(evt);
        }
        const node = rootNode;
        initEvents.add(node, 'dragstart', (evt)=>evt.preventDefault(), nonPassiveEvent).add(node, 'touchmove', ()=>undefined, nonPassiveEvent).add(node, 'touchend', ()=>undefined).add(node, 'touchstart', downIfAllowed).add(node, 'mousedown', downIfAllowed).add(node, 'touchcancel', up).add(node, 'contextmenu', up).add(node, 'click', click, true);
    }
    function destroy() {
        initEvents.clear();
        dragEvents.clear();
    }
    function addDragEvents() {
        const node = isMouse ? ownerDocument : rootNode;
        dragEvents.add(node, 'touchmove', move, nonPassiveEvent).add(node, 'touchend', up).add(node, 'mousemove', move, nonPassiveEvent).add(node, 'mouseup', up);
    }
    function isFocusNode(node) {
        const nodeName = node.nodeName || '';
        return focusNodes.includes(nodeName);
    }
    function forceBoost() {
        const boost = dragFree ? freeForceBoost : snapForceBoost;
        const type = isMouse ? 'mouse' : 'touch';
        return boost[type];
    }
    function allowedForce(force, targetChanged) {
        const next = index.add($3898885b5c8ce990$var$mathSign(force) * -1);
        const baseForce = scrollTarget.byDistance(force, !dragFree).distance;
        if (dragFree || $3898885b5c8ce990$var$mathAbs(force) < goToNextThreshold) return baseForce;
        if (skipSnaps && targetChanged) return baseForce * 0.5;
        return scrollTarget.byIndex(next.get(), 0).distance;
    }
    function down(evt) {
        const isMouseEvt = $3898885b5c8ce990$var$isMouseEvent(evt, ownerWindow);
        isMouse = isMouseEvt;
        preventClick = dragFree && isMouseEvt && !evt.buttons && isMoving;
        isMoving = $3898885b5c8ce990$var$deltaAbs(target.get(), location.get()) >= 2;
        if (isMouseEvt && evt.button !== 0) return;
        if (isFocusNode(evt.target)) return;
        pointerIsDown = true;
        dragTracker.pointerDown(evt);
        scrollBody.useFriction(0).useDuration(0);
        target.set(location);
        addDragEvents();
        startScroll = dragTracker.readPoint(evt);
        startCross = dragTracker.readPoint(evt, crossAxis);
        eventHandler.emit('pointerDown');
    }
    function move(evt) {
        const isTouchEvt = !$3898885b5c8ce990$var$isMouseEvent(evt, ownerWindow);
        if (isTouchEvt && evt.touches.length >= 2) return up(evt);
        const lastScroll = dragTracker.readPoint(evt);
        const lastCross = dragTracker.readPoint(evt, crossAxis);
        const diffScroll = $3898885b5c8ce990$var$deltaAbs(lastScroll, startScroll);
        const diffCross = $3898885b5c8ce990$var$deltaAbs(lastCross, startCross);
        if (!preventScroll && !isMouse) {
            if (!evt.cancelable) return up(evt);
            preventScroll = diffScroll > diffCross;
            if (!preventScroll) return up(evt);
        }
        const diff = dragTracker.pointerMove(evt);
        if (diffScroll > dragThreshold) preventClick = true;
        scrollBody.useFriction(0.3).useDuration(0.75);
        animation.start();
        target.add(direction(diff));
        evt.preventDefault();
    }
    function up(evt) {
        const currentLocation = scrollTarget.byDistance(0, false);
        const targetChanged = currentLocation.index !== index.get();
        const rawForce = dragTracker.pointerUp(evt) * forceBoost();
        const force = allowedForce(direction(rawForce), targetChanged);
        const forceFactor = $3898885b5c8ce990$var$factorAbs(rawForce, force);
        const speed = baseSpeed - 10 * forceFactor;
        const friction = baseFriction + forceFactor / 50;
        preventScroll = false;
        pointerIsDown = false;
        dragEvents.clear();
        scrollBody.useDuration(speed).useFriction(friction);
        scrollTo.distance(force, !dragFree);
        isMouse = false;
        eventHandler.emit('pointerUp');
    }
    function click(evt) {
        if (preventClick) {
            evt.stopPropagation();
            evt.preventDefault();
            preventClick = false;
        }
    }
    function pointerDown() {
        return pointerIsDown;
    }
    const self = {
        init: init,
        destroy: destroy,
        pointerDown: pointerDown
    };
    return self;
}
function $3898885b5c8ce990$var$DragTracker(axis, ownerWindow) {
    const logInterval = 170;
    let startEvent;
    let lastEvent;
    function readTime(evt) {
        return evt.timeStamp;
    }
    function readPoint(evt, evtAxis) {
        const property = evtAxis || axis.scroll;
        const coord = `client${property === 'x' ? 'X' : 'Y'}`;
        return ($3898885b5c8ce990$var$isMouseEvent(evt, ownerWindow) ? evt : evt.touches[0])[coord];
    }
    function pointerDown(evt) {
        startEvent = evt;
        lastEvent = evt;
        return readPoint(evt);
    }
    function pointerMove(evt) {
        const diff = readPoint(evt) - readPoint(lastEvent);
        const expired = readTime(evt) - readTime(startEvent) > logInterval;
        lastEvent = evt;
        if (expired) startEvent = evt;
        return diff;
    }
    function pointerUp(evt) {
        if (!startEvent || !lastEvent) return 0;
        const diffDrag = readPoint(lastEvent) - readPoint(startEvent);
        const diffTime = readTime(evt) - readTime(startEvent);
        const expired = readTime(evt) - readTime(lastEvent) > logInterval;
        const force = diffDrag / diffTime;
        const isFlick = diffTime && !expired && $3898885b5c8ce990$var$mathAbs(force) > 0.1;
        return isFlick ? force : 0;
    }
    const self = {
        pointerDown: pointerDown,
        pointerMove: pointerMove,
        pointerUp: pointerUp,
        readPoint: readPoint
    };
    return self;
}
function $3898885b5c8ce990$var$NodeRects() {
    function measure(node) {
        const { offsetTop: offsetTop, offsetLeft: offsetLeft, offsetWidth: offsetWidth, offsetHeight: offsetHeight } = node;
        const offset = {
            top: offsetTop,
            right: offsetLeft + offsetWidth,
            bottom: offsetTop + offsetHeight,
            left: offsetLeft,
            width: offsetWidth,
            height: offsetHeight
        };
        return offset;
    }
    const self = {
        measure: measure
    };
    return self;
}
function $3898885b5c8ce990$var$PercentOfView(viewSize) {
    function measure(n) {
        return viewSize * (n / 100);
    }
    const self = {
        measure: measure
    };
    return self;
}
function $3898885b5c8ce990$var$ResizeHandler(container, eventHandler, ownerWindow, slides, axis, watchResize, nodeRects) {
    const observeNodes = [
        container
    ].concat(slides);
    let resizeObserver;
    let containerSize;
    let slideSizes = [];
    let destroyed = false;
    function readSize(node) {
        return axis.measureSize(nodeRects.measure(node));
    }
    function init(emblaApi) {
        if (!watchResize) return;
        containerSize = readSize(container);
        slideSizes = slides.map(readSize);
        function defaultCallback(entries) {
            for (const entry of entries){
                if (destroyed) return;
                const isContainer = entry.target === container;
                const slideIndex = slides.indexOf(entry.target);
                const lastSize = isContainer ? containerSize : slideSizes[slideIndex];
                const newSize = readSize(isContainer ? container : slides[slideIndex]);
                const diffSize = $3898885b5c8ce990$var$mathAbs(newSize - lastSize);
                if (diffSize >= 0.5) {
                    emblaApi.reInit();
                    eventHandler.emit('resize');
                    break;
                }
            }
        }
        resizeObserver = new ResizeObserver((entries)=>{
            if ($3898885b5c8ce990$var$isBoolean(watchResize) || watchResize(emblaApi, entries)) defaultCallback(entries);
        });
        ownerWindow.requestAnimationFrame(()=>{
            observeNodes.forEach((node)=>resizeObserver.observe(node));
        });
    }
    function destroy() {
        destroyed = true;
        if (resizeObserver) resizeObserver.disconnect();
    }
    const self = {
        init: init,
        destroy: destroy
    };
    return self;
}
function $3898885b5c8ce990$var$ScrollBody(location, offsetLocation, previousLocation, target, baseDuration, baseFriction) {
    let scrollVelocity = 0;
    let scrollDirection = 0;
    let scrollDuration = baseDuration;
    let scrollFriction = baseFriction;
    let rawLocation = location.get();
    let rawLocationPrevious = 0;
    function seek() {
        const displacement = target.get() - location.get();
        const isInstant = !scrollDuration;
        let scrollDistance = 0;
        if (isInstant) {
            scrollVelocity = 0;
            previousLocation.set(target);
            location.set(target);
            scrollDistance = displacement;
        } else {
            previousLocation.set(location);
            scrollVelocity += displacement / scrollDuration;
            scrollVelocity *= scrollFriction;
            rawLocation += scrollVelocity;
            location.add(scrollVelocity);
            scrollDistance = rawLocation - rawLocationPrevious;
        }
        scrollDirection = $3898885b5c8ce990$var$mathSign(scrollDistance);
        rawLocationPrevious = rawLocation;
        return self;
    }
    function settled() {
        const diff = target.get() - offsetLocation.get();
        return $3898885b5c8ce990$var$mathAbs(diff) < 0.001;
    }
    function duration() {
        return scrollDuration;
    }
    function direction() {
        return scrollDirection;
    }
    function velocity() {
        return scrollVelocity;
    }
    function useBaseDuration() {
        return useDuration(baseDuration);
    }
    function useBaseFriction() {
        return useFriction(baseFriction);
    }
    function useDuration(n) {
        scrollDuration = n;
        return self;
    }
    function useFriction(n) {
        scrollFriction = n;
        return self;
    }
    const self = {
        direction: direction,
        duration: duration,
        velocity: velocity,
        seek: seek,
        settled: settled,
        useBaseFriction: useBaseFriction,
        useBaseDuration: useBaseDuration,
        useFriction: useFriction,
        useDuration: useDuration
    };
    return self;
}
function $3898885b5c8ce990$var$ScrollBounds(limit, location, target, scrollBody, percentOfView) {
    const pullBackThreshold = percentOfView.measure(10);
    const edgeOffsetTolerance = percentOfView.measure(50);
    const frictionLimit = $3898885b5c8ce990$var$Limit(0.1, 0.99);
    let disabled = false;
    function shouldConstrain() {
        if (disabled) return false;
        if (!limit.reachedAny(target.get())) return false;
        if (!limit.reachedAny(location.get())) return false;
        return true;
    }
    function constrain(pointerDown) {
        if (!shouldConstrain()) return;
        const edge = limit.reachedMin(location.get()) ? 'min' : 'max';
        const diffToEdge = $3898885b5c8ce990$var$mathAbs(limit[edge] - location.get());
        const diffToTarget = target.get() - location.get();
        const friction = frictionLimit.constrain(diffToEdge / edgeOffsetTolerance);
        target.subtract(diffToTarget * friction);
        if (!pointerDown && $3898885b5c8ce990$var$mathAbs(diffToTarget) < pullBackThreshold) {
            target.set(limit.constrain(target.get()));
            scrollBody.useDuration(25).useBaseFriction();
        }
    }
    function toggleActive(active) {
        disabled = !active;
    }
    const self = {
        shouldConstrain: shouldConstrain,
        constrain: constrain,
        toggleActive: toggleActive
    };
    return self;
}
function $3898885b5c8ce990$var$ScrollContain(viewSize, contentSize, snapsAligned, containScroll, pixelTolerance) {
    const scrollBounds = $3898885b5c8ce990$var$Limit(-contentSize + viewSize, 0);
    const snapsBounded = measureBounded();
    const scrollContainLimit = findScrollContainLimit();
    const snapsContained = measureContained();
    function usePixelTolerance(bound, snap) {
        return $3898885b5c8ce990$var$deltaAbs(bound, snap) <= 1;
    }
    function findScrollContainLimit() {
        const startSnap = snapsBounded[0];
        const endSnap = $3898885b5c8ce990$var$arrayLast(snapsBounded);
        const min = snapsBounded.lastIndexOf(startSnap);
        const max = snapsBounded.indexOf(endSnap) + 1;
        return $3898885b5c8ce990$var$Limit(min, max);
    }
    function measureBounded() {
        return snapsAligned.map((snapAligned, index)=>{
            const { min: min, max: max } = scrollBounds;
            const snap = scrollBounds.constrain(snapAligned);
            const isFirst = !index;
            const isLast = $3898885b5c8ce990$var$arrayIsLastIndex(snapsAligned, index);
            if (isFirst) return max;
            if (isLast) return min;
            if (usePixelTolerance(min, snap)) return min;
            if (usePixelTolerance(max, snap)) return max;
            return snap;
        }).map((scrollBound)=>parseFloat(scrollBound.toFixed(3)));
    }
    function measureContained() {
        if (contentSize <= viewSize + pixelTolerance) return [
            scrollBounds.max
        ];
        if (containScroll === 'keepSnaps') return snapsBounded;
        const { min: min, max: max } = scrollContainLimit;
        return snapsBounded.slice(min, max);
    }
    const self = {
        snapsContained: snapsContained,
        scrollContainLimit: scrollContainLimit
    };
    return self;
}
function $3898885b5c8ce990$var$ScrollLimit(contentSize, scrollSnaps, loop) {
    const max = scrollSnaps[0];
    const min = loop ? max - contentSize : $3898885b5c8ce990$var$arrayLast(scrollSnaps);
    const limit = $3898885b5c8ce990$var$Limit(min, max);
    const self = {
        limit: limit
    };
    return self;
}
function $3898885b5c8ce990$var$ScrollLooper(contentSize, limit, location, vectors) {
    const jointSafety = 0.1;
    const min = limit.min + jointSafety;
    const max = limit.max + jointSafety;
    const { reachedMin: reachedMin, reachedMax: reachedMax } = $3898885b5c8ce990$var$Limit(min, max);
    function shouldLoop(direction) {
        if (direction === 1) return reachedMax(location.get());
        if (direction === -1) return reachedMin(location.get());
        return false;
    }
    function loop(direction) {
        if (!shouldLoop(direction)) return;
        const loopDistance = contentSize * (direction * -1);
        vectors.forEach((v)=>v.add(loopDistance));
    }
    const self = {
        loop: loop
    };
    return self;
}
function $3898885b5c8ce990$var$ScrollProgress(limit) {
    const { max: max, length: length } = limit;
    function get(n) {
        const currentLocation = n - max;
        return length ? currentLocation / -length : 0;
    }
    const self = {
        get: get
    };
    return self;
}
function $3898885b5c8ce990$var$ScrollSnaps(axis, alignment, containerRect, slideRects, slidesToScroll) {
    const { startEdge: startEdge, endEdge: endEdge } = axis;
    const { groupSlides: groupSlides } = slidesToScroll;
    const alignments = measureSizes().map(alignment.measure);
    const snaps = measureUnaligned();
    const snapsAligned = measureAligned();
    function measureSizes() {
        return groupSlides(slideRects).map((rects)=>$3898885b5c8ce990$var$arrayLast(rects)[endEdge] - rects[0][startEdge]).map($3898885b5c8ce990$var$mathAbs);
    }
    function measureUnaligned() {
        return slideRects.map((rect)=>containerRect[startEdge] - rect[startEdge]).map((snap)=>-$3898885b5c8ce990$var$mathAbs(snap));
    }
    function measureAligned() {
        return groupSlides(snaps).map((g)=>g[0]).map((snap, index)=>snap + alignments[index]);
    }
    const self = {
        snaps: snaps,
        snapsAligned: snapsAligned
    };
    return self;
}
function $3898885b5c8ce990$var$SlideRegistry(containSnaps, containScroll, scrollSnaps, scrollContainLimit, slidesToScroll, slideIndexes) {
    const { groupSlides: groupSlides } = slidesToScroll;
    const { min: min, max: max } = scrollContainLimit;
    const slideRegistry = createSlideRegistry();
    function createSlideRegistry() {
        const groupedSlideIndexes = groupSlides(slideIndexes);
        const doNotContain = !containSnaps || containScroll === 'keepSnaps';
        if (scrollSnaps.length === 1) return [
            slideIndexes
        ];
        if (doNotContain) return groupedSlideIndexes;
        return groupedSlideIndexes.slice(min, max).map((group, index, groups)=>{
            const isFirst = !index;
            const isLast = $3898885b5c8ce990$var$arrayIsLastIndex(groups, index);
            if (isFirst) {
                const range = $3898885b5c8ce990$var$arrayLast(groups[0]) + 1;
                return $3898885b5c8ce990$var$arrayFromNumber(range);
            }
            if (isLast) {
                const range = $3898885b5c8ce990$var$arrayLastIndex(slideIndexes) - $3898885b5c8ce990$var$arrayLast(groups)[0] + 1;
                return $3898885b5c8ce990$var$arrayFromNumber(range, $3898885b5c8ce990$var$arrayLast(groups)[0]);
            }
            return group;
        });
    }
    const self = {
        slideRegistry: slideRegistry
    };
    return self;
}
function $3898885b5c8ce990$var$ScrollTarget(loop, scrollSnaps, contentSize, limit, targetVector) {
    const { reachedAny: reachedAny, removeOffset: removeOffset, constrain: constrain } = limit;
    function minDistance(distances) {
        return distances.concat().sort((a, b)=>$3898885b5c8ce990$var$mathAbs(a) - $3898885b5c8ce990$var$mathAbs(b))[0];
    }
    function findTargetSnap(target) {
        const distance = loop ? removeOffset(target) : constrain(target);
        const ascDiffsToSnaps = scrollSnaps.map((snap, index)=>({
                diff: shortcut(snap - distance, 0),
                index: index
            })).sort((d1, d2)=>$3898885b5c8ce990$var$mathAbs(d1.diff) - $3898885b5c8ce990$var$mathAbs(d2.diff));
        const { index: index } = ascDiffsToSnaps[0];
        return {
            index: index,
            distance: distance
        };
    }
    function shortcut(target, direction) {
        const targets = [
            target,
            target + contentSize,
            target - contentSize
        ];
        if (!loop) return target;
        if (!direction) return minDistance(targets);
        const matchingTargets = targets.filter((t)=>$3898885b5c8ce990$var$mathSign(t) === direction);
        if (matchingTargets.length) return minDistance(matchingTargets);
        return $3898885b5c8ce990$var$arrayLast(targets) - contentSize;
    }
    function byIndex(index, direction) {
        const diffToSnap = scrollSnaps[index] - targetVector.get();
        const distance = shortcut(diffToSnap, direction);
        return {
            index: index,
            distance: distance
        };
    }
    function byDistance(distance, snap) {
        const target = targetVector.get() + distance;
        const { index: index, distance: targetSnapDistance } = findTargetSnap(target);
        const reachedBound = !loop && reachedAny(target);
        if (!snap || reachedBound) return {
            index: index,
            distance: distance
        };
        const diffToSnap = scrollSnaps[index] - targetSnapDistance;
        const snapDistance = distance + shortcut(diffToSnap, 0);
        return {
            index: index,
            distance: snapDistance
        };
    }
    const self = {
        byDistance: byDistance,
        byIndex: byIndex,
        shortcut: shortcut
    };
    return self;
}
function $3898885b5c8ce990$var$ScrollTo(animation, indexCurrent, indexPrevious, scrollBody, scrollTarget, targetVector, eventHandler) {
    function scrollTo(target) {
        const distanceDiff = target.distance;
        const indexDiff = target.index !== indexCurrent.get();
        targetVector.add(distanceDiff);
        if (distanceDiff) {
            if (scrollBody.duration()) animation.start();
            else {
                animation.update();
                animation.render(1);
                animation.update();
            }
        }
        if (indexDiff) {
            indexPrevious.set(indexCurrent.get());
            indexCurrent.set(target.index);
            eventHandler.emit('select');
        }
    }
    function distance(n, snap) {
        const target = scrollTarget.byDistance(n, snap);
        scrollTo(target);
    }
    function index(n, direction) {
        const targetIndex = indexCurrent.clone().set(n);
        const target = scrollTarget.byIndex(targetIndex.get(), direction);
        scrollTo(target);
    }
    const self = {
        distance: distance,
        index: index
    };
    return self;
}
function $3898885b5c8ce990$var$SlideFocus(root, slides, slideRegistry, scrollTo, scrollBody, eventStore, eventHandler, watchFocus) {
    const focusListenerOptions = {
        passive: true,
        capture: true
    };
    let lastTabPressTime = 0;
    function init(emblaApi) {
        if (!watchFocus) return;
        function defaultCallback(index) {
            const nowTime = new Date().getTime();
            const diffTime = nowTime - lastTabPressTime;
            if (diffTime > 10) return;
            eventHandler.emit('slideFocusStart');
            root.scrollLeft = 0;
            const group = slideRegistry.findIndex((group)=>group.includes(index));
            if (!$3898885b5c8ce990$var$isNumber(group)) return;
            scrollBody.useDuration(0);
            scrollTo.index(group, 0);
            eventHandler.emit('slideFocus');
        }
        eventStore.add(document, 'keydown', registerTabPress, false);
        slides.forEach((slide, slideIndex)=>{
            eventStore.add(slide, 'focus', (evt)=>{
                if ($3898885b5c8ce990$var$isBoolean(watchFocus) || watchFocus(emblaApi, evt)) defaultCallback(slideIndex);
            }, focusListenerOptions);
        });
    }
    function registerTabPress(event) {
        if (event.code === 'Tab') lastTabPressTime = new Date().getTime();
    }
    const self = {
        init: init
    };
    return self;
}
function $3898885b5c8ce990$var$Vector1D(initialValue) {
    let value = initialValue;
    function get() {
        return value;
    }
    function set(n) {
        value = normalizeInput(n);
    }
    function add(n) {
        value += normalizeInput(n);
    }
    function subtract(n) {
        value -= normalizeInput(n);
    }
    function normalizeInput(n) {
        return $3898885b5c8ce990$var$isNumber(n) ? n : n.get();
    }
    const self = {
        get: get,
        set: set,
        add: add,
        subtract: subtract
    };
    return self;
}
function $3898885b5c8ce990$var$Translate(axis, container) {
    const translate = axis.scroll === 'x' ? x : y;
    const containerStyle = container.style;
    let previousTarget = null;
    let disabled = false;
    function x(n) {
        return `translate3d(${n}px,0px,0px)`;
    }
    function y(n) {
        return `translate3d(0px,${n}px,0px)`;
    }
    function to(target) {
        if (disabled) return;
        const newTarget = $3898885b5c8ce990$var$roundToTwoDecimals(axis.direction(target));
        if (newTarget === previousTarget) return;
        containerStyle.transform = translate(newTarget);
        previousTarget = newTarget;
    }
    function toggleActive(active) {
        disabled = !active;
    }
    function clear() {
        if (disabled) return;
        containerStyle.transform = '';
        if (!container.getAttribute('style')) container.removeAttribute('style');
    }
    const self = {
        clear: clear,
        to: to,
        toggleActive: toggleActive
    };
    return self;
}
function $3898885b5c8ce990$var$SlideLooper(axis, viewSize, contentSize, slideSizes, slideSizesWithGaps, snaps, scrollSnaps, location, slides) {
    const roundingSafety = 0.5;
    const ascItems = $3898885b5c8ce990$var$arrayKeys(slideSizesWithGaps);
    const descItems = $3898885b5c8ce990$var$arrayKeys(slideSizesWithGaps).reverse();
    const loopPoints = startPoints().concat(endPoints());
    function removeSlideSizes(indexes, from) {
        return indexes.reduce((a, i)=>{
            return a - slideSizesWithGaps[i];
        }, from);
    }
    function slidesInGap(indexes, gap) {
        return indexes.reduce((a, i)=>{
            const remainingGap = removeSlideSizes(a, gap);
            return remainingGap > 0 ? a.concat([
                i
            ]) : a;
        }, []);
    }
    function findSlideBounds(offset) {
        return snaps.map((snap, index)=>({
                start: snap - slideSizes[index] + roundingSafety + offset,
                end: snap + viewSize - roundingSafety + offset
            }));
    }
    function findLoopPoints(indexes, offset, isEndEdge) {
        const slideBounds = findSlideBounds(offset);
        return indexes.map((index)=>{
            const initial = isEndEdge ? 0 : -contentSize;
            const altered = isEndEdge ? contentSize : 0;
            const boundEdge = isEndEdge ? 'end' : 'start';
            const loopPoint = slideBounds[index][boundEdge];
            return {
                index: index,
                loopPoint: loopPoint,
                slideLocation: $3898885b5c8ce990$var$Vector1D(-1),
                translate: $3898885b5c8ce990$var$Translate(axis, slides[index]),
                target: ()=>location.get() > loopPoint ? initial : altered
            };
        });
    }
    function startPoints() {
        const gap = scrollSnaps[0];
        const indexes = slidesInGap(descItems, gap);
        return findLoopPoints(indexes, contentSize, false);
    }
    function endPoints() {
        const gap = viewSize - scrollSnaps[0] - 1;
        const indexes = slidesInGap(ascItems, gap);
        return findLoopPoints(indexes, -contentSize, true);
    }
    function canLoop() {
        return loopPoints.every(({ index: index })=>{
            const otherIndexes = ascItems.filter((i)=>i !== index);
            return removeSlideSizes(otherIndexes, viewSize) <= 0.1;
        });
    }
    function loop() {
        loopPoints.forEach((loopPoint)=>{
            const { target: target, translate: translate, slideLocation: slideLocation } = loopPoint;
            const shiftLocation = target();
            if (shiftLocation === slideLocation.get()) return;
            translate.to(shiftLocation);
            slideLocation.set(shiftLocation);
        });
    }
    function clear() {
        loopPoints.forEach((loopPoint)=>loopPoint.translate.clear());
    }
    const self = {
        canLoop: canLoop,
        clear: clear,
        loop: loop,
        loopPoints: loopPoints
    };
    return self;
}
function $3898885b5c8ce990$var$SlidesHandler(container, eventHandler, watchSlides) {
    let mutationObserver;
    let destroyed = false;
    function init(emblaApi) {
        if (!watchSlides) return;
        function defaultCallback(mutations) {
            for (const mutation of mutations)if (mutation.type === 'childList') {
                emblaApi.reInit();
                eventHandler.emit('slidesChanged');
                break;
            }
        }
        mutationObserver = new MutationObserver((mutations)=>{
            if (destroyed) return;
            if ($3898885b5c8ce990$var$isBoolean(watchSlides) || watchSlides(emblaApi, mutations)) defaultCallback(mutations);
        });
        mutationObserver.observe(container, {
            childList: true
        });
    }
    function destroy() {
        if (mutationObserver) mutationObserver.disconnect();
        destroyed = true;
    }
    const self = {
        init: init,
        destroy: destroy
    };
    return self;
}
function $3898885b5c8ce990$var$SlidesInView(container, slides, eventHandler, threshold) {
    const intersectionEntryMap = {};
    let inViewCache = null;
    let notInViewCache = null;
    let intersectionObserver;
    let destroyed = false;
    function init() {
        intersectionObserver = new IntersectionObserver((entries)=>{
            if (destroyed) return;
            entries.forEach((entry)=>{
                const index = slides.indexOf(entry.target);
                intersectionEntryMap[index] = entry;
            });
            inViewCache = null;
            notInViewCache = null;
            eventHandler.emit('slidesInView');
        }, {
            root: container.parentElement,
            threshold: threshold
        });
        slides.forEach((slide)=>intersectionObserver.observe(slide));
    }
    function destroy() {
        if (intersectionObserver) intersectionObserver.disconnect();
        destroyed = true;
    }
    function createInViewList(inView) {
        return $3898885b5c8ce990$var$objectKeys(intersectionEntryMap).reduce((list, slideIndex)=>{
            const index = parseInt(slideIndex);
            const { isIntersecting: isIntersecting } = intersectionEntryMap[index];
            const inViewMatch = inView && isIntersecting;
            const notInViewMatch = !inView && !isIntersecting;
            if (inViewMatch || notInViewMatch) list.push(index);
            return list;
        }, []);
    }
    function get(inView = true) {
        if (inView && inViewCache) return inViewCache;
        if (!inView && notInViewCache) return notInViewCache;
        const slideIndexes = createInViewList(inView);
        if (inView) inViewCache = slideIndexes;
        if (!inView) notInViewCache = slideIndexes;
        return slideIndexes;
    }
    const self = {
        init: init,
        destroy: destroy,
        get: get
    };
    return self;
}
function $3898885b5c8ce990$var$SlideSizes(axis, containerRect, slideRects, slides, readEdgeGap, ownerWindow) {
    const { measureSize: measureSize, startEdge: startEdge, endEdge: endEdge } = axis;
    const withEdgeGap = slideRects[0] && readEdgeGap;
    const startGap = measureStartGap();
    const endGap = measureEndGap();
    const slideSizes = slideRects.map(measureSize);
    const slideSizesWithGaps = measureWithGaps();
    function measureStartGap() {
        if (!withEdgeGap) return 0;
        const slideRect = slideRects[0];
        return $3898885b5c8ce990$var$mathAbs(containerRect[startEdge] - slideRect[startEdge]);
    }
    function measureEndGap() {
        if (!withEdgeGap) return 0;
        const style = ownerWindow.getComputedStyle($3898885b5c8ce990$var$arrayLast(slides));
        return parseFloat(style.getPropertyValue(`margin-${endEdge}`));
    }
    function measureWithGaps() {
        return slideRects.map((rect, index, rects)=>{
            const isFirst = !index;
            const isLast = $3898885b5c8ce990$var$arrayIsLastIndex(rects, index);
            if (isFirst) return slideSizes[index] + startGap;
            if (isLast) return slideSizes[index] + endGap;
            return rects[index + 1][startEdge] - rect[startEdge];
        }).map($3898885b5c8ce990$var$mathAbs);
    }
    const self = {
        slideSizes: slideSizes,
        slideSizesWithGaps: slideSizesWithGaps,
        startGap: startGap,
        endGap: endGap
    };
    return self;
}
function $3898885b5c8ce990$var$SlidesToScroll(axis, viewSize, slidesToScroll, loop, containerRect, slideRects, startGap, endGap, pixelTolerance) {
    const { startEdge: startEdge, endEdge: endEdge, direction: direction } = axis;
    const groupByNumber = $3898885b5c8ce990$var$isNumber(slidesToScroll);
    function byNumber(array, groupSize) {
        return $3898885b5c8ce990$var$arrayKeys(array).filter((i)=>i % groupSize === 0).map((i)=>array.slice(i, i + groupSize));
    }
    function bySize(array) {
        if (!array.length) return [];
        return $3898885b5c8ce990$var$arrayKeys(array).reduce((groups, rectB, index)=>{
            const rectA = $3898885b5c8ce990$var$arrayLast(groups) || 0;
            const isFirst = rectA === 0;
            const isLast = rectB === $3898885b5c8ce990$var$arrayLastIndex(array);
            const edgeA = containerRect[startEdge] - slideRects[rectA][startEdge];
            const edgeB = containerRect[startEdge] - slideRects[rectB][endEdge];
            const gapA = !loop && isFirst ? direction(startGap) : 0;
            const gapB = !loop && isLast ? direction(endGap) : 0;
            const chunkSize = $3898885b5c8ce990$var$mathAbs(edgeB - gapB - (edgeA + gapA));
            if (index && chunkSize > viewSize + pixelTolerance) groups.push(rectB);
            if (isLast) groups.push(array.length);
            return groups;
        }, []).map((currentSize, index, groups)=>{
            const previousSize = Math.max(groups[index - 1] || 0);
            return array.slice(previousSize, currentSize);
        });
    }
    function groupSlides(array) {
        return groupByNumber ? byNumber(array, slidesToScroll) : bySize(array);
    }
    const self = {
        groupSlides: groupSlides
    };
    return self;
}
function $3898885b5c8ce990$var$Engine(root, container, slides, ownerDocument, ownerWindow, options, eventHandler) {
    // Options
    const { align: align, axis: scrollAxis, direction: direction, startIndex: startIndex, loop: loop, duration: duration, dragFree: dragFree, dragThreshold: dragThreshold, inViewThreshold: inViewThreshold, slidesToScroll: groupSlides, skipSnaps: skipSnaps, containScroll: containScroll, watchResize: watchResize, watchSlides: watchSlides, watchDrag: watchDrag, watchFocus: watchFocus } = options;
    // Measurements
    const pixelTolerance = 2;
    const nodeRects = $3898885b5c8ce990$var$NodeRects();
    const containerRect = nodeRects.measure(container);
    const slideRects = slides.map(nodeRects.measure);
    const axis = $3898885b5c8ce990$var$Axis(scrollAxis, direction);
    const viewSize = axis.measureSize(containerRect);
    const percentOfView = $3898885b5c8ce990$var$PercentOfView(viewSize);
    const alignment = $3898885b5c8ce990$var$Alignment(align, viewSize);
    const containSnaps = !loop && !!containScroll;
    const readEdgeGap = loop || !!containScroll;
    const { slideSizes: slideSizes, slideSizesWithGaps: slideSizesWithGaps, startGap: startGap, endGap: endGap } = $3898885b5c8ce990$var$SlideSizes(axis, containerRect, slideRects, slides, readEdgeGap, ownerWindow);
    const slidesToScroll = $3898885b5c8ce990$var$SlidesToScroll(axis, viewSize, groupSlides, loop, containerRect, slideRects, startGap, endGap, pixelTolerance);
    const { snaps: snaps, snapsAligned: snapsAligned } = $3898885b5c8ce990$var$ScrollSnaps(axis, alignment, containerRect, slideRects, slidesToScroll);
    const contentSize = -$3898885b5c8ce990$var$arrayLast(snaps) + $3898885b5c8ce990$var$arrayLast(slideSizesWithGaps);
    const { snapsContained: snapsContained, scrollContainLimit: scrollContainLimit } = $3898885b5c8ce990$var$ScrollContain(viewSize, contentSize, snapsAligned, containScroll, pixelTolerance);
    const scrollSnaps = containSnaps ? snapsContained : snapsAligned;
    const { limit: limit } = $3898885b5c8ce990$var$ScrollLimit(contentSize, scrollSnaps, loop);
    // Indexes
    const index = $3898885b5c8ce990$var$Counter($3898885b5c8ce990$var$arrayLastIndex(scrollSnaps), startIndex, loop);
    const indexPrevious = index.clone();
    const slideIndexes = $3898885b5c8ce990$var$arrayKeys(slides);
    // Animation
    const update = ({ dragHandler: dragHandler, scrollBody: scrollBody, scrollBounds: scrollBounds, options: { loop: loop } })=>{
        if (!loop) scrollBounds.constrain(dragHandler.pointerDown());
        scrollBody.seek();
    };
    const render = ({ scrollBody: scrollBody, translate: translate, location: location, offsetLocation: offsetLocation, previousLocation: previousLocation, scrollLooper: scrollLooper, slideLooper: slideLooper, dragHandler: dragHandler, animation: animation, eventHandler: eventHandler, scrollBounds: scrollBounds, options: { loop: loop } }, alpha)=>{
        const shouldSettle = scrollBody.settled();
        const withinBounds = !scrollBounds.shouldConstrain();
        const hasSettled = loop ? shouldSettle : shouldSettle && withinBounds;
        const hasSettledAndIdle = hasSettled && !dragHandler.pointerDown();
        if (hasSettledAndIdle) animation.stop();
        const interpolatedLocation = location.get() * alpha + previousLocation.get() * (1 - alpha);
        offsetLocation.set(interpolatedLocation);
        if (loop) {
            scrollLooper.loop(scrollBody.direction());
            slideLooper.loop();
        }
        translate.to(offsetLocation.get());
        if (hasSettledAndIdle) eventHandler.emit('settle');
        if (!hasSettled) eventHandler.emit('scroll');
    };
    const animation = $3898885b5c8ce990$var$Animations(ownerDocument, ownerWindow, ()=>update(engine), (alpha)=>render(engine, alpha));
    // Shared
    const friction = 0.68;
    const startLocation = scrollSnaps[index.get()];
    const location = $3898885b5c8ce990$var$Vector1D(startLocation);
    const previousLocation = $3898885b5c8ce990$var$Vector1D(startLocation);
    const offsetLocation = $3898885b5c8ce990$var$Vector1D(startLocation);
    const target = $3898885b5c8ce990$var$Vector1D(startLocation);
    const scrollBody = $3898885b5c8ce990$var$ScrollBody(location, offsetLocation, previousLocation, target, duration, friction);
    const scrollTarget = $3898885b5c8ce990$var$ScrollTarget(loop, scrollSnaps, contentSize, limit, target);
    const scrollTo = $3898885b5c8ce990$var$ScrollTo(animation, index, indexPrevious, scrollBody, scrollTarget, target, eventHandler);
    const scrollProgress = $3898885b5c8ce990$var$ScrollProgress(limit);
    const eventStore = $3898885b5c8ce990$var$EventStore();
    const slidesInView = $3898885b5c8ce990$var$SlidesInView(container, slides, eventHandler, inViewThreshold);
    const { slideRegistry: slideRegistry } = $3898885b5c8ce990$var$SlideRegistry(containSnaps, containScroll, scrollSnaps, scrollContainLimit, slidesToScroll, slideIndexes);
    const slideFocus = $3898885b5c8ce990$var$SlideFocus(root, slides, slideRegistry, scrollTo, scrollBody, eventStore, eventHandler, watchFocus);
    // Engine
    const engine = {
        ownerDocument: ownerDocument,
        ownerWindow: ownerWindow,
        eventHandler: eventHandler,
        containerRect: containerRect,
        slideRects: slideRects,
        animation: animation,
        axis: axis,
        dragHandler: $3898885b5c8ce990$var$DragHandler(axis, root, ownerDocument, ownerWindow, target, $3898885b5c8ce990$var$DragTracker(axis, ownerWindow), location, animation, scrollTo, scrollBody, scrollTarget, index, eventHandler, percentOfView, dragFree, dragThreshold, skipSnaps, friction, watchDrag),
        eventStore: eventStore,
        percentOfView: percentOfView,
        index: index,
        indexPrevious: indexPrevious,
        limit: limit,
        location: location,
        offsetLocation: offsetLocation,
        previousLocation: previousLocation,
        options: options,
        resizeHandler: $3898885b5c8ce990$var$ResizeHandler(container, eventHandler, ownerWindow, slides, axis, watchResize, nodeRects),
        scrollBody: scrollBody,
        scrollBounds: $3898885b5c8ce990$var$ScrollBounds(limit, offsetLocation, target, scrollBody, percentOfView),
        scrollLooper: $3898885b5c8ce990$var$ScrollLooper(contentSize, limit, offsetLocation, [
            location,
            offsetLocation,
            previousLocation,
            target
        ]),
        scrollProgress: scrollProgress,
        scrollSnapList: scrollSnaps.map(scrollProgress.get),
        scrollSnaps: scrollSnaps,
        scrollTarget: scrollTarget,
        scrollTo: scrollTo,
        slideLooper: $3898885b5c8ce990$var$SlideLooper(axis, viewSize, contentSize, slideSizes, slideSizesWithGaps, snaps, scrollSnaps, offsetLocation, slides),
        slideFocus: slideFocus,
        slidesHandler: $3898885b5c8ce990$var$SlidesHandler(container, eventHandler, watchSlides),
        slidesInView: slidesInView,
        slideIndexes: slideIndexes,
        slideRegistry: slideRegistry,
        slidesToScroll: slidesToScroll,
        target: target,
        translate: $3898885b5c8ce990$var$Translate(axis, container)
    };
    return engine;
}
function $3898885b5c8ce990$var$EventHandler() {
    let listeners = {};
    let api;
    function init(emblaApi) {
        api = emblaApi;
    }
    function getListeners(evt) {
        return listeners[evt] || [];
    }
    function emit(evt) {
        getListeners(evt).forEach((e)=>e(api, evt));
        return self;
    }
    function on(evt, cb) {
        listeners[evt] = getListeners(evt).concat([
            cb
        ]);
        return self;
    }
    function off(evt, cb) {
        listeners[evt] = getListeners(evt).filter((e)=>e !== cb);
        return self;
    }
    function clear() {
        listeners = {};
    }
    const self = {
        init: init,
        emit: emit,
        off: off,
        on: on,
        clear: clear
    };
    return self;
}
const $3898885b5c8ce990$var$defaultOptions = {
    align: 'center',
    axis: 'x',
    container: null,
    slides: null,
    containScroll: 'trimSnaps',
    direction: 'ltr',
    slidesToScroll: 1,
    inViewThreshold: 0,
    breakpoints: {},
    dragFree: false,
    dragThreshold: 10,
    loop: false,
    skipSnaps: false,
    duration: 25,
    startIndex: 0,
    active: true,
    watchDrag: true,
    watchResize: true,
    watchSlides: true,
    watchFocus: true
};
function $3898885b5c8ce990$var$OptionsHandler(ownerWindow) {
    function mergeOptions(optionsA, optionsB) {
        return $3898885b5c8ce990$var$objectsMergeDeep(optionsA, optionsB || {});
    }
    function optionsAtMedia(options) {
        const optionsAtMedia = options.breakpoints || {};
        const matchedMediaOptions = $3898885b5c8ce990$var$objectKeys(optionsAtMedia).filter((media)=>ownerWindow.matchMedia(media).matches).map((media)=>optionsAtMedia[media]).reduce((a, mediaOption)=>mergeOptions(a, mediaOption), {});
        return mergeOptions(options, matchedMediaOptions);
    }
    function optionsMediaQueries(optionsList) {
        return optionsList.map((options)=>$3898885b5c8ce990$var$objectKeys(options.breakpoints || {})).reduce((acc, mediaQueries)=>acc.concat(mediaQueries), []).map(ownerWindow.matchMedia);
    }
    const self = {
        mergeOptions: mergeOptions,
        optionsAtMedia: optionsAtMedia,
        optionsMediaQueries: optionsMediaQueries
    };
    return self;
}
function $3898885b5c8ce990$var$PluginsHandler(optionsHandler) {
    let activePlugins = [];
    function init(emblaApi, plugins) {
        activePlugins = plugins.filter(({ options: options })=>optionsHandler.optionsAtMedia(options).active !== false);
        activePlugins.forEach((plugin)=>plugin.init(emblaApi, optionsHandler));
        return plugins.reduce((map, plugin)=>Object.assign(map, {
                [plugin.name]: plugin
            }), {});
    }
    function destroy() {
        activePlugins = activePlugins.filter((plugin)=>plugin.destroy());
    }
    const self = {
        init: init,
        destroy: destroy
    };
    return self;
}
function $3898885b5c8ce990$export$2e2bcd8739ae039(root, userOptions, userPlugins) {
    const ownerDocument = root.ownerDocument;
    const ownerWindow = ownerDocument.defaultView;
    const optionsHandler = $3898885b5c8ce990$var$OptionsHandler(ownerWindow);
    const pluginsHandler = $3898885b5c8ce990$var$PluginsHandler(optionsHandler);
    const mediaHandlers = $3898885b5c8ce990$var$EventStore();
    const eventHandler = $3898885b5c8ce990$var$EventHandler();
    const { mergeOptions: mergeOptions, optionsAtMedia: optionsAtMedia, optionsMediaQueries: optionsMediaQueries } = optionsHandler;
    const { on: on, off: off, emit: emit } = eventHandler;
    const reInit = reActivate;
    let destroyed = false;
    let engine;
    let optionsBase = mergeOptions($3898885b5c8ce990$var$defaultOptions, $3898885b5c8ce990$export$2e2bcd8739ae039.globalOptions);
    let options = mergeOptions(optionsBase);
    let pluginList = [];
    let pluginApis;
    let container;
    let slides;
    function storeElements() {
        const { container: userContainer, slides: userSlides } = options;
        const customContainer = $3898885b5c8ce990$var$isString(userContainer) ? root.querySelector(userContainer) : userContainer;
        container = customContainer || root.children[0];
        const customSlides = $3898885b5c8ce990$var$isString(userSlides) ? container.querySelectorAll(userSlides) : userSlides;
        slides = [].slice.call(customSlides || container.children);
    }
    function createEngine(options) {
        const engine = $3898885b5c8ce990$var$Engine(root, container, slides, ownerDocument, ownerWindow, options, eventHandler);
        if (options.loop && !engine.slideLooper.canLoop()) {
            const optionsWithoutLoop = Object.assign({}, options, {
                loop: false
            });
            return createEngine(optionsWithoutLoop);
        }
        return engine;
    }
    function activate(withOptions, withPlugins) {
        if (destroyed) return;
        optionsBase = mergeOptions(optionsBase, withOptions);
        options = optionsAtMedia(optionsBase);
        pluginList = withPlugins || pluginList;
        storeElements();
        engine = createEngine(options);
        optionsMediaQueries([
            optionsBase,
            ...pluginList.map(({ options: options })=>options)
        ]).forEach((query)=>mediaHandlers.add(query, 'change', reActivate));
        if (!options.active) return;
        engine.translate.to(engine.location.get());
        engine.animation.init();
        engine.slidesInView.init();
        engine.slideFocus.init(self);
        engine.eventHandler.init(self);
        engine.resizeHandler.init(self);
        engine.slidesHandler.init(self);
        if (engine.options.loop) engine.slideLooper.loop();
        if (container.offsetParent && slides.length) engine.dragHandler.init(self);
        pluginApis = pluginsHandler.init(self, pluginList);
    }
    function reActivate(withOptions, withPlugins) {
        const startIndex = selectedScrollSnap();
        deActivate();
        activate(mergeOptions({
            startIndex: startIndex
        }, withOptions), withPlugins);
        eventHandler.emit('reInit');
    }
    function deActivate() {
        engine.dragHandler.destroy();
        engine.eventStore.clear();
        engine.translate.clear();
        engine.slideLooper.clear();
        engine.resizeHandler.destroy();
        engine.slidesHandler.destroy();
        engine.slidesInView.destroy();
        engine.animation.destroy();
        pluginsHandler.destroy();
        mediaHandlers.clear();
    }
    function destroy() {
        if (destroyed) return;
        destroyed = true;
        mediaHandlers.clear();
        deActivate();
        eventHandler.emit('destroy');
        eventHandler.clear();
    }
    function scrollTo(index, jump, direction) {
        if (!options.active || destroyed) return;
        engine.scrollBody.useBaseFriction().useDuration(jump === true ? 0 : options.duration);
        engine.scrollTo.index(index, direction || 0);
    }
    function scrollNext(jump) {
        const next = engine.index.add(1).get();
        scrollTo(next, jump, -1);
    }
    function scrollPrev(jump) {
        const prev = engine.index.add(-1).get();
        scrollTo(prev, jump, 1);
    }
    function canScrollNext() {
        const next = engine.index.add(1).get();
        return next !== selectedScrollSnap();
    }
    function canScrollPrev() {
        const prev = engine.index.add(-1).get();
        return prev !== selectedScrollSnap();
    }
    function scrollSnapList() {
        return engine.scrollSnapList;
    }
    function scrollProgress() {
        return engine.scrollProgress.get(engine.offsetLocation.get());
    }
    function selectedScrollSnap() {
        return engine.index.get();
    }
    function previousScrollSnap() {
        return engine.indexPrevious.get();
    }
    function slidesInView() {
        return engine.slidesInView.get();
    }
    function slidesNotInView() {
        return engine.slidesInView.get(false);
    }
    function plugins() {
        return pluginApis;
    }
    function internalEngine() {
        return engine;
    }
    function rootNode() {
        return root;
    }
    function containerNode() {
        return container;
    }
    function slideNodes() {
        return slides;
    }
    const self = {
        canScrollNext: canScrollNext,
        canScrollPrev: canScrollPrev,
        containerNode: containerNode,
        internalEngine: internalEngine,
        destroy: destroy,
        off: off,
        on: on,
        emit: emit,
        plugins: plugins,
        previousScrollSnap: previousScrollSnap,
        reInit: reInit,
        rootNode: rootNode,
        scrollNext: scrollNext,
        scrollPrev: scrollPrev,
        scrollProgress: scrollProgress,
        scrollSnapList: scrollSnapList,
        scrollTo: scrollTo,
        selectedScrollSnap: selectedScrollSnap,
        slideNodes: slideNodes,
        slidesInView: slidesInView,
        slidesNotInView: slidesNotInView
    };
    activate(userOptions, userPlugins);
    setTimeout(()=>eventHandler.emit('init'), 0);
    return self;
}
$3898885b5c8ce990$export$2e2bcd8739ae039.globalOptions = undefined;

});

parcelRegister("gITAg", function(module, exports) {

$parcel$export(module.exports, "Fancybox", () => $c2cbdf39c20c8a0e$export$cb45b08d97cdc4fd);
const $c2cbdf39c20c8a0e$var$t = (t, e = 1e4)=>(t = parseFloat(t + "") || 0, Math.round((t + Number.EPSILON) * e) / e), $c2cbdf39c20c8a0e$var$e = function(t) {
    if (!(t && t instanceof Element && t.offsetParent)) return !1;
    const e = t.scrollHeight > t.clientHeight, i = window.getComputedStyle(t).overflowY, n = -1 !== i.indexOf("hidden"), s = -1 !== i.indexOf("visible");
    return e && !n && !s;
}, $c2cbdf39c20c8a0e$var$i = function(t, n) {
    return !(!t || t === document.body || n && t === n) && ($c2cbdf39c20c8a0e$var$e(t) ? t : $c2cbdf39c20c8a0e$var$i(t.parentElement, n));
}, $c2cbdf39c20c8a0e$var$n = function(t) {
    var e = (new DOMParser).parseFromString(t, "text/html").body;
    if (e.childElementCount > 1) {
        for(var i = document.createElement("div"); e.firstChild;)i.appendChild(e.firstChild);
        return i;
    }
    return e.firstChild;
}, $c2cbdf39c20c8a0e$var$s = (t)=>`${t || ""}`.split(" ").filter((t)=>!!t), $c2cbdf39c20c8a0e$var$o = (t, e, i)=>{
    t && $c2cbdf39c20c8a0e$var$s(e).forEach((e)=>{
        t.classList.toggle(e, i || !1);
    });
};
class $c2cbdf39c20c8a0e$var$a {
    constructor(t){
        Object.defineProperty(this, "pageX", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "pageY", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "clientX", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "clientY", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "id", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "time", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "nativePointer", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), this.nativePointer = t, this.pageX = t.pageX, this.pageY = t.pageY, this.clientX = t.clientX, this.clientY = t.clientY, this.id = self.Touch && t instanceof Touch ? t.identifier : -1, this.time = Date.now();
    }
}
const $c2cbdf39c20c8a0e$var$r = {
    passive: !1
};
class $c2cbdf39c20c8a0e$var$l {
    constructor(t, { start: e = ()=>!0, move: i = ()=>{}, end: n = ()=>{} }){
        Object.defineProperty(this, "element", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "startCallback", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "moveCallback", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "endCallback", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "currentPointers", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: []
        }), Object.defineProperty(this, "startPointers", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: []
        }), this.element = t, this.startCallback = e, this.moveCallback = i, this.endCallback = n;
        for (const t of [
            "onPointerStart",
            "onTouchStart",
            "onMove",
            "onTouchEnd",
            "onPointerEnd",
            "onWindowBlur"
        ])this[t] = this[t].bind(this);
        this.element.addEventListener("mousedown", this.onPointerStart, $c2cbdf39c20c8a0e$var$r), this.element.addEventListener("touchstart", this.onTouchStart, $c2cbdf39c20c8a0e$var$r), this.element.addEventListener("touchmove", this.onMove, $c2cbdf39c20c8a0e$var$r), this.element.addEventListener("touchend", this.onTouchEnd), this.element.addEventListener("touchcancel", this.onTouchEnd);
    }
    onPointerStart(t) {
        if (!t.buttons || 0 !== t.button) return;
        const e = new $c2cbdf39c20c8a0e$var$a(t);
        this.currentPointers.some((t)=>t.id === e.id) || this.triggerPointerStart(e, t) && (window.addEventListener("mousemove", this.onMove), window.addEventListener("mouseup", this.onPointerEnd), window.addEventListener("blur", this.onWindowBlur));
    }
    onTouchStart(t) {
        for (const e of Array.from(t.changedTouches || []))this.triggerPointerStart(new $c2cbdf39c20c8a0e$var$a(e), t);
        window.addEventListener("blur", this.onWindowBlur);
    }
    onMove(t) {
        const e = this.currentPointers.slice(), i = "changedTouches" in t ? Array.from(t.changedTouches || []).map((t)=>new $c2cbdf39c20c8a0e$var$a(t)) : [
            new $c2cbdf39c20c8a0e$var$a(t)
        ], n = [];
        for (const t of i){
            const e = this.currentPointers.findIndex((e)=>e.id === t.id);
            e < 0 || (n.push(t), this.currentPointers[e] = t);
        }
        n.length && this.moveCallback(t, this.currentPointers.slice(), e);
    }
    onPointerEnd(t) {
        t.buttons > 0 && 0 !== t.button || (this.triggerPointerEnd(t, new $c2cbdf39c20c8a0e$var$a(t)), window.removeEventListener("mousemove", this.onMove), window.removeEventListener("mouseup", this.onPointerEnd), window.removeEventListener("blur", this.onWindowBlur));
    }
    onTouchEnd(t) {
        for (const e of Array.from(t.changedTouches || []))this.triggerPointerEnd(t, new $c2cbdf39c20c8a0e$var$a(e));
    }
    triggerPointerStart(t, e) {
        return !!this.startCallback(e, t, this.currentPointers.slice()) && (this.currentPointers.push(t), this.startPointers.push(t), !0);
    }
    triggerPointerEnd(t, e) {
        const i = this.currentPointers.findIndex((t)=>t.id === e.id);
        i < 0 || (this.currentPointers.splice(i, 1), this.startPointers.splice(i, 1), this.endCallback(t, e, this.currentPointers.slice()));
    }
    onWindowBlur() {
        this.clear();
    }
    clear() {
        for(; this.currentPointers.length;){
            const t = this.currentPointers[this.currentPointers.length - 1];
            this.currentPointers.splice(this.currentPointers.length - 1, 1), this.startPointers.splice(this.currentPointers.length - 1, 1), this.endCallback(new Event("touchend", {
                bubbles: !0,
                cancelable: !0,
                clientX: t.clientX,
                clientY: t.clientY
            }), t, this.currentPointers.slice());
        }
    }
    stop() {
        this.element.removeEventListener("mousedown", this.onPointerStart, $c2cbdf39c20c8a0e$var$r), this.element.removeEventListener("touchstart", this.onTouchStart, $c2cbdf39c20c8a0e$var$r), this.element.removeEventListener("touchmove", this.onMove, $c2cbdf39c20c8a0e$var$r), this.element.removeEventListener("touchend", this.onTouchEnd), this.element.removeEventListener("touchcancel", this.onTouchEnd), window.removeEventListener("mousemove", this.onMove), window.removeEventListener("mouseup", this.onPointerEnd), window.removeEventListener("blur", this.onWindowBlur);
    }
}
function $c2cbdf39c20c8a0e$var$c(t, e) {
    return e ? Math.sqrt(Math.pow(e.clientX - t.clientX, 2) + Math.pow(e.clientY - t.clientY, 2)) : 0;
}
function $c2cbdf39c20c8a0e$var$h(t, e) {
    return e ? {
        clientX: (t.clientX + e.clientX) / 2,
        clientY: (t.clientY + e.clientY) / 2
    } : t;
}
const $c2cbdf39c20c8a0e$var$d = (t)=>"object" == typeof t && null !== t && t.constructor === Object && "[object Object]" === Object.prototype.toString.call(t), $c2cbdf39c20c8a0e$var$u = (t, ...e)=>{
    const i = e.length;
    for(let n = 0; n < i; n++){
        const i = e[n] || {};
        Object.entries(i).forEach(([e, i])=>{
            const n = Array.isArray(i) ? [] : {};
            t[e] || Object.assign(t, {
                [e]: n
            }), $c2cbdf39c20c8a0e$var$d(i) ? Object.assign(t[e], $c2cbdf39c20c8a0e$var$u(n, i)) : Array.isArray(i) ? Object.assign(t, {
                [e]: [
                    ...i
                ]
            }) : Object.assign(t, {
                [e]: i
            });
        });
    }
    return t;
}, $c2cbdf39c20c8a0e$var$p = function(t, e) {
    return t.split(".").reduce((t, e)=>"object" == typeof t ? t[e] : void 0, e);
};
class $c2cbdf39c20c8a0e$var$f {
    constructor(t = {}){
        Object.defineProperty(this, "options", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: t
        }), Object.defineProperty(this, "events", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: new Map
        }), this.setOptions(t);
        for (const t of Object.getOwnPropertyNames(Object.getPrototypeOf(this)))t.startsWith("on") && "function" == typeof this[t] && (this[t] = this[t].bind(this));
    }
    setOptions(t) {
        this.options = t ? $c2cbdf39c20c8a0e$var$u({}, this.constructor.defaults, t) : {};
        for (const [t, e] of Object.entries(this.option("on") || {}))this.on(t, e);
    }
    option(t, ...e) {
        let i = $c2cbdf39c20c8a0e$var$p(t, this.options);
        return i && "function" == typeof i && (i = i.call(this, this, ...e)), i;
    }
    optionFor(t, e, i, ...n) {
        let s = $c2cbdf39c20c8a0e$var$p(e, t);
        var o;
        "string" != typeof (o = s) || isNaN(o) || isNaN(parseFloat(o)) || (s = parseFloat(s)), "true" === s && (s = !0), "false" === s && (s = !1), s && "function" == typeof s && (s = s.call(this, this, t, ...n));
        let a = $c2cbdf39c20c8a0e$var$p(e, this.options);
        return a && "function" == typeof a ? s = a.call(this, this, t, ...n, s) : void 0 === s && (s = a), void 0 === s ? i : s;
    }
    cn(t) {
        const e = this.options.classes;
        return e && e[t] || "";
    }
    localize(t, e = []) {
        t = String(t).replace(/\{\{(\w+).?(\w+)?\}\}/g, (t, e, i)=>{
            let n = "";
            return i ? n = this.option(`${e[0] + e.toLowerCase().substring(1)}.l10n.${i}`) : e && (n = this.option(`l10n.${e}`)), n || (n = t), n;
        });
        for(let i = 0; i < e.length; i++)t = t.split(e[i][0]).join(e[i][1]);
        return t = t.replace(/\{\{(.*?)\}\}/g, (t, e)=>e);
    }
    on(t, e) {
        let i = [];
        "string" == typeof t ? i = t.split(" ") : Array.isArray(t) && (i = t), this.events || (this.events = new Map), i.forEach((t)=>{
            let i = this.events.get(t);
            i || (this.events.set(t, []), i = []), i.includes(e) || i.push(e), this.events.set(t, i);
        });
    }
    off(t, e) {
        let i = [];
        "string" == typeof t ? i = t.split(" ") : Array.isArray(t) && (i = t), i.forEach((t)=>{
            const i = this.events.get(t);
            if (Array.isArray(i)) {
                const t = i.indexOf(e);
                t > -1 && i.splice(t, 1);
            }
        });
    }
    emit(t, ...e) {
        [
            ...this.events.get(t) || []
        ].forEach((t)=>t(this, ...e)), "*" !== t && this.emit("*", t, ...e);
    }
}
Object.defineProperty($c2cbdf39c20c8a0e$var$f, "version", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: "5.0.36"
}), Object.defineProperty($c2cbdf39c20c8a0e$var$f, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: {}
});
class $c2cbdf39c20c8a0e$var$g extends $c2cbdf39c20c8a0e$var$f {
    constructor(t = {}){
        super(t), Object.defineProperty(this, "plugins", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: {}
        });
    }
    attachPlugins(t = {}) {
        const e = new Map;
        for (const [i, n] of Object.entries(t)){
            const t = this.option(i), s = this.plugins[i];
            s || !1 === t ? s && !1 === t && (s.detach(), delete this.plugins[i]) : e.set(i, new n(this, t || {}));
        }
        for (const [t, i] of e)this.plugins[t] = i, i.attach();
    }
    detachPlugins(t) {
        t = t || Object.keys(this.plugins);
        for (const e of t){
            const t = this.plugins[e];
            t && t.detach(), delete this.plugins[e];
        }
        return this.emit("detachPlugins"), this;
    }
}
var $c2cbdf39c20c8a0e$var$m;
!function(t) {
    t[t.Init = 0] = "Init", t[t.Error = 1] = "Error", t[t.Ready = 2] = "Ready", t[t.Panning = 3] = "Panning", t[t.Mousemove = 4] = "Mousemove", t[t.Destroy = 5] = "Destroy";
}($c2cbdf39c20c8a0e$var$m || ($c2cbdf39c20c8a0e$var$m = {}));
const $c2cbdf39c20c8a0e$var$v = [
    "a",
    "b",
    "c",
    "d",
    "e",
    "f"
], $c2cbdf39c20c8a0e$var$b = {
    PANUP: "Move up",
    PANDOWN: "Move down",
    PANLEFT: "Move left",
    PANRIGHT: "Move right",
    ZOOMIN: "Zoom in",
    ZOOMOUT: "Zoom out",
    TOGGLEZOOM: "Toggle zoom level",
    TOGGLE1TO1: "Toggle zoom level",
    ITERATEZOOM: "Toggle zoom level",
    ROTATECCW: "Rotate counterclockwise",
    ROTATECW: "Rotate clockwise",
    FLIPX: "Flip horizontally",
    FLIPY: "Flip vertically",
    FITX: "Fit horizontally",
    FITY: "Fit vertically",
    RESET: "Reset",
    TOGGLEFS: "Toggle fullscreen"
}, $c2cbdf39c20c8a0e$var$y = {
    content: null,
    width: "auto",
    height: "auto",
    panMode: "drag",
    touch: !0,
    dragMinThreshold: 3,
    lockAxis: !1,
    mouseMoveFactor: 1,
    mouseMoveFriction: .12,
    zoom: !0,
    pinchToZoom: !0,
    panOnlyZoomed: "auto",
    minScale: 1,
    maxScale: 2,
    friction: .25,
    dragFriction: .35,
    decelFriction: .05,
    click: "toggleZoom",
    dblClick: !1,
    wheel: "zoom",
    wheelLimit: 7,
    spinner: !0,
    bounds: "auto",
    infinite: !1,
    rubberband: !0,
    bounce: !0,
    maxVelocity: 75,
    transformParent: !1,
    classes: {
        content: "f-panzoom__content",
        isLoading: "is-loading",
        canZoomIn: "can-zoom_in",
        canZoomOut: "can-zoom_out",
        isDraggable: "is-draggable",
        isDragging: "is-dragging",
        inFullscreen: "in-fullscreen",
        htmlHasFullscreen: "with-panzoom-in-fullscreen"
    },
    l10n: $c2cbdf39c20c8a0e$var$b
}, $c2cbdf39c20c8a0e$var$w = '<circle cx="25" cy="25" r="20"></circle>', $c2cbdf39c20c8a0e$var$x = '<div class="f-spinner"><svg viewBox="0 0 50 50">' + $c2cbdf39c20c8a0e$var$w + $c2cbdf39c20c8a0e$var$w + "</svg></div>", $c2cbdf39c20c8a0e$var$E = (t)=>t && null !== t && t instanceof Element && "nodeType" in t, $c2cbdf39c20c8a0e$var$S = (t, e)=>{
    t && $c2cbdf39c20c8a0e$var$s(e).forEach((e)=>{
        t.classList.remove(e);
    });
}, $c2cbdf39c20c8a0e$var$P = (t, e)=>{
    t && $c2cbdf39c20c8a0e$var$s(e).forEach((e)=>{
        t.classList.add(e);
    });
}, $c2cbdf39c20c8a0e$var$C = {
    a: 1,
    b: 0,
    c: 0,
    d: 1,
    e: 0,
    f: 0
}, $c2cbdf39c20c8a0e$var$T = 1e5, $c2cbdf39c20c8a0e$var$M = 1e4, $c2cbdf39c20c8a0e$var$O = "mousemove", $c2cbdf39c20c8a0e$var$A = "drag", $c2cbdf39c20c8a0e$var$L = "content", $c2cbdf39c20c8a0e$var$z = "auto";
let $c2cbdf39c20c8a0e$var$R = null, $c2cbdf39c20c8a0e$var$k = null;
class $c2cbdf39c20c8a0e$export$b704d075ddd20210 extends $c2cbdf39c20c8a0e$var$g {
    get fits() {
        return this.contentRect.width - this.contentRect.fitWidth < 1 && this.contentRect.height - this.contentRect.fitHeight < 1;
    }
    get isTouchDevice() {
        return null === $c2cbdf39c20c8a0e$var$k && ($c2cbdf39c20c8a0e$var$k = window.matchMedia("(hover: none)").matches), $c2cbdf39c20c8a0e$var$k;
    }
    get isMobile() {
        return null === $c2cbdf39c20c8a0e$var$R && ($c2cbdf39c20c8a0e$var$R = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)), $c2cbdf39c20c8a0e$var$R;
    }
    get panMode() {
        return this.options.panMode !== $c2cbdf39c20c8a0e$var$O || this.isTouchDevice ? $c2cbdf39c20c8a0e$var$A : $c2cbdf39c20c8a0e$var$O;
    }
    get panOnlyZoomed() {
        const t = this.options.panOnlyZoomed;
        return t === $c2cbdf39c20c8a0e$var$z ? this.isTouchDevice : t;
    }
    get isInfinite() {
        return this.option("infinite");
    }
    get angle() {
        return 180 * Math.atan2(this.current.b, this.current.a) / Math.PI || 0;
    }
    get targetAngle() {
        return 180 * Math.atan2(this.target.b, this.target.a) / Math.PI || 0;
    }
    get scale() {
        const { a: t, b: e } = this.current;
        return Math.sqrt(t * t + e * e) || 1;
    }
    get targetScale() {
        const { a: t, b: e } = this.target;
        return Math.sqrt(t * t + e * e) || 1;
    }
    get minScale() {
        return this.option("minScale") || 1;
    }
    get fullScale() {
        const { contentRect: t } = this;
        return t.fullWidth / t.fitWidth || 1;
    }
    get maxScale() {
        return this.fullScale * (this.option("maxScale") || 1) || 1;
    }
    get coverScale() {
        const { containerRect: t, contentRect: e } = this, i = Math.max(t.height / e.fitHeight, t.width / e.fitWidth) || 1;
        return Math.min(this.fullScale, i);
    }
    get isScaling() {
        return Math.abs(this.targetScale - this.scale) > 1e-5 && !this.isResting;
    }
    get isContentLoading() {
        const t = this.content;
        return !!(t && t instanceof HTMLImageElement) && !t.complete;
    }
    get isResting() {
        if (this.isBouncingX || this.isBouncingY) return !1;
        for (const t of $c2cbdf39c20c8a0e$var$v){
            const e = "e" == t || "f" === t ? 1e-4 : 1e-5;
            if (Math.abs(this.target[t] - this.current[t]) > e) return !1;
        }
        return !(!this.ignoreBounds && !this.checkBounds().inBounds);
    }
    constructor(t, e = {}, i = {}){
        var s;
        if (super(e), Object.defineProperty(this, "pointerTracker", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "resizeObserver", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "updateTimer", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "clickTimer", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "rAF", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "isTicking", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "ignoreBounds", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "isBouncingX", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "isBouncingY", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "clicks", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "trackingPoints", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: []
        }), Object.defineProperty(this, "pwt", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "cwd", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "pmme", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "friction", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "state", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $c2cbdf39c20c8a0e$var$m.Init
        }), Object.defineProperty(this, "isDragging", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "container", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "content", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "spinner", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "containerRect", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: {
                width: 0,
                height: 0,
                innerWidth: 0,
                innerHeight: 0
            }
        }), Object.defineProperty(this, "contentRect", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: {
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
                fullWidth: 0,
                fullHeight: 0,
                fitWidth: 0,
                fitHeight: 0,
                width: 0,
                height: 0
            }
        }), Object.defineProperty(this, "dragStart", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: {
                x: 0,
                y: 0,
                top: 0,
                left: 0,
                time: 0
            }
        }), Object.defineProperty(this, "dragOffset", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: {
                x: 0,
                y: 0,
                time: 0
            }
        }), Object.defineProperty(this, "current", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: Object.assign({}, $c2cbdf39c20c8a0e$var$C)
        }), Object.defineProperty(this, "target", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: Object.assign({}, $c2cbdf39c20c8a0e$var$C)
        }), Object.defineProperty(this, "velocity", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: {
                a: 0,
                b: 0,
                c: 0,
                d: 0,
                e: 0,
                f: 0
            }
        }), Object.defineProperty(this, "lockedAxis", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), !t) throw new Error("Container Element Not Found");
        this.container = t, this.initContent(), this.attachPlugins(Object.assign(Object.assign({}, $c2cbdf39c20c8a0e$export$b704d075ddd20210.Plugins), i)), this.emit("attachPlugins"), this.emit("init");
        const o = this.content;
        if (o.addEventListener("load", this.onLoad), o.addEventListener("error", this.onError), this.isContentLoading) {
            if (this.option("spinner")) {
                t.classList.add(this.cn("isLoading"));
                const e = $c2cbdf39c20c8a0e$var$n($c2cbdf39c20c8a0e$var$x);
                !t.contains(o) || o.parentElement instanceof HTMLPictureElement ? this.spinner = t.appendChild(e) : this.spinner = (null === (s = o.parentElement) || void 0 === s ? void 0 : s.insertBefore(e, o)) || null;
            }
            this.emit("beforeLoad");
        } else queueMicrotask(()=>{
            this.enable();
        });
    }
    initContent() {
        const { container: t } = this, e = this.cn($c2cbdf39c20c8a0e$var$L);
        let i = this.option($c2cbdf39c20c8a0e$var$L) || t.querySelector(`.${e}`);
        if (i || (i = t.querySelector("img,picture") || t.firstElementChild, i && $c2cbdf39c20c8a0e$var$P(i, e)), i instanceof HTMLPictureElement && (i = i.querySelector("img")), !i) throw new Error("No content found");
        this.content = i;
    }
    onLoad() {
        const { spinner: t, container: e, state: i } = this;
        t && (t.remove(), this.spinner = null), this.option("spinner") && e.classList.remove(this.cn("isLoading")), this.emit("afterLoad"), i === $c2cbdf39c20c8a0e$var$m.Init ? this.enable() : this.updateMetrics();
    }
    onError() {
        this.state !== $c2cbdf39c20c8a0e$var$m.Destroy && (this.spinner && (this.spinner.remove(), this.spinner = null), this.stop(), this.detachEvents(), this.state = $c2cbdf39c20c8a0e$var$m.Error, this.emit("error"));
    }
    getNextScale(t) {
        const { fullScale: e, targetScale: i, coverScale: n, maxScale: s, minScale: o } = this;
        let a = o;
        switch(t){
            case "toggleMax":
                a = i - o < .5 * (s - o) ? s : o;
                break;
            case "toggleCover":
                a = i - o < .5 * (n - o) ? n : o;
                break;
            case "toggleZoom":
                a = i - o < .5 * (e - o) ? e : o;
                break;
            case "iterateZoom":
                let t1 = [
                    1,
                    e,
                    s
                ].sort((t, e)=>t - e), r = t1.findIndex((t)=>t > i + 1e-5);
                a = t1[r] || 1;
        }
        return a;
    }
    attachObserver() {
        var t;
        const e = ()=>{
            const { container: t, containerRect: e } = this;
            return Math.abs(e.width - t.getBoundingClientRect().width) > .1 || Math.abs(e.height - t.getBoundingClientRect().height) > .1;
        };
        this.resizeObserver || void 0 === window.ResizeObserver || (this.resizeObserver = new ResizeObserver(()=>{
            this.updateTimer || (e() ? (this.onResize(), this.isMobile && (this.updateTimer = setTimeout(()=>{
                e() && this.onResize(), this.updateTimer = null;
            }, 500))) : this.updateTimer && (clearTimeout(this.updateTimer), this.updateTimer = null));
        })), null === (t = this.resizeObserver) || void 0 === t || t.observe(this.container);
    }
    detachObserver() {
        var t;
        null === (t = this.resizeObserver) || void 0 === t || t.disconnect();
    }
    attachEvents() {
        const { container: t } = this;
        t.addEventListener("click", this.onClick, {
            passive: !1,
            capture: !1
        }), t.addEventListener("wheel", this.onWheel, {
            passive: !1
        }), this.pointerTracker = new $c2cbdf39c20c8a0e$var$l(t, {
            start: this.onPointerDown,
            move: this.onPointerMove,
            end: this.onPointerUp
        }), document.addEventListener($c2cbdf39c20c8a0e$var$O, this.onMouseMove);
    }
    detachEvents() {
        var t;
        const { container: e } = this;
        e.removeEventListener("click", this.onClick, {
            passive: !1,
            capture: !1
        }), e.removeEventListener("wheel", this.onWheel, {
            passive: !1
        }), null === (t = this.pointerTracker) || void 0 === t || t.stop(), this.pointerTracker = null, document.removeEventListener($c2cbdf39c20c8a0e$var$O, this.onMouseMove), document.removeEventListener("keydown", this.onKeydown, !0), this.clickTimer && (clearTimeout(this.clickTimer), this.clickTimer = null), this.updateTimer && (clearTimeout(this.updateTimer), this.updateTimer = null);
    }
    animate() {
        this.setTargetForce();
        const t = this.friction, e = this.option("maxVelocity");
        for (const i of $c2cbdf39c20c8a0e$var$v)t ? (this.velocity[i] *= 1 - t, e && !this.isScaling && (this.velocity[i] = Math.max(Math.min(this.velocity[i], e), -1 * e)), this.current[i] += this.velocity[i]) : this.current[i] = this.target[i];
        this.setTransform(), this.setEdgeForce(), !this.isResting || this.isDragging ? this.rAF = requestAnimationFrame(()=>this.animate()) : this.stop("current");
    }
    setTargetForce() {
        for (const t of $c2cbdf39c20c8a0e$var$v)"e" === t && this.isBouncingX || "f" === t && this.isBouncingY || (this.velocity[t] = (1 / (1 - this.friction) - 1) * (this.target[t] - this.current[t]));
    }
    checkBounds(t = 0, e = 0) {
        const { current: i } = this, n = i.e + t, s = i.f + e, o = this.getBounds(), { x: a, y: r } = o, l = a.min, c = a.max, h = r.min, d = r.max;
        let u = 0, p = 0;
        return l !== 1 / 0 && n < l ? u = l - n : c !== 1 / 0 && n > c && (u = c - n), h !== 1 / 0 && s < h ? p = h - s : d !== 1 / 0 && s > d && (p = d - s), Math.abs(u) < 1e-4 && (u = 0), Math.abs(p) < 1e-4 && (p = 0), Object.assign(Object.assign({}, o), {
            xDiff: u,
            yDiff: p,
            inBounds: !u && !p
        });
    }
    clampTargetBounds() {
        const { target: t } = this, { x: e, y: i } = this.getBounds();
        e.min !== 1 / 0 && (t.e = Math.max(t.e, e.min)), e.max !== 1 / 0 && (t.e = Math.min(t.e, e.max)), i.min !== 1 / 0 && (t.f = Math.max(t.f, i.min)), i.max !== 1 / 0 && (t.f = Math.min(t.f, i.max));
    }
    calculateContentDim(t = this.current) {
        const { content: e, contentRect: i } = this, { fitWidth: n, fitHeight: s, fullWidth: o, fullHeight: a } = i;
        let r = o, l = a;
        if (this.option("zoom") || 0 !== this.angle) {
            const i = !(e instanceof HTMLImageElement) && ("none" === window.getComputedStyle(e).maxWidth || "none" === window.getComputedStyle(e).maxHeight), c = i ? o : n, h = i ? a : s, d = this.getMatrix(t), u = new DOMPoint(0, 0).matrixTransform(d), p = new DOMPoint(0 + c, 0).matrixTransform(d), f = new DOMPoint(0 + c, 0 + h).matrixTransform(d), g = new DOMPoint(0, 0 + h).matrixTransform(d), m = Math.abs(f.x - u.x), v = Math.abs(f.y - u.y), b = Math.abs(g.x - p.x), y = Math.abs(g.y - p.y);
            r = Math.max(m, b), l = Math.max(v, y);
        }
        return {
            contentWidth: r,
            contentHeight: l
        };
    }
    setEdgeForce() {
        if (this.ignoreBounds || this.isDragging || this.panMode === $c2cbdf39c20c8a0e$var$O || this.targetScale < this.scale) return this.isBouncingX = !1, void (this.isBouncingY = !1);
        const { target: t } = this, { x: e, y: i, xDiff: n, yDiff: s } = this.checkBounds();
        const o = this.option("maxVelocity");
        let a = this.velocity.e, r = this.velocity.f;
        0 !== n ? (this.isBouncingX = !0, n * a <= 0 ? a += .14 * n : (a = .14 * n, e.min !== 1 / 0 && (this.target.e = Math.max(t.e, e.min)), e.max !== 1 / 0 && (this.target.e = Math.min(t.e, e.max))), o && (a = Math.max(Math.min(a, o), -1 * o))) : this.isBouncingX = !1, 0 !== s ? (this.isBouncingY = !0, s * r <= 0 ? r += .14 * s : (r = .14 * s, i.min !== 1 / 0 && (this.target.f = Math.max(t.f, i.min)), i.max !== 1 / 0 && (this.target.f = Math.min(t.f, i.max))), o && (r = Math.max(Math.min(r, o), -1 * o))) : this.isBouncingY = !1, this.isBouncingX && (this.velocity.e = a), this.isBouncingY && (this.velocity.f = r);
    }
    enable() {
        const { content: t } = this, e = new DOMMatrixReadOnly(window.getComputedStyle(t).transform);
        for (const t of $c2cbdf39c20c8a0e$var$v)this.current[t] = this.target[t] = e[t];
        this.updateMetrics(), this.attachObserver(), this.attachEvents(), this.state = $c2cbdf39c20c8a0e$var$m.Ready, this.emit("ready");
    }
    onClick(t) {
        var e;
        "click" === t.type && 0 === t.detail && (this.dragOffset.x = 0, this.dragOffset.y = 0), this.isDragging && (null === (e = this.pointerTracker) || void 0 === e || e.clear(), this.trackingPoints = [], this.startDecelAnim());
        const i = t.target;
        if (!i || t.defaultPrevented) return;
        if (i.hasAttribute("disabled")) return t.preventDefault(), void t.stopPropagation();
        if ((()=>{
            const t = window.getSelection();
            return t && "Range" === t.type;
        })() && !i.closest("button")) return;
        const n = i.closest("[data-panzoom-action]"), s = i.closest("[data-panzoom-change]"), o = n || s, a = o && $c2cbdf39c20c8a0e$var$E(o) ? o.dataset : null;
        if (a) {
            const e = a.panzoomChange, i = a.panzoomAction;
            if ((e || i) && t.preventDefault(), e) {
                let t = {};
                try {
                    t = JSON.parse(e);
                } catch (t) {
                    console && console.warn("The given data was not valid JSON");
                }
                return void this.applyChange(t);
            }
            if (i) return void (this[i] && this[i]());
        }
        if (Math.abs(this.dragOffset.x) > 3 || Math.abs(this.dragOffset.y) > 3) return t.preventDefault(), void t.stopPropagation();
        if (i.closest("[data-fancybox]")) return;
        const r = this.content.getBoundingClientRect(), l = this.dragStart;
        if (l.time && !this.canZoomOut() && (Math.abs(r.x - l.x) > 2 || Math.abs(r.y - l.y) > 2)) return;
        this.dragStart.time = 0;
        const c = (e)=>{
            this.option("zoom", t) && e && "string" == typeof e && /(iterateZoom)|(toggle(Zoom|Full|Cover|Max)|(zoomTo(Fit|Cover|Max)))/.test(e) && "function" == typeof this[e] && (t.preventDefault(), this[e]({
                event: t
            }));
        }, h = this.option("click", t), d = this.option("dblClick", t);
        d ? (this.clicks++, 1 == this.clicks && (this.clickTimer = setTimeout(()=>{
            1 === this.clicks ? (this.emit("click", t), !t.defaultPrevented && h && c(h)) : (this.emit("dblClick", t), t.defaultPrevented || c(d)), this.clicks = 0, this.clickTimer = null;
        }, 350))) : (this.emit("click", t), !t.defaultPrevented && h && c(h));
    }
    addTrackingPoint(t) {
        const e = this.trackingPoints.filter((t)=>t.time > Date.now() - 100);
        e.push(t), this.trackingPoints = e;
    }
    onPointerDown(t, e, i) {
        var n;
        if (!1 === this.option("touch", t)) return !1;
        this.pwt = 0, this.dragOffset = {
            x: 0,
            y: 0,
            time: 0
        }, this.trackingPoints = [];
        const s = this.content.getBoundingClientRect();
        if (this.dragStart = {
            x: s.x,
            y: s.y,
            top: s.top,
            left: s.left,
            time: Date.now()
        }, this.clickTimer) return !1;
        if (this.panMode === $c2cbdf39c20c8a0e$var$O && this.targetScale > 1) return t.preventDefault(), t.stopPropagation(), !1;
        const o = t.composedPath()[0];
        if (!i.length) {
            if ([
                "TEXTAREA",
                "OPTION",
                "INPUT",
                "SELECT",
                "VIDEO",
                "IFRAME"
            ].includes(o.nodeName) || o.closest("[contenteditable],[data-selectable],[data-draggable],[data-clickable],[data-panzoom-change],[data-panzoom-action]")) return !1;
            null === (n = window.getSelection()) || void 0 === n || n.removeAllRanges();
        }
        if ("mousedown" === t.type) [
            "A",
            "BUTTON"
        ].includes(o.nodeName) || t.preventDefault();
        else if (Math.abs(this.velocity.a) > .3) return !1;
        return this.target.e = this.current.e, this.target.f = this.current.f, this.stop(), this.isDragging || (this.isDragging = !0, this.addTrackingPoint(e), this.emit("touchStart", t)), !0;
    }
    onPointerMove(e, n, s) {
        if (!1 === this.option("touch", e)) return;
        if (!this.isDragging) return;
        if (n.length < 2 && this.panOnlyZoomed && $c2cbdf39c20c8a0e$var$t(this.targetScale) <= $c2cbdf39c20c8a0e$var$t(this.minScale)) return;
        if (this.emit("touchMove", e), e.defaultPrevented) return;
        this.addTrackingPoint(n[0]);
        const { content: o } = this, a = $c2cbdf39c20c8a0e$var$h(s[0], s[1]), r = $c2cbdf39c20c8a0e$var$h(n[0], n[1]);
        let l = 0, d = 0;
        if (n.length > 1) {
            const t = o.getBoundingClientRect();
            l = a.clientX - t.left - .5 * t.width, d = a.clientY - t.top - .5 * t.height;
        }
        const u = $c2cbdf39c20c8a0e$var$c(s[0], s[1]), p = $c2cbdf39c20c8a0e$var$c(n[0], n[1]);
        let f = u ? p / u : 1, g = r.clientX - a.clientX, m = r.clientY - a.clientY;
        this.dragOffset.x += g, this.dragOffset.y += m, this.dragOffset.time = Date.now() - this.dragStart.time;
        let v = $c2cbdf39c20c8a0e$var$t(this.targetScale) === $c2cbdf39c20c8a0e$var$t(this.minScale) && this.option("lockAxis");
        if (v && !this.lockedAxis) {
            if ("xy" === v || "y" === v || "touchmove" === e.type) {
                if (Math.abs(this.dragOffset.x) < 6 && Math.abs(this.dragOffset.y) < 6) return void e.preventDefault();
                const t = Math.abs(180 * Math.atan2(this.dragOffset.y, this.dragOffset.x) / Math.PI);
                this.lockedAxis = t > 45 && t < 135 ? "y" : "x", this.dragOffset.x = 0, this.dragOffset.y = 0, g = 0, m = 0;
            } else this.lockedAxis = v;
        }
        if ($c2cbdf39c20c8a0e$var$i(e.target, this.content) && (v = "x", this.dragOffset.y = 0), v && "xy" !== v && this.lockedAxis !== v && $c2cbdf39c20c8a0e$var$t(this.targetScale) === $c2cbdf39c20c8a0e$var$t(this.minScale)) return;
        e.cancelable && e.preventDefault(), this.container.classList.add(this.cn("isDragging"));
        const b = this.checkBounds(g, m);
        this.option("rubberband") ? ("x" !== this.isInfinite && (b.xDiff > 0 && g < 0 || b.xDiff < 0 && g > 0) && (g *= Math.max(0, .5 - Math.abs(.75 / this.contentRect.fitWidth * b.xDiff))), "y" !== this.isInfinite && (b.yDiff > 0 && m < 0 || b.yDiff < 0 && m > 0) && (m *= Math.max(0, .5 - Math.abs(.75 / this.contentRect.fitHeight * b.yDiff)))) : (b.xDiff && (g = 0), b.yDiff && (m = 0));
        const y = this.targetScale, w = this.minScale, x = this.maxScale;
        y < .5 * w && (f = Math.max(f, w)), y > 1.5 * x && (f = Math.min(f, x)), "y" === this.lockedAxis && $c2cbdf39c20c8a0e$var$t(y) === $c2cbdf39c20c8a0e$var$t(w) && (g = 0), "x" === this.lockedAxis && $c2cbdf39c20c8a0e$var$t(y) === $c2cbdf39c20c8a0e$var$t(w) && (m = 0), this.applyChange({
            originX: l,
            originY: d,
            panX: g,
            panY: m,
            scale: f,
            friction: this.option("dragFriction"),
            ignoreBounds: !0
        });
    }
    onPointerUp(t, e, n) {
        if (n.length) return this.dragOffset.x = 0, this.dragOffset.y = 0, void (this.trackingPoints = []);
        this.container.classList.remove(this.cn("isDragging")), this.isDragging && (this.addTrackingPoint(e), this.panOnlyZoomed && this.contentRect.width - this.contentRect.fitWidth < 1 && this.contentRect.height - this.contentRect.fitHeight < 1 && (this.trackingPoints = []), $c2cbdf39c20c8a0e$var$i(t.target, this.content) && "y" === this.lockedAxis && (this.trackingPoints = []), this.emit("touchEnd", t), this.isDragging = !1, this.lockedAxis = !1, this.state !== $c2cbdf39c20c8a0e$var$m.Destroy && (t.defaultPrevented || this.startDecelAnim()));
    }
    startDecelAnim() {
        var e;
        const i = this.isScaling;
        this.rAF && (cancelAnimationFrame(this.rAF), this.rAF = null), this.isBouncingX = !1, this.isBouncingY = !1;
        for (const t of $c2cbdf39c20c8a0e$var$v)this.velocity[t] = 0;
        this.target.e = this.current.e, this.target.f = this.current.f, $c2cbdf39c20c8a0e$var$S(this.container, "is-scaling"), $c2cbdf39c20c8a0e$var$S(this.container, "is-animating"), this.isTicking = !1;
        const { trackingPoints: n } = this, s = n[0], o = n[n.length - 1];
        let a = 0, r = 0, l = 0;
        o && s && (a = o.clientX - s.clientX, r = o.clientY - s.clientY, l = o.time - s.time);
        const c = (null === (e = window.visualViewport) || void 0 === e ? void 0 : e.scale) || 1;
        1 !== c && (a *= c, r *= c);
        let h = 0, d = 0, u = 0, p = 0, f = this.option("decelFriction");
        const g = this.targetScale;
        if (l > 0) {
            u = Math.abs(a) > 3 ? a / (l / 30) : 0, p = Math.abs(r) > 3 ? r / (l / 30) : 0;
            const t = this.option("maxVelocity");
            t && (u = Math.max(Math.min(u, t), -1 * t), p = Math.max(Math.min(p, t), -1 * t));
        }
        u && (h = u / (1 / (1 - f) - 1)), p && (d = p / (1 / (1 - f) - 1)), ("y" === this.option("lockAxis") || "xy" === this.option("lockAxis") && "y" === this.lockedAxis && $c2cbdf39c20c8a0e$var$t(g) === this.minScale) && (h = u = 0), ("x" === this.option("lockAxis") || "xy" === this.option("lockAxis") && "x" === this.lockedAxis && $c2cbdf39c20c8a0e$var$t(g) === this.minScale) && (d = p = 0);
        const m = this.dragOffset.x, b = this.dragOffset.y, y = this.option("dragMinThreshold") || 0;
        Math.abs(m) < y && Math.abs(b) < y && (h = d = 0, u = p = 0), (this.option("zoom") && (g < this.minScale - 1e-5 || g > this.maxScale + 1e-5) || i && !h && !d) && (f = .35), this.applyChange({
            panX: h,
            panY: d,
            friction: f
        }), this.emit("decel", u, p, m, b);
    }
    onWheel(t) {
        var e = [
            -t.deltaX || 0,
            -t.deltaY || 0,
            -t.detail || 0
        ].reduce(function(t, e) {
            return Math.abs(e) > Math.abs(t) ? e : t;
        });
        const i = Math.max(-1, Math.min(1, e));
        if (this.emit("wheel", t, i), this.panMode === $c2cbdf39c20c8a0e$var$O) return;
        if (t.defaultPrevented) return;
        const n = this.option("wheel");
        "pan" === n ? (t.preventDefault(), this.panOnlyZoomed && !this.canZoomOut() || this.applyChange({
            panX: 2 * -t.deltaX,
            panY: 2 * -t.deltaY,
            bounce: !1
        })) : "zoom" === n && !1 !== this.option("zoom") && this.zoomWithWheel(t);
    }
    onMouseMove(t) {
        this.panWithMouse(t);
    }
    onKeydown(t) {
        "Escape" === t.key && this.toggleFS();
    }
    onResize() {
        this.updateMetrics(), this.checkBounds().inBounds || this.requestTick();
    }
    setTransform() {
        this.emit("beforeTransform");
        const { current: e, target: i, content: n, contentRect: s } = this, o = Object.assign({}, $c2cbdf39c20c8a0e$var$C);
        for (const n of $c2cbdf39c20c8a0e$var$v){
            const s = "e" == n || "f" === n ? $c2cbdf39c20c8a0e$var$M : $c2cbdf39c20c8a0e$var$T;
            o[n] = $c2cbdf39c20c8a0e$var$t(e[n], s), Math.abs(i[n] - e[n]) < ("e" == n || "f" === n ? .51 : .001) && (e[n] = i[n]);
        }
        let { a: a, b: r, c: l, d: c, e: h, f: d } = o, u = `matrix(${a}, ${r}, ${l}, ${c}, ${h}, ${d})`, p = n.parentElement instanceof HTMLPictureElement ? n.parentElement : n;
        if (this.option("transformParent") && (p = p.parentElement || p), p.style.transform === u) return;
        p.style.transform = u;
        const { contentWidth: f, contentHeight: g } = this.calculateContentDim();
        s.width = f, s.height = g, this.emit("afterTransform");
    }
    updateMetrics(e = !1) {
        var i;
        if (!this || this.state === $c2cbdf39c20c8a0e$var$m.Destroy) return;
        if (this.isContentLoading) return;
        const n = Math.max(1, (null === (i = window.visualViewport) || void 0 === i ? void 0 : i.scale) || 1), { container: s, content: o } = this, a = o instanceof HTMLImageElement, r = s.getBoundingClientRect(), l = getComputedStyle(this.container);
        let c = r.width * n, h = r.height * n;
        const d = parseFloat(l.paddingTop) + parseFloat(l.paddingBottom), u = c - (parseFloat(l.paddingLeft) + parseFloat(l.paddingRight)), p = h - d;
        this.containerRect = {
            width: c,
            height: h,
            innerWidth: u,
            innerHeight: p
        };
        const f = parseFloat(o.dataset.width || "") || ((t)=>{
            let e = 0;
            return e = t instanceof HTMLImageElement ? t.naturalWidth : t instanceof SVGElement ? t.width.baseVal.value : Math.max(t.offsetWidth, t.scrollWidth), e || 0;
        })(o), g = parseFloat(o.dataset.height || "") || ((t)=>{
            let e = 0;
            return e = t instanceof HTMLImageElement ? t.naturalHeight : t instanceof SVGElement ? t.height.baseVal.value : Math.max(t.offsetHeight, t.scrollHeight), e || 0;
        })(o);
        let v = this.option("width", f) || $c2cbdf39c20c8a0e$var$z, b = this.option("height", g) || $c2cbdf39c20c8a0e$var$z;
        const y = v === $c2cbdf39c20c8a0e$var$z, w = b === $c2cbdf39c20c8a0e$var$z;
        "number" != typeof v && (v = f), "number" != typeof b && (b = g), y && (v = f * (b / g)), w && (b = g / (f / v));
        let x = o.parentElement instanceof HTMLPictureElement ? o.parentElement : o;
        this.option("transformParent") && (x = x.parentElement || x);
        const E = x.getAttribute("style") || "";
        x.style.setProperty("transform", "none", "important"), a && (x.style.width = "", x.style.height = ""), x.offsetHeight;
        const S = o.getBoundingClientRect();
        let P = S.width * n, C = S.height * n, T = P, M = C;
        P = Math.min(P, v), C = Math.min(C, b), a ? { width: P, height: C } = ((t, e, i, n)=>{
            const s = i / t, o = n / e, a = Math.min(s, o);
            return {
                width: t *= a,
                height: e *= a
            };
        })(v, b, P, C) : (P = Math.min(P, v), C = Math.min(C, b));
        let O = .5 * (M - C), A = .5 * (T - P);
        this.contentRect = Object.assign(Object.assign({}, this.contentRect), {
            top: S.top - r.top + O,
            bottom: r.bottom - S.bottom + O,
            left: S.left - r.left + A,
            right: r.right - S.right + A,
            fitWidth: P,
            fitHeight: C,
            width: P,
            height: C,
            fullWidth: v,
            fullHeight: b
        }), x.style.cssText = E, a && (x.style.width = `${P}px`, x.style.height = `${C}px`), this.setTransform(), !0 !== e && this.emit("refresh"), this.ignoreBounds || ($c2cbdf39c20c8a0e$var$t(this.targetScale) < $c2cbdf39c20c8a0e$var$t(this.minScale) ? this.zoomTo(this.minScale, {
            friction: 0
        }) : this.targetScale > this.maxScale ? this.zoomTo(this.maxScale, {
            friction: 0
        }) : this.state === $c2cbdf39c20c8a0e$var$m.Init || this.checkBounds().inBounds || this.requestTick()), this.updateControls();
    }
    calculateBounds() {
        const { contentWidth: e, contentHeight: i } = this.calculateContentDim(this.target), { targetScale: n, lockedAxis: s } = this, { fitWidth: o, fitHeight: a } = this.contentRect;
        let r = 0, l = 0, c = 0, h = 0;
        const d = this.option("infinite");
        if (!0 === d || s && d === s) r = -1 / 0, c = 1 / 0, l = -1 / 0, h = 1 / 0;
        else {
            let { containerRect: s, contentRect: d } = this, u = $c2cbdf39c20c8a0e$var$t(o * n, $c2cbdf39c20c8a0e$var$M), p = $c2cbdf39c20c8a0e$var$t(a * n, $c2cbdf39c20c8a0e$var$M), { innerWidth: f, innerHeight: g } = s;
            if (s.width === u && (f = s.width), s.width === p && (g = s.height), e > f) {
                c = .5 * (e - f), r = -1 * c;
                let t = .5 * (d.right - d.left);
                r += t, c += t;
            }
            if (o > f && e < f && (r -= .5 * (o - f), c -= .5 * (o - f)), i > g) {
                h = .5 * (i - g), l = -1 * h;
                let t = .5 * (d.bottom - d.top);
                l += t, h += t;
            }
            a > g && i < g && (r -= .5 * (a - g), c -= .5 * (a - g));
        }
        return {
            x: {
                min: r,
                max: c
            },
            y: {
                min: l,
                max: h
            }
        };
    }
    getBounds() {
        const t = this.option("bounds");
        return t !== $c2cbdf39c20c8a0e$var$z ? t : this.calculateBounds();
    }
    updateControls() {
        const e = this, i = e.container, { panMode: n, contentRect: s, targetScale: a, minScale: r } = e;
        let l = r, c = e.option("click") || !1;
        c && (l = e.getNextScale(c));
        let h = e.canZoomIn(), d = e.canZoomOut(), u = n === $c2cbdf39c20c8a0e$var$A && !!this.option("touch"), p = d && u;
        if (u && ($c2cbdf39c20c8a0e$var$t(a) < $c2cbdf39c20c8a0e$var$t(r) && !this.panOnlyZoomed && (p = !0), ($c2cbdf39c20c8a0e$var$t(s.width, 1) > $c2cbdf39c20c8a0e$var$t(s.fitWidth, 1) || $c2cbdf39c20c8a0e$var$t(s.height, 1) > $c2cbdf39c20c8a0e$var$t(s.fitHeight, 1)) && (p = !0)), $c2cbdf39c20c8a0e$var$t(s.width * a, 1) < $c2cbdf39c20c8a0e$var$t(s.fitWidth, 1) && (p = !1), n === $c2cbdf39c20c8a0e$var$O && (p = !1), $c2cbdf39c20c8a0e$var$o(i, this.cn("isDraggable"), p), !this.option("zoom")) return;
        let f = h && $c2cbdf39c20c8a0e$var$t(l) > $c2cbdf39c20c8a0e$var$t(a), g = !f && !p && d && $c2cbdf39c20c8a0e$var$t(l) < $c2cbdf39c20c8a0e$var$t(a);
        $c2cbdf39c20c8a0e$var$o(i, this.cn("canZoomIn"), f), $c2cbdf39c20c8a0e$var$o(i, this.cn("canZoomOut"), g);
        for (const t of i.querySelectorAll("[data-panzoom-action]")){
            let e = !1, i = !1;
            switch(t.dataset.panzoomAction){
                case "zoomIn":
                    h ? e = !0 : i = !0;
                    break;
                case "zoomOut":
                    d ? e = !0 : i = !0;
                    break;
                case "toggleZoom":
                case "iterateZoom":
                    h || d ? e = !0 : i = !0;
                    const n = t.querySelector("g");
                    n && (n.style.display = h ? "" : "none");
            }
            e ? (t.removeAttribute("disabled"), t.removeAttribute("tabindex")) : i && (t.setAttribute("disabled", ""), t.setAttribute("tabindex", "-1"));
        }
    }
    panTo({ x: t = this.target.e, y: e = this.target.f, scale: i = this.targetScale, friction: n = this.option("friction"), angle: s = 0, originX: o = 0, originY: a = 0, flipX: r = !1, flipY: l = !1, ignoreBounds: c = !1 }) {
        this.state !== $c2cbdf39c20c8a0e$var$m.Destroy && this.applyChange({
            panX: t - this.target.e,
            panY: e - this.target.f,
            scale: i / this.targetScale,
            angle: s,
            originX: o,
            originY: a,
            friction: n,
            flipX: r,
            flipY: l,
            ignoreBounds: c
        });
    }
    applyChange({ panX: e = 0, panY: i = 0, scale: n = 1, angle: s = 0, originX: o = -this.current.e, originY: a = -this.current.f, friction: r = this.option("friction"), flipX: l = !1, flipY: c = !1, ignoreBounds: h = !1, bounce: d = this.option("bounce") }) {
        const u = this.state;
        if (u === $c2cbdf39c20c8a0e$var$m.Destroy) return;
        this.rAF && (cancelAnimationFrame(this.rAF), this.rAF = null), this.friction = r || 0, this.ignoreBounds = h;
        const { current: p } = this, f = p.e, g = p.f, b = this.getMatrix(this.target);
        let y = (new DOMMatrix).translate(f, g).translate(o, a).translate(e, i);
        if (this.option("zoom")) {
            if (!h) {
                const t = this.targetScale, e = this.minScale, i = this.maxScale;
                t * n < e && (n = e / t), t * n > i && (n = i / t);
            }
            y = y.scale(n);
        }
        y = y.translate(-o, -a).translate(-f, -g).multiply(b), s && (y = y.rotate(s)), l && (y = y.scale(-1, 1)), c && (y = y.scale(1, -1));
        for (const e of $c2cbdf39c20c8a0e$var$v)"e" !== e && "f" !== e && (y[e] > this.minScale + 1e-5 || y[e] < this.minScale - 1e-5) ? this.target[e] = y[e] : this.target[e] = $c2cbdf39c20c8a0e$var$t(y[e], $c2cbdf39c20c8a0e$var$M);
        (this.targetScale < this.scale || Math.abs(n - 1) > .1 || this.panMode === $c2cbdf39c20c8a0e$var$O || !1 === d) && !h && this.clampTargetBounds(), u === $c2cbdf39c20c8a0e$var$m.Init ? this.animate() : this.isResting || (this.state = $c2cbdf39c20c8a0e$var$m.Panning, this.requestTick());
    }
    stop(t = !1) {
        if (this.state === $c2cbdf39c20c8a0e$var$m.Init || this.state === $c2cbdf39c20c8a0e$var$m.Destroy) return;
        const e = this.isTicking;
        this.rAF && (cancelAnimationFrame(this.rAF), this.rAF = null), this.isBouncingX = !1, this.isBouncingY = !1;
        for (const e of $c2cbdf39c20c8a0e$var$v)this.velocity[e] = 0, "current" === t ? this.current[e] = this.target[e] : "target" === t && (this.target[e] = this.current[e]);
        this.setTransform(), $c2cbdf39c20c8a0e$var$S(this.container, "is-scaling"), $c2cbdf39c20c8a0e$var$S(this.container, "is-animating"), this.isTicking = !1, this.state = $c2cbdf39c20c8a0e$var$m.Ready, e && (this.emit("endAnimation"), this.updateControls());
    }
    requestTick() {
        this.isTicking || (this.emit("startAnimation"), this.updateControls(), $c2cbdf39c20c8a0e$var$P(this.container, "is-animating"), this.isScaling && $c2cbdf39c20c8a0e$var$P(this.container, "is-scaling")), this.isTicking = !0, this.rAF || (this.rAF = requestAnimationFrame(()=>this.animate()));
    }
    panWithMouse(e, i = this.option("mouseMoveFriction")) {
        if (this.pmme = e, this.panMode !== $c2cbdf39c20c8a0e$var$O || !e) return;
        if ($c2cbdf39c20c8a0e$var$t(this.targetScale) <= $c2cbdf39c20c8a0e$var$t(this.minScale)) return;
        this.emit("mouseMove", e);
        const { container: n, containerRect: s, contentRect: o } = this, a = s.width, r = s.height, l = n.getBoundingClientRect(), c = (e.clientX || 0) - l.left, h = (e.clientY || 0) - l.top;
        let { contentWidth: d, contentHeight: u } = this.calculateContentDim(this.target);
        const p = this.option("mouseMoveFactor");
        p > 1 && (d !== a && (d *= p), u !== r && (u *= p));
        let f = .5 * (d - a) - c / a * 100 / 100 * (d - a);
        f += .5 * (o.right - o.left);
        let g = .5 * (u - r) - h / r * 100 / 100 * (u - r);
        g += .5 * (o.bottom - o.top), this.applyChange({
            panX: f - this.target.e,
            panY: g - this.target.f,
            friction: i
        });
    }
    zoomWithWheel(e) {
        if (this.state === $c2cbdf39c20c8a0e$var$m.Destroy || this.state === $c2cbdf39c20c8a0e$var$m.Init) return;
        const i = Date.now();
        if (i - this.pwt < 45) return void e.preventDefault();
        this.pwt = i;
        var n = [
            -e.deltaX || 0,
            -e.deltaY || 0,
            -e.detail || 0
        ].reduce(function(t, e) {
            return Math.abs(e) > Math.abs(t) ? e : t;
        });
        const s = Math.max(-1, Math.min(1, n)), { targetScale: o, maxScale: a, minScale: r } = this;
        let l = o * (100 + 45 * s) / 100;
        $c2cbdf39c20c8a0e$var$t(l) < $c2cbdf39c20c8a0e$var$t(r) && $c2cbdf39c20c8a0e$var$t(o) <= $c2cbdf39c20c8a0e$var$t(r) ? (this.cwd += Math.abs(s), l = r) : $c2cbdf39c20c8a0e$var$t(l) > $c2cbdf39c20c8a0e$var$t(a) && $c2cbdf39c20c8a0e$var$t(o) >= $c2cbdf39c20c8a0e$var$t(a) ? (this.cwd += Math.abs(s), l = a) : (this.cwd = 0, l = Math.max(Math.min(l, a), r)), this.cwd > this.option("wheelLimit") || (e.preventDefault(), $c2cbdf39c20c8a0e$var$t(l) !== $c2cbdf39c20c8a0e$var$t(o) && this.zoomTo(l, {
            event: e
        }));
    }
    canZoomIn() {
        return this.option("zoom") && ($c2cbdf39c20c8a0e$var$t(this.contentRect.width, 1) < $c2cbdf39c20c8a0e$var$t(this.contentRect.fitWidth, 1) || $c2cbdf39c20c8a0e$var$t(this.targetScale) < $c2cbdf39c20c8a0e$var$t(this.maxScale));
    }
    canZoomOut() {
        return this.option("zoom") && $c2cbdf39c20c8a0e$var$t(this.targetScale) > $c2cbdf39c20c8a0e$var$t(this.minScale);
    }
    zoomIn(t = 1.25, e) {
        this.zoomTo(this.targetScale * t, e);
    }
    zoomOut(t = .8, e) {
        this.zoomTo(this.targetScale * t, e);
    }
    zoomToFit(t) {
        this.zoomTo("fit", t);
    }
    zoomToCover(t) {
        this.zoomTo("cover", t);
    }
    zoomToFull(t) {
        this.zoomTo("full", t);
    }
    zoomToMax(t) {
        this.zoomTo("max", t);
    }
    toggleZoom(t) {
        this.zoomTo(this.getNextScale("toggleZoom"), t);
    }
    toggleMax(t) {
        this.zoomTo(this.getNextScale("toggleMax"), t);
    }
    toggleCover(t) {
        this.zoomTo(this.getNextScale("toggleCover"), t);
    }
    iterateZoom(t) {
        this.zoomTo("next", t);
    }
    zoomTo(t = 1, { friction: e = $c2cbdf39c20c8a0e$var$z, originX: i = $c2cbdf39c20c8a0e$var$z, originY: n = $c2cbdf39c20c8a0e$var$z, event: s } = {}) {
        if (this.isContentLoading || this.state === $c2cbdf39c20c8a0e$var$m.Destroy) return;
        const { targetScale: o, fullScale: a, maxScale: r, coverScale: l } = this;
        if (this.stop(), this.panMode === $c2cbdf39c20c8a0e$var$O && (s = this.pmme || s), s || i === $c2cbdf39c20c8a0e$var$z || n === $c2cbdf39c20c8a0e$var$z) {
            const t = this.content.getBoundingClientRect(), e = this.container.getBoundingClientRect(), o = s ? s.clientX : e.left + .5 * e.width, a = s ? s.clientY : e.top + .5 * e.height;
            i = o - t.left - .5 * t.width, n = a - t.top - .5 * t.height;
        }
        let c = 1;
        "number" == typeof t ? c = t : "full" === t ? c = a : "cover" === t ? c = l : "max" === t ? c = r : "fit" === t ? c = 1 : "next" === t && (c = this.getNextScale("iterateZoom")), c = c / o || 1, e = e === $c2cbdf39c20c8a0e$var$z ? c > 1 ? .15 : .25 : e, this.applyChange({
            scale: c,
            originX: i,
            originY: n,
            friction: e
        }), s && this.panMode === $c2cbdf39c20c8a0e$var$O && this.panWithMouse(s, e);
    }
    rotateCCW() {
        this.applyChange({
            angle: -90
        });
    }
    rotateCW() {
        this.applyChange({
            angle: 90
        });
    }
    flipX() {
        this.applyChange({
            flipX: !0
        });
    }
    flipY() {
        this.applyChange({
            flipY: !0
        });
    }
    fitX() {
        this.stop("target");
        const { containerRect: t, contentRect: e, target: i } = this;
        this.applyChange({
            panX: .5 * t.width - (e.left + .5 * e.fitWidth) - i.e,
            panY: .5 * t.height - (e.top + .5 * e.fitHeight) - i.f,
            scale: t.width / e.fitWidth / this.targetScale,
            originX: 0,
            originY: 0,
            ignoreBounds: !0
        });
    }
    fitY() {
        this.stop("target");
        const { containerRect: t, contentRect: e, target: i } = this;
        this.applyChange({
            panX: .5 * t.width - (e.left + .5 * e.fitWidth) - i.e,
            panY: .5 * t.innerHeight - (e.top + .5 * e.fitHeight) - i.f,
            scale: t.height / e.fitHeight / this.targetScale,
            originX: 0,
            originY: 0,
            ignoreBounds: !0
        });
    }
    toggleFS() {
        const { container: t } = this, e = this.cn("inFullscreen"), i = this.cn("htmlHasFullscreen");
        t.classList.toggle(e);
        const n = t.classList.contains(e);
        n ? (document.documentElement.classList.add(i), document.addEventListener("keydown", this.onKeydown, !0)) : (document.documentElement.classList.remove(i), document.removeEventListener("keydown", this.onKeydown, !0)), this.updateMetrics(), this.emit(n ? "enterFS" : "exitFS");
    }
    getMatrix(t = this.current) {
        const { a: e, b: i, c: n, d: s, e: o, f: a } = t;
        return new DOMMatrix([
            e,
            i,
            n,
            s,
            o,
            a
        ]);
    }
    reset(t) {
        if (this.state !== $c2cbdf39c20c8a0e$var$m.Init && this.state !== $c2cbdf39c20c8a0e$var$m.Destroy) {
            this.stop("current");
            for (const t of $c2cbdf39c20c8a0e$var$v)this.target[t] = $c2cbdf39c20c8a0e$var$C[t];
            this.target.a = this.minScale, this.target.d = this.minScale, this.clampTargetBounds(), this.isResting || (this.friction = void 0 === t ? this.option("friction") : t, this.state = $c2cbdf39c20c8a0e$var$m.Panning, this.requestTick());
        }
    }
    destroy() {
        this.stop(), this.state = $c2cbdf39c20c8a0e$var$m.Destroy, this.detachEvents(), this.detachObserver();
        const { container: t, content: e } = this, i = this.option("classes") || {};
        for (const e of Object.values(i))t.classList.remove(e + "");
        e && (e.removeEventListener("load", this.onLoad), e.removeEventListener("error", this.onError)), this.detachPlugins();
    }
}
Object.defineProperty($c2cbdf39c20c8a0e$export$b704d075ddd20210, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $c2cbdf39c20c8a0e$var$y
}), Object.defineProperty($c2cbdf39c20c8a0e$export$b704d075ddd20210, "Plugins", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: {}
});
const $c2cbdf39c20c8a0e$var$D = function(t, e) {
    let i = !0;
    return (...n)=>{
        i && (i = !1, t(...n), setTimeout(()=>{
            i = !0;
        }, e));
    };
}, $c2cbdf39c20c8a0e$var$F = (t, e)=>{
    let i = [];
    return t.childNodes.forEach((t)=>{
        t.nodeType !== Node.ELEMENT_NODE || e && !t.matches(e) || i.push(t);
    }), i;
}, $c2cbdf39c20c8a0e$var$j = {
    viewport: null,
    track: null,
    enabled: !0,
    slides: [],
    axis: "x",
    transition: "fade",
    preload: 1,
    slidesPerPage: "auto",
    initialPage: 0,
    friction: .12,
    Panzoom: {
        decelFriction: .12
    },
    center: !0,
    infinite: !0,
    fill: !0,
    dragFree: !1,
    adaptiveHeight: !1,
    direction: "ltr",
    classes: {
        container: "f-carousel",
        viewport: "f-carousel__viewport",
        track: "f-carousel__track",
        slide: "f-carousel__slide",
        isLTR: "is-ltr",
        isRTL: "is-rtl",
        isHorizontal: "is-horizontal",
        isVertical: "is-vertical",
        inTransition: "in-transition",
        isSelected: "is-selected"
    },
    l10n: {
        NEXT: "Next slide",
        PREV: "Previous slide",
        GOTO: "Go to slide #%d"
    }
};
var $c2cbdf39c20c8a0e$var$B;
!function(t) {
    t[t.Init = 0] = "Init", t[t.Ready = 1] = "Ready", t[t.Destroy = 2] = "Destroy";
}($c2cbdf39c20c8a0e$var$B || ($c2cbdf39c20c8a0e$var$B = {}));
const $c2cbdf39c20c8a0e$var$H = (t)=>{
    if ("string" == typeof t || t instanceof HTMLElement) t = {
        html: t
    };
    else {
        const e = t.thumb;
        void 0 !== e && ("string" == typeof e && (t.thumbSrc = e), e instanceof HTMLImageElement && (t.thumbEl = e, t.thumbElSrc = e.src, t.thumbSrc = e.src), delete t.thumb);
    }
    return Object.assign({
        html: "",
        el: null,
        isDom: !1,
        class: "",
        customClass: "",
        index: -1,
        dim: 0,
        gap: 0,
        pos: 0,
        transition: !1
    }, t);
}, $c2cbdf39c20c8a0e$var$N = (t = {})=>Object.assign({
        index: -1,
        slides: [],
        dim: 0,
        pos: -1
    }, t);
class $c2cbdf39c20c8a0e$var$_ extends $c2cbdf39c20c8a0e$var$f {
    constructor(t, e){
        super(e), Object.defineProperty(this, "instance", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: t
        });
    }
    attach() {}
    detach() {}
}
const $c2cbdf39c20c8a0e$var$$ = {
    classes: {
        list: "f-carousel__dots",
        isDynamic: "is-dynamic",
        hasDots: "has-dots",
        dot: "f-carousel__dot",
        isBeforePrev: "is-before-prev",
        isPrev: "is-prev",
        isCurrent: "is-current",
        isNext: "is-next",
        isAfterNext: "is-after-next"
    },
    dotTpl: '<button type="button" data-carousel-page="%i" aria-label="{{GOTO}}"><span class="f-carousel__dot" aria-hidden="true"></span></button>',
    dynamicFrom: 11,
    maxCount: 1 / 0,
    minCount: 2
};
class $c2cbdf39c20c8a0e$var$W extends $c2cbdf39c20c8a0e$var$_ {
    constructor(){
        super(...arguments), Object.defineProperty(this, "isDynamic", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "list", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        });
    }
    onRefresh() {
        this.refresh();
    }
    build() {
        let t = this.list;
        if (!t) {
            t = document.createElement("ul"), $c2cbdf39c20c8a0e$var$P(t, this.cn("list")), t.setAttribute("role", "tablist");
            const e = this.instance.container;
            e.appendChild(t), $c2cbdf39c20c8a0e$var$P(e, this.cn("hasDots")), this.list = t;
        }
        return t;
    }
    refresh() {
        var t;
        const e = this.instance.pages.length, i = Math.min(2, this.option("minCount")), n = Math.max(2e3, this.option("maxCount")), s = this.option("dynamicFrom");
        if (e < i || e > n) return void this.cleanup();
        const a = "number" == typeof s && e > 5 && e >= s, r = !this.list || this.isDynamic !== a || this.list.children.length !== e;
        r && this.cleanup();
        const l = this.build();
        if ($c2cbdf39c20c8a0e$var$o(l, this.cn("isDynamic"), !!a), r) for(let t = 0; t < e; t++)l.append(this.createItem(t));
        let c, h = 0;
        for (const e of [
            ...l.children
        ]){
            const i = h === this.instance.page;
            i && (c = e), $c2cbdf39c20c8a0e$var$o(e, this.cn("isCurrent"), i), null === (t = e.children[0]) || void 0 === t || t.setAttribute("aria-selected", i ? "true" : "false");
            for (const t of [
                "isBeforePrev",
                "isPrev",
                "isNext",
                "isAfterNext"
            ])$c2cbdf39c20c8a0e$var$S(e, this.cn(t));
            h++;
        }
        if (c = c || l.firstChild, a && c) {
            const t = c.previousElementSibling, e = t && t.previousElementSibling;
            $c2cbdf39c20c8a0e$var$P(t, this.cn("isPrev")), $c2cbdf39c20c8a0e$var$P(e, this.cn("isBeforePrev"));
            const i = c.nextElementSibling, n = i && i.nextElementSibling;
            $c2cbdf39c20c8a0e$var$P(i, this.cn("isNext")), $c2cbdf39c20c8a0e$var$P(n, this.cn("isAfterNext"));
        }
        this.isDynamic = a;
    }
    createItem(t = 0) {
        var e;
        const i = document.createElement("li");
        i.setAttribute("role", "presentation");
        const s = $c2cbdf39c20c8a0e$var$n(this.instance.localize(this.option("dotTpl"), [
            [
                "%d",
                t + 1
            ]
        ]).replace(/\%i/g, t + ""));
        return i.appendChild(s), null === (e = i.children[0]) || void 0 === e || e.setAttribute("role", "tab"), i;
    }
    cleanup() {
        this.list && (this.list.remove(), this.list = null), this.isDynamic = !1, $c2cbdf39c20c8a0e$var$S(this.instance.container, this.cn("hasDots"));
    }
    attach() {
        this.instance.on([
            "refresh",
            "change"
        ], this.onRefresh);
    }
    detach() {
        this.instance.off([
            "refresh",
            "change"
        ], this.onRefresh), this.cleanup();
    }
}
Object.defineProperty($c2cbdf39c20c8a0e$var$W, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $c2cbdf39c20c8a0e$var$$
});
const $c2cbdf39c20c8a0e$var$X = "disabled", $c2cbdf39c20c8a0e$var$q = "next", $c2cbdf39c20c8a0e$var$Y = "prev";
class $c2cbdf39c20c8a0e$var$V extends $c2cbdf39c20c8a0e$var$_ {
    constructor(){
        super(...arguments), Object.defineProperty(this, "container", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "prev", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "next", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "isDom", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        });
    }
    onRefresh() {
        const t = this.instance, e = t.pages.length, i = t.page;
        if (e < 2) return void this.cleanup();
        this.build();
        let n = this.prev, s = this.next;
        n && s && (n.removeAttribute($c2cbdf39c20c8a0e$var$X), s.removeAttribute($c2cbdf39c20c8a0e$var$X), t.isInfinite || (i <= 0 && n.setAttribute($c2cbdf39c20c8a0e$var$X, ""), i >= e - 1 && s.setAttribute($c2cbdf39c20c8a0e$var$X, "")));
    }
    addBtn(t) {
        var e;
        const i = this.instance, n = document.createElement("button");
        n.setAttribute("tabindex", "0"), n.setAttribute("title", i.localize(`{{${t.toUpperCase()}}}`)), $c2cbdf39c20c8a0e$var$P(n, this.cn("button") + " " + this.cn(t === $c2cbdf39c20c8a0e$var$q ? "isNext" : "isPrev"));
        const s = i.isRTL ? t === $c2cbdf39c20c8a0e$var$q ? $c2cbdf39c20c8a0e$var$Y : $c2cbdf39c20c8a0e$var$q : t;
        var o;
        return n.innerHTML = i.localize(this.option(`${s}Tpl`)), n.dataset[`carousel${o = t, o ? o.match("^[a-z]") ? o.charAt(0).toUpperCase() + o.substring(1) : o : ""}`] = "true", null === (e = this.container) || void 0 === e || e.appendChild(n), n;
    }
    build() {
        const t = this.instance.container, e = this.cn("container");
        let { container: i, prev: n, next: s } = this;
        i || (i = t.querySelector("." + e), this.isDom = !!i), i || (i = document.createElement("div"), $c2cbdf39c20c8a0e$var$P(i, e), t.appendChild(i)), this.container = i, s || (s = i.querySelector("[data-carousel-next]")), s || (s = this.addBtn($c2cbdf39c20c8a0e$var$q)), this.next = s, n || (n = i.querySelector("[data-carousel-prev]")), n || (n = this.addBtn($c2cbdf39c20c8a0e$var$Y)), this.prev = n;
    }
    cleanup() {
        this.isDom || (this.prev && this.prev.remove(), this.next && this.next.remove(), this.container && this.container.remove()), this.prev = null, this.next = null, this.container = null, this.isDom = !1;
    }
    attach() {
        this.instance.on([
            "refresh",
            "change"
        ], this.onRefresh);
    }
    detach() {
        this.instance.off([
            "refresh",
            "change"
        ], this.onRefresh), this.cleanup();
    }
}
Object.defineProperty($c2cbdf39c20c8a0e$var$V, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: {
        classes: {
            container: "f-carousel__nav",
            button: "f-button",
            isNext: "is-next",
            isPrev: "is-prev"
        },
        nextTpl: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1"><path d="M9 3l9 9-9 9"/></svg>',
        prevTpl: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1"><path d="M15 3l-9 9 9 9"/></svg>'
    }
});
class $c2cbdf39c20c8a0e$var$Z extends $c2cbdf39c20c8a0e$var$_ {
    constructor(){
        super(...arguments), Object.defineProperty(this, "selectedIndex", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "target", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "nav", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        });
    }
    addAsTargetFor(t) {
        this.target = this.instance, this.nav = t, this.attachEvents();
    }
    addAsNavFor(t) {
        this.nav = this.instance, this.target = t, this.attachEvents();
    }
    attachEvents() {
        const { nav: t, target: e } = this;
        t && e && (t.options.initialSlide = e.options.initialPage, t.state === $c2cbdf39c20c8a0e$var$B.Ready ? this.onNavReady(t) : t.on("ready", this.onNavReady), e.state === $c2cbdf39c20c8a0e$var$B.Ready ? this.onTargetReady(e) : e.on("ready", this.onTargetReady));
    }
    onNavReady(t) {
        t.on("createSlide", this.onNavCreateSlide), t.on("Panzoom.click", this.onNavClick), t.on("Panzoom.touchEnd", this.onNavTouch), this.onTargetChange();
    }
    onTargetReady(t) {
        t.on("change", this.onTargetChange), t.on("Panzoom.refresh", this.onTargetChange), this.onTargetChange();
    }
    onNavClick(t, e, i) {
        this.onNavTouch(t, t.panzoom, i);
    }
    onNavTouch(t, e, i) {
        var n, s;
        if (Math.abs(e.dragOffset.x) > 3 || Math.abs(e.dragOffset.y) > 3) return;
        const o = i.target, { nav: a, target: r } = this;
        if (!a || !r || !o) return;
        const l = o.closest("[data-index]");
        if (i.stopPropagation(), i.preventDefault(), !l) return;
        const c = parseInt(l.dataset.index || "", 10) || 0, h = r.getPageForSlide(c), d = a.getPageForSlide(c);
        a.slideTo(d), r.slideTo(h, {
            friction: (null === (s = null === (n = this.nav) || void 0 === n ? void 0 : n.plugins) || void 0 === s ? void 0 : s.Sync.option("friction")) || 0
        }), this.markSelectedSlide(c);
    }
    onNavCreateSlide(t, e) {
        e.index === this.selectedIndex && this.markSelectedSlide(e.index);
    }
    onTargetChange() {
        var t, e;
        const { target: i, nav: n } = this;
        if (!i || !n) return;
        if (n.state !== $c2cbdf39c20c8a0e$var$B.Ready || i.state !== $c2cbdf39c20c8a0e$var$B.Ready) return;
        const s = null === (e = null === (t = i.pages[i.page]) || void 0 === t ? void 0 : t.slides[0]) || void 0 === e ? void 0 : e.index, o = n.getPageForSlide(s);
        this.markSelectedSlide(s), n.slideTo(o, null === n.prevPage && null === i.prevPage ? {
            friction: 0
        } : void 0);
    }
    markSelectedSlide(t) {
        const e = this.nav;
        e && e.state === $c2cbdf39c20c8a0e$var$B.Ready && (this.selectedIndex = t, [
            ...e.slides
        ].map((e)=>{
            e.el && e.el.classList[e.index === t ? "add" : "remove"]("is-nav-selected");
        }));
    }
    attach() {
        const t = this;
        let e = t.options.target, i = t.options.nav;
        e ? t.addAsNavFor(e) : i && t.addAsTargetFor(i);
    }
    detach() {
        const t = this, e = t.nav, i = t.target;
        e && (e.off("ready", t.onNavReady), e.off("createSlide", t.onNavCreateSlide), e.off("Panzoom.click", t.onNavClick), e.off("Panzoom.touchEnd", t.onNavTouch)), t.nav = null, i && (i.off("ready", t.onTargetReady), i.off("refresh", t.onTargetChange), i.off("change", t.onTargetChange)), t.target = null;
    }
}
Object.defineProperty($c2cbdf39c20c8a0e$var$Z, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: {
        friction: .35
    }
});
const $c2cbdf39c20c8a0e$var$U = {
    Navigation: $c2cbdf39c20c8a0e$var$V,
    Dots: $c2cbdf39c20c8a0e$var$W,
    Sync: $c2cbdf39c20c8a0e$var$Z
}, $c2cbdf39c20c8a0e$var$G = "animationend", $c2cbdf39c20c8a0e$var$K = "isSelected", $c2cbdf39c20c8a0e$var$J = "slide";
class $c2cbdf39c20c8a0e$export$144901db2ea8e967 extends $c2cbdf39c20c8a0e$var$g {
    get axis() {
        return this.isHorizontal ? "e" : "f";
    }
    get isEnabled() {
        return this.state === $c2cbdf39c20c8a0e$var$B.Ready;
    }
    get isInfinite() {
        let t = !1;
        const { contentDim: e, viewportDim: i, pages: n, slides: s } = this, o = s[0];
        return n.length >= 2 && o && e + o.dim >= i && (t = this.option("infinite")), t;
    }
    get isRTL() {
        return "rtl" === this.option("direction");
    }
    get isHorizontal() {
        return "x" === this.option("axis");
    }
    constructor(t, e = {}, i = {}){
        if (super(), Object.defineProperty(this, "bp", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: ""
        }), Object.defineProperty(this, "lp", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "userOptions", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: {}
        }), Object.defineProperty(this, "userPlugins", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: {}
        }), Object.defineProperty(this, "state", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $c2cbdf39c20c8a0e$var$B.Init
        }), Object.defineProperty(this, "page", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "prevPage", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "container", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "viewport", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "track", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "slides", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: []
        }), Object.defineProperty(this, "pages", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: []
        }), Object.defineProperty(this, "panzoom", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "inTransition", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: new Set
        }), Object.defineProperty(this, "contentDim", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "viewportDim", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), "string" == typeof t && (t = document.querySelector(t)), !t || !$c2cbdf39c20c8a0e$var$E(t)) throw new Error("No Element found");
        this.container = t, this.slideNext = $c2cbdf39c20c8a0e$var$D(this.slideNext.bind(this), 150), this.slidePrev = $c2cbdf39c20c8a0e$var$D(this.slidePrev.bind(this), 150), this.userOptions = e, this.userPlugins = i, queueMicrotask(()=>{
            this.processOptions();
        });
    }
    processOptions() {
        var t, e;
        const i = $c2cbdf39c20c8a0e$var$u({}, $c2cbdf39c20c8a0e$export$144901db2ea8e967.defaults, this.userOptions);
        let n = "";
        const s = i.breakpoints;
        if (s && $c2cbdf39c20c8a0e$var$d(s)) for (const [t, e] of Object.entries(s))window.matchMedia(t).matches && $c2cbdf39c20c8a0e$var$d(e) && (n += t, $c2cbdf39c20c8a0e$var$u(i, e));
        n === this.bp && this.state !== $c2cbdf39c20c8a0e$var$B.Init || (this.bp = n, this.state === $c2cbdf39c20c8a0e$var$B.Ready && (i.initialSlide = (null === (e = null === (t = this.pages[this.page]) || void 0 === t ? void 0 : t.slides[0]) || void 0 === e ? void 0 : e.index) || 0), this.state !== $c2cbdf39c20c8a0e$var$B.Init && this.destroy(), super.setOptions(i), !1 === this.option("enabled") ? this.attachEvents() : setTimeout(()=>{
            this.init();
        }, 0));
    }
    init() {
        this.state = $c2cbdf39c20c8a0e$var$B.Init, this.emit("init"), this.attachPlugins(Object.assign(Object.assign({}, $c2cbdf39c20c8a0e$export$144901db2ea8e967.Plugins), this.userPlugins)), this.emit("attachPlugins"), this.initLayout(), this.initSlides(), this.updateMetrics(), this.setInitialPosition(), this.initPanzoom(), this.attachEvents(), this.state = $c2cbdf39c20c8a0e$var$B.Ready, this.emit("ready");
    }
    initLayout() {
        const { container: t } = this, e = this.option("classes");
        $c2cbdf39c20c8a0e$var$P(t, this.cn("container")), $c2cbdf39c20c8a0e$var$o(t, e.isLTR, !this.isRTL), $c2cbdf39c20c8a0e$var$o(t, e.isRTL, this.isRTL), $c2cbdf39c20c8a0e$var$o(t, e.isVertical, !this.isHorizontal), $c2cbdf39c20c8a0e$var$o(t, e.isHorizontal, this.isHorizontal);
        let i = this.option("viewport") || t.querySelector(`.${e.viewport}`);
        i || (i = document.createElement("div"), $c2cbdf39c20c8a0e$var$P(i, e.viewport), i.append(...$c2cbdf39c20c8a0e$var$F(t, `.${e.slide}`)), t.prepend(i)), i.addEventListener("scroll", this.onScroll);
        let n = this.option("track") || t.querySelector(`.${e.track}`);
        n || (n = document.createElement("div"), $c2cbdf39c20c8a0e$var$P(n, e.track), n.append(...Array.from(i.childNodes))), n.setAttribute("aria-live", "polite"), i.contains(n) || i.prepend(n), this.viewport = i, this.track = n, this.emit("initLayout");
    }
    initSlides() {
        const { track: t } = this;
        if (!t) return;
        const e = [
            ...this.slides
        ], i = [];
        [
            ...$c2cbdf39c20c8a0e$var$F(t, `.${this.cn($c2cbdf39c20c8a0e$var$J)}`)
        ].forEach((t)=>{
            if ($c2cbdf39c20c8a0e$var$E(t)) {
                const e = $c2cbdf39c20c8a0e$var$H({
                    el: t,
                    isDom: !0,
                    index: this.slides.length
                });
                i.push(e);
            }
        });
        for (let t of [
            ...this.option("slides", []) || [],
            ...e
        ])i.push($c2cbdf39c20c8a0e$var$H(t));
        this.slides = i;
        for(let t = 0; t < this.slides.length; t++)this.slides[t].index = t;
        for (const t of i)this.emit("beforeInitSlide", t, t.index), this.emit("initSlide", t, t.index);
        this.emit("initSlides");
    }
    setInitialPage() {
        const t = this.option("initialSlide");
        this.page = "number" == typeof t ? this.getPageForSlide(t) : parseInt(this.option("initialPage", 0) + "", 10) || 0;
    }
    setInitialPosition() {
        const { track: t, pages: e, isHorizontal: i } = this;
        if (!t || !e.length) return;
        let n = this.page;
        e[n] || (this.page = n = 0);
        const s = (e[n].pos || 0) * (this.isRTL && i ? 1 : -1), o = i ? `${s}px` : "0", a = i ? "0" : `${s}px`;
        t.style.transform = `translate3d(${o}, ${a}, 0) scale(1)`, this.option("adaptiveHeight") && this.setViewportHeight();
    }
    initPanzoom() {
        this.panzoom && (this.panzoom.destroy(), this.panzoom = null);
        const t = this.option("Panzoom") || {};
        this.panzoom = new $c2cbdf39c20c8a0e$export$b704d075ddd20210(this.viewport, $c2cbdf39c20c8a0e$var$u({}, {
            content: this.track,
            zoom: !1,
            panOnlyZoomed: !1,
            lockAxis: this.isHorizontal ? "x" : "y",
            infinite: this.isInfinite,
            click: !1,
            dblClick: !1,
            touch: (t)=>!(this.pages.length < 2 && !t.options.infinite),
            bounds: ()=>this.getBounds(),
            maxVelocity: (t)=>Math.abs(t.target[this.axis] - t.current[this.axis]) < 2 * this.viewportDim ? 100 : 0
        }, t)), this.panzoom.on("*", (t, e, ...i)=>{
            this.emit(`Panzoom.${e}`, t, ...i);
        }), this.panzoom.on("decel", this.onDecel), this.panzoom.on("refresh", this.onRefresh), this.panzoom.on("beforeTransform", this.onBeforeTransform), this.panzoom.on("endAnimation", this.onEndAnimation);
    }
    attachEvents() {
        const t = this.container;
        t && (t.addEventListener("click", this.onClick, {
            passive: !1,
            capture: !1
        }), t.addEventListener("slideTo", this.onSlideTo)), window.addEventListener("resize", this.onResize);
    }
    createPages() {
        let t = [];
        const { contentDim: e, viewportDim: i } = this;
        let n = this.option("slidesPerPage");
        n = ("auto" === n || e <= i) && !1 !== this.option("fill") ? 1 / 0 : parseFloat(n + "");
        let s = 0, o = 0, a = 0;
        for (const e of this.slides)(!t.length || o + e.dim - i > .05 || a >= n) && (t.push($c2cbdf39c20c8a0e$var$N()), s = t.length - 1, o = 0, a = 0), t[s].slides.push(e), o += e.dim + e.gap, a++;
        return t;
    }
    processPages() {
        const e = this.pages, { contentDim: i, viewportDim: n, isInfinite: s } = this, o = this.option("center"), a = this.option("fill"), r = a && o && i > n && !s;
        if (e.forEach((t, e)=>{
            var s;
            t.index = e, t.pos = (null === (s = t.slides[0]) || void 0 === s ? void 0 : s.pos) || 0, t.dim = 0;
            for (const [e, i] of t.slides.entries())t.dim += i.dim, e < t.slides.length - 1 && (t.dim += i.gap);
            r && t.pos + .5 * t.dim < .5 * n ? t.pos = 0 : r && t.pos + .5 * t.dim >= i - .5 * n ? t.pos = i - n : o && (t.pos += -0.5 * (n - t.dim));
        }), e.forEach((e)=>{
            a && !s && i > n && (e.pos = Math.max(e.pos, 0), e.pos = Math.min(e.pos, i - n)), e.pos = $c2cbdf39c20c8a0e$var$t(e.pos, 1e3), e.dim = $c2cbdf39c20c8a0e$var$t(e.dim, 1e3), Math.abs(e.pos) <= .1 && (e.pos = 0);
        }), s) return e;
        const l = [];
        let c;
        return e.forEach((t)=>{
            const e = Object.assign({}, t);
            c && e.pos === c.pos ? (c.dim += e.dim, c.slides = [
                ...c.slides,
                ...e.slides
            ]) : (e.index = l.length, c = e, l.push(e));
        }), l;
    }
    getPageFromIndex(t = 0) {
        const e = this.pages.length;
        let i;
        return t = parseInt((t || 0).toString()) || 0, i = this.isInfinite ? (t % e + e) % e : Math.max(Math.min(t, e - 1), 0), i;
    }
    getSlideMetrics(e) {
        var i, n;
        const s = this.isHorizontal ? "width" : "height";
        let o = 0, a = 0, r = e.el;
        const l = !(!r || r.parentNode);
        if (r ? o = parseFloat(r.dataset[s] || "") || 0 : (r = document.createElement("div"), r.style.visibility = "hidden", (this.track || document.body).prepend(r)), $c2cbdf39c20c8a0e$var$P(r, this.cn($c2cbdf39c20c8a0e$var$J) + " " + e.class + " " + e.customClass), o) r.style[s] = `${o}px`, r.style["width" === s ? "height" : "width"] = "";
        else {
            l && (this.track || document.body).prepend(r), o = r.getBoundingClientRect()[s] * Math.max(1, (null === (i = window.visualViewport) || void 0 === i ? void 0 : i.scale) || 1);
            let t = r[this.isHorizontal ? "offsetWidth" : "offsetHeight"];
            t - 1 > o && (o = t);
        }
        const c = getComputedStyle(r);
        return "content-box" === c.boxSizing && (this.isHorizontal ? (o += parseFloat(c.paddingLeft) || 0, o += parseFloat(c.paddingRight) || 0) : (o += parseFloat(c.paddingTop) || 0, o += parseFloat(c.paddingBottom) || 0)), a = parseFloat(c[this.isHorizontal ? "marginRight" : "marginBottom"]) || 0, l ? null === (n = r.parentElement) || void 0 === n || n.removeChild(r) : e.el || r.remove(), {
            dim: $c2cbdf39c20c8a0e$var$t(o, 1e3),
            gap: $c2cbdf39c20c8a0e$var$t(a, 1e3)
        };
    }
    getBounds() {
        const { isInfinite: t, isRTL: e, isHorizontal: i, pages: n } = this;
        let s = {
            min: 0,
            max: 0
        };
        if (t) s = {
            min: -1 / 0,
            max: 1 / 0
        };
        else if (n.length) {
            const t = n[0].pos, o = n[n.length - 1].pos;
            s = e && i ? {
                min: t,
                max: o
            } : {
                min: -1 * o,
                max: -1 * t
            };
        }
        return {
            x: i ? s : {
                min: 0,
                max: 0
            },
            y: i ? {
                min: 0,
                max: 0
            } : s
        };
    }
    repositionSlides() {
        let e, { isHorizontal: i, isRTL: n, isInfinite: s, viewport: o, viewportDim: a, contentDim: r, page: l, pages: c, slides: h, panzoom: d } = this, u = 0, p = 0, f = 0, g = 0;
        d ? g = -1 * d.current[this.axis] : c[l] && (g = c[l].pos || 0), e = i ? n ? "right" : "left" : "top", n && i && (g *= -1);
        for (const i of h){
            const n = i.el;
            n ? ("top" === e ? (n.style.right = "", n.style.left = "") : n.style.top = "", i.index !== u ? n.style[e] = 0 === p ? "" : `${$c2cbdf39c20c8a0e$var$t(p, 1e3)}px` : n.style[e] = "", f += i.dim + i.gap, u++) : p += i.dim + i.gap;
        }
        if (s && f && o) {
            let n = getComputedStyle(o), s = "padding", l = i ? "Right" : "Bottom", c = parseFloat(n[s + (i ? "Left" : "Top")]);
            g -= c, a += c, a += parseFloat(n[s + l]);
            for (const i of h)i.el && ($c2cbdf39c20c8a0e$var$t(i.pos) < $c2cbdf39c20c8a0e$var$t(a) && $c2cbdf39c20c8a0e$var$t(i.pos + i.dim + i.gap) < $c2cbdf39c20c8a0e$var$t(g) && $c2cbdf39c20c8a0e$var$t(g) > $c2cbdf39c20c8a0e$var$t(r - a) && (i.el.style[e] = `${$c2cbdf39c20c8a0e$var$t(p + f, 1e3)}px`), $c2cbdf39c20c8a0e$var$t(i.pos + i.gap) >= $c2cbdf39c20c8a0e$var$t(r - a) && $c2cbdf39c20c8a0e$var$t(i.pos) > $c2cbdf39c20c8a0e$var$t(g + a) && $c2cbdf39c20c8a0e$var$t(g) < $c2cbdf39c20c8a0e$var$t(a) && (i.el.style[e] = `-${$c2cbdf39c20c8a0e$var$t(f, 1e3)}px`));
        }
        let m, v, b = [
            ...this.inTransition
        ];
        if (b.length > 1 && (m = c[b[0]], v = c[b[1]]), m && v) {
            let i = 0;
            for (const n of h)n.el ? this.inTransition.has(n.index) && m.slides.indexOf(n) < 0 && (n.el.style[e] = `${$c2cbdf39c20c8a0e$var$t(i + (m.pos - v.pos), 1e3)}px`) : i += n.dim + n.gap;
        }
    }
    createSlideEl(t) {
        const { track: e, slides: i } = this;
        if (!e || !t) return;
        if (t.el && t.el.parentNode) return;
        const n = t.el || document.createElement("div");
        $c2cbdf39c20c8a0e$var$P(n, this.cn($c2cbdf39c20c8a0e$var$J)), $c2cbdf39c20c8a0e$var$P(n, t.class), $c2cbdf39c20c8a0e$var$P(n, t.customClass);
        const s = t.html;
        s && (s instanceof HTMLElement ? n.appendChild(s) : n.innerHTML = t.html + "");
        const o = [];
        i.forEach((t, e)=>{
            t.el && o.push(e);
        });
        const a = t.index;
        let r = null;
        if (o.length) r = i[o.reduce((t, e)=>Math.abs(e - a) < Math.abs(t - a) ? e : t)];
        const l = r && r.el && r.el.parentNode ? r.index < t.index ? r.el.nextSibling : r.el : null;
        e.insertBefore(n, e.contains(l) ? l : null), t.el = n, this.emit("createSlide", t);
    }
    removeSlideEl(t, e = !1) {
        const i = null == t ? void 0 : t.el;
        if (!i || !i.parentNode) return;
        const n = this.cn($c2cbdf39c20c8a0e$var$K);
        if (i.classList.contains(n) && ($c2cbdf39c20c8a0e$var$S(i, n), this.emit("unselectSlide", t)), t.isDom && !e) return i.removeAttribute("aria-hidden"), i.removeAttribute("data-index"), void (i.style.left = "");
        this.emit("removeSlide", t);
        const s = new CustomEvent($c2cbdf39c20c8a0e$var$G);
        i.dispatchEvent(s), t.el && (t.el.remove(), t.el = null);
    }
    transitionTo(t = 0, e = this.option("transition")) {
        var i, n, s, o;
        if (!e) return !1;
        const a = this.page, { pages: r, panzoom: l } = this;
        t = parseInt((t || 0).toString()) || 0;
        const c = this.getPageFromIndex(t);
        if (!l || !r[c] || r.length < 2 || Math.abs(((null === (n = null === (i = r[a]) || void 0 === i ? void 0 : i.slides[0]) || void 0 === n ? void 0 : n.dim) || 0) - this.viewportDim) > 1) return !1;
        let h = t > a ? 1 : -1;
        this.isInfinite && (0 === a && t === r.length - 1 && (h = -1), a === r.length - 1 && 0 === t && (h = 1));
        const d = r[c].pos * (this.isRTL ? 1 : -1);
        if (a === c && Math.abs(d - l.target[this.axis]) < 1) return !1;
        this.clearTransitions();
        const u = l.isResting;
        $c2cbdf39c20c8a0e$var$P(this.container, this.cn("inTransition"));
        const p = (null === (s = r[a]) || void 0 === s ? void 0 : s.slides[0]) || null, f = (null === (o = r[c]) || void 0 === o ? void 0 : o.slides[0]) || null;
        this.inTransition.add(f.index), this.createSlideEl(f);
        let g = p.el, m = f.el;
        u || e === $c2cbdf39c20c8a0e$var$J || (e = "fadeFast", g = null);
        const v = this.isRTL ? "next" : "prev", b = this.isRTL ? "prev" : "next";
        return g && (this.inTransition.add(p.index), p.transition = e, g.addEventListener($c2cbdf39c20c8a0e$var$G, this.onAnimationEnd), g.classList.add(`f-${e}Out`, `to-${h > 0 ? b : v}`)), m && (f.transition = e, m.addEventListener($c2cbdf39c20c8a0e$var$G, this.onAnimationEnd), m.classList.add(`f-${e}In`, `from-${h > 0 ? v : b}`)), l.current[this.axis] = d, l.target[this.axis] = d, l.requestTick(), this.onChange(c), !0;
    }
    manageSlideVisiblity() {
        const t = new Set, e = new Set, i = this.getVisibleSlides(parseFloat(this.option("preload", 0) + "") || 0);
        for (const n of this.slides)i.has(n) ? t.add(n) : e.add(n);
        for (const e of this.inTransition)t.add(this.slides[e]);
        for (const e of t)this.createSlideEl(e), this.lazyLoadSlide(e);
        for (const i of e)t.has(i) || this.removeSlideEl(i);
        this.markSelectedSlides(), this.repositionSlides();
    }
    markSelectedSlides() {
        if (!this.pages[this.page] || !this.pages[this.page].slides) return;
        const t = "aria-hidden";
        let e = this.cn($c2cbdf39c20c8a0e$var$K);
        if (e) for (const i of this.slides){
            const n = i.el;
            n && (n.dataset.index = `${i.index}`, n.classList.contains("f-thumbs__slide") ? this.getVisibleSlides(0).has(i) ? n.removeAttribute(t) : n.setAttribute(t, "true") : this.pages[this.page].slides.includes(i) ? (n.classList.contains(e) || ($c2cbdf39c20c8a0e$var$P(n, e), this.emit("selectSlide", i)), n.removeAttribute(t)) : (n.classList.contains(e) && ($c2cbdf39c20c8a0e$var$S(n, e), this.emit("unselectSlide", i)), n.setAttribute(t, "true")));
        }
    }
    flipInfiniteTrack() {
        const { axis: t, isHorizontal: e, isInfinite: i, isRTL: n, viewportDim: s, contentDim: o } = this, a = this.panzoom;
        if (!a || !i) return;
        let r = a.current[t], l = a.target[t] - r, c = 0, h = .5 * s;
        n && e ? (r < -h && (c = -1, r += o), r > o - h && (c = 1, r -= o)) : (r > h && (c = 1, r -= o), r < -o + h && (c = -1, r += o)), c && (a.current[t] = r, a.target[t] = r + l);
    }
    lazyLoadImg(t, e) {
        const i = this, s = "f-fadeIn", o = "is-preloading";
        let a = !1, r = null;
        const l = ()=>{
            a || (a = !0, r && (r.remove(), r = null), $c2cbdf39c20c8a0e$var$S(e, o), e.complete && ($c2cbdf39c20c8a0e$var$P(e, s), setTimeout(()=>{
                $c2cbdf39c20c8a0e$var$S(e, s);
            }, 350)), this.option("adaptiveHeight") && t.el && this.pages[this.page].slides.indexOf(t) > -1 && (i.updateMetrics(), i.setViewportHeight()), this.emit("load", t));
        };
        $c2cbdf39c20c8a0e$var$P(e, o), e.src = e.dataset.lazySrcset || e.dataset.lazySrc || "", delete e.dataset.lazySrc, delete e.dataset.lazySrcset, e.addEventListener("error", ()=>{
            l();
        }), e.addEventListener("load", ()=>{
            l();
        }), setTimeout(()=>{
            const i = e.parentNode;
            i && t.el && (e.complete ? l() : a || (r = $c2cbdf39c20c8a0e$var$n($c2cbdf39c20c8a0e$var$x), i.insertBefore(r, e)));
        }, 300);
    }
    lazyLoadSlide(t) {
        const e = t && t.el;
        if (!e) return;
        const i = new Set;
        let n = Array.from(e.querySelectorAll("[data-lazy-src],[data-lazy-srcset]"));
        e.dataset.lazySrc && n.push(e), n.map((t)=>{
            t instanceof HTMLImageElement ? i.add(t) : t instanceof HTMLElement && t.dataset.lazySrc && (t.style.backgroundImage = `url('${t.dataset.lazySrc}')`, delete t.dataset.lazySrc);
        });
        for (const e of i)this.lazyLoadImg(t, e);
    }
    onAnimationEnd(t) {
        var e;
        const i = t.target, n = i ? parseInt(i.dataset.index || "", 10) || 0 : -1, s = this.slides[n], o = t.animationName;
        if (!i || !s || !o) return;
        const a = !!this.inTransition.has(n) && s.transition;
        a && o.substring(0, a.length + 2) === `f-${a}` && this.inTransition.delete(n), this.inTransition.size || this.clearTransitions(), n === this.page && (null === (e = this.panzoom) || void 0 === e ? void 0 : e.isResting) && this.emit("settle");
    }
    onDecel(t, e = 0, i = 0, n = 0, s = 0) {
        if (this.option("dragFree")) return void this.setPageFromPosition();
        const { isRTL: o, isHorizontal: a, axis: r, pages: l } = this, c = l.length, h = Math.abs(Math.atan2(i, e) / (Math.PI / 180));
        let d = 0;
        if (d = h > 45 && h < 135 ? a ? 0 : i : a ? e : 0, !c) return;
        let u = this.page, p = o && a ? 1 : -1;
        const f = t.current[r] * p;
        let { pageIndex: g } = this.getPageFromPosition(f);
        Math.abs(d) > 5 ? (l[u].dim < document.documentElement["client" + (this.isHorizontal ? "Width" : "Height")] - 1 && (u = g), u = o && a ? d < 0 ? u - 1 : u + 1 : d < 0 ? u + 1 : u - 1) : u = 0 === n && 0 === s ? u : g, this.slideTo(u, {
            transition: !1,
            friction: t.option("decelFriction")
        });
    }
    onClick(t) {
        const e = t.target, i = e && $c2cbdf39c20c8a0e$var$E(e) ? e.dataset : null;
        let n, s;
        i && (void 0 !== i.carouselPage ? (s = "slideTo", n = i.carouselPage) : void 0 !== i.carouselNext ? s = "slideNext" : void 0 !== i.carouselPrev && (s = "slidePrev")), s ? (t.preventDefault(), t.stopPropagation(), e && !e.hasAttribute("disabled") && this[s](n)) : this.emit("click", t);
    }
    onSlideTo(t) {
        const e = t.detail || 0;
        this.slideTo(this.getPageForSlide(e), {
            friction: 0
        });
    }
    onChange(t, e = 0) {
        const i = this.page;
        this.prevPage = i, this.page = t, this.option("adaptiveHeight") && this.setViewportHeight(), t !== i && (this.markSelectedSlides(), this.emit("change", t, i, e));
    }
    onRefresh() {
        let t = this.contentDim, e = this.viewportDim;
        this.updateMetrics(), this.contentDim === t && this.viewportDim === e || this.slideTo(this.page, {
            friction: 0,
            transition: !1
        });
    }
    onScroll() {
        var t;
        null === (t = this.viewport) || void 0 === t || t.scroll(0, 0);
    }
    onResize() {
        this.option("breakpoints") && this.processOptions();
    }
    onBeforeTransform(t) {
        this.lp !== t.current[this.axis] && (this.flipInfiniteTrack(), this.manageSlideVisiblity()), this.lp = t.current.e;
    }
    onEndAnimation() {
        this.inTransition.size || this.emit("settle");
    }
    reInit(t = null, e = null) {
        this.destroy(), this.state = $c2cbdf39c20c8a0e$var$B.Init, this.prevPage = null, this.userOptions = t || this.userOptions, this.userPlugins = e || this.userPlugins, this.processOptions();
    }
    slideTo(t = 0, { friction: e = this.option("friction"), transition: i = this.option("transition") } = {}) {
        if (this.state === $c2cbdf39c20c8a0e$var$B.Destroy) return;
        t = parseInt((t || 0).toString()) || 0;
        const n = this.getPageFromIndex(t), { axis: s, isHorizontal: o, isRTL: a, pages: r, panzoom: l } = this, c = r.length, h = a && o ? 1 : -1;
        if (!l || !c) return;
        if (this.page !== n) {
            const e = new Event("beforeChange", {
                bubbles: !0,
                cancelable: !0
            });
            if (this.emit("beforeChange", e, t), e.defaultPrevented) return;
        }
        if (this.transitionTo(t, i)) return;
        let d = r[n].pos;
        if (this.isInfinite) {
            const e = this.contentDim, i = l.target[s] * h;
            if (2 === c) d += e * Math.floor(parseFloat(t + "") / 2);
            else d = [
                d,
                d - e,
                d + e
            ].reduce(function(t, e) {
                return Math.abs(e - i) < Math.abs(t - i) ? e : t;
            });
        }
        d *= h, Math.abs(l.target[s] - d) < 1 || (l.panTo({
            x: o ? d : 0,
            y: o ? 0 : d,
            friction: e
        }), this.onChange(n));
    }
    slideToClosest(t) {
        if (this.panzoom) {
            const { pageIndex: e } = this.getPageFromPosition();
            this.slideTo(e, t);
        }
    }
    slideNext() {
        this.slideTo(this.page + 1);
    }
    slidePrev() {
        this.slideTo(this.page - 1);
    }
    clearTransitions() {
        this.inTransition.clear(), $c2cbdf39c20c8a0e$var$S(this.container, this.cn("inTransition"));
        const t = [
            "to-prev",
            "to-next",
            "from-prev",
            "from-next"
        ];
        for (const e of this.slides){
            const i = e.el;
            if (i) {
                i.removeEventListener($c2cbdf39c20c8a0e$var$G, this.onAnimationEnd), i.classList.remove(...t);
                const n = e.transition;
                n && i.classList.remove(`f-${n}Out`, `f-${n}In`);
            }
        }
        this.manageSlideVisiblity();
    }
    addSlide(t, e) {
        var i, n, s, o;
        const a = this.panzoom, r = (null === (i = this.pages[this.page]) || void 0 === i ? void 0 : i.pos) || 0, l = (null === (n = this.pages[this.page]) || void 0 === n ? void 0 : n.dim) || 0, c = this.contentDim < this.viewportDim;
        let h = Array.isArray(e) ? e : [
            e
        ];
        const d = [];
        for (const t of h)d.push($c2cbdf39c20c8a0e$var$H(t));
        this.slides.splice(t, 0, ...d);
        for(let t = 0; t < this.slides.length; t++)this.slides[t].index = t;
        for (const t of d)this.emit("beforeInitSlide", t, t.index);
        if (this.page >= t && (this.page += d.length), this.updateMetrics(), a) {
            const e = (null === (s = this.pages[this.page]) || void 0 === s ? void 0 : s.pos) || 0, i = (null === (o = this.pages[this.page]) || void 0 === o ? void 0 : o.dim) || 0, n = this.pages.length || 1, h = this.isRTL ? l - i : i - l, d = this.isRTL ? r - e : e - r;
            c && 1 === n ? (t <= this.page && (a.current[this.axis] -= h, a.target[this.axis] -= h), a.panTo({
                [this.isHorizontal ? "x" : "y"]: -1 * e
            })) : d && t <= this.page && (a.target[this.axis] -= d, a.current[this.axis] -= d, a.requestTick());
        }
        for (const t of d)this.emit("initSlide", t, t.index);
    }
    prependSlide(t) {
        this.addSlide(0, t);
    }
    appendSlide(t) {
        this.addSlide(this.slides.length, t);
    }
    removeSlide(t) {
        const e = this.slides.length;
        t = (t % e + e) % e;
        const i = this.slides[t];
        if (i) {
            this.removeSlideEl(i, !0), this.slides.splice(t, 1);
            for(let t = 0; t < this.slides.length; t++)this.slides[t].index = t;
            this.updateMetrics(), this.slideTo(this.page, {
                friction: 0,
                transition: !1
            }), this.emit("destroySlide", i);
        }
    }
    updateMetrics() {
        const { panzoom: e, viewport: i, track: n, slides: s, isHorizontal: o, isInfinite: a } = this;
        if (!n) return;
        const r = o ? "width" : "height", l = o ? "offsetWidth" : "offsetHeight";
        if (i) {
            let e = Math.max(i[l], $c2cbdf39c20c8a0e$var$t(i.getBoundingClientRect()[r], 1e3)), n = getComputedStyle(i), s = "padding", a = o ? "Right" : "Bottom";
            e -= parseFloat(n[s + (o ? "Left" : "Top")]) + parseFloat(n[s + a]), this.viewportDim = e;
        }
        let c, h = 0;
        for (const [e, i] of s.entries()){
            let n = 0, o = 0;
            !i.el && c ? (n = c.dim, o = c.gap) : ({ dim: n, gap: o } = this.getSlideMetrics(i), c = i), n = $c2cbdf39c20c8a0e$var$t(n, 1e3), o = $c2cbdf39c20c8a0e$var$t(o, 1e3), i.dim = n, i.gap = o, i.pos = h, h += n, (a || e < s.length - 1) && (h += o);
        }
        h = $c2cbdf39c20c8a0e$var$t(h, 1e3), this.contentDim = h, e && (e.contentRect[r] = h, e.contentRect[o ? "fullWidth" : "fullHeight"] = h), this.pages = this.createPages(), this.pages = this.processPages(), this.state === $c2cbdf39c20c8a0e$var$B.Init && this.setInitialPage(), this.page = Math.max(0, Math.min(this.page, this.pages.length - 1)), this.manageSlideVisiblity(), this.emit("refresh");
    }
    getProgress(e, i = !1, n = !1) {
        void 0 === e && (e = this.page);
        const s = this, o = s.panzoom, a = s.contentDim, r = s.pages[e] || 0;
        if (!r || !o) return e > this.page ? -1 : 1;
        let l = -1 * o.current.e, c = $c2cbdf39c20c8a0e$var$t((l - r.pos) / (1 * r.dim), 1e3), h = c, d = c;
        this.isInfinite && !0 !== n && (h = $c2cbdf39c20c8a0e$var$t((l - r.pos + a) / (1 * r.dim), 1e3), d = $c2cbdf39c20c8a0e$var$t((l - r.pos - a) / (1 * r.dim), 1e3));
        let u = [
            c,
            h,
            d
        ].reduce(function(t, e) {
            return Math.abs(e) < Math.abs(t) ? e : t;
        });
        return i ? u : u > 1 ? 1 : u < -1 ? -1 : u;
    }
    setViewportHeight() {
        const { page: t, pages: e, viewport: i, isHorizontal: n } = this;
        if (!i || !e[t]) return;
        let s = 0;
        n && this.track && (this.track.style.height = "auto", e[t].slides.forEach((t)=>{
            t.el && (s = Math.max(s, t.el.offsetHeight));
        })), i.style.height = s ? `${s}px` : "";
    }
    getPageForSlide(t) {
        for (const e of this.pages)for (const i of e.slides)if (i.index === t) return e.index;
        return -1;
    }
    getVisibleSlides(t = 0) {
        var e;
        const i = new Set;
        let { panzoom: n, contentDim: s, viewportDim: o, pages: a, page: r } = this;
        if (o) {
            s = s + (null === (e = this.slides[this.slides.length - 1]) || void 0 === e ? void 0 : e.gap) || 0;
            let l = 0;
            l = n && n.state !== $c2cbdf39c20c8a0e$var$m.Init && n.state !== $c2cbdf39c20c8a0e$var$m.Destroy ? -1 * n.current[this.axis] : a[r] && a[r].pos || 0, this.isInfinite && (l -= Math.floor(l / s) * s), this.isRTL && this.isHorizontal && (l *= -1);
            const c = l - o * t, h = l + o * (t + 1), d = this.isInfinite ? [
                -1,
                0,
                1
            ] : [
                0
            ];
            for (const t of this.slides)for (const e of d){
                const n = t.pos + e * s, o = n + t.dim + t.gap;
                n < h && o > c && i.add(t);
            }
        }
        return i;
    }
    getPageFromPosition(t) {
        const { viewportDim: e, contentDim: i, slides: n, pages: s, panzoom: o } = this, a = s.length, r = n.length, l = n[0], c = n[r - 1], h = this.option("center");
        let d = 0, u = 0, p = 0, f = void 0 === t ? -1 * ((null == o ? void 0 : o.target[this.axis]) || 0) : t;
        h && (f += .5 * e), this.isInfinite ? (f < l.pos - .5 * c.gap && (f -= i, p = -1), f > c.pos + c.dim + .5 * c.gap && (f -= i, p = 1)) : f = Math.max(l.pos || 0, Math.min(f, c.pos));
        let g = c, m = n.find((t)=>{
            const e = t.pos - .5 * g.gap, i = t.pos + t.dim + .5 * t.gap;
            return g = t, f >= e && f < i;
        });
        return m || (m = c), u = this.getPageForSlide(m.index), d = u + p * a, {
            page: d,
            pageIndex: u
        };
    }
    setPageFromPosition() {
        const { pageIndex: t } = this.getPageFromPosition();
        this.onChange(t);
    }
    destroy() {
        if ([
            $c2cbdf39c20c8a0e$var$B.Destroy
        ].includes(this.state)) return;
        this.state = $c2cbdf39c20c8a0e$var$B.Destroy;
        const { container: t, viewport: e, track: i, slides: n, panzoom: s } = this, o = this.option("classes");
        t.removeEventListener("click", this.onClick, {
            passive: !1,
            capture: !1
        }), t.removeEventListener("slideTo", this.onSlideTo), window.removeEventListener("resize", this.onResize), s && (s.destroy(), this.panzoom = null), n && n.forEach((t)=>{
            this.removeSlideEl(t);
        }), this.detachPlugins(), e && (e.removeEventListener("scroll", this.onScroll), e.offsetParent && i && i.offsetParent && e.replaceWith(...i.childNodes));
        for (const [e, i] of Object.entries(o))"container" !== e && i && t.classList.remove(i);
        this.track = null, this.viewport = null, this.page = 0, this.slides = [];
        const a = this.events.get("ready");
        this.events = new Map, a && this.events.set("ready", a);
    }
}
Object.defineProperty($c2cbdf39c20c8a0e$export$144901db2ea8e967, "Panzoom", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $c2cbdf39c20c8a0e$export$b704d075ddd20210
}), Object.defineProperty($c2cbdf39c20c8a0e$export$144901db2ea8e967, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $c2cbdf39c20c8a0e$var$j
}), Object.defineProperty($c2cbdf39c20c8a0e$export$144901db2ea8e967, "Plugins", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $c2cbdf39c20c8a0e$var$U
});
const $c2cbdf39c20c8a0e$var$tt = function(t) {
    if (!$c2cbdf39c20c8a0e$var$E(t)) return 0;
    const e = window.scrollY, i = window.innerHeight, n = e + i, s = t.getBoundingClientRect(), o = s.y + e, a = s.height, r = o + a;
    if (e > r || n < o) return 0;
    if (e < o && n > r) return 100;
    if (o < e && r > n) return 100;
    let l = a;
    o < e && (l -= e - o), r > n && (l -= r - n);
    const c = l / i * 100;
    return Math.round(c);
}, $c2cbdf39c20c8a0e$var$et = !("undefined" == typeof window || !window.document || !window.document.createElement);
let $c2cbdf39c20c8a0e$var$it;
const $c2cbdf39c20c8a0e$var$nt = [
    "a[href]",
    "area[href]",
    'input:not([disabled]):not([type="hidden"]):not([aria-hidden])',
    "select:not([disabled]):not([aria-hidden])",
    "textarea:not([disabled]):not([aria-hidden])",
    "button:not([disabled]):not([aria-hidden]):not(.fancybox-focus-guard)",
    "iframe",
    "object",
    "embed",
    "video",
    "audio",
    "[contenteditable]",
    '[tabindex]:not([tabindex^="-"]):not([disabled]):not([aria-hidden])'
].join(","), $c2cbdf39c20c8a0e$var$st = (t)=>{
    if (t && $c2cbdf39c20c8a0e$var$et) {
        void 0 === $c2cbdf39c20c8a0e$var$it && document.createElement("div").focus({
            get preventScroll () {
                return $c2cbdf39c20c8a0e$var$it = !0, !1;
            }
        });
        try {
            if ($c2cbdf39c20c8a0e$var$it) t.focus({
                preventScroll: !0
            });
            else {
                const e = window.scrollY || document.body.scrollTop, i = window.scrollX || document.body.scrollLeft;
                t.focus(), document.body.scrollTo({
                    top: e,
                    left: i,
                    behavior: "auto"
                });
            }
        } catch (t) {}
    }
}, $c2cbdf39c20c8a0e$var$ot = ()=>{
    const t = document;
    let e, i = "", n = "", s = "";
    return t.fullscreenEnabled ? (i = "requestFullscreen", n = "exitFullscreen", s = "fullscreenElement") : t.webkitFullscreenEnabled && (i = "webkitRequestFullscreen", n = "webkitExitFullscreen", s = "webkitFullscreenElement"), i && (e = {
        request: function(e = t.documentElement) {
            return "webkitRequestFullscreen" === i ? e[i](Element.ALLOW_KEYBOARD_INPUT) : e[i]();
        },
        exit: function() {
            return t[s] && t[n]();
        },
        isFullscreen: function() {
            return t[s];
        }
    }), e;
}, $c2cbdf39c20c8a0e$var$at = {
    animated: !0,
    autoFocus: !0,
    backdropClick: "close",
    Carousel: {
        classes: {
            container: "fancybox__carousel",
            viewport: "fancybox__viewport",
            track: "fancybox__track",
            slide: "fancybox__slide"
        }
    },
    closeButton: "auto",
    closeExisting: !1,
    commonCaption: !1,
    compact: ()=>window.matchMedia("(max-width: 578px), (max-height: 578px)").matches,
    contentClick: "toggleZoom",
    contentDblClick: !1,
    defaultType: "image",
    defaultDisplay: "flex",
    dragToClose: !0,
    Fullscreen: {
        autoStart: !1
    },
    groupAll: !1,
    groupAttr: "data-fancybox",
    hideClass: "f-fadeOut",
    hideScrollbar: !0,
    idle: 3500,
    keyboard: {
        Escape: "close",
        Delete: "close",
        Backspace: "close",
        PageUp: "next",
        PageDown: "prev",
        ArrowUp: "prev",
        ArrowDown: "next",
        ArrowRight: "next",
        ArrowLeft: "prev"
    },
    l10n: Object.assign(Object.assign({}, $c2cbdf39c20c8a0e$var$b), {
        CLOSE: "Close",
        NEXT: "Next",
        PREV: "Previous",
        MODAL: "You can close this modal content with the ESC key",
        ERROR: "Something Went Wrong, Please Try Again Later",
        IMAGE_ERROR: "Image Not Found",
        ELEMENT_NOT_FOUND: "HTML Element Not Found",
        AJAX_NOT_FOUND: "Error Loading AJAX : Not Found",
        AJAX_FORBIDDEN: "Error Loading AJAX : Forbidden",
        IFRAME_ERROR: "Error Loading Page",
        TOGGLE_ZOOM: "Toggle zoom level",
        TOGGLE_THUMBS: "Toggle thumbnails",
        TOGGLE_SLIDESHOW: "Toggle slideshow",
        TOGGLE_FULLSCREEN: "Toggle full-screen mode",
        DOWNLOAD: "Download"
    }),
    parentEl: null,
    placeFocusBack: !0,
    showClass: "f-zoomInUp",
    startIndex: 0,
    tpl: {
        closeButton: '<button data-fancybox-close class="f-button is-close-btn" title="{{CLOSE}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1"><path d="M20 20L4 4m16 0L4 20"/></svg></button>',
        main: '<div class="fancybox__container" role="dialog" aria-modal="true" aria-label="{{MODAL}}" tabindex="-1">\n    <div class="fancybox__backdrop"></div>\n    <div class="fancybox__carousel"></div>\n    <div class="fancybox__footer"></div>\n  </div>'
    },
    trapFocus: !0,
    wheel: "zoom"
};
var $c2cbdf39c20c8a0e$var$rt, $c2cbdf39c20c8a0e$var$lt;
!function(t) {
    t[t.Init = 0] = "Init", t[t.Ready = 1] = "Ready", t[t.Closing = 2] = "Closing", t[t.CustomClosing = 3] = "CustomClosing", t[t.Destroy = 4] = "Destroy";
}($c2cbdf39c20c8a0e$var$rt || ($c2cbdf39c20c8a0e$var$rt = {})), function(t) {
    t[t.Loading = 0] = "Loading", t[t.Opening = 1] = "Opening", t[t.Ready = 2] = "Ready", t[t.Closing = 3] = "Closing";
}($c2cbdf39c20c8a0e$var$lt || ($c2cbdf39c20c8a0e$var$lt = {}));
let $c2cbdf39c20c8a0e$var$ct = "", $c2cbdf39c20c8a0e$var$ht = !1, $c2cbdf39c20c8a0e$var$dt = !1, $c2cbdf39c20c8a0e$var$ut = null;
const $c2cbdf39c20c8a0e$var$pt = ()=>{
    let t = "", e = "";
    const i = $c2cbdf39c20c8a0e$export$cb45b08d97cdc4fd.getInstance();
    if (i) {
        const n = i.carousel, s = i.getSlide();
        if (n && s) {
            let o = s.slug || void 0, a = s.triggerEl || void 0;
            e = o || i.option("slug") || "", !e && a && a.dataset && (e = a.dataset.fancybox || ""), e && "true" !== e && (t = "#" + e + (!o && n.slides.length > 1 ? "-" + (s.index + 1) : ""));
        }
    }
    return {
        hash: t,
        slug: e,
        index: 1
    };
}, $c2cbdf39c20c8a0e$var$ft = ()=>{
    const t = new URL(document.URL).hash, e = t.slice(1).split("-"), i = e[e.length - 1], n = i && /^\+?\d+$/.test(i) && parseInt(e.pop() || "1", 10) || 1;
    return {
        hash: t,
        slug: e.join("-"),
        index: n
    };
}, $c2cbdf39c20c8a0e$var$gt = ()=>{
    const { slug: t, index: e } = $c2cbdf39c20c8a0e$var$ft();
    if (!t) return;
    let i = document.querySelector(`[data-slug="${t}"]`);
    if (i && i.dispatchEvent(new CustomEvent("click", {
        bubbles: !0,
        cancelable: !0
    })), $c2cbdf39c20c8a0e$export$cb45b08d97cdc4fd.getInstance()) return;
    const n = document.querySelectorAll(`[data-fancybox="${t}"]`);
    n.length && (i = n[e - 1], i && i.dispatchEvent(new CustomEvent("click", {
        bubbles: !0,
        cancelable: !0
    })));
}, $c2cbdf39c20c8a0e$var$mt = ()=>{
    if (!1 === $c2cbdf39c20c8a0e$export$cb45b08d97cdc4fd.defaults.Hash) return;
    const t = $c2cbdf39c20c8a0e$export$cb45b08d97cdc4fd.getInstance();
    if (!1 === (null == t ? void 0 : t.options.Hash)) return;
    const { slug: e, index: i } = $c2cbdf39c20c8a0e$var$ft(), { slug: n } = $c2cbdf39c20c8a0e$var$pt();
    t && (e === n ? t.jumpTo(i - 1) : ($c2cbdf39c20c8a0e$var$ht = !0, t.close())), $c2cbdf39c20c8a0e$var$gt();
}, $c2cbdf39c20c8a0e$var$vt = ()=>{
    $c2cbdf39c20c8a0e$var$ut && clearTimeout($c2cbdf39c20c8a0e$var$ut), queueMicrotask(()=>{
        $c2cbdf39c20c8a0e$var$mt();
    });
}, $c2cbdf39c20c8a0e$var$bt = ()=>{
    window.addEventListener("hashchange", $c2cbdf39c20c8a0e$var$vt, !1), setTimeout(()=>{
        $c2cbdf39c20c8a0e$var$mt();
    }, 500);
};
$c2cbdf39c20c8a0e$var$et && (/complete|interactive|loaded/.test(document.readyState) ? $c2cbdf39c20c8a0e$var$bt() : document.addEventListener("DOMContentLoaded", $c2cbdf39c20c8a0e$var$bt));
const $c2cbdf39c20c8a0e$var$yt = "is-zooming-in";
class $c2cbdf39c20c8a0e$var$wt extends $c2cbdf39c20c8a0e$var$_ {
    onCreateSlide(t, e, i) {
        const n = this.instance.optionFor(i, "src") || "";
        i.el && "image" === i.type && "string" == typeof n && this.setImage(i, n);
    }
    onRemoveSlide(t, e, i) {
        i.panzoom && i.panzoom.destroy(), i.panzoom = void 0, i.imageEl = void 0;
    }
    onChange(t, e, i, n) {
        $c2cbdf39c20c8a0e$var$S(this.instance.container, $c2cbdf39c20c8a0e$var$yt);
        for (const t of e.slides){
            const e = t.panzoom;
            e && t.index !== i && e.reset(.35);
        }
    }
    onClose() {
        var t;
        const e = this.instance, i = e.container, n = e.getSlide();
        if (!i || !i.parentElement || !n) return;
        const { el: s, contentEl: o, panzoom: a, thumbElSrc: r } = n;
        if (!s || !r || !o || !a || a.isContentLoading || a.state === $c2cbdf39c20c8a0e$var$m.Init || a.state === $c2cbdf39c20c8a0e$var$m.Destroy) return;
        a.updateMetrics();
        let l = this.getZoomInfo(n);
        if (!l) return;
        this.instance.state = $c2cbdf39c20c8a0e$var$rt.CustomClosing, i.classList.remove($c2cbdf39c20c8a0e$var$yt), i.classList.add("is-zooming-out"), o.style.backgroundImage = `url('${r}')`;
        const c = i.getBoundingClientRect();
        1 === ((null === (t = window.visualViewport) || void 0 === t ? void 0 : t.scale) || 1) && Object.assign(i.style, {
            position: "absolute",
            top: `${i.offsetTop + window.scrollY}px`,
            left: `${i.offsetLeft + window.scrollX}px`,
            bottom: "auto",
            right: "auto",
            width: `${c.width}px`,
            height: `${c.height}px`,
            overflow: "hidden"
        });
        const { x: h, y: d, scale: u, opacity: p } = l;
        if (p) {
            const t = ((t, e, i, n)=>{
                const s = e - t, o = n - i;
                return (e)=>i + ((e - t) / s * o || 0);
            })(a.scale, u, 1, 0);
            a.on("afterTransform", ()=>{
                o.style.opacity = t(a.scale) + "";
            });
        }
        a.on("endAnimation", ()=>{
            e.destroy();
        }), a.target.a = u, a.target.b = 0, a.target.c = 0, a.target.d = u, a.panTo({
            x: h,
            y: d,
            scale: u,
            friction: p ? .2 : .33,
            ignoreBounds: !0
        }), a.isResting && e.destroy();
    }
    setImage(t, e) {
        const i = this.instance;
        t.src = e, this.process(t, e).then((e)=>{
            const { contentEl: n, imageEl: s, thumbElSrc: o, el: a } = t;
            if (i.isClosing() || !n || !s) return;
            n.offsetHeight;
            const r = !!i.isOpeningSlide(t) && this.getZoomInfo(t);
            if (this.option("protected") && a) {
                a.addEventListener("contextmenu", (t)=>{
                    t.preventDefault();
                });
                const t = document.createElement("div");
                $c2cbdf39c20c8a0e$var$P(t, "fancybox-protected"), n.appendChild(t);
            }
            if (o && r) {
                const s = e.contentRect, a = Math.max(s.fullWidth, s.fullHeight);
                let c = null;
                !r.opacity && a > 1200 && (c = document.createElement("img"), $c2cbdf39c20c8a0e$var$P(c, "fancybox-ghost"), c.src = o, n.appendChild(c));
                const h = ()=>{
                    c && ($c2cbdf39c20c8a0e$var$P(c, "f-fadeFastOut"), setTimeout(()=>{
                        c && (c.remove(), c = null);
                    }, 200));
                };
                (l = o, new Promise((t, e)=>{
                    const i = new Image;
                    i.onload = t, i.onerror = e, i.src = l;
                })).then(()=>{
                    i.hideLoading(t), t.state = $c2cbdf39c20c8a0e$var$lt.Opening, this.instance.emit("reveal", t), this.zoomIn(t).then(()=>{
                        h(), this.instance.done(t);
                    }, ()=>{}), c && setTimeout(()=>{
                        h();
                    }, a > 2500 ? 800 : 200);
                }, ()=>{
                    i.hideLoading(t), i.revealContent(t);
                });
            } else {
                const n = this.optionFor(t, "initialSize"), s = this.optionFor(t, "zoom"), o = {
                    event: i.prevMouseMoveEvent || i.options.event,
                    friction: s ? .12 : 0
                };
                let a = i.optionFor(t, "showClass") || void 0, r = !0;
                i.isOpeningSlide(t) && ("full" === n ? e.zoomToFull(o) : "cover" === n ? e.zoomToCover(o) : "max" === n ? e.zoomToMax(o) : r = !1, e.stop("current")), r && a && (a = e.isDragging ? "f-fadeIn" : ""), i.hideLoading(t), i.revealContent(t, a);
            }
            var l;
        }, ()=>{
            i.setError(t, "{{IMAGE_ERROR}}");
        });
    }
    process(t, e) {
        return new Promise((i, s)=>{
            var o;
            const a = this.instance, r = t.el;
            a.clearContent(t), a.showLoading(t);
            let l = this.optionFor(t, "content");
            if ("string" == typeof l && (l = $c2cbdf39c20c8a0e$var$n(l)), !l || !$c2cbdf39c20c8a0e$var$E(l)) {
                if (l = document.createElement("img"), l instanceof HTMLImageElement) {
                    let i = "", n = t.caption;
                    i = "string" == typeof n && n ? n.replace(/<[^>]+>/gi, "").substring(0, 1e3) : `Image ${t.index + 1} of ${(null === (o = a.carousel) || void 0 === o ? void 0 : o.pages.length) || 1}`, l.src = e || "", l.alt = i, l.draggable = !1, t.srcset && l.setAttribute("srcset", t.srcset), this.instance.isOpeningSlide(t) && (l.fetchPriority = "high");
                }
                t.sizes && l.setAttribute("sizes", t.sizes);
            }
            $c2cbdf39c20c8a0e$var$P(l, "fancybox-image"), t.imageEl = l, a.setContent(t, l, !1);
            t.panzoom = new $c2cbdf39c20c8a0e$export$b704d075ddd20210(r, $c2cbdf39c20c8a0e$var$u({
                transformParent: !0
            }, this.option("Panzoom") || {}, {
                content: l,
                width: (e, i)=>a.optionFor(t, "width", "auto", i) || "auto",
                height: (e, i)=>a.optionFor(t, "height", "auto", i) || "auto",
                wheel: ()=>{
                    const t = a.option("wheel");
                    return ("zoom" === t || "pan" == t) && t;
                },
                click: (e, i)=>{
                    var n, s;
                    if (a.isCompact || a.isClosing()) return !1;
                    if (t.index !== (null === (n = a.getSlide()) || void 0 === n ? void 0 : n.index)) return !1;
                    if (i) {
                        const t = i.composedPath()[0];
                        if ([
                            "A",
                            "BUTTON",
                            "TEXTAREA",
                            "OPTION",
                            "INPUT",
                            "SELECT",
                            "VIDEO"
                        ].includes(t.nodeName)) return !1;
                    }
                    let o = !i || i.target && (null === (s = t.contentEl) || void 0 === s ? void 0 : s.contains(i.target));
                    return a.option(o ? "contentClick" : "backdropClick") || !1;
                },
                dblClick: ()=>a.isCompact ? "toggleZoom" : a.option("contentDblClick") || !1,
                spinner: !1,
                panOnlyZoomed: !0,
                wheelLimit: 1 / 0,
                on: {
                    ready: (t)=>{
                        i(t);
                    },
                    error: ()=>{
                        s();
                    },
                    destroy: ()=>{
                        s();
                    }
                }
            }));
        });
    }
    zoomIn(t) {
        return new Promise((e, i)=>{
            const n = this.instance, s = n.container, { panzoom: o, contentEl: a, el: r } = t;
            o && o.updateMetrics();
            const l = this.getZoomInfo(t);
            if (!(l && r && a && o && s)) return void i();
            const { x: c, y: h, scale: d, opacity: u } = l, p = ()=>{
                t.state !== $c2cbdf39c20c8a0e$var$lt.Closing && (u && (a.style.opacity = Math.max(Math.min(1, 1 - (1 - o.scale) / (1 - d)), 0) + ""), o.scale >= 1 && o.scale > o.targetScale - .1 && e(o));
            }, f = (t)=>{
                (t.scale < .99 || t.scale > 1.01) && !t.isDragging || ($c2cbdf39c20c8a0e$var$S(s, $c2cbdf39c20c8a0e$var$yt), a.style.opacity = "", t.off("endAnimation", f), t.off("touchStart", f), t.off("afterTransform", p), e(t));
            };
            o.on("endAnimation", f), o.on("touchStart", f), o.on("afterTransform", p), o.on([
                "error",
                "destroy"
            ], ()=>{
                i();
            }), o.panTo({
                x: c,
                y: h,
                scale: d,
                friction: 0,
                ignoreBounds: !0
            }), o.stop("current");
            const g = {
                event: "mousemove" === o.panMode ? n.prevMouseMoveEvent || n.options.event : void 0
            }, m = this.optionFor(t, "initialSize");
            $c2cbdf39c20c8a0e$var$P(s, $c2cbdf39c20c8a0e$var$yt), n.hideLoading(t), "full" === m ? o.zoomToFull(g) : "cover" === m ? o.zoomToCover(g) : "max" === m ? o.zoomToMax(g) : o.reset(.172);
        });
    }
    getZoomInfo(t) {
        const { el: e, imageEl: i, thumbEl: n, panzoom: s } = t, o = this.instance, a = o.container;
        if (!e || !i || !n || !s || $c2cbdf39c20c8a0e$var$tt(n) < 3 || !this.optionFor(t, "zoom") || !a || o.state === $c2cbdf39c20c8a0e$var$rt.Destroy) return !1;
        if ("0" === getComputedStyle(a).getPropertyValue("--f-images-zoom")) return !1;
        const r = window.visualViewport || null;
        if (1 !== (r ? r.scale : 1)) return !1;
        let { top: l, left: c, width: h, height: d } = n.getBoundingClientRect(), { top: u, left: p, fitWidth: f, fitHeight: g } = s.contentRect;
        if (!(h && d && f && g)) return !1;
        const m = s.container.getBoundingClientRect();
        p += m.left, u += m.top;
        const v = -1 * (p + .5 * f - (c + .5 * h)), b = -1 * (u + .5 * g - (l + .5 * d)), y = h / f;
        let w = this.option("zoomOpacity") || !1;
        return "auto" === w && (w = Math.abs(h / d - f / g) > .1), {
            x: v,
            y: b,
            scale: y,
            opacity: w
        };
    }
    attach() {
        const t = this, e = t.instance;
        e.on("Carousel.change", t.onChange), e.on("Carousel.createSlide", t.onCreateSlide), e.on("Carousel.removeSlide", t.onRemoveSlide), e.on("close", t.onClose);
    }
    detach() {
        const t = this, e = t.instance;
        e.off("Carousel.change", t.onChange), e.off("Carousel.createSlide", t.onCreateSlide), e.off("Carousel.removeSlide", t.onRemoveSlide), e.off("close", t.onClose);
    }
}
Object.defineProperty($c2cbdf39c20c8a0e$var$wt, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: {
        initialSize: "fit",
        Panzoom: {
            maxScale: 1
        },
        protected: !1,
        zoom: !0,
        zoomOpacity: "auto"
    }
}), "function" == typeof SuppressedError && SuppressedError;
const $c2cbdf39c20c8a0e$var$xt = "html", $c2cbdf39c20c8a0e$var$Et = "image", $c2cbdf39c20c8a0e$var$St = "map", $c2cbdf39c20c8a0e$var$Pt = "youtube", $c2cbdf39c20c8a0e$var$Ct = "vimeo", $c2cbdf39c20c8a0e$var$Tt = "html5video", $c2cbdf39c20c8a0e$var$Mt = (t, e = {})=>{
    const i = new URL(t), n = new URLSearchParams(i.search), s = new URLSearchParams;
    for (const [t, i] of [
        ...n,
        ...Object.entries(e)
    ]){
        let e = i + "";
        if ("t" === t) {
            let t = e.match(/((\d*)m)?(\d*)s?/);
            t && s.set("start", 60 * parseInt(t[2] || "0") + parseInt(t[3] || "0") + "");
        } else s.set(t, e);
    }
    let o = s + "", a = t.match(/#t=((.*)?\d+s)/);
    return a && (o += `#t=${a[1]}`), o;
}, $c2cbdf39c20c8a0e$var$Ot = {
    ajax: null,
    autoSize: !0,
    iframeAttr: {
        allow: "autoplay; fullscreen",
        scrolling: "auto"
    },
    preload: !0,
    videoAutoplay: !0,
    videoRatio: 16 / 9,
    videoTpl: '<video class="fancybox__html5video" playsinline controls controlsList="nodownload" poster="{{poster}}">\n  <source src="{{src}}" type="{{format}}" />Sorry, your browser doesn\'t support embedded videos.</video>',
    videoFormat: "",
    vimeo: {
        byline: 1,
        color: "00adef",
        controls: 1,
        dnt: 1,
        muted: 0
    },
    youtube: {
        controls: 1,
        enablejsapi: 1,
        nocookie: 1,
        rel: 0,
        fs: 1
    }
}, $c2cbdf39c20c8a0e$var$At = [
    "image",
    "html",
    "ajax",
    "inline",
    "clone",
    "iframe",
    "map",
    "pdf",
    "html5video",
    "youtube",
    "vimeo"
];
class $c2cbdf39c20c8a0e$var$Lt extends $c2cbdf39c20c8a0e$var$_ {
    onBeforeInitSlide(t, e, i) {
        this.processType(i);
    }
    onCreateSlide(t, e, i) {
        this.setContent(i);
    }
    onClearContent(t, e) {
        e.xhr && (e.xhr.abort(), e.xhr = null);
        const i = e.iframeEl;
        i && (i.onload = i.onerror = null, i.src = "//about:blank", e.iframeEl = null);
        const n = e.contentEl, s = e.placeholderEl;
        if ("inline" === e.type && n && s) n.classList.remove("fancybox__content"), "none" !== getComputedStyle(n).getPropertyValue("display") && (n.style.display = "none"), setTimeout(()=>{
            s && (n && s.parentNode && s.parentNode.insertBefore(n, s), s.remove());
        }, 0), e.contentEl = void 0, e.placeholderEl = void 0;
        else for(; e.el && e.el.firstChild;)e.el.removeChild(e.el.firstChild);
    }
    onSelectSlide(t, e, i) {
        i.state === $c2cbdf39c20c8a0e$var$lt.Ready && this.playVideo();
    }
    onUnselectSlide(t, e, i) {
        var n, s;
        if (i.type === $c2cbdf39c20c8a0e$var$Tt) {
            try {
                null === (s = null === (n = i.el) || void 0 === n ? void 0 : n.querySelector("video")) || void 0 === s || s.pause();
            } catch (t) {}
            return;
        }
        let o;
        i.type === $c2cbdf39c20c8a0e$var$Ct ? o = {
            method: "pause",
            value: "true"
        } : i.type === $c2cbdf39c20c8a0e$var$Pt && (o = {
            event: "command",
            func: "pauseVideo"
        }), o && i.iframeEl && i.iframeEl.contentWindow && i.iframeEl.contentWindow.postMessage(JSON.stringify(o), "*"), i.poller && clearTimeout(i.poller);
    }
    onDone(t, e) {
        t.isCurrentSlide(e) && !t.isClosing() && this.playVideo();
    }
    onRefresh(t, e) {
        e.slides.forEach((t)=>{
            t.el && (this.resizeIframe(t), this.setAspectRatio(t));
        });
    }
    onMessage(t) {
        try {
            let e = JSON.parse(t.data);
            if ("https://player.vimeo.com" === t.origin) {
                if ("ready" === e.event) for (let e of Array.from(document.getElementsByClassName("fancybox__iframe")))e instanceof HTMLIFrameElement && e.contentWindow === t.source && (e.dataset.ready = "true");
            } else if (t.origin.match(/^https:\/\/(www.)?youtube(-nocookie)?.com$/) && "onReady" === e.event) {
                const t = document.getElementById(e.id);
                t && (t.dataset.ready = "true");
            }
        } catch (t) {}
    }
    loadAjaxContent(t) {
        const e = this.instance.optionFor(t, "src") || "";
        this.instance.showLoading(t);
        const i = this.instance, n = new XMLHttpRequest;
        i.showLoading(t), n.onreadystatechange = function() {
            n.readyState === XMLHttpRequest.DONE && i.state === $c2cbdf39c20c8a0e$var$rt.Ready && (i.hideLoading(t), 200 === n.status ? i.setContent(t, n.responseText) : i.setError(t, 404 === n.status ? "{{AJAX_NOT_FOUND}}" : "{{AJAX_FORBIDDEN}}"));
        };
        const s = t.ajax || null;
        n.open(s ? "POST" : "GET", e + ""), n.setRequestHeader("Content-Type", "application/x-www-form-urlencoded"), n.setRequestHeader("X-Requested-With", "XMLHttpRequest"), n.send(s), t.xhr = n;
    }
    setInlineContent(t) {
        let e = null;
        if ($c2cbdf39c20c8a0e$var$E(t.src)) e = t.src;
        else if ("string" == typeof t.src) {
            const i = t.src.split("#", 2).pop();
            e = i ? document.getElementById(i) : null;
        }
        if (e) {
            if ("clone" === t.type || e.closest(".fancybox__slide")) {
                e = e.cloneNode(!0);
                const i = e.dataset.animationName;
                i && (e.classList.remove(i), delete e.dataset.animationName);
                let n = e.getAttribute("id");
                n = n ? `${n}--clone` : `clone-${this.instance.id}-${t.index}`, e.setAttribute("id", n);
            } else if (e.parentNode) {
                const i = document.createElement("div");
                i.classList.add("fancybox-placeholder"), e.parentNode.insertBefore(i, e), t.placeholderEl = i;
            }
            this.instance.setContent(t, e);
        } else this.instance.setError(t, "{{ELEMENT_NOT_FOUND}}");
    }
    setIframeContent(t) {
        const { src: e, el: i } = t;
        if (!e || "string" != typeof e || !i) return;
        i.classList.add("is-loading");
        const n = this.instance, s = document.createElement("iframe");
        s.className = "fancybox__iframe", s.setAttribute("id", `fancybox__iframe_${n.id}_${t.index}`);
        for (const [e, i] of Object.entries(this.optionFor(t, "iframeAttr") || {}))s.setAttribute(e, i);
        s.onerror = ()=>{
            n.setError(t, "{{IFRAME_ERROR}}");
        }, t.iframeEl = s;
        const o = this.optionFor(t, "preload");
        if ("iframe" !== t.type || !1 === o) return s.setAttribute("src", t.src + ""), n.setContent(t, s, !1), this.resizeIframe(t), void n.revealContent(t);
        n.showLoading(t), s.onload = ()=>{
            if (!s.src.length) return;
            const e = "true" !== s.dataset.ready;
            s.dataset.ready = "true", this.resizeIframe(t), e ? n.revealContent(t) : n.hideLoading(t);
        }, s.setAttribute("src", e), n.setContent(t, s, !1);
    }
    resizeIframe(t) {
        const { type: e, iframeEl: i } = t;
        if (e === $c2cbdf39c20c8a0e$var$Pt || e === $c2cbdf39c20c8a0e$var$Ct) return;
        const n = null == i ? void 0 : i.parentElement;
        if (!i || !n) return;
        let s = t.autoSize;
        void 0 === s && (s = this.optionFor(t, "autoSize"));
        let o = t.width || 0, a = t.height || 0;
        o && a && (s = !1);
        const r = n && n.style;
        if (!1 !== t.preload && !1 !== s && r) try {
            const t = window.getComputedStyle(n), e = parseFloat(t.paddingLeft) + parseFloat(t.paddingRight), s = parseFloat(t.paddingTop) + parseFloat(t.paddingBottom), l = i.contentWindow;
            if (l) {
                const t = l.document, i = t.getElementsByTagName($c2cbdf39c20c8a0e$var$xt)[0], n = t.body;
                r.width = "", n.style.overflow = "hidden", o = o || i.scrollWidth + e, r.width = `${o}px`, n.style.overflow = "", r.flex = "0 0 auto", r.height = `${n.scrollHeight}px`, a = i.scrollHeight + s;
            }
        } catch (t) {}
        if (o || a) {
            const t = {
                flex: "0 1 auto",
                width: "",
                height: ""
            };
            o && "auto" !== o && (t.width = `${o}px`), a && "auto" !== a && (t.height = `${a}px`), Object.assign(r, t);
        }
    }
    playVideo() {
        const t = this.instance.getSlide();
        if (!t) return;
        const { el: e } = t;
        if (!e || !e.offsetParent) return;
        if (!this.optionFor(t, "videoAutoplay")) return;
        if (t.type === $c2cbdf39c20c8a0e$var$Tt) try {
            const t = e.querySelector("video");
            if (t) {
                const e = t.play();
                void 0 !== e && e.then(()=>{}).catch((e)=>{
                    t.muted = !0, t.play();
                });
            }
        } catch (t) {}
        if (t.type !== $c2cbdf39c20c8a0e$var$Pt && t.type !== $c2cbdf39c20c8a0e$var$Ct) return;
        const i = ()=>{
            if (t.iframeEl && t.iframeEl.contentWindow) {
                let e;
                if ("true" === t.iframeEl.dataset.ready) return e = t.type === $c2cbdf39c20c8a0e$var$Pt ? {
                    event: "command",
                    func: "playVideo"
                } : {
                    method: "play",
                    value: "true"
                }, e && t.iframeEl.contentWindow.postMessage(JSON.stringify(e), "*"), void (t.poller = void 0);
                t.type === $c2cbdf39c20c8a0e$var$Pt && (e = {
                    event: "listening",
                    id: t.iframeEl.getAttribute("id")
                }, t.iframeEl.contentWindow.postMessage(JSON.stringify(e), "*"));
            }
            t.poller = setTimeout(i, 250);
        };
        i();
    }
    processType(t) {
        if (t.html) return t.type = $c2cbdf39c20c8a0e$var$xt, t.src = t.html, void (t.html = "");
        const e = this.instance.optionFor(t, "src", "");
        if (!e || "string" != typeof e) return;
        let i = t.type, n = null;
        if (n = e.match(/(youtube\.com|youtu\.be|youtube\-nocookie\.com)\/(?:watch\?(?:.*&)?v=|v\/|u\/|shorts\/|embed\/?)?(videoseries\?list=(?:.*)|[\w-]{11}|\?listType=(?:.*)&list=(?:.*))(?:.*)/i)) {
            const s = this.optionFor(t, $c2cbdf39c20c8a0e$var$Pt), { nocookie: o } = s, a = function(t, e) {
                var i = {};
                for(var n in t)Object.prototype.hasOwnProperty.call(t, n) && e.indexOf(n) < 0 && (i[n] = t[n]);
                if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
                    var s = 0;
                    for(n = Object.getOwnPropertySymbols(t); s < n.length; s++)e.indexOf(n[s]) < 0 && Object.prototype.propertyIsEnumerable.call(t, n[s]) && (i[n[s]] = t[n[s]]);
                }
                return i;
            }(s, [
                "nocookie"
            ]), r = `www.youtube${o ? "-nocookie" : ""}.com`, l = $c2cbdf39c20c8a0e$var$Mt(e, a), c = encodeURIComponent(n[2]);
            t.videoId = c, t.src = `https://${r}/embed/${c}?${l}`, t.thumbSrc = t.thumbSrc || `https://i.ytimg.com/vi/${c}/mqdefault.jpg`, i = $c2cbdf39c20c8a0e$var$Pt;
        } else if (n = e.match(/^.+vimeo.com\/(?:\/)?([\d]+)((\/|\?h=)([a-z0-9]+))?(.*)?/)) {
            const s = $c2cbdf39c20c8a0e$var$Mt(e, this.optionFor(t, $c2cbdf39c20c8a0e$var$Ct)), o = encodeURIComponent(n[1]), a = n[4] || "";
            t.videoId = o, t.src = `https://player.vimeo.com/video/${o}?${a ? `h=${a}${s ? "&" : ""}` : ""}${s}`, i = $c2cbdf39c20c8a0e$var$Ct;
        }
        if (!i && t.triggerEl) {
            const e = t.triggerEl.dataset.type;
            $c2cbdf39c20c8a0e$var$At.includes(e) && (i = e);
        }
        i || "string" == typeof e && ("#" === e.charAt(0) ? i = "inline" : (n = e.match(/\.(mp4|mov|ogv|webm)((\?|#).*)?$/i)) ? (i = $c2cbdf39c20c8a0e$var$Tt, t.videoFormat = t.videoFormat || "video/" + ("ogv" === n[1] ? "ogg" : n[1])) : e.match(/(^data:image\/[a-z0-9+\/=]*,)|(\.(jp(e|g|eg)|gif|png|bmp|webp|svg|ico)((\?|#).*)?$)/i) ? i = $c2cbdf39c20c8a0e$var$Et : e.match(/\.(pdf)((\?|#).*)?$/i) && (i = "pdf")), (n = e.match(/(?:maps\.)?google\.([a-z]{2,3}(?:\.[a-z]{2})?)\/(?:(?:(?:maps\/(?:place\/(?:.*)\/)?\@(.*),(\d+.?\d+?)z))|(?:\?ll=))(.*)?/i)) ? (t.src = `https://maps.google.${n[1]}/?ll=${(n[2] ? n[2] + "&z=" + Math.floor(parseFloat(n[3])) + (n[4] ? n[4].replace(/^\//, "&") : "") : n[4] + "").replace(/\?/, "&")}&output=${n[4] && n[4].indexOf("layer=c") > 0 ? "svembed" : "embed"}`, i = $c2cbdf39c20c8a0e$var$St) : (n = e.match(/(?:maps\.)?google\.([a-z]{2,3}(?:\.[a-z]{2})?)\/(?:maps\/search\/)(.*)/i)) && (t.src = `https://maps.google.${n[1]}/maps?q=${n[2].replace("query=", "q=").replace("api=1", "")}&output=embed`, i = $c2cbdf39c20c8a0e$var$St), i = i || this.instance.option("defaultType"), t.type = i, i === $c2cbdf39c20c8a0e$var$Et && (t.thumbSrc = t.thumbSrc || t.src);
    }
    setContent(t) {
        const e = this.instance.optionFor(t, "src") || "";
        if (t && t.type && e) {
            switch(t.type){
                case $c2cbdf39c20c8a0e$var$xt:
                    this.instance.setContent(t, e);
                    break;
                case $c2cbdf39c20c8a0e$var$Tt:
                    const i = this.option("videoTpl");
                    i && this.instance.setContent(t, i.replace(/\{\{src\}\}/gi, e + "").replace(/\{\{format\}\}/gi, this.optionFor(t, "videoFormat") || "").replace(/\{\{poster\}\}/gi, t.poster || t.thumbSrc || ""));
                    break;
                case "inline":
                case "clone":
                    this.setInlineContent(t);
                    break;
                case "ajax":
                    this.loadAjaxContent(t);
                    break;
                case "pdf":
                case $c2cbdf39c20c8a0e$var$St:
                case $c2cbdf39c20c8a0e$var$Pt:
                case $c2cbdf39c20c8a0e$var$Ct:
                    t.preload = !1;
                case "iframe":
                    this.setIframeContent(t);
            }
            this.setAspectRatio(t);
        }
    }
    setAspectRatio(t) {
        const e = t.contentEl;
        if (!(t.el && e && t.type && [
            $c2cbdf39c20c8a0e$var$Pt,
            $c2cbdf39c20c8a0e$var$Ct,
            $c2cbdf39c20c8a0e$var$Tt
        ].includes(t.type))) return;
        let i, n = t.width || "auto", s = t.height || "auto";
        if ("auto" === n || "auto" === s) {
            i = this.optionFor(t, "videoRatio");
            const e = (i + "").match(/(\d+)\s*\/\s?(\d+)/);
            i = e && e.length > 2 ? parseFloat(e[1]) / parseFloat(e[2]) : parseFloat(i + "");
        } else n && s && (i = n / s);
        if (!i) return;
        e.style.aspectRatio = "", e.style.width = "", e.style.height = "", e.offsetHeight;
        const o = e.getBoundingClientRect(), a = o.width || 1, r = o.height || 1;
        e.style.aspectRatio = i + "", i < a / r ? (s = "auto" === s ? r : Math.min(r, s), e.style.width = "auto", e.style.height = `${s}px`) : (n = "auto" === n ? a : Math.min(a, n), e.style.width = `${n}px`, e.style.height = "auto");
    }
    attach() {
        const t = this, e = t.instance;
        e.on("Carousel.beforeInitSlide", t.onBeforeInitSlide), e.on("Carousel.createSlide", t.onCreateSlide), e.on("Carousel.selectSlide", t.onSelectSlide), e.on("Carousel.unselectSlide", t.onUnselectSlide), e.on("Carousel.Panzoom.refresh", t.onRefresh), e.on("done", t.onDone), e.on("clearContent", t.onClearContent), window.addEventListener("message", t.onMessage);
    }
    detach() {
        const t = this, e = t.instance;
        e.off("Carousel.beforeInitSlide", t.onBeforeInitSlide), e.off("Carousel.createSlide", t.onCreateSlide), e.off("Carousel.selectSlide", t.onSelectSlide), e.off("Carousel.unselectSlide", t.onUnselectSlide), e.off("Carousel.Panzoom.refresh", t.onRefresh), e.off("done", t.onDone), e.off("clearContent", t.onClearContent), window.removeEventListener("message", t.onMessage);
    }
}
Object.defineProperty($c2cbdf39c20c8a0e$var$Lt, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $c2cbdf39c20c8a0e$var$Ot
});
const $c2cbdf39c20c8a0e$var$zt = "play", $c2cbdf39c20c8a0e$var$Rt = "pause", $c2cbdf39c20c8a0e$var$kt = "ready";
class $c2cbdf39c20c8a0e$var$It extends $c2cbdf39c20c8a0e$var$_ {
    constructor(){
        super(...arguments), Object.defineProperty(this, "state", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $c2cbdf39c20c8a0e$var$kt
        }), Object.defineProperty(this, "inHover", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "timer", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "progressBar", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        });
    }
    get isActive() {
        return this.state !== $c2cbdf39c20c8a0e$var$kt;
    }
    onReady(t) {
        this.option("autoStart") && (t.isInfinite || t.page < t.pages.length - 1) && this.start();
    }
    onChange() {
        this.removeProgressBar(), this.pause();
    }
    onSettle() {
        this.resume();
    }
    onVisibilityChange() {
        "visible" === document.visibilityState ? this.resume() : this.pause();
    }
    onMouseEnter() {
        this.inHover = !0, this.pause();
    }
    onMouseLeave() {
        var t;
        this.inHover = !1, (null === (t = this.instance.panzoom) || void 0 === t ? void 0 : t.isResting) && this.resume();
    }
    onTimerEnd() {
        const t = this.instance;
        "play" === this.state && (t.isInfinite || t.page !== t.pages.length - 1 ? t.slideNext() : t.slideTo(0));
    }
    removeProgressBar() {
        this.progressBar && (this.progressBar.remove(), this.progressBar = null);
    }
    createProgressBar() {
        var t;
        if (!this.option("showProgress")) return null;
        this.removeProgressBar();
        const e = this.instance, i = (null === (t = e.pages[e.page]) || void 0 === t ? void 0 : t.slides) || [];
        let n = this.option("progressParentEl");
        if (n || (n = (1 === i.length ? i[0].el : null) || e.viewport), !n) return null;
        const s = document.createElement("div");
        return $c2cbdf39c20c8a0e$var$P(s, "f-progress"), n.prepend(s), this.progressBar = s, s.offsetHeight, s;
    }
    set() {
        const t = this, e = t.instance;
        if (e.pages.length < 2) return;
        if (t.timer) return;
        const i = t.option("timeout");
        t.state = $c2cbdf39c20c8a0e$var$zt, $c2cbdf39c20c8a0e$var$P(e.container, "has-autoplay");
        let n = t.createProgressBar();
        n && (n.style.transitionDuration = `${i}ms`, n.style.transform = "scaleX(1)"), t.timer = setTimeout(()=>{
            t.timer = null, t.inHover || t.onTimerEnd();
        }, i), t.emit("set");
    }
    clear() {
        const t = this;
        t.timer && (clearTimeout(t.timer), t.timer = null), t.removeProgressBar();
    }
    start() {
        const t = this;
        if (t.set(), t.state !== $c2cbdf39c20c8a0e$var$kt) {
            if (t.option("pauseOnHover")) {
                const e = t.instance.container;
                e.addEventListener("mouseenter", t.onMouseEnter, !1), e.addEventListener("mouseleave", t.onMouseLeave, !1);
            }
            document.addEventListener("visibilitychange", t.onVisibilityChange, !1), t.emit("start");
        }
    }
    stop() {
        const t = this, e = t.state, i = t.instance.container;
        t.clear(), t.state = $c2cbdf39c20c8a0e$var$kt, i.removeEventListener("mouseenter", t.onMouseEnter, !1), i.removeEventListener("mouseleave", t.onMouseLeave, !1), document.removeEventListener("visibilitychange", t.onVisibilityChange, !1), $c2cbdf39c20c8a0e$var$S(i, "has-autoplay"), e !== $c2cbdf39c20c8a0e$var$kt && t.emit("stop");
    }
    pause() {
        const t = this;
        t.state === $c2cbdf39c20c8a0e$var$zt && (t.state = $c2cbdf39c20c8a0e$var$Rt, t.clear(), t.emit($c2cbdf39c20c8a0e$var$Rt));
    }
    resume() {
        const t = this, e = t.instance;
        if (e.isInfinite || e.page !== e.pages.length - 1) {
            if (t.state !== $c2cbdf39c20c8a0e$var$zt) {
                if (t.state === $c2cbdf39c20c8a0e$var$Rt && !t.inHover) {
                    const e = new Event("resume", {
                        bubbles: !0,
                        cancelable: !0
                    });
                    t.emit("resume", e), e.defaultPrevented || t.set();
                }
            } else t.set();
        } else t.stop();
    }
    toggle() {
        this.state === $c2cbdf39c20c8a0e$var$zt || this.state === $c2cbdf39c20c8a0e$var$Rt ? this.stop() : this.start();
    }
    attach() {
        const t = this, e = t.instance;
        e.on("ready", t.onReady), e.on("Panzoom.startAnimation", t.onChange), e.on("Panzoom.endAnimation", t.onSettle), e.on("Panzoom.touchMove", t.onChange);
    }
    detach() {
        const t = this, e = t.instance;
        e.off("ready", t.onReady), e.off("Panzoom.startAnimation", t.onChange), e.off("Panzoom.endAnimation", t.onSettle), e.off("Panzoom.touchMove", t.onChange), t.stop();
    }
}
Object.defineProperty($c2cbdf39c20c8a0e$var$It, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: {
        autoStart: !0,
        pauseOnHover: !0,
        progressParentEl: null,
        showProgress: !0,
        timeout: 3e3
    }
});
class $c2cbdf39c20c8a0e$var$Dt extends $c2cbdf39c20c8a0e$var$_ {
    constructor(){
        super(...arguments), Object.defineProperty(this, "ref", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        });
    }
    onPrepare(t) {
        const e = t.carousel;
        if (!e) return;
        const i = t.container;
        i && (e.options.Autoplay = $c2cbdf39c20c8a0e$var$u({
            autoStart: !1
        }, this.option("Autoplay") || {}, {
            pauseOnHover: !1,
            timeout: this.option("timeout"),
            progressParentEl: ()=>this.option("progressParentEl") || null,
            on: {
                start: ()=>{
                    t.emit("startSlideshow");
                },
                set: (e)=>{
                    var n;
                    i.classList.add("has-slideshow"), (null === (n = t.getSlide()) || void 0 === n ? void 0 : n.state) !== $c2cbdf39c20c8a0e$var$lt.Ready && e.pause();
                },
                stop: ()=>{
                    i.classList.remove("has-slideshow"), t.isCompact || t.endIdle(), t.emit("endSlideshow");
                },
                resume: (e, i)=>{
                    var n, s, o;
                    !i || !i.cancelable || (null === (n = t.getSlide()) || void 0 === n ? void 0 : n.state) === $c2cbdf39c20c8a0e$var$lt.Ready && (null === (o = null === (s = t.carousel) || void 0 === s ? void 0 : s.panzoom) || void 0 === o ? void 0 : o.isResting) || i.preventDefault();
                }
            }
        }), e.attachPlugins({
            Autoplay: $c2cbdf39c20c8a0e$var$It
        }), this.ref = e.plugins.Autoplay);
    }
    onReady(t) {
        const e = t.carousel, i = this.ref;
        i && e && this.option("playOnStart") && (e.isInfinite || e.page < e.pages.length - 1) && i.start();
    }
    onDone(t, e) {
        const i = this.ref, n = t.carousel;
        if (!i || !n) return;
        const s = e.panzoom;
        s && s.on("startAnimation", ()=>{
            t.isCurrentSlide(e) && i.stop();
        }), t.isCurrentSlide(e) && i.resume();
    }
    onKeydown(t, e) {
        var i;
        const n = this.ref;
        n && e === this.option("key") && "BUTTON" !== (null === (i = document.activeElement) || void 0 === i ? void 0 : i.nodeName) && n.toggle();
    }
    attach() {
        const t = this, e = t.instance;
        e.on("Carousel.init", t.onPrepare), e.on("Carousel.ready", t.onReady), e.on("done", t.onDone), e.on("keydown", t.onKeydown);
    }
    detach() {
        const t = this, e = t.instance;
        e.off("Carousel.init", t.onPrepare), e.off("Carousel.ready", t.onReady), e.off("done", t.onDone), e.off("keydown", t.onKeydown);
    }
}
Object.defineProperty($c2cbdf39c20c8a0e$var$Dt, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: {
        key: " ",
        playOnStart: !1,
        progressParentEl: (t)=>{
            var e;
            return (null === (e = t.instance.container) || void 0 === e ? void 0 : e.querySelector(".fancybox__toolbar [data-fancybox-toggle-slideshow]")) || t.instance.container;
        },
        timeout: 3e3
    }
});
const $c2cbdf39c20c8a0e$var$Ft = {
    classes: {
        container: "f-thumbs f-carousel__thumbs",
        viewport: "f-thumbs__viewport",
        track: "f-thumbs__track",
        slide: "f-thumbs__slide",
        isResting: "is-resting",
        isSelected: "is-selected",
        isLoading: "is-loading",
        hasThumbs: "has-thumbs"
    },
    minCount: 2,
    parentEl: null,
    thumbTpl: '<button class="f-thumbs__slide__button" tabindex="0" type="button" aria-label="{{GOTO}}" data-carousel-index="%i"><img class="f-thumbs__slide__img" data-lazy-src="{{%s}}" alt="" /></button>',
    type: "modern"
};
var $c2cbdf39c20c8a0e$var$jt;
!function(t) {
    t[t.Init = 0] = "Init", t[t.Ready = 1] = "Ready", t[t.Hidden = 2] = "Hidden";
}($c2cbdf39c20c8a0e$var$jt || ($c2cbdf39c20c8a0e$var$jt = {}));
const $c2cbdf39c20c8a0e$var$Bt = "isResting", $c2cbdf39c20c8a0e$var$Ht = "thumbWidth", $c2cbdf39c20c8a0e$var$Nt = "thumbHeight", $c2cbdf39c20c8a0e$var$_t = "thumbClipWidth";
let $c2cbdf39c20c8a0e$var$$t = class extends $c2cbdf39c20c8a0e$var$_ {
    constructor(){
        super(...arguments), Object.defineProperty(this, "type", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "modern"
        }), Object.defineProperty(this, "container", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "track", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "carousel", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "thumbWidth", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "thumbClipWidth", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "thumbHeight", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "thumbGap", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "thumbExtraGap", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "state", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $c2cbdf39c20c8a0e$var$jt.Init
        });
    }
    get isModern() {
        return "modern" === this.type;
    }
    onInitSlide(t, e) {
        const i = e.el ? e.el.dataset : void 0;
        i && (e.thumbSrc = i.thumbSrc || e.thumbSrc || "", e[$c2cbdf39c20c8a0e$var$_t] = parseFloat(i[$c2cbdf39c20c8a0e$var$_t] || "") || e[$c2cbdf39c20c8a0e$var$_t] || 0, e[$c2cbdf39c20c8a0e$var$Nt] = parseFloat(i.thumbHeight || "") || e[$c2cbdf39c20c8a0e$var$Nt] || 0), this.addSlide(e);
    }
    onInitSlides() {
        this.build();
    }
    onChange() {
        var t;
        if (!this.isModern) return;
        const e = this.container, i = this.instance, n = i.panzoom, s = this.carousel, a = s ? s.panzoom : null, r = i.page;
        if (n && s && a) {
            if (n.isDragging) {
                $c2cbdf39c20c8a0e$var$S(e, this.cn($c2cbdf39c20c8a0e$var$Bt));
                let n = (null === (t = s.pages[r]) || void 0 === t ? void 0 : t.pos) || 0;
                n += i.getProgress(r) * (this[$c2cbdf39c20c8a0e$var$_t] + this.thumbGap);
                let o = a.getBounds();
                -1 * n > o.x.min && -1 * n < o.x.max && a.panTo({
                    x: -1 * n,
                    friction: .12
                });
            } else $c2cbdf39c20c8a0e$var$o(e, this.cn($c2cbdf39c20c8a0e$var$Bt), n.isResting);
            this.shiftModern();
        }
    }
    onRefresh() {
        this.updateProps();
        for (const t of this.instance.slides || [])this.resizeModernSlide(t);
        this.shiftModern();
    }
    isDisabled() {
        const t = this.option("minCount") || 0;
        if (t) {
            const e = this.instance;
            let i = 0;
            for (const t of e.slides || [])t.thumbSrc && i++;
            if (i < t) return !0;
        }
        const e = this.option("type");
        return [
            "modern",
            "classic"
        ].indexOf(e) < 0;
    }
    getThumb(t) {
        const e = this.option("thumbTpl") || "";
        return {
            html: this.instance.localize(e, [
                [
                    "%i",
                    t.index
                ],
                [
                    "%d",
                    t.index + 1
                ],
                [
                    "%s",
                    t.thumbSrc || "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                ]
            ])
        };
    }
    addSlide(t) {
        const e = this.carousel;
        e && e.addSlide(t.index, this.getThumb(t));
    }
    getSlides() {
        const t = [];
        for (const e of this.instance.slides || [])t.push(this.getThumb(e));
        return t;
    }
    resizeModernSlide(t) {
        this.isModern && (t[$c2cbdf39c20c8a0e$var$Ht] = t[$c2cbdf39c20c8a0e$var$_t] && t[$c2cbdf39c20c8a0e$var$Nt] ? Math.round(this[$c2cbdf39c20c8a0e$var$Nt] * (t[$c2cbdf39c20c8a0e$var$_t] / t[$c2cbdf39c20c8a0e$var$Nt])) : this[$c2cbdf39c20c8a0e$var$Ht]);
    }
    updateProps() {
        const t = this.container;
        if (!t) return;
        const e = (e)=>parseFloat(getComputedStyle(t).getPropertyValue("--f-thumb-" + e)) || 0;
        this.thumbGap = e("gap"), this.thumbExtraGap = e("extra-gap"), this[$c2cbdf39c20c8a0e$var$Ht] = e("width") || 40, this[$c2cbdf39c20c8a0e$var$_t] = e("clip-width") || 40, this[$c2cbdf39c20c8a0e$var$Nt] = e("height") || 40;
    }
    build() {
        const t = this;
        if (t.state !== $c2cbdf39c20c8a0e$var$jt.Init) return;
        if (t.isDisabled()) return void t.emit("disabled");
        const e = t.instance, i = e.container, n = t.getSlides(), s = t.option("type");
        t.type = s;
        const o = t.option("parentEl"), a = t.cn("container"), r = t.cn("track");
        let l = null == o ? void 0 : o.querySelector("." + a);
        l || (l = document.createElement("div"), $c2cbdf39c20c8a0e$var$P(l, a), o ? o.appendChild(l) : i.after(l)), $c2cbdf39c20c8a0e$var$P(l, `is-${s}`), $c2cbdf39c20c8a0e$var$P(i, t.cn("hasThumbs")), t.container = l, t.updateProps();
        let c = l.querySelector("." + r);
        c || (c = document.createElement("div"), $c2cbdf39c20c8a0e$var$P(c, t.cn("track")), l.appendChild(c)), t.track = c;
        const h = $c2cbdf39c20c8a0e$var$u({}, {
            track: c,
            infinite: !1,
            center: !0,
            fill: "classic" === s,
            dragFree: !0,
            slidesPerPage: 1,
            transition: !1,
            preload: .25,
            friction: .12,
            Panzoom: {
                maxVelocity: 0
            },
            Dots: !1,
            Navigation: !1,
            classes: {
                container: "f-thumbs",
                viewport: "f-thumbs__viewport",
                track: "f-thumbs__track",
                slide: "f-thumbs__slide"
            }
        }, t.option("Carousel") || {}, {
            Sync: {
                target: e
            },
            slides: n
        }), d = new e.constructor(l, h);
        d.on("createSlide", (e, i)=>{
            t.setProps(i.index), t.emit("createSlide", i, i.el);
        }), d.on("ready", ()=>{
            t.shiftModern(), t.emit("ready");
        }), d.on("refresh", ()=>{
            t.shiftModern();
        }), d.on("Panzoom.click", (e, i, n)=>{
            t.onClick(n);
        }), t.carousel = d, t.state = $c2cbdf39c20c8a0e$var$jt.Ready;
    }
    onClick(t) {
        t.preventDefault(), t.stopPropagation();
        const e = this.instance, { pages: i, page: n } = e, s = (t)=>{
            if (t) {
                const e = t.closest("[data-carousel-index]");
                if (e) return [
                    parseInt(e.dataset.carouselIndex || "", 10) || 0,
                    e
                ];
            }
            return [
                -1,
                void 0
            ];
        }, o = (t, e)=>{
            const i = document.elementFromPoint(t, e);
            return i ? s(i) : [
                -1,
                void 0
            ];
        };
        let [a, r] = s(t.target);
        if (a > -1) return;
        const l = this[$c2cbdf39c20c8a0e$var$_t], c = t.clientX, h = t.clientY;
        let [d, u] = o(c - l, h), [p, f] = o(c + l, h);
        u && f ? (a = Math.abs(c - u.getBoundingClientRect().right) < Math.abs(c - f.getBoundingClientRect().left) ? d : p, a === n && (a = a === d ? p : d)) : u ? a = d : f && (a = p), a > -1 && i[a] && e.slideTo(a);
    }
    getShift(t) {
        var e;
        const i = this, { instance: n } = i, s = i.carousel;
        if (!n || !s) return 0;
        const o = i[$c2cbdf39c20c8a0e$var$Ht], a = i[$c2cbdf39c20c8a0e$var$_t], r = i.thumbGap, l = i.thumbExtraGap;
        if (!(null === (e = s.slides[t]) || void 0 === e ? void 0 : e.el)) return 0;
        const c = .5 * (o - a), h = n.pages.length - 1;
        let d = n.getProgress(0), u = n.getProgress(h), p = n.getProgress(t, !1, !0), f = 0, g = c + l + r;
        const m = d < 0 && d > -1, v = u > 0 && u < 1;
        return 0 === t ? (f = g * Math.abs(d), v && 1 === d && (f -= g * Math.abs(u))) : t === h ? (f = g * Math.abs(u) * -1, m && -1 === u && (f += g * Math.abs(d))) : m || v ? (f = -1 * g, f += g * Math.abs(d), f += g * (1 - Math.abs(u))) : f = g * p, f;
    }
    setProps(e) {
        var i;
        const n = this;
        if (!n.isModern) return;
        const { instance: s } = n, o = n.carousel;
        if (s && o) {
            const a = null === (i = o.slides[e]) || void 0 === i ? void 0 : i.el;
            if (a && a.childNodes.length) {
                let i = $c2cbdf39c20c8a0e$var$t(1 - Math.abs(s.getProgress(e))), o = $c2cbdf39c20c8a0e$var$t(n.getShift(e));
                a.style.setProperty("--progress", i ? i + "" : ""), a.style.setProperty("--shift", o + "");
            }
        }
    }
    shiftModern() {
        const t = this;
        if (!t.isModern) return;
        const { instance: e, track: i } = t, n = e.panzoom, s = t.carousel;
        if (!(e && i && n && s)) return;
        if (n.state === $c2cbdf39c20c8a0e$var$m.Init || n.state === $c2cbdf39c20c8a0e$var$m.Destroy) return;
        for (const i of e.slides)t.setProps(i.index);
        let o = (t[$c2cbdf39c20c8a0e$var$_t] + t.thumbGap) * (s.slides.length || 0);
        i.style.setProperty("--width", o + "");
    }
    cleanup() {
        const t = this;
        t.carousel && t.carousel.destroy(), t.carousel = null, t.container && t.container.remove(), t.container = null, t.track && t.track.remove(), t.track = null, t.state = $c2cbdf39c20c8a0e$var$jt.Init, $c2cbdf39c20c8a0e$var$S(t.instance.container, t.cn("hasThumbs"));
    }
    attach() {
        const t = this, e = t.instance;
        e.on("initSlide", t.onInitSlide), e.state === $c2cbdf39c20c8a0e$var$B.Init ? e.on("initSlides", t.onInitSlides) : t.onInitSlides(), e.on([
            "change",
            "Panzoom.afterTransform"
        ], t.onChange), e.on("Panzoom.refresh", t.onRefresh);
    }
    detach() {
        const t = this, e = t.instance;
        e.off("initSlide", t.onInitSlide), e.off("initSlides", t.onInitSlides), e.off([
            "change",
            "Panzoom.afterTransform"
        ], t.onChange), e.off("Panzoom.refresh", t.onRefresh), t.cleanup();
    }
};
Object.defineProperty($c2cbdf39c20c8a0e$var$$t, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $c2cbdf39c20c8a0e$var$Ft
});
const $c2cbdf39c20c8a0e$var$Wt = Object.assign(Object.assign({}, $c2cbdf39c20c8a0e$var$Ft), {
    key: "t",
    showOnStart: !0,
    parentEl: null
}), $c2cbdf39c20c8a0e$var$Xt = "is-masked", $c2cbdf39c20c8a0e$var$qt = "aria-hidden";
class $c2cbdf39c20c8a0e$var$Yt extends $c2cbdf39c20c8a0e$var$_ {
    constructor(){
        super(...arguments), Object.defineProperty(this, "ref", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "hidden", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        });
    }
    get isEnabled() {
        const t = this.ref;
        return t && !t.isDisabled();
    }
    get isHidden() {
        return this.hidden;
    }
    onClick(t, e) {
        e.stopPropagation();
    }
    onCreateSlide(t, e) {
        var i, n, s;
        const o = (null === (s = null === (n = null === (i = this.instance) || void 0 === i ? void 0 : i.carousel) || void 0 === n ? void 0 : n.slides[e.index]) || void 0 === s ? void 0 : s.type) || "", a = e.el;
        if (a && o) {
            let t = `for-${o}`;
            [
                "video",
                "youtube",
                "vimeo",
                "html5video"
            ].includes(o) && (t += " for-video"), $c2cbdf39c20c8a0e$var$P(a, t);
        }
    }
    onInit() {
        var t;
        const e = this, i = e.instance, n = i.carousel;
        if (e.ref || !n) return;
        const s = e.option("parentEl") || i.footer || i.container;
        if (!s) return;
        const o = $c2cbdf39c20c8a0e$var$u({}, e.options, {
            parentEl: s,
            classes: {
                container: "f-thumbs fancybox__thumbs"
            },
            Carousel: {
                Sync: {
                    friction: i.option("Carousel.friction") || 0
                }
            },
            on: {
                ready: (t)=>{
                    const i = t.container;
                    i && this.hidden && (e.refresh(), i.style.transition = "none", e.hide(), i.offsetHeight, queueMicrotask(()=>{
                        i.style.transition = "", e.show();
                    }));
                }
            }
        });
        o.Carousel = o.Carousel || {}, o.Carousel.on = $c2cbdf39c20c8a0e$var$u((null === (t = e.options.Carousel) || void 0 === t ? void 0 : t.on) || {}, {
            click: this.onClick,
            createSlide: this.onCreateSlide
        }), n.options.Thumbs = o, n.attachPlugins({
            Thumbs: $c2cbdf39c20c8a0e$var$$t
        }), e.ref = n.plugins.Thumbs, e.option("showOnStart") || (e.ref.state = $c2cbdf39c20c8a0e$var$jt.Hidden, e.hidden = !0);
    }
    onResize() {
        var t;
        const e = null === (t = this.ref) || void 0 === t ? void 0 : t.container;
        e && (e.style.maxHeight = "");
    }
    onKeydown(t, e) {
        const i = this.option("key");
        i && i === e && this.toggle();
    }
    toggle() {
        const t = this.ref;
        if (t && !t.isDisabled()) return t.state === $c2cbdf39c20c8a0e$var$jt.Hidden ? (t.state = $c2cbdf39c20c8a0e$var$jt.Init, void t.build()) : void (this.hidden ? this.show() : this.hide());
    }
    show() {
        const t = this.ref;
        if (!t || t.isDisabled()) return;
        const e = t.container;
        e && (this.refresh(), e.offsetHeight, e.removeAttribute($c2cbdf39c20c8a0e$var$qt), e.classList.remove($c2cbdf39c20c8a0e$var$Xt), this.hidden = !1);
    }
    hide() {
        const t = this.ref, e = t && t.container;
        e && (this.refresh(), e.offsetHeight, e.classList.add($c2cbdf39c20c8a0e$var$Xt), e.setAttribute($c2cbdf39c20c8a0e$var$qt, "true")), this.hidden = !0;
    }
    refresh() {
        const t = this.ref;
        if (!t || !t.state) return;
        const e = t.container, i = (null == e ? void 0 : e.firstChild) || null;
        e && i && i.childNodes.length && (e.style.maxHeight = `${i.getBoundingClientRect().height}px`);
    }
    attach() {
        const t = this, e = t.instance;
        e.state === $c2cbdf39c20c8a0e$var$rt.Init ? e.on("Carousel.init", t.onInit) : t.onInit(), e.on("resize", t.onResize), e.on("keydown", t.onKeydown);
    }
    detach() {
        var t;
        const e = this, i = e.instance;
        i.off("Carousel.init", e.onInit), i.off("resize", e.onResize), i.off("keydown", e.onKeydown), null === (t = i.carousel) || void 0 === t || t.detachPlugins([
            "Thumbs"
        ]), e.ref = null;
    }
}
Object.defineProperty($c2cbdf39c20c8a0e$var$Yt, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $c2cbdf39c20c8a0e$var$Wt
});
const $c2cbdf39c20c8a0e$var$Vt = {
    panLeft: {
        icon: '<svg><path d="M5 12h14M5 12l6 6M5 12l6-6"/></svg>',
        change: {
            panX: -100
        }
    },
    panRight: {
        icon: '<svg><path d="M5 12h14M13 18l6-6M13 6l6 6"/></svg>',
        change: {
            panX: 100
        }
    },
    panUp: {
        icon: '<svg><path d="M12 5v14M18 11l-6-6M6 11l6-6"/></svg>',
        change: {
            panY: -100
        }
    },
    panDown: {
        icon: '<svg><path d="M12 5v14M18 13l-6 6M6 13l6 6"/></svg>',
        change: {
            panY: 100
        }
    },
    zoomIn: {
        icon: '<svg><circle cx="11" cy="11" r="7.5"/><path d="m21 21-4.35-4.35M11 8v6M8 11h6"/></svg>',
        action: "zoomIn"
    },
    zoomOut: {
        icon: '<svg><circle cx="11" cy="11" r="7.5"/><path d="m21 21-4.35-4.35M8 11h6"/></svg>',
        action: "zoomOut"
    },
    toggle1to1: {
        icon: '<svg><path d="M3.51 3.07c5.74.02 11.48-.02 17.22.02 1.37.1 2.34 1.64 2.18 3.13 0 4.08.02 8.16 0 12.23-.1 1.54-1.47 2.64-2.79 2.46-5.61-.01-11.24.02-16.86-.01-1.36-.12-2.33-1.65-2.17-3.14 0-4.07-.02-8.16 0-12.23.1-1.36 1.22-2.48 2.42-2.46Z"/><path d="M5.65 8.54h1.49v6.92m8.94-6.92h1.49v6.92M11.5 9.4v.02m0 5.18v0"/></svg>',
        action: "toggleZoom"
    },
    toggleZoom: {
        icon: '<svg><g><line x1="11" y1="8" x2="11" y2="14"></line></g><circle cx="11" cy="11" r="7.5"/><path d="m21 21-4.35-4.35M8 11h6"/></svg>',
        action: "toggleZoom"
    },
    iterateZoom: {
        icon: '<svg><g><line x1="11" y1="8" x2="11" y2="14"></line></g><circle cx="11" cy="11" r="7.5"/><path d="m21 21-4.35-4.35M8 11h6"/></svg>',
        action: "iterateZoom"
    },
    rotateCCW: {
        icon: '<svg><path d="M15 4.55a8 8 0 0 0-6 14.9M9 15v5H4M18.37 7.16v.01M13 19.94v.01M16.84 18.37v.01M19.37 15.1v.01M19.94 11v.01"/></svg>',
        action: "rotateCCW"
    },
    rotateCW: {
        icon: '<svg><path d="M9 4.55a8 8 0 0 1 6 14.9M15 15v5h5M5.63 7.16v.01M4.06 11v.01M4.63 15.1v.01M7.16 18.37v.01M11 19.94v.01"/></svg>',
        action: "rotateCW"
    },
    flipX: {
        icon: '<svg style="stroke-width: 1.3"><path d="M12 3v18M16 7v10h5L16 7M8 7v10H3L8 7"/></svg>',
        action: "flipX"
    },
    flipY: {
        icon: '<svg style="stroke-width: 1.3"><path d="M3 12h18M7 16h10L7 21v-5M7 8h10L7 3v5"/></svg>',
        action: "flipY"
    },
    fitX: {
        icon: '<svg><path d="M4 12V6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v6M10 18H3M21 18h-7M6 15l-3 3 3 3M18 15l3 3-3 3"/></svg>',
        action: "fitX"
    },
    fitY: {
        icon: '<svg><path d="M12 20H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h6M18 14v7M18 3v7M15 18l3 3 3-3M15 6l3-3 3 3"/></svg>',
        action: "fitY"
    },
    reset: {
        icon: '<svg><path d="M20 11A8.1 8.1 0 0 0 4.5 9M4 5v4h4M4 13a8.1 8.1 0 0 0 15.5 2m.5 4v-4h-4"/></svg>',
        action: "reset"
    },
    toggleFS: {
        icon: '<svg><g><path d="M14.5 9.5 21 3m0 0h-6m6 0v6M3 21l6.5-6.5M3 21v-6m0 6h6"/></g><g><path d="m14 10 7-7m-7 7h6m-6 0V4M3 21l7-7m0 0v6m0-6H4"/></g></svg>',
        action: "toggleFS"
    }
};
var $c2cbdf39c20c8a0e$var$Zt;
!function(t) {
    t[t.Init = 0] = "Init", t[t.Ready = 1] = "Ready", t[t.Disabled = 2] = "Disabled";
}($c2cbdf39c20c8a0e$var$Zt || ($c2cbdf39c20c8a0e$var$Zt = {}));
const $c2cbdf39c20c8a0e$var$Ut = {
    absolute: "auto",
    display: {
        left: [
            "infobar"
        ],
        middle: [],
        right: [
            "iterateZoom",
            "slideshow",
            "fullscreen",
            "thumbs",
            "close"
        ]
    },
    enabled: "auto",
    items: {
        infobar: {
            tpl: '<div class="fancybox__infobar" tabindex="-1"><span data-fancybox-current-index></span>/<span data-fancybox-count></span></div>'
        },
        download: {
            tpl: '<a class="f-button" title="{{DOWNLOAD}}" data-fancybox-download href="javasript:;"><svg><path d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2M7 11l5 5 5-5M12 4v12"/></svg></a>'
        },
        prev: {
            tpl: '<button class="f-button" title="{{PREV}}" data-fancybox-prev><svg><path d="m15 6-6 6 6 6"/></svg></button>'
        },
        next: {
            tpl: '<button class="f-button" title="{{NEXT}}" data-fancybox-next><svg><path d="m9 6 6 6-6 6"/></svg></button>'
        },
        slideshow: {
            tpl: '<button class="f-button" title="{{TOGGLE_SLIDESHOW}}" data-fancybox-toggle-slideshow><svg><g><path d="M8 4v16l13 -8z"></path></g><g><path d="M8 4v15M17 4v15"/></g></svg></button>'
        },
        fullscreen: {
            tpl: '<button class="f-button" title="{{TOGGLE_FULLSCREEN}}" data-fancybox-toggle-fullscreen><svg><g><path d="M4 8V6a2 2 0 0 1 2-2h2M4 16v2a2 2 0 0 0 2 2h2M16 4h2a2 2 0 0 1 2 2v2M16 20h2a2 2 0 0 0 2-2v-2"/></g><g><path d="M15 19v-2a2 2 0 0 1 2-2h2M15 5v2a2 2 0 0 0 2 2h2M5 15h2a2 2 0 0 1 2 2v2M5 9h2a2 2 0 0 0 2-2V5"/></g></svg></button>'
        },
        thumbs: {
            tpl: '<button class="f-button" title="{{TOGGLE_THUMBS}}" data-fancybox-toggle-thumbs><svg><circle cx="5.5" cy="5.5" r="1"/><circle cx="12" cy="5.5" r="1"/><circle cx="18.5" cy="5.5" r="1"/><circle cx="5.5" cy="12" r="1"/><circle cx="12" cy="12" r="1"/><circle cx="18.5" cy="12" r="1"/><circle cx="5.5" cy="18.5" r="1"/><circle cx="12" cy="18.5" r="1"/><circle cx="18.5" cy="18.5" r="1"/></svg></button>'
        },
        close: {
            tpl: '<button class="f-button" title="{{CLOSE}}" data-fancybox-close><svg><path d="m19.5 4.5-15 15M4.5 4.5l15 15"/></svg></button>'
        }
    },
    parentEl: null
}, $c2cbdf39c20c8a0e$var$Gt = {
    tabindex: "-1",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
}, $c2cbdf39c20c8a0e$var$Kt = "has-toolbar", $c2cbdf39c20c8a0e$var$Jt = "fancybox__toolbar";
class $c2cbdf39c20c8a0e$var$Qt extends $c2cbdf39c20c8a0e$var$_ {
    constructor(){
        super(...arguments), Object.defineProperty(this, "state", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $c2cbdf39c20c8a0e$var$Zt.Init
        }), Object.defineProperty(this, "container", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        });
    }
    onReady(t) {
        var e;
        if (!t.carousel) return;
        let i = this.option("display"), n = this.option("absolute"), s = this.option("enabled");
        if ("auto" === s) {
            const t = this.instance.carousel;
            let e = 0;
            if (t) for (const i of t.slides)(i.panzoom || "image" === i.type) && e++;
            e || (s = !1);
        }
        s || (i = void 0);
        let o = 0;
        const a = {
            left: [],
            middle: [],
            right: []
        };
        if (i) for (const t of [
            "left",
            "middle",
            "right"
        ])for (const n of i[t]){
            const i = this.createEl(n);
            i && (null === (e = a[t]) || void 0 === e || e.push(i), o++);
        }
        let r = null;
        if (o && (r = this.createContainer()), r) {
            for (const [t, e] of Object.entries(a)){
                const i = document.createElement("div");
                $c2cbdf39c20c8a0e$var$P(i, $c2cbdf39c20c8a0e$var$Jt + "__column is-" + t);
                for (const t of e)i.appendChild(t);
                "auto" !== n || "middle" !== t || e.length || (n = !0), r.appendChild(i);
            }
            !0 === n && $c2cbdf39c20c8a0e$var$P(r, "is-absolute"), this.state = $c2cbdf39c20c8a0e$var$Zt.Ready, this.onRefresh();
        } else this.state = $c2cbdf39c20c8a0e$var$Zt.Disabled;
    }
    onClick(t) {
        var e, i;
        const n = this.instance, s = n.getSlide(), o = null == s ? void 0 : s.panzoom, a = t.target, r = a && $c2cbdf39c20c8a0e$var$E(a) ? a.dataset : null;
        if (!r) return;
        if (void 0 !== r.fancyboxToggleThumbs) return t.preventDefault(), t.stopPropagation(), void (null === (e = n.plugins.Thumbs) || void 0 === e || e.toggle());
        if (void 0 !== r.fancyboxToggleFullscreen) return t.preventDefault(), t.stopPropagation(), void this.instance.toggleFullscreen();
        if (void 0 !== r.fancyboxToggleSlideshow) {
            t.preventDefault(), t.stopPropagation();
            const e = null === (i = n.carousel) || void 0 === i ? void 0 : i.plugins.Autoplay;
            let s = e.isActive;
            return o && "mousemove" === o.panMode && !s && o.reset(), void (s ? e.stop() : e.start());
        }
        const l = r.panzoomAction, c = r.panzoomChange;
        if ((c || l) && (t.preventDefault(), t.stopPropagation()), c) {
            let t = {};
            try {
                t = JSON.parse(c);
            } catch (t) {}
            o && o.applyChange(t);
        } else l && o && o[l] && o[l]();
    }
    onChange() {
        this.onRefresh();
    }
    onRefresh() {
        if (this.instance.isClosing()) return;
        const t = this.container;
        if (!t) return;
        const e = this.instance.getSlide();
        if (!e || e.state !== $c2cbdf39c20c8a0e$var$lt.Ready) return;
        const i = e && !e.error && e.panzoom;
        for (const e of t.querySelectorAll("[data-panzoom-action]"))i ? (e.removeAttribute("disabled"), e.removeAttribute("tabindex")) : (e.setAttribute("disabled", ""), e.setAttribute("tabindex", "-1"));
        let n = i && i.canZoomIn(), s = i && i.canZoomOut();
        for (const e of t.querySelectorAll('[data-panzoom-action="zoomIn"]'))n ? (e.removeAttribute("disabled"), e.removeAttribute("tabindex")) : (e.setAttribute("disabled", ""), e.setAttribute("tabindex", "-1"));
        for (const e of t.querySelectorAll('[data-panzoom-action="zoomOut"]'))s ? (e.removeAttribute("disabled"), e.removeAttribute("tabindex")) : (e.setAttribute("disabled", ""), e.setAttribute("tabindex", "-1"));
        for (const e of t.querySelectorAll('[data-panzoom-action="toggleZoom"],[data-panzoom-action="iterateZoom"]')){
            s || n ? (e.removeAttribute("disabled"), e.removeAttribute("tabindex")) : (e.setAttribute("disabled", ""), e.setAttribute("tabindex", "-1"));
            const t = e.querySelector("g");
            t && (t.style.display = n ? "" : "none");
        }
    }
    onDone(t, e) {
        var i;
        null === (i = e.panzoom) || void 0 === i || i.on("afterTransform", ()=>{
            this.instance.isCurrentSlide(e) && this.onRefresh();
        }), this.instance.isCurrentSlide(e) && this.onRefresh();
    }
    createContainer() {
        const t = this.instance.container;
        if (!t) return null;
        const e = this.option("parentEl") || t;
        let i = e.querySelector("." + $c2cbdf39c20c8a0e$var$Jt);
        return i || (i = document.createElement("div"), $c2cbdf39c20c8a0e$var$P(i, $c2cbdf39c20c8a0e$var$Jt), e.prepend(i)), i.addEventListener("click", this.onClick, {
            passive: !1,
            capture: !0
        }), t && $c2cbdf39c20c8a0e$var$P(t, $c2cbdf39c20c8a0e$var$Kt), this.container = i, i;
    }
    createEl(t) {
        const e = this.instance, i = e.carousel;
        if (!i) return null;
        if ("toggleFS" === t) return null;
        if ("fullscreen" === t && !$c2cbdf39c20c8a0e$var$ot()) return null;
        let s = null;
        const o = i.slides.length || 0;
        let a = 0, r = 0;
        for (const t of i.slides)(t.panzoom || "image" === t.type) && a++, ("image" === t.type || t.downloadSrc) && r++;
        if (o < 2 && [
            "infobar",
            "prev",
            "next"
        ].includes(t)) return s;
        if (void 0 !== $c2cbdf39c20c8a0e$var$Vt[t] && !a) return null;
        if ("download" === t && !r) return null;
        if ("thumbs" === t) {
            const t = e.plugins.Thumbs;
            if (!t || !t.isEnabled) return null;
        }
        if ("slideshow" === t) {
            if (!i.plugins.Autoplay || o < 2) return null;
        }
        if (void 0 !== $c2cbdf39c20c8a0e$var$Vt[t]) {
            const e = $c2cbdf39c20c8a0e$var$Vt[t];
            s = document.createElement("button"), s.setAttribute("title", this.instance.localize(`{{${t.toUpperCase()}}}`)), $c2cbdf39c20c8a0e$var$P(s, "f-button"), e.action && (s.dataset.panzoomAction = e.action), e.change && (s.dataset.panzoomChange = JSON.stringify(e.change)), s.appendChild($c2cbdf39c20c8a0e$var$n(this.instance.localize(e.icon)));
        } else {
            const e = (this.option("items") || [])[t];
            e && (s = $c2cbdf39c20c8a0e$var$n(this.instance.localize(e.tpl)), "function" == typeof e.click && s.addEventListener("click", (t)=>{
                t.preventDefault(), t.stopPropagation(), "function" == typeof e.click && e.click.call(this, this, t);
            }));
        }
        const l = null == s ? void 0 : s.querySelector("svg");
        if (l) for (const [t, e] of Object.entries($c2cbdf39c20c8a0e$var$Gt))l.getAttribute(t) || l.setAttribute(t, String(e));
        return s;
    }
    removeContainer() {
        const t = this.container;
        t && t.remove(), this.container = null, this.state = $c2cbdf39c20c8a0e$var$Zt.Disabled;
        const e = this.instance.container;
        e && $c2cbdf39c20c8a0e$var$S(e, $c2cbdf39c20c8a0e$var$Kt);
    }
    attach() {
        const t = this, e = t.instance;
        e.on("Carousel.initSlides", t.onReady), e.on("done", t.onDone), e.on([
            "reveal",
            "Carousel.change"
        ], t.onChange), t.onReady(t.instance);
    }
    detach() {
        const t = this, e = t.instance;
        e.off("Carousel.initSlides", t.onReady), e.off("done", t.onDone), e.off([
            "reveal",
            "Carousel.change"
        ], t.onChange), t.removeContainer();
    }
}
Object.defineProperty($c2cbdf39c20c8a0e$var$Qt, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $c2cbdf39c20c8a0e$var$Ut
});
const $c2cbdf39c20c8a0e$var$te = {
    Hash: class extends $c2cbdf39c20c8a0e$var$_ {
        onReady() {
            $c2cbdf39c20c8a0e$var$ht = !1;
        }
        onChange(t) {
            $c2cbdf39c20c8a0e$var$ut && clearTimeout($c2cbdf39c20c8a0e$var$ut);
            const { hash: e } = $c2cbdf39c20c8a0e$var$pt(), { hash: i } = $c2cbdf39c20c8a0e$var$ft(), n = t.isOpeningSlide(t.getSlide());
            n && ($c2cbdf39c20c8a0e$var$ct = i === e ? "" : i), e && e !== i && ($c2cbdf39c20c8a0e$var$ut = setTimeout(()=>{
                try {
                    if (t.state === $c2cbdf39c20c8a0e$var$rt.Ready) {
                        let t = "replaceState";
                        n && !$c2cbdf39c20c8a0e$var$dt && (t = "pushState", $c2cbdf39c20c8a0e$var$dt = !0), window.history[t]({}, document.title, window.location.pathname + window.location.search + e);
                    }
                } catch (t) {}
            }, 300));
        }
        onClose(t) {
            if ($c2cbdf39c20c8a0e$var$ut && clearTimeout($c2cbdf39c20c8a0e$var$ut), !$c2cbdf39c20c8a0e$var$ht && $c2cbdf39c20c8a0e$var$dt) return $c2cbdf39c20c8a0e$var$dt = !1, $c2cbdf39c20c8a0e$var$ht = !1, void window.history.back();
            if (!$c2cbdf39c20c8a0e$var$ht) try {
                window.history.replaceState({}, document.title, window.location.pathname + window.location.search + ($c2cbdf39c20c8a0e$var$ct || ""));
            } catch (t) {}
        }
        attach() {
            const t = this.instance;
            t.on("ready", this.onReady), t.on([
                "Carousel.ready",
                "Carousel.change"
            ], this.onChange), t.on("close", this.onClose);
        }
        detach() {
            const t = this.instance;
            t.off("ready", this.onReady), t.off([
                "Carousel.ready",
                "Carousel.change"
            ], this.onChange), t.off("close", this.onClose);
        }
        static parseURL() {
            return $c2cbdf39c20c8a0e$var$ft();
        }
        static startFromUrl() {
            $c2cbdf39c20c8a0e$var$gt();
        }
        static destroy() {
            window.removeEventListener("hashchange", $c2cbdf39c20c8a0e$var$vt, !1);
        }
    },
    Html: $c2cbdf39c20c8a0e$var$Lt,
    Images: $c2cbdf39c20c8a0e$var$wt,
    Slideshow: $c2cbdf39c20c8a0e$var$Dt,
    Thumbs: $c2cbdf39c20c8a0e$var$Yt,
    Toolbar: $c2cbdf39c20c8a0e$var$Qt
}, $c2cbdf39c20c8a0e$var$ee = "with-fancybox", $c2cbdf39c20c8a0e$var$ie = "hide-scrollbar", $c2cbdf39c20c8a0e$var$ne = "--fancybox-scrollbar-compensate", $c2cbdf39c20c8a0e$var$se = "--fancybox-body-margin", $c2cbdf39c20c8a0e$var$oe = "aria-hidden", $c2cbdf39c20c8a0e$var$ae = "is-using-tab", $c2cbdf39c20c8a0e$var$re = "is-animated", $c2cbdf39c20c8a0e$var$le = "is-compact", $c2cbdf39c20c8a0e$var$ce = "is-loading", $c2cbdf39c20c8a0e$var$he = "is-opening", $c2cbdf39c20c8a0e$var$de = "has-caption", $c2cbdf39c20c8a0e$var$ue = "disabled", $c2cbdf39c20c8a0e$var$pe = "tabindex", $c2cbdf39c20c8a0e$var$fe = "download", $c2cbdf39c20c8a0e$var$ge = "href", $c2cbdf39c20c8a0e$var$me = "src", $c2cbdf39c20c8a0e$var$ve = (t)=>"string" == typeof t, $c2cbdf39c20c8a0e$var$be = function() {
    var t = window.getSelection();
    return !!t && "Range" === t.type;
};
let $c2cbdf39c20c8a0e$var$ye, $c2cbdf39c20c8a0e$var$we = null, $c2cbdf39c20c8a0e$var$xe = null, $c2cbdf39c20c8a0e$var$Ee = 0, $c2cbdf39c20c8a0e$var$Se = 0, $c2cbdf39c20c8a0e$var$Pe = 0, $c2cbdf39c20c8a0e$var$Ce = 0;
const $c2cbdf39c20c8a0e$var$Te = new Map;
let $c2cbdf39c20c8a0e$var$Me = 0;
class $c2cbdf39c20c8a0e$export$cb45b08d97cdc4fd extends $c2cbdf39c20c8a0e$var$g {
    get isIdle() {
        return this.idle;
    }
    get isCompact() {
        return this.option("compact");
    }
    constructor(t = [], e = {}, i = {}){
        super(e), Object.defineProperty(this, "userSlides", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: []
        }), Object.defineProperty(this, "userPlugins", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: {}
        }), Object.defineProperty(this, "idle", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "idleTimer", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "clickTimer", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "pwt", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "ignoreFocusChange", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "startedFs", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "state", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $c2cbdf39c20c8a0e$var$rt.Init
        }), Object.defineProperty(this, "id", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "container", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "caption", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "footer", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "carousel", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "lastFocus", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "prevMouseMoveEvent", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), $c2cbdf39c20c8a0e$var$ye || ($c2cbdf39c20c8a0e$var$ye = $c2cbdf39c20c8a0e$var$ot()), this.id = e.id || ++$c2cbdf39c20c8a0e$var$Me, $c2cbdf39c20c8a0e$var$Te.set(this.id, this), this.userSlides = t, this.userPlugins = i, queueMicrotask(()=>{
            this.init();
        });
    }
    init() {
        if (this.state === $c2cbdf39c20c8a0e$var$rt.Destroy) return;
        this.state = $c2cbdf39c20c8a0e$var$rt.Init, this.attachPlugins(Object.assign(Object.assign({}, $c2cbdf39c20c8a0e$export$cb45b08d97cdc4fd.Plugins), this.userPlugins)), this.emit("init"), this.emit("attachPlugins"), !0 === this.option("hideScrollbar") && (()=>{
            if (!$c2cbdf39c20c8a0e$var$et) return;
            const t = document, e = t.body, i = t.documentElement;
            if (e.classList.contains($c2cbdf39c20c8a0e$var$ie)) return;
            let n = window.innerWidth - i.getBoundingClientRect().width;
            const s = parseFloat(window.getComputedStyle(e).marginRight);
            n < 0 && (n = 0), i.style.setProperty($c2cbdf39c20c8a0e$var$ne, `${n}px`), s && e.style.setProperty($c2cbdf39c20c8a0e$var$se, `${s}px`), e.classList.add($c2cbdf39c20c8a0e$var$ie);
        })(), this.initLayout(), this.scale();
        const t = ()=>{
            this.initCarousel(this.userSlides), this.state = $c2cbdf39c20c8a0e$var$rt.Ready, this.attachEvents(), this.emit("ready"), setTimeout(()=>{
                this.container && this.container.setAttribute($c2cbdf39c20c8a0e$var$oe, "false");
            }, 16);
        };
        this.option("Fullscreen.autoStart") && $c2cbdf39c20c8a0e$var$ye && !$c2cbdf39c20c8a0e$var$ye.isFullscreen() ? $c2cbdf39c20c8a0e$var$ye.request().then(()=>{
            this.startedFs = !0, t();
        }).catch(()=>t()) : t();
    }
    initLayout() {
        var t, e;
        const i = this.option("parentEl") || document.body, s = $c2cbdf39c20c8a0e$var$n(this.localize(this.option("tpl.main") || ""));
        if (s) {
            if (s.setAttribute("id", `fancybox-${this.id}`), s.setAttribute("aria-label", this.localize("{{MODAL}}")), s.classList.toggle($c2cbdf39c20c8a0e$var$le, this.isCompact), $c2cbdf39c20c8a0e$var$P(s, this.option("mainClass") || ""), $c2cbdf39c20c8a0e$var$P(s, $c2cbdf39c20c8a0e$var$he), this.container = s, this.footer = s.querySelector(".fancybox__footer"), i.appendChild(s), $c2cbdf39c20c8a0e$var$P(document.documentElement, $c2cbdf39c20c8a0e$var$ee), $c2cbdf39c20c8a0e$var$we && $c2cbdf39c20c8a0e$var$xe || ($c2cbdf39c20c8a0e$var$we = document.createElement("span"), $c2cbdf39c20c8a0e$var$P($c2cbdf39c20c8a0e$var$we, "fancybox-focus-guard"), $c2cbdf39c20c8a0e$var$we.setAttribute($c2cbdf39c20c8a0e$var$pe, "0"), $c2cbdf39c20c8a0e$var$we.setAttribute($c2cbdf39c20c8a0e$var$oe, "true"), $c2cbdf39c20c8a0e$var$we.setAttribute("aria-label", "Focus guard"), $c2cbdf39c20c8a0e$var$xe = $c2cbdf39c20c8a0e$var$we.cloneNode(), null === (t = s.parentElement) || void 0 === t || t.insertBefore($c2cbdf39c20c8a0e$var$we, s), null === (e = s.parentElement) || void 0 === e || e.append($c2cbdf39c20c8a0e$var$xe)), s.addEventListener("mousedown", (t)=>{
                $c2cbdf39c20c8a0e$var$Ee = t.pageX, $c2cbdf39c20c8a0e$var$Se = t.pageY, $c2cbdf39c20c8a0e$var$S(s, $c2cbdf39c20c8a0e$var$ae);
            }), this.option("closeExisting")) for (const t of $c2cbdf39c20c8a0e$var$Te.values())t.id !== this.id && t.close();
            else this.option("animated") && ($c2cbdf39c20c8a0e$var$P(s, $c2cbdf39c20c8a0e$var$re), setTimeout(()=>{
                this.isClosing() || $c2cbdf39c20c8a0e$var$S(s, $c2cbdf39c20c8a0e$var$re);
            }, 350));
            this.emit("initLayout");
        }
    }
    initCarousel(t) {
        const i = this.container;
        if (!i) return;
        const n = i.querySelector(".fancybox__carousel");
        if (!n) return;
        const s = this.carousel = new $c2cbdf39c20c8a0e$export$144901db2ea8e967(n, $c2cbdf39c20c8a0e$var$u({}, {
            slides: t,
            transition: "fade",
            Panzoom: {
                lockAxis: this.option("dragToClose") ? "xy" : "x",
                infinite: !!this.option("dragToClose") && "y"
            },
            Dots: !1,
            Navigation: {
                classes: {
                    container: "fancybox__nav",
                    button: "f-button",
                    isNext: "is-next",
                    isPrev: "is-prev"
                }
            },
            initialPage: this.option("startIndex"),
            l10n: this.option("l10n")
        }, this.option("Carousel") || {}));
        s.on("*", (t, e, ...i)=>{
            this.emit(`Carousel.${e}`, t, ...i);
        }), s.on([
            "ready",
            "change"
        ], ()=>{
            this.manageCaption();
        }), this.on("Carousel.removeSlide", (t, e, i)=>{
            this.clearContent(i), i.state = void 0;
        }), s.on("Panzoom.touchStart", ()=>{
            var t, e;
            this.isCompact || this.endIdle(), (null === (t = document.activeElement) || void 0 === t ? void 0 : t.closest(".f-thumbs")) && (null === (e = this.container) || void 0 === e || e.focus());
        }), s.on("settle", ()=>{
            this.idleTimer || this.isCompact || !this.option("idle") || this.setIdle(), this.option("autoFocus") && !this.isClosing && this.checkFocus();
        }), this.option("dragToClose") && (s.on("Panzoom.afterTransform", (t, i)=>{
            const n = this.getSlide();
            if (n && $c2cbdf39c20c8a0e$var$e(n.el)) return;
            const s = this.container;
            if (s) {
                const t = Math.abs(i.current.f), e = t < 1 ? "" : Math.max(.5, Math.min(1, 1 - t / i.contentRect.fitHeight * 1.5));
                s.style.setProperty("--fancybox-ts", e ? "0s" : ""), s.style.setProperty("--fancybox-opacity", e + "");
            }
        }), s.on("Panzoom.touchEnd", (t, i, n)=>{
            var s;
            const o = this.getSlide();
            if (o && $c2cbdf39c20c8a0e$var$e(o.el)) return;
            if (i.isMobile && document.activeElement && -1 !== [
                "TEXTAREA",
                "INPUT"
            ].indexOf(null === (s = document.activeElement) || void 0 === s ? void 0 : s.nodeName)) return;
            const a = Math.abs(i.dragOffset.y);
            "y" === i.lockedAxis && (a >= 200 || a >= 50 && i.dragOffset.time < 300) && (n && n.cancelable && n.preventDefault(), this.close(n, "f-throwOut" + (i.current.f < 0 ? "Up" : "Down")));
        })), s.on("change", (t)=>{
            var e;
            let i = null === (e = this.getSlide()) || void 0 === e ? void 0 : e.triggerEl;
            if (i) {
                const e = new CustomEvent("slideTo", {
                    bubbles: !0,
                    cancelable: !0,
                    detail: t.page
                });
                i.dispatchEvent(e);
            }
        }), s.on([
            "refresh",
            "change"
        ], (t)=>{
            const e = this.container;
            if (!e) return;
            for (const i of e.querySelectorAll("[data-fancybox-current-index]"))i.innerHTML = t.page + 1;
            for (const i of e.querySelectorAll("[data-fancybox-count]"))i.innerHTML = t.pages.length;
            if (!t.isInfinite) {
                for (const i of e.querySelectorAll("[data-fancybox-next]"))t.page < t.pages.length - 1 ? (i.removeAttribute($c2cbdf39c20c8a0e$var$ue), i.removeAttribute($c2cbdf39c20c8a0e$var$pe)) : (i.setAttribute($c2cbdf39c20c8a0e$var$ue, ""), i.setAttribute($c2cbdf39c20c8a0e$var$pe, "-1"));
                for (const i of e.querySelectorAll("[data-fancybox-prev]"))t.page > 0 ? (i.removeAttribute($c2cbdf39c20c8a0e$var$ue), i.removeAttribute($c2cbdf39c20c8a0e$var$pe)) : (i.setAttribute($c2cbdf39c20c8a0e$var$ue, ""), i.setAttribute($c2cbdf39c20c8a0e$var$pe, "-1"));
            }
            const i = this.getSlide();
            if (!i) return;
            let n = i.downloadSrc || "";
            n || "image" !== i.type || i.error || !$c2cbdf39c20c8a0e$var$ve(i[$c2cbdf39c20c8a0e$var$me]) || (n = i[$c2cbdf39c20c8a0e$var$me]);
            for (const t of e.querySelectorAll("[data-fancybox-download]")){
                const e = i.downloadFilename;
                n ? (t.removeAttribute($c2cbdf39c20c8a0e$var$ue), t.removeAttribute($c2cbdf39c20c8a0e$var$pe), t.setAttribute($c2cbdf39c20c8a0e$var$ge, n), t.setAttribute($c2cbdf39c20c8a0e$var$fe, e || n), t.setAttribute("target", "_blank")) : (t.setAttribute($c2cbdf39c20c8a0e$var$ue, ""), t.setAttribute($c2cbdf39c20c8a0e$var$pe, "-1"), t.removeAttribute($c2cbdf39c20c8a0e$var$ge), t.removeAttribute($c2cbdf39c20c8a0e$var$fe));
            }
        }), this.emit("initCarousel");
    }
    attachEvents() {
        const t = this, e = t.container;
        if (!e) return;
        e.addEventListener("click", t.onClick, {
            passive: !1,
            capture: !1
        }), e.addEventListener("wheel", t.onWheel, {
            passive: !1,
            capture: !1
        }), document.addEventListener("keydown", t.onKeydown, {
            passive: !1,
            capture: !0
        }), document.addEventListener("visibilitychange", t.onVisibilityChange, !1), document.addEventListener("mousemove", t.onMousemove), t.option("trapFocus") && document.addEventListener("focus", t.onFocus, !0), window.addEventListener("resize", t.onResize);
        const i = window.visualViewport;
        i && (i.addEventListener("scroll", t.onResize), i.addEventListener("resize", t.onResize));
    }
    detachEvents() {
        const t = this, e = t.container;
        if (!e) return;
        document.removeEventListener("keydown", t.onKeydown, {
            passive: !1,
            capture: !0
        }), e.removeEventListener("wheel", t.onWheel, {
            passive: !1,
            capture: !1
        }), e.removeEventListener("click", t.onClick, {
            passive: !1,
            capture: !1
        }), document.removeEventListener("mousemove", t.onMousemove), window.removeEventListener("resize", t.onResize);
        const i = window.visualViewport;
        i && (i.removeEventListener("resize", t.onResize), i.removeEventListener("scroll", t.onResize)), document.removeEventListener("visibilitychange", t.onVisibilityChange, !1), document.removeEventListener("focus", t.onFocus, !0);
    }
    scale() {
        const t = this.container;
        if (!t) return;
        const e = window.visualViewport, i = Math.max(1, (null == e ? void 0 : e.scale) || 1);
        let n = "", s = "", o = "";
        if (e && i > 1) {
            let t = `${e.offsetLeft}px`, a = `${e.offsetTop}px`;
            n = e.width * i + "px", s = e.height * i + "px", o = `translate3d(${t}, ${a}, 0) scale(${1 / i})`;
        }
        t.style.transform = o, t.style.width = n, t.style.height = s;
    }
    onClick(t) {
        var e;
        const { container: i, isCompact: n } = this;
        if (!i || this.isClosing()) return;
        !n && this.option("idle") && this.resetIdle();
        const s = t.composedPath()[0];
        if (s.closest(".fancybox-spinner") || s.closest("[data-fancybox-close]")) return t.preventDefault(), void this.close(t);
        if (s.closest("[data-fancybox-prev]")) return t.preventDefault(), void this.prev();
        if (s.closest("[data-fancybox-next]")) return t.preventDefault(), void this.next();
        if ("click" === t.type && 0 === t.detail) return;
        if (Math.abs(t.pageX - $c2cbdf39c20c8a0e$var$Ee) > 30 || Math.abs(t.pageY - $c2cbdf39c20c8a0e$var$Se) > 30) return;
        const o = document.activeElement;
        if ($c2cbdf39c20c8a0e$var$be() && o && i.contains(o)) return;
        if (n && "image" === (null === (e = this.getSlide()) || void 0 === e ? void 0 : e.type)) return void (this.clickTimer ? (clearTimeout(this.clickTimer), this.clickTimer = null) : this.clickTimer = setTimeout(()=>{
            this.toggleIdle(), this.clickTimer = null;
        }, 350));
        if (this.emit("click", t), t.defaultPrevented) return;
        let a = !1;
        if (s.closest(".fancybox__content")) {
            if (o) {
                if (o.closest("[contenteditable]")) return;
                s.matches($c2cbdf39c20c8a0e$var$nt) || o.blur();
            }
            if ($c2cbdf39c20c8a0e$var$be()) return;
            a = this.option("contentClick");
        } else s.closest(".fancybox__carousel") && !s.matches($c2cbdf39c20c8a0e$var$nt) && (a = this.option("backdropClick"));
        "close" === a ? (t.preventDefault(), this.close(t)) : "next" === a ? (t.preventDefault(), this.next()) : "prev" === a && (t.preventDefault(), this.prev());
    }
    onWheel(t) {
        const e = t.target;
        let n = this.option("wheel", t);
        e.closest(".fancybox__thumbs") && (n = "slide");
        const s = "slide" === n, o = [
            -t.deltaX || 0,
            -t.deltaY || 0,
            -t.detail || 0
        ].reduce(function(t, e) {
            return Math.abs(e) > Math.abs(t) ? e : t;
        }), a = Math.max(-1, Math.min(1, o)), r = Date.now();
        this.pwt && r - this.pwt < 300 ? s && t.preventDefault() : (this.pwt = r, this.emit("wheel", t, a), t.defaultPrevented || ("close" === n ? (t.preventDefault(), this.close(t)) : "slide" === n && ($c2cbdf39c20c8a0e$var$i(e) || (t.preventDefault(), this[a > 0 ? "prev" : "next"]()))));
    }
    onScroll() {
        window.scrollTo($c2cbdf39c20c8a0e$var$Pe, $c2cbdf39c20c8a0e$var$Ce);
    }
    onKeydown(t) {
        if (!this.isTopmost()) return;
        this.isCompact || !this.option("idle") || this.isClosing() || this.resetIdle();
        const e = t.key, i = this.option("keyboard");
        if (!i) return;
        const n = t.composedPath()[0], s = document.activeElement && document.activeElement.classList, o = s && s.contains("f-button") || n.dataset.carouselPage || n.dataset.carouselIndex;
        if ("Escape" !== e && !o && $c2cbdf39c20c8a0e$var$E(n)) {
            if (n.isContentEditable || -1 !== [
                "TEXTAREA",
                "OPTION",
                "INPUT",
                "SELECT",
                "VIDEO"
            ].indexOf(n.nodeName)) return;
        }
        if ("Tab" === t.key ? $c2cbdf39c20c8a0e$var$P(this.container, $c2cbdf39c20c8a0e$var$ae) : $c2cbdf39c20c8a0e$var$S(this.container, $c2cbdf39c20c8a0e$var$ae), t.ctrlKey || t.altKey || t.shiftKey) return;
        this.emit("keydown", e, t);
        const a = i[e];
        a && "function" == typeof this[a] && (t.preventDefault(), this[a]());
    }
    onResize() {
        const t = this.container;
        if (!t) return;
        const e = this.isCompact;
        t.classList.toggle($c2cbdf39c20c8a0e$var$le, e), this.manageCaption(this.getSlide()), this.isCompact ? this.clearIdle() : this.endIdle(), this.scale(), this.emit("resize");
    }
    onFocus(t) {
        this.isTopmost() && this.checkFocus(t);
    }
    onMousemove(t) {
        this.prevMouseMoveEvent = t, !this.isCompact && this.option("idle") && this.resetIdle();
    }
    onVisibilityChange() {
        "visible" === document.visibilityState ? this.checkFocus() : this.endIdle();
    }
    manageCloseBtn(t) {
        const e = this.optionFor(t, "closeButton") || !1;
        if ("auto" === e) {
            const t = this.plugins.Toolbar;
            if (t && t.state === $c2cbdf39c20c8a0e$var$Zt.Ready) return;
        }
        if (!e) return;
        if (!t.contentEl || t.closeBtnEl) return;
        const i = this.option("tpl.closeButton");
        if (i) {
            const e = $c2cbdf39c20c8a0e$var$n(this.localize(i));
            t.closeBtnEl = t.contentEl.appendChild(e), t.el && $c2cbdf39c20c8a0e$var$P(t.el, "has-close-btn");
        }
    }
    manageCaption(t) {
        var e, i;
        const n = "fancybox__caption", s = this.container;
        if (!s) return;
        $c2cbdf39c20c8a0e$var$S(s, $c2cbdf39c20c8a0e$var$de);
        const o = this.isCompact || this.option("commonCaption"), a = !o;
        if (this.caption && this.stop(this.caption), a && this.caption && (this.caption.remove(), this.caption = null), o && !this.caption) for (const t of (null === (e = this.carousel) || void 0 === e ? void 0 : e.slides) || [])t.captionEl && (t.captionEl.remove(), t.captionEl = void 0, $c2cbdf39c20c8a0e$var$S(t.el, $c2cbdf39c20c8a0e$var$de), null === (i = t.el) || void 0 === i || i.removeAttribute("aria-labelledby"));
        if (t || (t = this.getSlide()), !t || o && !this.isCurrentSlide(t)) return;
        const r = t.el;
        let l = this.optionFor(t, "caption", "");
        if (!l) return void (o && this.caption && this.animate(this.caption, "f-fadeOut", ()=>{
            this.caption && (this.caption.innerHTML = "");
        }));
        let c = null;
        if (a) {
            if (c = t.captionEl || null, r && !c) {
                const e = n + `_${this.id}_${t.index}`;
                c = document.createElement("div"), $c2cbdf39c20c8a0e$var$P(c, n), c.setAttribute("id", e), t.captionEl = r.appendChild(c), $c2cbdf39c20c8a0e$var$P(r, $c2cbdf39c20c8a0e$var$de), r.setAttribute("aria-labelledby", e);
            }
        } else {
            if (c = this.caption, c || (c = s.querySelector("." + n)), !c) {
                c = document.createElement("div"), c.dataset.fancyboxCaption = "", $c2cbdf39c20c8a0e$var$P(c, n);
                (this.footer || s).prepend(c);
            }
            $c2cbdf39c20c8a0e$var$P(s, $c2cbdf39c20c8a0e$var$de), this.caption = c;
        }
        c && (c.innerHTML = "", $c2cbdf39c20c8a0e$var$ve(l) || "number" == typeof l ? c.innerHTML = l + "" : l instanceof HTMLElement && c.appendChild(l));
    }
    checkFocus(t) {
        this.focus(t);
    }
    focus(t) {
        var e;
        if (this.ignoreFocusChange) return;
        const i = document.activeElement || null, n = (null == t ? void 0 : t.target) || null, s = this.container, o = null === (e = this.carousel) || void 0 === e ? void 0 : e.viewport;
        if (!s || !o) return;
        if (!t && i && s.contains(i)) return;
        const a = this.getSlide(), r = a && a.state === $c2cbdf39c20c8a0e$var$lt.Ready ? a.el : null;
        if (!r || r.contains(i) || s === i) return;
        t && t.cancelable && t.preventDefault(), this.ignoreFocusChange = !0;
        const l = Array.from(s.querySelectorAll($c2cbdf39c20c8a0e$var$nt));
        let c = [], h = null;
        for (let t of l){
            const e = !t.offsetParent || !!t.closest('[aria-hidden="true"]'), i = r && r.contains(t), n = !o.contains(t);
            if (t === s || (i || n) && !e) {
                c.push(t);
                const e = t.dataset.origTabindex;
                void 0 !== e && e && (t.tabIndex = parseFloat(e)), t.removeAttribute("data-orig-tabindex"), !t.hasAttribute("autoFocus") && h || (h = t);
            } else {
                const e = void 0 === t.dataset.origTabindex ? t.getAttribute("tabindex") || "" : t.dataset.origTabindex;
                e && (t.dataset.origTabindex = e), t.tabIndex = -1;
            }
        }
        let d = null;
        t ? (!n || c.indexOf(n) < 0) && (d = h || s, c.length && (i === $c2cbdf39c20c8a0e$var$xe ? d = c[0] : this.lastFocus !== s && i !== $c2cbdf39c20c8a0e$var$we || (d = c[c.length - 1]))) : d = a && "image" === a.type ? s : h || s, d && $c2cbdf39c20c8a0e$var$st(d), this.lastFocus = document.activeElement, this.ignoreFocusChange = !1;
    }
    next() {
        const t = this.carousel;
        t && t.pages.length > 1 && t.slideNext();
    }
    prev() {
        const t = this.carousel;
        t && t.pages.length > 1 && t.slidePrev();
    }
    jumpTo(...t) {
        this.carousel && this.carousel.slideTo(...t);
    }
    isTopmost() {
        var t;
        return (null === (t = $c2cbdf39c20c8a0e$export$cb45b08d97cdc4fd.getInstance()) || void 0 === t ? void 0 : t.id) == this.id;
    }
    animate(t = null, e = "", i) {
        if (!t || !e) return void (i && i());
        this.stop(t);
        const n = (s)=>{
            s.target === t && t.dataset.animationName && (t.removeEventListener("animationend", n), delete t.dataset.animationName, i && i(), $c2cbdf39c20c8a0e$var$S(t, e));
        };
        t.dataset.animationName = e, t.addEventListener("animationend", n), $c2cbdf39c20c8a0e$var$P(t, e);
    }
    stop(t) {
        t && t.dispatchEvent(new CustomEvent("animationend", {
            bubbles: !1,
            cancelable: !0,
            currentTarget: t
        }));
    }
    setContent(t, e = "", i = !0) {
        if (this.isClosing()) return;
        const s = t.el;
        if (!s) return;
        let o = null;
        if ($c2cbdf39c20c8a0e$var$E(e) ? o = e : (o = $c2cbdf39c20c8a0e$var$n(e + ""), $c2cbdf39c20c8a0e$var$E(o) || (o = document.createElement("div"), o.innerHTML = e + "")), [
            "img",
            "picture",
            "iframe",
            "video",
            "audio"
        ].includes(o.nodeName.toLowerCase())) {
            const t = document.createElement("div");
            t.appendChild(o), o = t;
        }
        $c2cbdf39c20c8a0e$var$E(o) && t.filter && !t.error && (o = o.querySelector(t.filter)), o && $c2cbdf39c20c8a0e$var$E(o) ? ($c2cbdf39c20c8a0e$var$P(o, "fancybox__content"), t.id && o.setAttribute("id", t.id), s.classList.add(`has-${t.error ? "error" : t.type || "unknown"}`), s.prepend(o), "none" === o.style.display && (o.style.display = ""), "none" === getComputedStyle(o).getPropertyValue("display") && (o.style.display = t.display || this.option("defaultDisplay") || "flex"), t.contentEl = o, i && this.revealContent(t), this.manageCloseBtn(t), this.manageCaption(t)) : this.setError(t, "{{ELEMENT_NOT_FOUND}}");
    }
    revealContent(t, e) {
        const i = t.el, n = t.contentEl;
        i && n && (this.emit("reveal", t), this.hideLoading(t), t.state = $c2cbdf39c20c8a0e$var$lt.Opening, (e = this.isOpeningSlide(t) ? void 0 === e ? this.optionFor(t, "showClass") : e : "f-fadeIn") ? this.animate(n, e, ()=>{
            this.done(t);
        }) : this.done(t));
    }
    done(t) {
        this.isClosing() || (t.state = $c2cbdf39c20c8a0e$var$lt.Ready, this.emit("done", t), $c2cbdf39c20c8a0e$var$P(t.el, "is-done"), this.isCurrentSlide(t) && this.option("autoFocus") && queueMicrotask(()=>{
            var e;
            null === (e = t.panzoom) || void 0 === e || e.updateControls(), this.option("autoFocus") && this.focus();
        }), this.isOpeningSlide(t) && ($c2cbdf39c20c8a0e$var$S(this.container, $c2cbdf39c20c8a0e$var$he), !this.isCompact && this.option("idle") && this.setIdle()));
    }
    isCurrentSlide(t) {
        const e = this.getSlide();
        return !(!t || !e) && e.index === t.index;
    }
    isOpeningSlide(t) {
        var e, i;
        return null === (null === (e = this.carousel) || void 0 === e ? void 0 : e.prevPage) && t && t.index === (null === (i = this.getSlide()) || void 0 === i ? void 0 : i.index);
    }
    showLoading(t) {
        t.state = $c2cbdf39c20c8a0e$var$lt.Loading;
        const e = t.el;
        if (!e) return;
        $c2cbdf39c20c8a0e$var$P(e, $c2cbdf39c20c8a0e$var$ce), this.emit("loading", t), t.spinnerEl || setTimeout(()=>{
            if (!this.isClosing() && !t.spinnerEl && t.state === $c2cbdf39c20c8a0e$var$lt.Loading) {
                let i = $c2cbdf39c20c8a0e$var$n($c2cbdf39c20c8a0e$var$x);
                $c2cbdf39c20c8a0e$var$P(i, "fancybox-spinner"), t.spinnerEl = i, e.prepend(i), this.animate(i, "f-fadeIn");
            }
        }, 250);
    }
    hideLoading(t) {
        const e = t.el;
        if (!e) return;
        const i = t.spinnerEl;
        this.isClosing() ? null == i || i.remove() : ($c2cbdf39c20c8a0e$var$S(e, $c2cbdf39c20c8a0e$var$ce), i && this.animate(i, "f-fadeOut", ()=>{
            i.remove();
        }), t.state === $c2cbdf39c20c8a0e$var$lt.Loading && (this.emit("loaded", t), t.state = $c2cbdf39c20c8a0e$var$lt.Ready));
    }
    setError(t, e) {
        if (this.isClosing()) return;
        const i = new Event("error", {
            bubbles: !0,
            cancelable: !0
        });
        if (this.emit("error", i, t), i.defaultPrevented) return;
        t.error = e, this.hideLoading(t), this.clearContent(t);
        const n = document.createElement("div");
        n.classList.add("fancybox-error"), n.innerHTML = this.localize(e || "<p>{{ERROR}}</p>"), this.setContent(t, n);
    }
    clearContent(t) {
        if (void 0 === t.state) return;
        this.emit("clearContent", t), t.contentEl && (t.contentEl.remove(), t.contentEl = void 0);
        const e = t.el;
        e && ($c2cbdf39c20c8a0e$var$S(e, "has-error"), $c2cbdf39c20c8a0e$var$S(e, "has-unknown"), $c2cbdf39c20c8a0e$var$S(e, `has-${t.type || "unknown"}`)), t.closeBtnEl && t.closeBtnEl.remove(), t.closeBtnEl = void 0, t.captionEl && t.captionEl.remove(), t.captionEl = void 0, t.spinnerEl && t.spinnerEl.remove(), t.spinnerEl = void 0;
    }
    getSlide() {
        var t;
        const e = this.carousel;
        return (null === (t = null == e ? void 0 : e.pages[null == e ? void 0 : e.page]) || void 0 === t ? void 0 : t.slides[0]) || void 0;
    }
    close(t, e) {
        if (this.isClosing()) return;
        const i = new Event("shouldClose", {
            bubbles: !0,
            cancelable: !0
        });
        if (this.emit("shouldClose", i, t), i.defaultPrevented) return;
        t && t.cancelable && (t.preventDefault(), t.stopPropagation());
        const n = ()=>{
            this.proceedClose(t, e);
        };
        this.startedFs && $c2cbdf39c20c8a0e$var$ye && $c2cbdf39c20c8a0e$var$ye.isFullscreen() ? Promise.resolve($c2cbdf39c20c8a0e$var$ye.exit()).then(()=>n()) : n();
    }
    clearIdle() {
        this.idleTimer && clearTimeout(this.idleTimer), this.idleTimer = null;
    }
    setIdle(t = !1) {
        const e = ()=>{
            this.clearIdle(), this.idle = !0, $c2cbdf39c20c8a0e$var$P(this.container, "is-idle"), this.emit("setIdle");
        };
        if (this.clearIdle(), !this.isClosing()) {
            if (t) e();
            else {
                const t = this.option("idle");
                t && (this.idleTimer = setTimeout(e, t));
            }
        }
    }
    endIdle() {
        this.clearIdle(), this.idle && !this.isClosing() && (this.idle = !1, $c2cbdf39c20c8a0e$var$S(this.container, "is-idle"), this.emit("endIdle"));
    }
    resetIdle() {
        this.endIdle(), this.setIdle();
    }
    toggleIdle() {
        this.idle ? this.endIdle() : this.setIdle(!0);
    }
    toggleFullscreen() {
        $c2cbdf39c20c8a0e$var$ye && ($c2cbdf39c20c8a0e$var$ye.isFullscreen() ? $c2cbdf39c20c8a0e$var$ye.exit() : $c2cbdf39c20c8a0e$var$ye.request().then(()=>{
            this.startedFs = !0;
        }));
    }
    isClosing() {
        return [
            $c2cbdf39c20c8a0e$var$rt.Closing,
            $c2cbdf39c20c8a0e$var$rt.CustomClosing,
            $c2cbdf39c20c8a0e$var$rt.Destroy
        ].includes(this.state);
    }
    proceedClose(t, e) {
        var i, n;
        this.state = $c2cbdf39c20c8a0e$var$rt.Closing, this.clearIdle(), this.detachEvents();
        const s = this.container, o = this.carousel, a = this.getSlide(), r = a && this.option("placeFocusBack") ? a.triggerEl || this.option("triggerEl") : null;
        if (r && ($c2cbdf39c20c8a0e$var$tt(r) ? $c2cbdf39c20c8a0e$var$st(r) : r.focus()), s && ($c2cbdf39c20c8a0e$var$S(s, $c2cbdf39c20c8a0e$var$he), $c2cbdf39c20c8a0e$var$P(s, "is-closing"), s.setAttribute($c2cbdf39c20c8a0e$var$oe, "true"), this.option("animated") && $c2cbdf39c20c8a0e$var$P(s, $c2cbdf39c20c8a0e$var$re), s.style.pointerEvents = "none"), o) {
            o.clearTransitions(), null === (i = o.panzoom) || void 0 === i || i.destroy(), null === (n = o.plugins.Navigation) || void 0 === n || n.detach();
            for (const t of o.slides){
                t.state = $c2cbdf39c20c8a0e$var$lt.Closing, this.hideLoading(t);
                const e = t.contentEl;
                e && this.stop(e);
                const i = null == t ? void 0 : t.panzoom;
                i && (i.stop(), i.detachEvents(), i.detachObserver()), this.isCurrentSlide(t) || o.emit("removeSlide", t);
            }
        }
        $c2cbdf39c20c8a0e$var$Pe = window.scrollX, $c2cbdf39c20c8a0e$var$Ce = window.scrollY, window.addEventListener("scroll", this.onScroll), this.emit("close", t), this.state !== $c2cbdf39c20c8a0e$var$rt.CustomClosing ? (void 0 === e && a && (e = this.optionFor(a, "hideClass")), e && a ? (this.animate(a.contentEl, e, ()=>{
            o && o.emit("removeSlide", a);
        }), setTimeout(()=>{
            this.destroy();
        }, 500)) : this.destroy()) : setTimeout(()=>{
            this.destroy();
        }, 500);
    }
    destroy() {
        var t;
        if (this.state === $c2cbdf39c20c8a0e$var$rt.Destroy) return;
        window.removeEventListener("scroll", this.onScroll), this.state = $c2cbdf39c20c8a0e$var$rt.Destroy, null === (t = this.carousel) || void 0 === t || t.destroy();
        const e = this.container;
        e && e.remove(), $c2cbdf39c20c8a0e$var$Te.delete(this.id);
        const i = $c2cbdf39c20c8a0e$export$cb45b08d97cdc4fd.getInstance();
        i ? i.focus() : ($c2cbdf39c20c8a0e$var$we && ($c2cbdf39c20c8a0e$var$we.remove(), $c2cbdf39c20c8a0e$var$we = null), $c2cbdf39c20c8a0e$var$xe && ($c2cbdf39c20c8a0e$var$xe.remove(), $c2cbdf39c20c8a0e$var$xe = null), $c2cbdf39c20c8a0e$var$S(document.documentElement, $c2cbdf39c20c8a0e$var$ee), (()=>{
            if (!$c2cbdf39c20c8a0e$var$et) return;
            const t = document, e = t.body;
            e.classList.remove($c2cbdf39c20c8a0e$var$ie), e.style.setProperty($c2cbdf39c20c8a0e$var$se, ""), t.documentElement.style.setProperty($c2cbdf39c20c8a0e$var$ne, "");
        })(), this.emit("destroy"));
    }
    static bind(t, e, i) {
        if (!$c2cbdf39c20c8a0e$var$et) return;
        let n, s = "", o = {};
        if (void 0 === t ? n = document.body : $c2cbdf39c20c8a0e$var$ve(t) ? (n = document.body, s = t, "object" == typeof e && (o = e || {})) : (n = t, $c2cbdf39c20c8a0e$var$ve(e) && (s = e), "object" == typeof i && (o = i || {})), !n || !$c2cbdf39c20c8a0e$var$E(n)) return;
        s = s || "[data-fancybox]";
        const a = $c2cbdf39c20c8a0e$export$cb45b08d97cdc4fd.openers.get(n) || new Map;
        a.set(s, o), $c2cbdf39c20c8a0e$export$cb45b08d97cdc4fd.openers.set(n, a), 1 === a.size && n.addEventListener("click", $c2cbdf39c20c8a0e$export$cb45b08d97cdc4fd.fromEvent);
    }
    static unbind(t, e) {
        let i, n = "";
        if ($c2cbdf39c20c8a0e$var$ve(t) ? (i = document.body, n = t) : (i = t, $c2cbdf39c20c8a0e$var$ve(e) && (n = e)), !i) return;
        const s = $c2cbdf39c20c8a0e$export$cb45b08d97cdc4fd.openers.get(i);
        s && n && s.delete(n), n && s || ($c2cbdf39c20c8a0e$export$cb45b08d97cdc4fd.openers.delete(i), i.removeEventListener("click", $c2cbdf39c20c8a0e$export$cb45b08d97cdc4fd.fromEvent));
    }
    static destroy() {
        let t;
        for(; t = $c2cbdf39c20c8a0e$export$cb45b08d97cdc4fd.getInstance();)t.destroy();
        for (const t of $c2cbdf39c20c8a0e$export$cb45b08d97cdc4fd.openers.keys())t.removeEventListener("click", $c2cbdf39c20c8a0e$export$cb45b08d97cdc4fd.fromEvent);
        $c2cbdf39c20c8a0e$export$cb45b08d97cdc4fd.openers = new Map;
    }
    static fromEvent(t) {
        if (t.defaultPrevented) return;
        if (t.button && 0 !== t.button) return;
        if (t.ctrlKey || t.metaKey || t.shiftKey) return;
        let e = t.composedPath()[0];
        const i = e.closest("[data-fancybox-trigger]");
        if (i) {
            const t = i.dataset.fancyboxTrigger || "", n = document.querySelectorAll(`[data-fancybox="${t}"]`), s = parseInt(i.dataset.fancyboxIndex || "", 10) || 0;
            e = n[s] || e;
        }
        if (!(e && e instanceof Element)) return;
        let n, s, o, a;
        if ([
            ...$c2cbdf39c20c8a0e$export$cb45b08d97cdc4fd.openers
        ].reverse().find(([t, i])=>!(!t.contains(e) || ![
                ...i
            ].reverse().find(([i, r])=>{
                let l = e.closest(i);
                return !!l && (n = t, s = i, o = l, a = r, !0);
            }))), !n || !s || !o) return;
        a = a || {}, t.preventDefault(), e = o;
        let r = [], l = $c2cbdf39c20c8a0e$var$u({}, $c2cbdf39c20c8a0e$var$at, a);
        l.event = t, l.triggerEl = e, l.delegate = i;
        const c = l.groupAll, h = l.groupAttr, d = h && e ? e.getAttribute(`${h}`) : "";
        if ((!e || d || c) && (r = [].slice.call(n.querySelectorAll(s))), e && !c && (r = d ? r.filter((t)=>t.getAttribute(`${h}`) === d) : [
            e
        ]), !r.length) return;
        const p = $c2cbdf39c20c8a0e$export$cb45b08d97cdc4fd.getInstance();
        return p && p.options.triggerEl && r.indexOf(p.options.triggerEl) > -1 ? void 0 : (e && (l.startIndex = r.indexOf(e)), $c2cbdf39c20c8a0e$export$cb45b08d97cdc4fd.fromNodes(r, l));
    }
    static fromSelector(t, e, i) {
        let n = null, s = "", o = {};
        if ($c2cbdf39c20c8a0e$var$ve(t) ? (n = document.body, s = t, "object" == typeof e && (o = e || {})) : t instanceof HTMLElement && $c2cbdf39c20c8a0e$var$ve(e) && (n = t, s = e, "object" == typeof i && (o = i || {})), !n || !s) return !1;
        const a = $c2cbdf39c20c8a0e$export$cb45b08d97cdc4fd.openers.get(n);
        return !!a && (o = $c2cbdf39c20c8a0e$var$u({}, a.get(s) || {}, o), !!o && $c2cbdf39c20c8a0e$export$cb45b08d97cdc4fd.fromNodes(Array.from(n.querySelectorAll(s)), o));
    }
    static fromNodes(t, e) {
        e = $c2cbdf39c20c8a0e$var$u({}, $c2cbdf39c20c8a0e$var$at, e || {});
        const i = [];
        for (const n of t){
            const t = n.dataset || {}, s = t[$c2cbdf39c20c8a0e$var$me] || n.getAttribute($c2cbdf39c20c8a0e$var$ge) || n.getAttribute("currentSrc") || n.getAttribute($c2cbdf39c20c8a0e$var$me) || void 0;
            let o;
            const a = e.delegate;
            let r;
            a && i.length === e.startIndex && (o = a instanceof HTMLImageElement ? a : a.querySelector("img:not([aria-hidden])")), o || (o = n instanceof HTMLImageElement ? n : n.querySelector("img:not([aria-hidden])")), o && (r = o.currentSrc || o[$c2cbdf39c20c8a0e$var$me] || void 0, !r && o.dataset && (r = o.dataset.lazySrc || o.dataset[$c2cbdf39c20c8a0e$var$me] || void 0));
            const l = {
                src: s,
                triggerEl: n,
                thumbEl: o,
                thumbElSrc: r,
                thumbSrc: r
            };
            for(const e in t){
                let i = t[e] + "";
                i = "false" !== i && ("true" === i || i), l[e] = i;
            }
            i.push(l);
        }
        return new $c2cbdf39c20c8a0e$export$cb45b08d97cdc4fd(i, e);
    }
    static getInstance(t) {
        if (t) return $c2cbdf39c20c8a0e$var$Te.get(t);
        return Array.from($c2cbdf39c20c8a0e$var$Te.values()).reverse().find((t)=>!t.isClosing() && t) || null;
    }
    static getSlide() {
        var t;
        return (null === (t = $c2cbdf39c20c8a0e$export$cb45b08d97cdc4fd.getInstance()) || void 0 === t ? void 0 : t.getSlide()) || null;
    }
    static show(t = [], e = {}) {
        return new $c2cbdf39c20c8a0e$export$cb45b08d97cdc4fd(t, e);
    }
    static next() {
        const t = $c2cbdf39c20c8a0e$export$cb45b08d97cdc4fd.getInstance();
        t && t.next();
    }
    static prev() {
        const t = $c2cbdf39c20c8a0e$export$cb45b08d97cdc4fd.getInstance();
        t && t.prev();
    }
    static close(t = !0, ...e) {
        if (t) for (const t of $c2cbdf39c20c8a0e$var$Te.values())t.close(...e);
        else {
            const t = $c2cbdf39c20c8a0e$export$cb45b08d97cdc4fd.getInstance();
            t && t.close(...e);
        }
    }
}
Object.defineProperty($c2cbdf39c20c8a0e$export$cb45b08d97cdc4fd, "version", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: "5.0.36"
}), Object.defineProperty($c2cbdf39c20c8a0e$export$cb45b08d97cdc4fd, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $c2cbdf39c20c8a0e$var$at
}), Object.defineProperty($c2cbdf39c20c8a0e$export$cb45b08d97cdc4fd, "Plugins", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $c2cbdf39c20c8a0e$var$te
}), Object.defineProperty($c2cbdf39c20c8a0e$export$cb45b08d97cdc4fd, "openers", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: new Map
});

});

parcelRegister("f5sus", function(module, exports) {

$parcel$export(module.exports, "reverseAriaExpanded", () => $afbd6c33c795e19c$export$6577ace5c44bfa6f);
$parcel$export(module.exports, "FocusTrap", () => $afbd6c33c795e19c$export$34eba2437817a67b);
function $afbd6c33c795e19c$export$6577ace5c44bfa6f(element, expand) {
    if (expand === undefined) expand = element.getAttribute('aria-expanded') === 'false';
    element.setAttribute('aria-expanded', expand);
}
class $afbd6c33c795e19c$export$34eba2437817a67b {
    constructor(element, focusableEls){
        this.element = element;
        this.focusableEls = focusableEls ?? this.constructor.getFocusableEls(element);
        this.firstFocusableEl = this.focusableEls[0];
        this.lastFocusableEl = this.focusableEls[this.focusableEls.length - 1];
        this._handler = this._handleKeydown.bind(this);
    }
    static getFocusableEls(element) {
        return element.querySelectorAll('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])');
    }
    enable() {
        document.addEventListener('keydown', this._handler);
    }
    disable() {
        document.removeEventListener('keydown', this._handler);
    }
    _handleKeydown(e) {
        if (!(e.key === 'Tab' || e.keyCode === 9)) return;
        if (e.shiftKey) {
            if (document.activeElement === this.firstFocusableEl) {
                this.lastFocusableEl.focus();
                e.preventDefault();
            }
        } else if (document.activeElement === this.lastFocusableEl) {
            this.firstFocusableEl.focus();
            e.preventDefault();
        }
    }
}

});

parcelRegister("lwga2", function(module, exports) {

$parcel$export(module.exports, "default", () => $faa91f5616b3e685$export$2e2bcd8739ae039);
/*! @vimeo/player v2.30.3 | (c) 2026 Vimeo | MIT License | https://github.com/vimeo/player.js */ /**
 * @module lib/functions
 */ /**
 * Check to see this is a Node environment.
 * @type {boolean}
 */ /* global global */ const $faa91f5616b3e685$var$isNode = typeof $parcel$global !== 'undefined' && ({}).toString.call($parcel$global) === '[object global]';
/**
 * Check to see if this is a Bun environment.
 * @see https://bun.sh/guides/util/detect-bun
 * @type {boolean}
 */ const $faa91f5616b3e685$var$isBun = typeof Bun !== 'undefined';
/**
 * Check to see if this is a Deno environment.
 * @see https://docs.deno.com/api/deno/~/Deno
 * @type {boolean}
 */ const $faa91f5616b3e685$var$isDeno = typeof Deno !== 'undefined';
/**
 * Check to see if this is a Cloudflare Worker environment.
 * @see https://community.cloudflare.com/t/how-to-detect-the-cloudflare-worker-runtime/293715
 * @type {boolean}
 */ const $faa91f5616b3e685$var$isCloudflareWorker = typeof WebSocketPair === 'function' && typeof caches?.default !== 'undefined';
/**
 * Check if this is a server runtime
 * @type {boolean}
 */ const $faa91f5616b3e685$var$isServerRuntime = $faa91f5616b3e685$var$isNode || $faa91f5616b3e685$var$isBun || $faa91f5616b3e685$var$isDeno || $faa91f5616b3e685$var$isCloudflareWorker;
/**
 * Get the name of the method for a given getter or setter.
 *
 * @param {string} prop The name of the property.
 * @param {string} type Either “get” or “set”.
 * @return {string}
 */ function $faa91f5616b3e685$var$getMethodName(prop, type) {
    if (prop.indexOf(type.toLowerCase()) === 0) return prop;
    return `${type.toLowerCase()}${prop.substr(0, 1).toUpperCase()}${prop.substr(1)}`;
}
/**
 * Check to see if the object is a DOM Element.
 *
 * @param {*} element The object to check.
 * @return {boolean}
 */ function $faa91f5616b3e685$var$isDomElement(element) {
    return Boolean(element && element.nodeType === 1 && 'nodeName' in element && element.ownerDocument && element.ownerDocument.defaultView);
}
/**
 * Check to see whether the value is a number.
 *
 * @see http://dl.dropboxusercontent.com/u/35146/js/tests/isNumber.html
 * @param {*} value The value to check.
 * @param {boolean} integer Check if the value is an integer.
 * @return {boolean}
 */ function $faa91f5616b3e685$var$isInteger(value) {
    // eslint-disable-next-line eqeqeq
    return !isNaN(parseFloat(value)) && isFinite(value) && Math.floor(value) == value;
}
/**
 * Check to see if the URL is a Vimeo url.
 *
 * @param {string} url The url string.
 * @return {boolean}
 */ function $faa91f5616b3e685$var$isVimeoUrl(url) {
    return /^(https?:)?\/\/((((player|www)\.)?vimeo\.com)|((player\.)?[a-zA-Z0-9-]+\.(videoji\.(hk|cn)|vimeo\.work)))(?=$|\/)/.test(url);
}
/**
 * Check to see if the URL is for a Vimeo embed.
 *
 * @param {string} url The url string.
 * @return {boolean}
 */ function $faa91f5616b3e685$var$isVimeoEmbed(url) {
    const expr = /^https:\/\/player\.((vimeo\.com)|([a-zA-Z0-9-]+\.(videoji\.(hk|cn)|vimeo\.work)))\/video\/\d+/;
    return expr.test(url);
}
function $faa91f5616b3e685$var$getOembedDomain(url) {
    const match = (url || '').match(/^(?:https?:)?(?:\/\/)?([^/?]+)/);
    const domain = (match && match[1] || '').replace('player.', '');
    const customDomains = [
        '.videoji.hk',
        '.vimeo.work',
        '.videoji.cn'
    ];
    for (const customDomain of customDomains){
        if (domain.endsWith(customDomain)) return domain;
    }
    return 'vimeo.com';
}
/**
 * Get the Vimeo URL from an element.
 * The element must have either a data-vimeo-id or data-vimeo-url attribute.
 *
 * @param {object} oEmbedParameters The oEmbed parameters.
 * @return {string}
 */ function $faa91f5616b3e685$var$getVimeoUrl() {
    let oEmbedParameters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const id = oEmbedParameters.id;
    const url = oEmbedParameters.url;
    const idOrUrl = id || url;
    if (!idOrUrl) throw new Error('An id or url must be passed, either in an options object or as a data-vimeo-id or data-vimeo-url attribute.');
    if ($faa91f5616b3e685$var$isInteger(idOrUrl)) return `https://vimeo.com/${idOrUrl}`;
    if ($faa91f5616b3e685$var$isVimeoUrl(idOrUrl)) return idOrUrl.replace('http:', 'https:');
    if (id) throw new TypeError(`\u{201C}${id}\u{201D} is not a valid video id.`);
    throw new TypeError(`\u{201C}${idOrUrl}\u{201D} is not a vimeo.com url.`);
}
/* eslint-disable max-params */ /**
 * A utility method for attaching and detaching event handlers
 *
 * @param {EventTarget} target
 * @param {string | string[]} eventName
 * @param {function} callback
 * @param {'addEventListener' | 'on'} onName
 * @param {'removeEventListener' | 'off'} offName
 * @return {{cancel: (function(): void)}}
 */ const $faa91f5616b3e685$var$subscribe = function(target, eventName, callback) {
    let onName = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'addEventListener';
    let offName = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'removeEventListener';
    const eventNames = typeof eventName === 'string' ? [
        eventName
    ] : eventName;
    eventNames.forEach((evName)=>{
        target[onName](evName, callback);
    });
    return {
        cancel: ()=>eventNames.forEach((evName)=>target[offName](evName, callback))
    };
};
/**
 * Find the iframe element that contains a specific source window
 *
 * @param {Window} sourceWindow The source window to find the iframe for
 * @param {Document} [doc=document] The document to search within
 * @return {HTMLIFrameElement|null} The iframe element if found, otherwise null
 */ function $faa91f5616b3e685$var$findIframeBySourceWindow(sourceWindow) {
    let doc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;
    if (!sourceWindow || !doc || typeof doc.querySelectorAll !== 'function') return null;
    const iframes = doc.querySelectorAll('iframe');
    for(let i = 0; i < iframes.length; i++){
        if (iframes[i] && iframes[i].contentWindow === sourceWindow) return iframes[i];
    }
    return null;
}
const $faa91f5616b3e685$var$arrayIndexOfSupport = typeof Array.prototype.indexOf !== 'undefined';
const $faa91f5616b3e685$var$postMessageSupport = typeof window !== 'undefined' && typeof window.postMessage !== 'undefined';
if (!$faa91f5616b3e685$var$isServerRuntime && (!$faa91f5616b3e685$var$arrayIndexOfSupport || !$faa91f5616b3e685$var$postMessageSupport)) throw new Error('Sorry, the Vimeo Player API is not available in this browser.');
var $faa91f5616b3e685$var$commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof $parcel$global !== 'undefined' ? $parcel$global : typeof self !== 'undefined' ? self : {};
function $faa91f5616b3e685$var$createCommonjsModule(fn, module) {
    return module = {
        exports: {}
    }, fn(module, module.exports), module.exports;
}
/*!
 * weakmap-polyfill v2.0.4 - ECMAScript6 WeakMap polyfill
 * https://github.com/polygonplanet/weakmap-polyfill
 * Copyright (c) 2015-2021 polygonplanet <polygon.planet.aqua@gmail.com>
 * @license MIT
 */ (function(self1) {
    if (self1.WeakMap) return;
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    var hasDefine = Object.defineProperty && function() {
        try {
            // Avoid IE8's broken Object.defineProperty
            return Object.defineProperty({}, 'x', {
                value: 1
            }).x === 1;
        } catch (e) {}
    }();
    var defineProperty = function(object, name, value) {
        if (hasDefine) Object.defineProperty(object, name, {
            configurable: true,
            writable: true,
            value: value
        });
        else object[name] = value;
    };
    self1.WeakMap = function() {
        // ECMA-262 23.3 WeakMap Objects
        function WeakMap1() {
            if (this === void 0) throw new TypeError("Constructor WeakMap requires 'new'");
            defineProperty(this, '_id', genId('_WeakMap'));
            // ECMA-262 23.3.1.1 WeakMap([iterable])
            if (arguments.length > 0) // Currently, WeakMap `iterable` argument is not supported
            throw new TypeError('WeakMap iterable is not supported');
        }
        // ECMA-262 23.3.3.2 WeakMap.prototype.delete(key)
        defineProperty(WeakMap1.prototype, 'delete', function(key) {
            checkInstance(this, 'delete');
            if (!isObject(key)) return false;
            var entry = key[this._id];
            if (entry && entry[0] === key) {
                delete key[this._id];
                return true;
            }
            return false;
        });
        // ECMA-262 23.3.3.3 WeakMap.prototype.get(key)
        defineProperty(WeakMap1.prototype, 'get', function(key) {
            checkInstance(this, 'get');
            if (!isObject(key)) return void 0;
            var entry = key[this._id];
            if (entry && entry[0] === key) return entry[1];
            return void 0;
        });
        // ECMA-262 23.3.3.4 WeakMap.prototype.has(key)
        defineProperty(WeakMap1.prototype, 'has', function(key) {
            checkInstance(this, 'has');
            if (!isObject(key)) return false;
            var entry = key[this._id];
            if (entry && entry[0] === key) return true;
            return false;
        });
        // ECMA-262 23.3.3.5 WeakMap.prototype.set(key, value)
        defineProperty(WeakMap1.prototype, 'set', function(key, value) {
            checkInstance(this, 'set');
            if (!isObject(key)) throw new TypeError('Invalid value used as weak map key');
            var entry = key[this._id];
            if (entry && entry[0] === key) {
                entry[1] = value;
                return this;
            }
            defineProperty(key, this._id, [
                key,
                value
            ]);
            return this;
        });
        function checkInstance(x, methodName) {
            if (!isObject(x) || !hasOwnProperty.call(x, '_id')) throw new TypeError(methodName + ' method called on incompatible receiver ' + typeof x);
        }
        function genId(prefix) {
            return prefix + '_' + rand() + '.' + rand();
        }
        function rand() {
            return Math.random().toString().substring(2);
        }
        defineProperty(WeakMap1, '_polyfill', true);
        return WeakMap1;
    }();
    function isObject(x) {
        return Object(x) === x;
    }
})(typeof globalThis !== 'undefined' ? globalThis : typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : typeof $faa91f5616b3e685$var$commonjsGlobal !== 'undefined' ? $faa91f5616b3e685$var$commonjsGlobal : $faa91f5616b3e685$var$commonjsGlobal);
var $faa91f5616b3e685$var$npo_src = $faa91f5616b3e685$var$createCommonjsModule(function(module) {
    /*! Native Promise Only
    v0.8.1 (c) Kyle Simpson
    MIT License: http://getify.mit-license.org
*/ (function UMD(name, context, definition) {
        // special form of UMD for polyfilling across evironments
        context[name] = context[name] || definition();
        if (module.exports) module.exports = context[name];
    })("Promise", typeof $faa91f5616b3e685$var$commonjsGlobal != "undefined" ? $faa91f5616b3e685$var$commonjsGlobal : $faa91f5616b3e685$var$commonjsGlobal, function DEF() {
        var builtInProp, cycle, scheduling_queue, ToString = Object.prototype.toString, timer = typeof setImmediate != "undefined" ? function timer(fn) {
            return setImmediate(fn);
        } : setTimeout;
        // dammit, IE8.
        try {
            Object.defineProperty({}, "x", {});
            builtInProp = function builtInProp(obj, name, val, config) {
                return Object.defineProperty(obj, name, {
                    value: val,
                    writable: true,
                    configurable: config !== false
                });
            };
        } catch (err) {
            builtInProp = function builtInProp(obj, name, val) {
                obj[name] = val;
                return obj;
            };
        }
        // Note: using a queue instead of array for efficiency
        scheduling_queue = function Queue() {
            var first, last, item;
            function Item(fn, self1) {
                this.fn = fn;
                this.self = self1;
                this.next = void 0;
            }
            return {
                add: function add(fn, self1) {
                    item = new Item(fn, self1);
                    if (last) last.next = item;
                    else first = item;
                    last = item;
                    item = void 0;
                },
                drain: function drain() {
                    var f = first;
                    first = last = cycle = void 0;
                    while(f){
                        f.fn.call(f.self);
                        f = f.next;
                    }
                }
            };
        }();
        function schedule(fn, self1) {
            scheduling_queue.add(fn, self1);
            if (!cycle) cycle = timer(scheduling_queue.drain);
        }
        // promise duck typing
        function isThenable(o) {
            var _then, o_type = typeof o;
            if (o != null && (o_type == "object" || o_type == "function")) _then = o.then;
            return typeof _then == "function" ? _then : false;
        }
        function notify() {
            for(var i = 0; i < this.chain.length; i++)notifyIsolated(this, this.state === 1 ? this.chain[i].success : this.chain[i].failure, this.chain[i]);
            this.chain.length = 0;
        }
        // NOTE: This is a separate function to isolate
        // the `try..catch` so that other code can be
        // optimized better
        function notifyIsolated(self1, cb, chain) {
            var ret, _then;
            try {
                if (cb === false) chain.reject(self1.msg);
                else {
                    if (cb === true) ret = self1.msg;
                    else ret = cb.call(void 0, self1.msg);
                    if (ret === chain.promise) chain.reject(TypeError("Promise-chain cycle"));
                    else if (_then = isThenable(ret)) _then.call(ret, chain.resolve, chain.reject);
                    else chain.resolve(ret);
                }
            } catch (err) {
                chain.reject(err);
            }
        }
        function resolve(msg) {
            var _then, self1 = this;
            // already triggered?
            if (self1.triggered) return;
            self1.triggered = true;
            // unwrap
            if (self1.def) self1 = self1.def;
            try {
                if (_then = isThenable(msg)) schedule(function() {
                    var def_wrapper = new MakeDefWrapper(self1);
                    try {
                        _then.call(msg, function $resolve$() {
                            resolve.apply(def_wrapper, arguments);
                        }, function $reject$() {
                            reject.apply(def_wrapper, arguments);
                        });
                    } catch (err) {
                        reject.call(def_wrapper, err);
                    }
                });
                else {
                    self1.msg = msg;
                    self1.state = 1;
                    if (self1.chain.length > 0) schedule(notify, self1);
                }
            } catch (err) {
                reject.call(new MakeDefWrapper(self1), err);
            }
        }
        function reject(msg) {
            var self1 = this;
            // already triggered?
            if (self1.triggered) return;
            self1.triggered = true;
            // unwrap
            if (self1.def) self1 = self1.def;
            self1.msg = msg;
            self1.state = 2;
            if (self1.chain.length > 0) schedule(notify, self1);
        }
        function iteratePromises(Constructor, arr, resolver, rejecter) {
            for(var idx = 0; idx < arr.length; idx++)(function IIFE(idx) {
                Constructor.resolve(arr[idx]).then(function $resolver$(msg) {
                    resolver(idx, msg);
                }, rejecter);
            })(idx);
        }
        function MakeDefWrapper(self1) {
            this.def = self1;
            this.triggered = false;
        }
        function MakeDef(self1) {
            this.promise = self1;
            this.state = 0;
            this.triggered = false;
            this.chain = [];
            this.msg = void 0;
        }
        function Promise1(executor) {
            if (typeof executor != "function") throw TypeError("Not a function");
            if (this.__NPO__ !== 0) throw TypeError("Not a promise");
            // instance shadowing the inherited "brand"
            // to signal an already "initialized" promise
            this.__NPO__ = 1;
            var def = new MakeDef(this);
            this["then"] = function then(success, failure) {
                var o = {
                    success: typeof success == "function" ? success : true,
                    failure: typeof failure == "function" ? failure : false
                };
                // Note: `then(..)` itself can be borrowed to be used against
                // a different promise constructor for making the chained promise,
                // by substituting a different `this` binding.
                o.promise = new this.constructor(function extractChain(resolve, reject) {
                    if (typeof resolve != "function" || typeof reject != "function") throw TypeError("Not a function");
                    o.resolve = resolve;
                    o.reject = reject;
                });
                def.chain.push(o);
                if (def.state !== 0) schedule(notify, def);
                return o.promise;
            };
            this["catch"] = function $catch$(failure) {
                return this.then(void 0, failure);
            };
            try {
                executor.call(void 0, function publicResolve(msg) {
                    resolve.call(def, msg);
                }, function publicReject(msg) {
                    reject.call(def, msg);
                });
            } catch (err) {
                reject.call(def, err);
            }
        }
        var PromisePrototype = builtInProp({}, "constructor", Promise1, /*configurable=*/ false);
        // Note: Android 4 cannot use `Object.defineProperty(..)` here
        Promise1.prototype = PromisePrototype;
        // built-in "brand" to signal an "uninitialized" promise
        builtInProp(PromisePrototype, "__NPO__", 0, /*configurable=*/ false);
        builtInProp(Promise1, "resolve", function Promise$resolve(msg) {
            var Constructor = this;
            // spec mandated checks
            // note: best "isPromise" check that's practical for now
            if (msg && typeof msg == "object" && msg.__NPO__ === 1) return msg;
            return new Constructor(function executor(resolve, reject) {
                if (typeof resolve != "function" || typeof reject != "function") throw TypeError("Not a function");
                resolve(msg);
            });
        });
        builtInProp(Promise1, "reject", function Promise$reject(msg) {
            return new this(function executor(resolve, reject) {
                if (typeof resolve != "function" || typeof reject != "function") throw TypeError("Not a function");
                reject(msg);
            });
        });
        builtInProp(Promise1, "all", function Promise$all(arr) {
            var Constructor = this;
            // spec mandated checks
            if (ToString.call(arr) != "[object Array]") return Constructor.reject(TypeError("Not an array"));
            if (arr.length === 0) return Constructor.resolve([]);
            return new Constructor(function executor(resolve, reject) {
                if (typeof resolve != "function" || typeof reject != "function") throw TypeError("Not a function");
                var len = arr.length, msgs = Array(len), count = 0;
                iteratePromises(Constructor, arr, function resolver(idx, msg) {
                    msgs[idx] = msg;
                    if (++count === len) resolve(msgs);
                }, reject);
            });
        });
        builtInProp(Promise1, "race", function Promise$race(arr) {
            var Constructor = this;
            // spec mandated checks
            if (ToString.call(arr) != "[object Array]") return Constructor.reject(TypeError("Not an array"));
            return new Constructor(function executor(resolve, reject) {
                if (typeof resolve != "function" || typeof reject != "function") throw TypeError("Not a function");
                iteratePromises(Constructor, arr, function resolver(idx, msg) {
                    resolve(msg);
                }, reject);
            });
        });
        return Promise1;
    });
});
/**
 * @module lib/callbacks
 */ const $faa91f5616b3e685$var$callbackMap = new WeakMap();
/**
 * Store a callback for a method or event for a player.
 *
 * @param {Player} player The player object.
 * @param {string} name The method or event name.
 * @param {(function(this:Player, *): void|{resolve: function, reject: function})} callback
 *        The callback to call or an object with resolve and reject functions for a promise.
 * @return {void}
 */ function $faa91f5616b3e685$var$storeCallback(player, name, callback) {
    const playerCallbacks = $faa91f5616b3e685$var$callbackMap.get(player.element) || {};
    if (!(name in playerCallbacks)) playerCallbacks[name] = [];
    playerCallbacks[name].push(callback);
    $faa91f5616b3e685$var$callbackMap.set(player.element, playerCallbacks);
}
/**
 * Get the callbacks for a player and event or method.
 *
 * @param {Player} player The player object.
 * @param {string} name The method or event name
 * @return {function[]}
 */ function $faa91f5616b3e685$var$getCallbacks(player, name) {
    const playerCallbacks = $faa91f5616b3e685$var$callbackMap.get(player.element) || {};
    return playerCallbacks[name] || [];
}
/**
 * Remove a stored callback for a method or event for a player.
 *
 * @param {Player} player The player object.
 * @param {string} name The method or event name
 * @param {function} [callback] The specific callback to remove.
 * @return {boolean} Was this the last callback?
 */ function $faa91f5616b3e685$var$removeCallback(player, name, callback) {
    const playerCallbacks = $faa91f5616b3e685$var$callbackMap.get(player.element) || {};
    if (!playerCallbacks[name]) return true;
    // If no callback is passed, remove all callbacks for the event
    if (!callback) {
        playerCallbacks[name] = [];
        $faa91f5616b3e685$var$callbackMap.set(player.element, playerCallbacks);
        return true;
    }
    const index = playerCallbacks[name].indexOf(callback);
    if (index !== -1) playerCallbacks[name].splice(index, 1);
    $faa91f5616b3e685$var$callbackMap.set(player.element, playerCallbacks);
    return playerCallbacks[name] && playerCallbacks[name].length === 0;
}
/**
 * Return the first stored callback for a player and event or method.
 *
 * @param {Player} player The player object.
 * @param {string} name The method or event name.
 * @return {function} The callback, or false if there were none
 */ function $faa91f5616b3e685$var$shiftCallbacks(player, name) {
    const playerCallbacks = $faa91f5616b3e685$var$getCallbacks(player, name);
    if (playerCallbacks.length < 1) return false;
    const callback = playerCallbacks.shift();
    $faa91f5616b3e685$var$removeCallback(player, name, callback);
    return callback;
}
/**
 * Move callbacks associated with an element to another element.
 *
 * @param {HTMLElement} oldElement The old element.
 * @param {HTMLElement} newElement The new element.
 * @return {void}
 */ function $faa91f5616b3e685$var$swapCallbacks(oldElement, newElement) {
    const playerCallbacks = $faa91f5616b3e685$var$callbackMap.get(oldElement);
    $faa91f5616b3e685$var$callbackMap.set(newElement, playerCallbacks);
    $faa91f5616b3e685$var$callbackMap.delete(oldElement);
}
/**
 * @module lib/postmessage
 */ /**
 * Parse a message received from postMessage.
 *
 * @param {*} data The data received from postMessage.
 * @return {object}
 */ function $faa91f5616b3e685$var$parseMessageData(data) {
    if (typeof data === 'string') try {
        data = JSON.parse(data);
    } catch (error) {
        // If the message cannot be parsed, throw the error as a warning
        console.warn(error);
        return {};
    }
    return data;
}
/**
 * Post a message to the specified target.
 *
 * @param {Player} player The player object to use.
 * @param {string} method The API method to call.
 * @param {string|number|object|Array|undefined} params The parameters to send to the player.
 * @return {void}
 */ function $faa91f5616b3e685$var$postMessage(player, method, params) {
    if (!player.element.contentWindow || !player.element.contentWindow.postMessage) return;
    let message = {
        method: method
    };
    if (params !== undefined) message.value = params;
    // IE 8 and 9 do not support passing messages, so stringify them
    const ieVersion = parseFloat(navigator.userAgent.toLowerCase().replace(/^.*msie (\d+).*$/, '$1'));
    if (ieVersion >= 8 && ieVersion < 10) message = JSON.stringify(message);
    player.element.contentWindow.postMessage(message, player.origin);
}
/**
 * Parse the data received from a message event.
 *
 * @param {Player} player The player that received the message.
 * @param {(Object|string)} data The message data. Strings will be parsed into JSON.
 * @return {void}
 */ function $faa91f5616b3e685$var$processData(player, data) {
    data = $faa91f5616b3e685$var$parseMessageData(data);
    let callbacks = [];
    let param;
    if (data.event) {
        if (data.event === 'error') {
            const promises = $faa91f5616b3e685$var$getCallbacks(player, data.data.method);
            promises.forEach((promise)=>{
                const error = new Error(data.data.message);
                error.name = data.data.name;
                promise.reject(error);
                $faa91f5616b3e685$var$removeCallback(player, data.data.method, promise);
            });
        }
        callbacks = $faa91f5616b3e685$var$getCallbacks(player, `event:${data.event}`);
        param = data.data;
    } else if (data.method) {
        const callback = $faa91f5616b3e685$var$shiftCallbacks(player, data.method);
        if (callback) {
            callbacks.push(callback);
            param = data.value;
        }
    }
    callbacks.forEach((callback)=>{
        try {
            if (typeof callback === 'function') {
                callback.call(player, param);
                return;
            }
            callback.resolve(param);
        } catch (e) {
        // empty
        }
    });
}
/**
 * @module lib/embed
 */ const $faa91f5616b3e685$var$oEmbedParameters = [
    'airplay',
    'audio_tracks',
    'audiotrack',
    'autopause',
    'autoplay',
    'background',
    'byline',
    'cc',
    'chapter_id',
    'chapters',
    'chromecast',
    'color',
    'colors',
    'controls',
    'dnt',
    'end_time',
    'fullscreen',
    'height',
    'id',
    'initial_quality',
    'interactive_params',
    'keyboard',
    'loop',
    'maxheight',
    'max_quality',
    'maxwidth',
    'min_quality',
    'muted',
    'play_button_position',
    'playsinline',
    'portrait',
    'preload',
    'progress_bar',
    'quality',
    'quality_selector',
    'responsive',
    'skipping_forward',
    'speed',
    'start_time',
    'texttrack',
    'thumbnail_id',
    'title',
    'transcript',
    'transparent',
    'unmute_button',
    'url',
    'vimeo_logo',
    'volume',
    'watch_full_video',
    'width'
];
/**
 * Get the 'data-vimeo'-prefixed attributes from an element as an object.
 *
 * @param {HTMLElement} element The element.
 * @param {Object} [defaults={}] The default values to use.
 * @return {Object<string, string>}
 */ function $faa91f5616b3e685$var$getOEmbedParameters(element) {
    let defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return $faa91f5616b3e685$var$oEmbedParameters.reduce((params, param)=>{
        const value = element.getAttribute(`data-vimeo-${param}`);
        if (value || value === '') params[param] = value === '' ? 1 : value;
        return params;
    }, defaults);
}
/**
 * Create an embed from oEmbed data inside an element.
 *
 * @param {object} data The oEmbed data.
 * @param {HTMLElement} element The element to put the iframe in.
 * @return {HTMLIFrameElement} The iframe embed.
 */ function $faa91f5616b3e685$var$createEmbed(_ref, element) {
    let { html: html } = _ref;
    if (!element) throw new TypeError('An element must be provided');
    if (element.getAttribute('data-vimeo-initialized') !== null) return element.querySelector('iframe');
    const div = document.createElement('div');
    div.innerHTML = html;
    element.appendChild(div.firstChild);
    element.setAttribute('data-vimeo-initialized', 'true');
    return element.querySelector('iframe');
}
/**
 * Make an oEmbed call for the specified URL.
 *
 * @param {string} videoUrl The vimeo.com url for the video.
 * @param {Object} [params] Parameters to pass to oEmbed.
 * @param {HTMLElement} element The element.
 * @return {Promise}
 */ function $faa91f5616b3e685$var$getOEmbedData(videoUrl) {
    let params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    let element = arguments.length > 2 ? arguments[2] : undefined;
    return new Promise((resolve, reject)=>{
        if (!$faa91f5616b3e685$var$isVimeoUrl(videoUrl)) throw new TypeError(`\u{201C}${videoUrl}\u{201D} is not a vimeo.com url.`);
        const domain = $faa91f5616b3e685$var$getOembedDomain(videoUrl);
        let url = `https://${domain}/api/oembed.json?url=${encodeURIComponent(videoUrl)}`;
        for(const param in params)if (params.hasOwnProperty(param)) url += `&${param}=${encodeURIComponent(params[param])}`;
        const xhr = 'XDomainRequest' in window ? new XDomainRequest() : new XMLHttpRequest();
        xhr.open('GET', url, true);
        xhr.onload = function() {
            if (xhr.status === 404) {
                reject(new Error(`\u{201C}${videoUrl}\u{201D} was not found.`));
                return;
            }
            if (xhr.status === 403) {
                reject(new Error(`\u{201C}${videoUrl}\u{201D} is not embeddable.`));
                return;
            }
            try {
                const json = JSON.parse(xhr.responseText);
                // Check api response for 403 on oembed
                if (json.domain_status_code === 403) {
                    // We still want to create the embed to give users visual feedback
                    $faa91f5616b3e685$var$createEmbed(json, element);
                    reject(new Error(`\u{201C}${videoUrl}\u{201D} is not embeddable.`));
                    return;
                }
                resolve(json);
            } catch (error) {
                reject(error);
            }
        };
        xhr.onerror = function() {
            const status = xhr.status ? ` (${xhr.status})` : '';
            reject(new Error(`There was an error fetching the embed code from Vimeo${status}.`));
        };
        xhr.send();
    });
}
/**
 * Initialize all embeds within a specific element
 *
 * @param {HTMLElement} [parent=document] The parent element.
 * @return {void}
 */ function $faa91f5616b3e685$var$initializeEmbeds() {
    let parent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
    const elements = [].slice.call(parent.querySelectorAll('[data-vimeo-id], [data-vimeo-url]'));
    const handleError = (error)=>{
        if ('console' in window && console.error) console.error(`There was an error creating an embed: ${error}`);
    };
    elements.forEach((element)=>{
        try {
            // Skip any that have data-vimeo-defer
            if (element.getAttribute('data-vimeo-defer') !== null) return;
            const params = $faa91f5616b3e685$var$getOEmbedParameters(element);
            const url = $faa91f5616b3e685$var$getVimeoUrl(params);
            $faa91f5616b3e685$var$getOEmbedData(url, params, element).then((data)=>{
                return $faa91f5616b3e685$var$createEmbed(data, element);
            }).catch(handleError);
        } catch (error) {
            handleError(error);
        }
    });
}
/**
 * Resize embeds when messaged by the player.
 *
 * @param {HTMLElement} [parent=document] The parent element.
 * @return {void}
 */ function $faa91f5616b3e685$var$resizeEmbeds() {
    let parent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
    // Prevent execution if users include the player.js script multiple times.
    if (window.VimeoPlayerResizeEmbeds_) return;
    window.VimeoPlayerResizeEmbeds_ = true;
    const onMessage = (event)=>{
        if (!$faa91f5616b3e685$var$isVimeoUrl(event.origin)) return;
        // 'spacechange' is fired only on embeds with cards
        if (!event.data || event.data.event !== 'spacechange') return;
        const senderIFrame = event.source ? $faa91f5616b3e685$var$findIframeBySourceWindow(event.source, parent) : null;
        if (senderIFrame) {
            // Change padding-bottom of the enclosing div to accommodate
            // card carousel without distorting aspect ratio
            const space = senderIFrame.parentElement;
            space.style.paddingBottom = `${event.data.data[0].bottom}px`;
        }
    };
    window.addEventListener('message', onMessage);
}
/**
 * Add chapters to existing metadata for Google SEO
 *
 * @param {HTMLElement} [parent=document] The parent element.
 * @return {void}
 */ function $faa91f5616b3e685$var$initAppendVideoMetadata() {
    let parent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
    //  Prevent execution if users include the player.js script multiple times.
    if (window.VimeoSeoMetadataAppended) return;
    window.VimeoSeoMetadataAppended = true;
    const onMessage = (event)=>{
        if (!$faa91f5616b3e685$var$isVimeoUrl(event.origin)) return;
        const data = $faa91f5616b3e685$var$parseMessageData(event.data);
        if (!data || data.event !== 'ready') return;
        const senderIFrame = event.source ? $faa91f5616b3e685$var$findIframeBySourceWindow(event.source, parent) : null;
        // Initiate appendVideoMetadata if iframe is a Vimeo embed
        if (senderIFrame && $faa91f5616b3e685$var$isVimeoEmbed(senderIFrame.src)) {
            const player = new $faa91f5616b3e685$var$Player(senderIFrame);
            player.callMethod('appendVideoMetadata', window.location.href);
        }
    };
    window.addEventListener('message', onMessage);
}
/**
 * Seek to time indicated by vimeo_t query parameter if present in URL
 *
 * @param {HTMLElement} [parent=document] The parent element.
 * @return {void}
 */ function $faa91f5616b3e685$var$checkUrlTimeParam() {
    let parent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
    //  Prevent execution if users include the player.js script multiple times.
    if (window.VimeoCheckedUrlTimeParam) return;
    window.VimeoCheckedUrlTimeParam = true;
    const handleError = (error)=>{
        if ('console' in window && console.error) console.error(`There was an error getting video Id: ${error}`);
    };
    const onMessage = (event)=>{
        if (!$faa91f5616b3e685$var$isVimeoUrl(event.origin)) return;
        const data = $faa91f5616b3e685$var$parseMessageData(event.data);
        if (!data || data.event !== 'ready') return;
        const senderIFrame = event.source ? $faa91f5616b3e685$var$findIframeBySourceWindow(event.source, parent) : null;
        if (senderIFrame && $faa91f5616b3e685$var$isVimeoEmbed(senderIFrame.src)) {
            const player = new $faa91f5616b3e685$var$Player(senderIFrame);
            player.getVideoId().then((videoId)=>{
                const matches = new RegExp(`[?&]vimeo_t_${videoId}=([^&#]*)`).exec(window.location.href);
                if (matches && matches[1]) {
                    const sec = decodeURI(matches[1]);
                    player.setCurrentTime(sec);
                }
                return;
            }).catch(handleError);
        }
    };
    window.addEventListener('message', onMessage);
}
/**
 * Updates iframe embeds to support DRM content playback by adding the 'encrypted-media' permission
 * to the iframe's allow attribute when DRM initialization fails. This function acts as a fallback
 * mechanism to enable playback of DRM-protected content in embeds that weren't properly configured.
 *
 * @return {void}
 */ function $faa91f5616b3e685$var$updateDRMEmbeds() {
    if (window.VimeoDRMEmbedsUpdated) return;
    window.VimeoDRMEmbedsUpdated = true;
    /**
   * Handle message events for DRM initialization failures
   * @param {MessageEvent} event - The message event from the iframe
   */ const onMessage = (event)=>{
        if (!$faa91f5616b3e685$var$isVimeoUrl(event.origin)) return;
        const data = $faa91f5616b3e685$var$parseMessageData(event.data);
        if (!data || data.event !== 'drminitfailed') return;
        const senderIFrame = event.source ? $faa91f5616b3e685$var$findIframeBySourceWindow(event.source) : null;
        if (!senderIFrame) return;
        const currentAllow = senderIFrame.getAttribute('allow') || '';
        const allowSupportsDRM = currentAllow.includes('encrypted-media');
        if (!allowSupportsDRM) {
            // For DRM playback to successfully occur, the iframe `allow` attribute must include 'encrypted-media'.
            // If the video requires DRM but doesn't have the attribute, we try to add on behalf of the embed owner
            // as a temporary measure to enable playback until they're able to update their embeds.
            senderIFrame.setAttribute('allow', `${currentAllow}; encrypted-media`);
            const currentUrl = new URL(senderIFrame.getAttribute('src'));
            // Adding this forces the embed to reload once `allow` has been updated with `encrypted-media`.
            currentUrl.searchParams.set('forcereload', 'drm');
            senderIFrame.setAttribute('src', currentUrl.toString());
            return;
        }
    };
    window.addEventListener('message', onMessage);
}
/* MIT License

Copyright (c) Sindre Sorhus <sindresorhus@gmail.com> (sindresorhus.com)

Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
Terms */ function $faa91f5616b3e685$var$initializeScreenfull() {
    const fn = function() {
        let val;
        const fnMap = [
            [
                'requestFullscreen',
                'exitFullscreen',
                'fullscreenElement',
                'fullscreenEnabled',
                'fullscreenchange',
                'fullscreenerror'
            ],
            // New WebKit
            [
                'webkitRequestFullscreen',
                'webkitExitFullscreen',
                'webkitFullscreenElement',
                'webkitFullscreenEnabled',
                'webkitfullscreenchange',
                'webkitfullscreenerror'
            ],
            // Old WebKit
            [
                'webkitRequestFullScreen',
                'webkitCancelFullScreen',
                'webkitCurrentFullScreenElement',
                'webkitCancelFullScreen',
                'webkitfullscreenchange',
                'webkitfullscreenerror'
            ],
            [
                'mozRequestFullScreen',
                'mozCancelFullScreen',
                'mozFullScreenElement',
                'mozFullScreenEnabled',
                'mozfullscreenchange',
                'mozfullscreenerror'
            ],
            [
                'msRequestFullscreen',
                'msExitFullscreen',
                'msFullscreenElement',
                'msFullscreenEnabled',
                'MSFullscreenChange',
                'MSFullscreenError'
            ]
        ];
        let i = 0;
        const l = fnMap.length;
        const ret = {};
        for(; i < l; i++){
            val = fnMap[i];
            if (val && val[1] in document) {
                for(i = 0; i < val.length; i++)ret[fnMap[0][i]] = val[i];
                return ret;
            }
        }
        return false;
    }();
    const eventNameMap = {
        fullscreenchange: fn.fullscreenchange,
        fullscreenerror: fn.fullscreenerror
    };
    const screenfull = {
        request (element) {
            return new Promise((resolve, reject)=>{
                const onFullScreenEntered = function() {
                    screenfull.off('fullscreenchange', onFullScreenEntered);
                    resolve();
                };
                screenfull.on('fullscreenchange', onFullScreenEntered);
                element = element || document.documentElement;
                const returnPromise = element[fn.requestFullscreen]();
                if (returnPromise instanceof Promise) returnPromise.then(onFullScreenEntered).catch(reject);
            });
        },
        exit () {
            return new Promise((resolve, reject)=>{
                if (!screenfull.isFullscreen) {
                    resolve();
                    return;
                }
                const onFullScreenExit = function() {
                    screenfull.off('fullscreenchange', onFullScreenExit);
                    resolve();
                };
                screenfull.on('fullscreenchange', onFullScreenExit);
                const returnPromise = document[fn.exitFullscreen]();
                if (returnPromise instanceof Promise) returnPromise.then(onFullScreenExit).catch(reject);
            });
        },
        on (event, callback) {
            const eventName = eventNameMap[event];
            if (eventName) document.addEventListener(eventName, callback);
        },
        off (event, callback) {
            const eventName = eventNameMap[event];
            if (eventName) document.removeEventListener(eventName, callback);
        }
    };
    Object.defineProperties(screenfull, {
        isFullscreen: {
            get () {
                return Boolean(document[fn.fullscreenElement]);
            }
        },
        element: {
            enumerable: true,
            get () {
                return document[fn.fullscreenElement];
            }
        },
        isEnabled: {
            enumerable: true,
            get () {
                // Coerce to boolean in case of old WebKit
                return Boolean(document[fn.fullscreenEnabled]);
            }
        }
    });
    return screenfull;
}
/** @typedef {import('./timing-src-connector.types').PlayerControls} PlayerControls */ /** @typedef {import('timing-object').ITimingObject} TimingObject */ /** @typedef {import('./timing-src-connector.types').TimingSrcConnectorOptions} TimingSrcConnectorOptions */ /** @typedef {(msg: string) => any} Logger */ /** @typedef {import('timing-object').TConnectionState} TConnectionState */ /**
 * @type {TimingSrcConnectorOptions}
 *
 * For details on these properties and their effects, see the typescript definition referenced above.
 */ const $faa91f5616b3e685$var$defaultOptions = {
    role: 'viewer',
    autoPlayMuted: true,
    allowedDrift: 0.3,
    maxAllowedDrift: 1,
    minCheckInterval: 0.1,
    maxRateAdjustment: 0.2,
    maxTimeToCatchUp: 1
};
/**
 * There's a proposed W3C spec for the Timing Object which would introduce a new set of APIs that would simplify time-synchronization tasks for browser applications.
 *
 * Proposed spec: https://webtiming.github.io/timingobject/
 * V3 Spec: https://timingsrc.readthedocs.io/en/latest/
 * Demuxed talk: https://www.youtube.com/watch?v=cZSjDaGDmX8
 *
 * This class makes it easy to connect Vimeo.Player to a provided TimingObject via Vimeo.Player.setTimingSrc(myTimingObject, options) and the synchronization will be handled automatically.
 *
 * There are 5 general responsibilities in TimingSrcConnector:
 *
 * 1. `updatePlayer()` which sets the player's currentTime, playbackRate and pause/play state based on current state of the TimingObject.
 * 2. `updateTimingObject()` which sets the TimingObject's position and velocity from the player's state.
 * 3. `playerUpdater` which listens for change events on the TimingObject and will respond by calling updatePlayer.
 * 4. `timingObjectUpdater` which listens to the player events of seeked, play and pause and will respond by calling `updateTimingObject()`.
 * 5. `maintainPlaybackPosition` this is code that constantly monitors the player to make sure it's always in sync with the TimingObject. This is needed because videos will generally not play with precise time accuracy and there will be some drift which becomes more noticeable over longer periods (as noted in the timing-object spec). More details on this method below.
 */ class $faa91f5616b3e685$var$TimingSrcConnector extends EventTarget {
    logger;
    /**
   * @param {PlayerControls} player
   * @param {TimingObject} timingObject
   * @param {TimingSrcConnectorOptions} options
   * @param {Logger} logger
   */ constructor(player, timingObject){
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        let logger = arguments.length > 3 ? arguments[3] : undefined;
        super();
        this.logger = logger;
        this.init(timingObject, player, {
            ...$faa91f5616b3e685$var$defaultOptions,
            ...options
        });
    }
    disconnect() {
        this.dispatchEvent(new Event('disconnect'));
    }
    /**
   * @param {TimingObject} timingObject
   * @param {PlayerControls} player
   * @param {TimingSrcConnectorOptions} options
   * @return {Promise<void>}
   */ async init(timingObject, player, options) {
        await this.waitForTOReadyState(timingObject, 'open');
        if (options.role === 'viewer') {
            await this.updatePlayer(timingObject, player, options);
            const playerUpdater = $faa91f5616b3e685$var$subscribe(timingObject, 'change', ()=>this.updatePlayer(timingObject, player, options));
            const positionSync = this.maintainPlaybackPosition(timingObject, player, options);
            this.addEventListener('disconnect', ()=>{
                positionSync.cancel();
                playerUpdater.cancel();
            });
        } else {
            await this.updateTimingObject(timingObject, player);
            const timingObjectUpdater = $faa91f5616b3e685$var$subscribe(player, [
                'seeked',
                'play',
                'pause',
                'ratechange'
            ], ()=>this.updateTimingObject(timingObject, player), 'on', 'off');
            this.addEventListener('disconnect', ()=>timingObjectUpdater.cancel());
        }
    }
    /**
   * Sets the TimingObject's state to reflect that of the player
   *
   * @param {TimingObject} timingObject
   * @param {PlayerControls} player
   * @return {Promise<void>}
   */ async updateTimingObject(timingObject, player) {
        const [position, isPaused, playbackRate] = await Promise.all([
            player.getCurrentTime(),
            player.getPaused(),
            player.getPlaybackRate()
        ]);
        timingObject.update({
            position: position,
            velocity: isPaused ? 0 : playbackRate
        });
    }
    /**
   * Sets the player's timing state to reflect that of the TimingObject
   *
   * @param {TimingObject} timingObject
   * @param {PlayerControls} player
   * @param {TimingSrcConnectorOptions} options
   * @return {Promise<void>}
   */ async updatePlayer(timingObject, player, options) {
        const { position: position, velocity: velocity } = timingObject.query();
        if (typeof position === 'number') player.setCurrentTime(position);
        if (typeof velocity === 'number') {
            if (velocity === 0) {
                if (await player.getPaused() === false) player.pause();
            } else if (velocity > 0) {
                if (await player.getPaused() === true) {
                    await player.play().catch(async (err)=>{
                        if (err.name === 'NotAllowedError' && options.autoPlayMuted) {
                            await player.setMuted(true);
                            await player.play().catch((err2)=>console.error('Couldn\'t play the video from TimingSrcConnector. Error:', err2));
                        }
                    });
                    this.updatePlayer(timingObject, player, options);
                }
                if (await player.getPlaybackRate() !== velocity) player.setPlaybackRate(velocity);
            }
        }
    }
    /**
   * Since video players do not play with 100% time precision, we need to closely monitor
   * our player to be sure it remains in sync with the TimingObject.
   *
   * If out of sync, we use the current conditions and the options provided to determine
   * whether to re-sync via setting currentTime or adjusting the playbackRate
   *
   * @param {TimingObject} timingObject
   * @param {PlayerControls} player
   * @param {TimingSrcConnectorOptions} options
   * @return {{cancel: (function(): void)}}
   */ maintainPlaybackPosition(timingObject, player, options) {
        const { allowedDrift: allowedDrift, maxAllowedDrift: maxAllowedDrift, minCheckInterval: minCheckInterval, maxRateAdjustment: maxRateAdjustment, maxTimeToCatchUp: maxTimeToCatchUp } = options;
        const syncInterval = Math.min(maxTimeToCatchUp, Math.max(minCheckInterval, maxAllowedDrift)) * 1000;
        const check = async ()=>{
            if (timingObject.query().velocity === 0 || await player.getPaused() === true) return;
            const diff = timingObject.query().position - await player.getCurrentTime();
            const diffAbs = Math.abs(diff);
            this.log(`Drift: ${diff}`);
            if (diffAbs > maxAllowedDrift) {
                await this.adjustSpeed(player, 0);
                player.setCurrentTime(timingObject.query().position);
                this.log('Resync by currentTime');
            } else if (diffAbs > allowedDrift) {
                const min = diffAbs / maxTimeToCatchUp;
                const max = maxRateAdjustment;
                const adjustment = min < max ? (max - min) / 2 : max;
                await this.adjustSpeed(player, adjustment * Math.sign(diff));
                this.log('Resync by playbackRate');
            }
        };
        const interval = setInterval(()=>check(), syncInterval);
        return {
            cancel: ()=>clearInterval(interval)
        };
    }
    /**
   * @param {string} msg
   */ log(msg) {
        this.logger?.(`TimingSrcConnector: ${msg}`);
    }
    speedAdjustment = 0;
    /**
   * @param {PlayerControls} player
   * @param {number} newAdjustment
   * @return {Promise<void>}
   */ adjustSpeed = async (player, newAdjustment)=>{
        if (this.speedAdjustment === newAdjustment) return;
        const newPlaybackRate = await player.getPlaybackRate() - this.speedAdjustment + newAdjustment;
        this.log(`New playbackRate:  ${newPlaybackRate}`);
        await player.setPlaybackRate(newPlaybackRate);
        this.speedAdjustment = newAdjustment;
    };
    /**
   * @param {TimingObject} timingObject
   * @param {TConnectionState} state
   * @return {Promise<void>}
   */ waitForTOReadyState(timingObject, state) {
        return new Promise((resolve)=>{
            const check = ()=>{
                if (timingObject.readyState === state) resolve();
                else timingObject.addEventListener('readystatechange', check, {
                    once: true
                });
            };
            check();
        });
    }
}
const $faa91f5616b3e685$var$playerMap = new WeakMap();
const $faa91f5616b3e685$var$readyMap = new WeakMap();
let $faa91f5616b3e685$var$screenfull = {};
class $faa91f5616b3e685$var$Player {
    /**
   * Create a Player.
   *
   * @param {(HTMLIFrameElement|HTMLElement|string|jQuery)} element A reference to the Vimeo
   *        player iframe, and id, or a jQuery object.
   * @param {object} [options] oEmbed parameters to use when creating an embed in the element.
   * @return {Player}
   */ constructor(element){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        /* global jQuery */ if (window.jQuery && element instanceof jQuery) {
            if (element.length > 1 && window.console && console.warn) console.warn('A jQuery object with multiple elements was passed, using the first element.');
            element = element[0];
        }
        // Find an element by ID
        if (typeof document !== 'undefined' && typeof element === 'string') element = document.getElementById(element);
        // Not an element!
        if (!$faa91f5616b3e685$var$isDomElement(element)) throw new TypeError('You must pass either a valid element or a valid id.');
        // Already initialized an embed in this div, so grab the iframe
        if (element.nodeName !== 'IFRAME') {
            const iframe = element.querySelector('iframe');
            if (iframe) element = iframe;
        }
        // iframe url is not a Vimeo url
        if (element.nodeName === 'IFRAME' && !$faa91f5616b3e685$var$isVimeoUrl(element.getAttribute('src') || '')) throw new Error("The player element passed isn\u2019t a Vimeo embed.");
        // If there is already a player object in the map, return that
        if ($faa91f5616b3e685$var$playerMap.has(element)) return $faa91f5616b3e685$var$playerMap.get(element);
        this._window = element.ownerDocument.defaultView;
        this.element = element;
        this.origin = '*';
        const readyPromise = new $faa91f5616b3e685$var$npo_src((resolve, reject)=>{
            this._onMessage = (event)=>{
                if (!$faa91f5616b3e685$var$isVimeoUrl(event.origin) || this.element.contentWindow !== event.source) return;
                if (this.origin === '*') this.origin = event.origin;
                const data = $faa91f5616b3e685$var$parseMessageData(event.data);
                const isError = data && data.event === 'error';
                const isReadyError = isError && data.data && data.data.method === 'ready';
                if (isReadyError) {
                    const error = new Error(data.data.message);
                    error.name = data.data.name;
                    reject(error);
                    return;
                }
                const isReadyEvent = data && data.event === 'ready';
                const isPingResponse = data && data.method === 'ping';
                if (isReadyEvent || isPingResponse) {
                    this.element.setAttribute('data-ready', 'true');
                    resolve();
                    return;
                }
                $faa91f5616b3e685$var$processData(this, data);
            };
            this._window.addEventListener('message', this._onMessage);
            if (this.element.nodeName !== 'IFRAME') {
                const params = $faa91f5616b3e685$var$getOEmbedParameters(element, options);
                const url = $faa91f5616b3e685$var$getVimeoUrl(params);
                $faa91f5616b3e685$var$getOEmbedData(url, params, element).then((data)=>{
                    const iframe = $faa91f5616b3e685$var$createEmbed(data, element);
                    // Overwrite element with the new iframe,
                    // but store reference to the original element
                    this.element = iframe;
                    this._originalElement = element;
                    $faa91f5616b3e685$var$swapCallbacks(element, iframe);
                    $faa91f5616b3e685$var$playerMap.set(this.element, this);
                    return data;
                }).catch(reject);
            }
        });
        // Store a copy of this Player in the map
        $faa91f5616b3e685$var$readyMap.set(this, readyPromise);
        $faa91f5616b3e685$var$playerMap.set(this.element, this);
        // Send a ping to the iframe so the ready promise will be resolved if
        // the player is already ready.
        if (this.element.nodeName === 'IFRAME') $faa91f5616b3e685$var$postMessage(this, 'ping');
        if ($faa91f5616b3e685$var$screenfull.isEnabled) {
            const exitFullscreen = ()=>$faa91f5616b3e685$var$screenfull.exit();
            this.fullscreenchangeHandler = ()=>{
                if ($faa91f5616b3e685$var$screenfull.isFullscreen) $faa91f5616b3e685$var$storeCallback(this, 'event:exitFullscreen', exitFullscreen);
                else $faa91f5616b3e685$var$removeCallback(this, 'event:exitFullscreen', exitFullscreen);
                // eslint-disable-next-line
                this.ready().then(()=>{
                    $faa91f5616b3e685$var$postMessage(this, 'fullscreenchange', $faa91f5616b3e685$var$screenfull.isFullscreen);
                });
            };
            $faa91f5616b3e685$var$screenfull.on('fullscreenchange', this.fullscreenchangeHandler);
        }
        return this;
    }
    /**
   * Check to see if the URL is a Vimeo URL.
   *
   * @param {string} url The URL string.
   * @return {boolean}
   */ static isVimeoUrl(url) {
        return $faa91f5616b3e685$var$isVimeoUrl(url);
    }
    /**
   * Get a promise for a method.
   *
   * @param {string} name The API method to call.
   * @param {...(string|number|object|Array)} args Arguments to send via postMessage.
   * @return {Promise}
   */ callMethod(name) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        if (name === undefined || name === null) throw new TypeError('You must pass a method name.');
        return new $faa91f5616b3e685$var$npo_src((resolve, reject)=>{
            // We are storing the resolve/reject handlers to call later, so we
            // can’t return here.
            return this.ready().then(()=>{
                $faa91f5616b3e685$var$storeCallback(this, name, {
                    resolve: resolve,
                    reject: reject
                });
                if (args.length === 0) args = {};
                else if (args.length === 1) args = args[0];
                $faa91f5616b3e685$var$postMessage(this, name, args);
            }).catch(reject);
        });
    }
    /**
   * Get a promise for the value of a player property.
   *
   * @param {string} name The property name
   * @return {Promise}
   */ get(name) {
        return new $faa91f5616b3e685$var$npo_src((resolve, reject)=>{
            name = $faa91f5616b3e685$var$getMethodName(name, 'get');
            // We are storing the resolve/reject handlers to call later, so we
            // can’t return here.
            return this.ready().then(()=>{
                $faa91f5616b3e685$var$storeCallback(this, name, {
                    resolve: resolve,
                    reject: reject
                });
                $faa91f5616b3e685$var$postMessage(this, name);
            }).catch(reject);
        });
    }
    /**
   * Get a promise for setting the value of a player property.
   *
   * @param {string} name The API method to call.
   * @param {mixed} value The value to set.
   * @return {Promise}
   */ set(name, value) {
        return new $faa91f5616b3e685$var$npo_src((resolve, reject)=>{
            name = $faa91f5616b3e685$var$getMethodName(name, 'set');
            if (value === undefined || value === null) throw new TypeError('There must be a value to set.');
            // We are storing the resolve/reject handlers to call later, so we
            // can’t return here.
            return this.ready().then(()=>{
                $faa91f5616b3e685$var$storeCallback(this, name, {
                    resolve: resolve,
                    reject: reject
                });
                $faa91f5616b3e685$var$postMessage(this, name, value);
            }).catch(reject);
        });
    }
    /**
   * Add an event listener for the specified event. Will call the
   * callback with a single parameter, `data`, that contains the data for
   * that event.
   *
   * @param {string} eventName The name of the event.
   * @param {function(*)} callback The function to call when the event fires.
   * @return {void}
   */ on(eventName, callback) {
        if (!eventName) throw new TypeError('You must pass an event name.');
        if (!callback) throw new TypeError('You must pass a callback function.');
        if (typeof callback !== 'function') throw new TypeError('The callback must be a function.');
        const callbacks = $faa91f5616b3e685$var$getCallbacks(this, `event:${eventName}`);
        if (callbacks.length === 0) this.callMethod('addEventListener', eventName).catch(()=>{
        // Ignore the error. There will be an error event fired that
        // will trigger the error callback if they are listening.
        });
        $faa91f5616b3e685$var$storeCallback(this, `event:${eventName}`, callback);
    }
    /**
   * Remove an event listener for the specified event. Will remove all
   * listeners for that event if a `callback` isn’t passed, or only that
   * specific callback if it is passed.
   *
   * @param {string} eventName The name of the event.
   * @param {function} [callback] The specific callback to remove.
   * @return {void}
   */ off(eventName, callback) {
        if (!eventName) throw new TypeError('You must pass an event name.');
        if (callback && typeof callback !== 'function') throw new TypeError('The callback must be a function.');
        const lastCallback = $faa91f5616b3e685$var$removeCallback(this, `event:${eventName}`, callback);
        // If there are no callbacks left, remove the listener
        if (lastCallback) this.callMethod('removeEventListener', eventName).catch((e)=>{
        // Ignore the error. There will be an error event fired that
        // will trigger the error callback if they are listening.
        });
    }
    /**
   * A promise to load a new video.
   *
   * @promise LoadVideoPromise
   * @fulfill {number} The video with this id or url successfully loaded.
   * @reject {TypeError} The id was not a number.
   */ /**
   * Load a new video into this embed. The promise will be resolved if
   * the video is successfully loaded, or it will be rejected if it could
   * not be loaded.
   *
   * @param {number|string|object} options The id of the video, the url of the video, or an object with embed options.
   * @return {LoadVideoPromise}
   */ loadVideo(options) {
        return this.callMethod('loadVideo', options);
    }
    /**
   * A promise to perform an action when the Player is ready.
   *
   * @todo document errors
   * @promise LoadVideoPromise
   * @fulfill {void}
   */ /**
   * Trigger a function when the player iframe has initialized. You do not
   * need to wait for `ready` to trigger to begin adding event listeners
   * or calling other methods.
   *
   * @return {ReadyPromise}
   */ ready() {
        const readyPromise = $faa91f5616b3e685$var$readyMap.get(this) || new $faa91f5616b3e685$var$npo_src((resolve, reject)=>{
            reject(new Error('Unknown player. Probably unloaded.'));
        });
        return $faa91f5616b3e685$var$npo_src.resolve(readyPromise);
    }
    /**
   * A promise to add a cue point to the player.
   *
   * @promise AddCuePointPromise
   * @fulfill {string} The id of the cue point to use for removeCuePoint.
   * @reject {RangeError} the time was less than 0 or greater than the
   *         video’s duration.
   * @reject {UnsupportedError} Cue points are not supported with the current
   *         player or browser.
   */ /**
   * Add a cue point to the player.
   *
   * @param {number} time The time for the cue point.
   * @param {object} [data] Arbitrary data to be returned with the cue point.
   * @return {AddCuePointPromise}
   */ addCuePoint(time) {
        let data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return this.callMethod('addCuePoint', {
            time: time,
            data: data
        });
    }
    /**
   * A promise to remove a cue point from the player.
   *
   * @promise AddCuePointPromise
   * @fulfill {string} The id of the cue point that was removed.
   * @reject {InvalidCuePoint} The cue point with the specified id was not
   *         found.
   * @reject {UnsupportedError} Cue points are not supported with the current
   *         player or browser.
   */ /**
   * Remove a cue point from the video.
   *
   * @param {string} id The id of the cue point to remove.
   * @return {RemoveCuePointPromise}
   */ removeCuePoint(id) {
        return this.callMethod('removeCuePoint', id);
    }
    /**
   * A representation of a text track on a video.
   *
   * @typedef {Object} VimeoTextTrack
   * @property {string} language The ISO language code.
   * @property {string} kind The kind of track it is (captions or subtitles).
   * @property {string} label The human‐readable label for the track.
   */ /**
   * A promise to enable a text track.
   *
   * @promise EnableTextTrackPromise
   * @fulfill {VimeoTextTrack} The text track that was enabled.
   * @reject {InvalidTrackLanguageError} No track was available with the
   *         specified language.
   * @reject {InvalidTrackError} No track was available with the specified
   *         language and kind.
   */ /**
   * Enable the text track with the specified language, and optionally the
   * specified kind (captions or subtitles).
   *
   * When set via the API, the track language will not change the viewer’s
   * stored preference.
   *
   * @param {string} language The two‐letter language code.
   * @param {string} [kind] The kind of track to enable (captions or subtitles).
   * @param {boolean} [showing] Whether to enable display of closed captions for enabled text track within the player.
   * @return {EnableTextTrackPromise}
   */ enableTextTrack(language) {
        let kind = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        let showing = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
        if (!language) throw new TypeError('You must pass a language.');
        return this.callMethod('enableTextTrack', {
            language: language,
            kind: kind,
            showing: showing
        });
    }
    /**
   * A promise to disable the active text track.
   *
   * @promise DisableTextTrackPromise
   * @fulfill {void} The track was disabled.
   */ /**
   * Disable the currently-active text track.
   *
   * @return {DisableTextTrackPromise}
   */ disableTextTrack() {
        return this.callMethod('disableTextTrack');
    }
    /** @typedef {import('../types/formats.js').VimeoAudioTrack} VimeoAudioTrack */ /** @typedef {import('../types/formats.js').AudioLanguage} AudioLanguage */ /** @typedef {import('../types/formats.js').AudioKind} AudioKind */ /**
   * A promise to enable an audio track.
   *
   * @promise SelectAudioTrackPromise
   * @fulfill {VimeoAudioTrack} The audio track that was enabled.
   * @reject {NoAudioTracksError} No audio exists for the video.
   * @reject {NoAlternateAudioTracksError} No alternate audio tracks exist for the video.
   * @reject {NoMatchingAudioTrackError} No track was available with the specified
   *         language and kind.
   */ /**
   * Enable the audio track with the specified language, and optionally the
   * specified kind (main, translation, descriptions, or commentary).
   *
   * When set via the API, the track language will not change the viewer’s
   * stored preference.
   *
   * @param {AudioLanguage} language The two‐letter language code.
   * @param {AudioKind} [kind] The kind of track to enable (main, translation, descriptions, commentary).
   * @return {SelectAudioTrackPromise}
   */ selectAudioTrack(language, kind) {
        if (!language) throw new TypeError('You must pass a language.');
        return this.callMethod('selectAudioTrack', {
            language: language,
            kind: kind
        });
    }
    /**
   * Enable the main audio track for the video.
   *
   * @return {SelectAudioTrackPromise}
   */ selectDefaultAudioTrack() {
        return this.callMethod('selectDefaultAudioTrack');
    }
    /**
   * A promise to pause the video.
   *
   * @promise PausePromise
   * @fulfill {void} The video was paused.
   */ /**
   * Pause the video if it’s playing.
   *
   * @return {PausePromise}
   */ pause() {
        return this.callMethod('pause');
    }
    /**
   * A promise to play the video.
   *
   * @promise PlayPromise
   * @fulfill {void} The video was played.
   */ /**
   * Play the video if it’s paused. **Note:** on iOS and some other
   * mobile devices, you cannot programmatically trigger play. Once the
   * viewer has tapped on the play button in the player, however, you
   * will be able to use this function.
   *
   * @return {PlayPromise}
   */ play() {
        return this.callMethod('play');
    }
    /**
   * Request that the player enters fullscreen.
   * @return {Promise}
   */ requestFullscreen() {
        if ($faa91f5616b3e685$var$screenfull.isEnabled) return $faa91f5616b3e685$var$screenfull.request(this.element);
        return this.callMethod('requestFullscreen');
    }
    /**
   * Request that the player exits fullscreen.
   * @return {Promise}
   */ exitFullscreen() {
        if ($faa91f5616b3e685$var$screenfull.isEnabled) return $faa91f5616b3e685$var$screenfull.exit();
        return this.callMethod('exitFullscreen');
    }
    /**
   * Returns true if the player is currently fullscreen.
   * @return {Promise}
   */ getFullscreen() {
        if ($faa91f5616b3e685$var$screenfull.isEnabled) return $faa91f5616b3e685$var$npo_src.resolve($faa91f5616b3e685$var$screenfull.isFullscreen);
        return this.get('fullscreen');
    }
    /**
   * Request that the player enters picture-in-picture.
   * @return {Promise}
   */ requestPictureInPicture() {
        return this.callMethod('requestPictureInPicture');
    }
    /**
   * Request that the player exits picture-in-picture.
   * @return {Promise}
   */ exitPictureInPicture() {
        return this.callMethod('exitPictureInPicture');
    }
    /**
   * Returns true if the player is currently picture-in-picture.
   * @return {Promise}
   */ getPictureInPicture() {
        return this.get('pictureInPicture');
    }
    /**
   * A promise to prompt the viewer to initiate remote playback.
   *
   * @promise RemotePlaybackPromptPromise
   * @fulfill {void}
   * @reject {NotFoundError} No remote playback device is available.
   */ /**
   * Request to prompt the user to initiate remote playback.
   *
   * @return {RemotePlaybackPromptPromise}
   */ remotePlaybackPrompt() {
        return this.callMethod('remotePlaybackPrompt');
    }
    /**
   * A promise to unload the video.
   *
   * @promise UnloadPromise
   * @fulfill {void} The video was unloaded.
   */ /**
   * Return the player to its initial state.
   *
   * @return {UnloadPromise}
   */ unload() {
        return this.callMethod('unload');
    }
    /**
   * Cleanup the player and remove it from the DOM
   *
   * It won't be usable and a new one should be constructed
   *  in order to do any operations.
   *
   * @return {Promise}
   */ destroy() {
        return new $faa91f5616b3e685$var$npo_src((resolve)=>{
            $faa91f5616b3e685$var$readyMap.delete(this);
            $faa91f5616b3e685$var$playerMap.delete(this.element);
            if (this._originalElement) {
                $faa91f5616b3e685$var$playerMap.delete(this._originalElement);
                this._originalElement.removeAttribute('data-vimeo-initialized');
            }
            if (this.element && this.element.nodeName === 'IFRAME' && this.element.parentNode) {
                // If we've added an additional wrapper div, remove that from the DOM.
                // If not, just remove the iframe element.
                if (this.element.parentNode.parentNode && this._originalElement && this._originalElement !== this.element.parentNode) this.element.parentNode.parentNode.removeChild(this.element.parentNode);
                else this.element.parentNode.removeChild(this.element);
            }
            // If the clip is private there is a case where the element stays the
            // div element. Destroy should reset the div and remove the iframe child.
            if (this.element && this.element.nodeName === 'DIV' && this.element.parentNode) {
                this.element.removeAttribute('data-vimeo-initialized');
                const iframe = this.element.querySelector('iframe');
                if (iframe && iframe.parentNode) {
                    // If we've added an additional wrapper div, remove that from the DOM.
                    // If not, just remove the iframe element.
                    if (iframe.parentNode.parentNode && this._originalElement && this._originalElement !== iframe.parentNode) iframe.parentNode.parentNode.removeChild(iframe.parentNode);
                    else iframe.parentNode.removeChild(iframe);
                }
            }
            this._window.removeEventListener('message', this._onMessage);
            if ($faa91f5616b3e685$var$screenfull.isEnabled) $faa91f5616b3e685$var$screenfull.off('fullscreenchange', this.fullscreenchangeHandler);
            resolve();
        });
    }
    /**
   * A promise to get the autopause behavior of the video.
   *
   * @promise GetAutopausePromise
   * @fulfill {boolean} Whether autopause is turned on or off.
   * @reject {UnsupportedError} Autopause is not supported with the current
   *         player or browser.
   */ /**
   * Get the autopause behavior for this player.
   *
   * @return {GetAutopausePromise}
   */ getAutopause() {
        return this.get('autopause');
    }
    /**
   * A promise to set the autopause behavior of the video.
   *
   * @promise SetAutopausePromise
   * @fulfill {boolean} Whether autopause is turned on or off.
   * @reject {UnsupportedError} Autopause is not supported with the current
   *         player or browser.
   */ /**
   * Enable or disable the autopause behavior of this player.
   *
   * By default, when another video is played in the same browser, this
   * player will automatically pause. Unless you have a specific reason
   * for doing so, we recommend that you leave autopause set to the
   * default (`true`).
   *
   * @param {boolean} autopause
   * @return {SetAutopausePromise}
   */ setAutopause(autopause) {
        return this.set('autopause', autopause);
    }
    /**
   * A promise to get the buffered property of the video.
   *
   * @promise GetBufferedPromise
   * @fulfill {Array} Buffered Timeranges converted to an Array.
   */ /**
   * Get the buffered property of the video.
   *
   * @return {GetBufferedPromise}
   */ getBuffered() {
        return this.get('buffered');
    }
    /**
   * @typedef {Object} CameraProperties
   * @prop {number} props.yaw - Number between 0 and 360.
   * @prop {number} props.pitch - Number between -90 and 90.
   * @prop {number} props.roll - Number between -180 and 180.
   * @prop {number} props.fov - The field of view in degrees.
   */ /**
   * A promise to get the camera properties of the player.
   *
   * @promise GetCameraPromise
   * @fulfill {CameraProperties} The camera properties.
   */ /**
   * For 360° videos get the camera properties for this player.
   *
   * @return {GetCameraPromise}
   */ getCameraProps() {
        return this.get('cameraProps');
    }
    /**
   * A promise to set the camera properties of the player.
   *
   * @promise SetCameraPromise
   * @fulfill {Object} The camera was successfully set.
   * @reject {RangeError} The range was out of bounds.
   */ /**
   * For 360° videos set the camera properties for this player.
   *
   * @param {CameraProperties} camera The camera properties
   * @return {SetCameraPromise}
   */ setCameraProps(camera) {
        return this.set('cameraProps', camera);
    }
    /**
   * A representation of a chapter.
   *
   * @typedef {Object} VimeoChapter
   * @property {number} startTime The start time of the chapter.
   * @property {object} title The title of the chapter.
   * @property {number} index The place in the order of Chapters. Starts at 1.
   */ /**
   * A promise to get chapters for the video.
   *
   * @promise GetChaptersPromise
   * @fulfill {VimeoChapter[]} The chapters for the video.
   */ /**
   * Get an array of all the chapters for the video.
   *
   * @return {GetChaptersPromise}
   */ getChapters() {
        return this.get('chapters');
    }
    /**
   * A promise to get the currently active chapter.
   *
   * @promise GetCurrentChaptersPromise
   * @fulfill {VimeoChapter|undefined} The current chapter for the video.
   */ /**
   * Get the currently active chapter for the video.
   *
   * @return {GetCurrentChaptersPromise}
   */ getCurrentChapter() {
        return this.get('currentChapter');
    }
    /**
   * A promise to get the accent color of the player.
   *
   * @promise GetColorPromise
   * @fulfill {string} The hex color of the player.
   */ /**
   * Get the accent color for this player. Note this is deprecated in place of `getColorTwo`.
   *
   * @return {GetColorPromise}
   */ getColor() {
        return this.get('color');
    }
    /**
   * A promise to get all colors for the player in an array.
   *
   * @promise GetColorsPromise
   * @fulfill {string[]} The hex colors of the player.
   */ /**
   * Get all the colors for this player in an array: [colorOne, colorTwo, colorThree, colorFour]
   *
   * @return {GetColorPromise}
   */ getColors() {
        return $faa91f5616b3e685$var$npo_src.all([
            this.get('colorOne'),
            this.get('colorTwo'),
            this.get('colorThree'),
            this.get('colorFour')
        ]);
    }
    /**
   * A promise to set the accent color of the player.
   *
   * @promise SetColorPromise
   * @fulfill {string} The color was successfully set.
   * @reject {TypeError} The string was not a valid hex or rgb color.
   * @reject {ContrastError} The color was set, but the contrast is
   *         outside of the acceptable range.
   * @reject {EmbedSettingsError} The owner of the player has chosen to
   *         use a specific color.
   */ /**
   * Set the accent color of this player to a hex or rgb string. Setting the
   * color may fail if the owner of the video has set their embed
   * preferences to force a specific color.
   * Note this is deprecated in place of `setColorTwo`.
   *
   * @param {string} color The hex or rgb color string to set.
   * @return {SetColorPromise}
   */ setColor(color) {
        return this.set('color', color);
    }
    /**
   * A promise to set all colors for the player.
   *
   * @promise SetColorsPromise
   * @fulfill {string[]} The colors were successfully set.
   * @reject {TypeError} The string was not a valid hex or rgb color.
   * @reject {ContrastError} The color was set, but the contrast is
   *         outside of the acceptable range.
   * @reject {EmbedSettingsError} The owner of the player has chosen to
   *         use a specific color.
   */ /**
   * Set the colors of this player to a hex or rgb string. Setting the
   * color may fail if the owner of the video has set their embed
   * preferences to force a specific color.
   * The colors should be passed in as an array: [colorOne, colorTwo, colorThree, colorFour].
   * If a color should not be set, the index in the array can be left as null.
   *
   * @param {string[]} colors Array of the hex or rgb color strings to set.
   * @return {SetColorsPromise}
   */ setColors(colors) {
        if (!Array.isArray(colors)) return new $faa91f5616b3e685$var$npo_src((resolve, reject)=>reject(new TypeError('Argument must be an array.')));
        const nullPromise = new $faa91f5616b3e685$var$npo_src((resolve)=>resolve(null));
        const colorPromises = [
            colors[0] ? this.set('colorOne', colors[0]) : nullPromise,
            colors[1] ? this.set('colorTwo', colors[1]) : nullPromise,
            colors[2] ? this.set('colorThree', colors[2]) : nullPromise,
            colors[3] ? this.set('colorFour', colors[3]) : nullPromise
        ];
        return $faa91f5616b3e685$var$npo_src.all(colorPromises);
    }
    /**
   * A representation of a cue point.
   *
   * @typedef {Object} VimeoCuePoint
   * @property {number} time The time of the cue point.
   * @property {object} data The data passed when adding the cue point.
   * @property {string} id The unique id for use with removeCuePoint.
   */ /**
   * A promise to get the cue points of a video.
   *
   * @promise GetCuePointsPromise
   * @fulfill {VimeoCuePoint[]} The cue points added to the video.
   * @reject {UnsupportedError} Cue points are not supported with the current
   *         player or browser.
   */ /**
   * Get an array of the cue points added to the video.
   *
   * @return {GetCuePointsPromise}
   */ getCuePoints() {
        return this.get('cuePoints');
    }
    /**
   * A promise to get the current time of the video.
   *
   * @promise GetCurrentTimePromise
   * @fulfill {number} The current time in seconds.
   */ /**
   * Get the current playback position in seconds.
   *
   * @return {GetCurrentTimePromise}
   */ getCurrentTime() {
        return this.get('currentTime');
    }
    /**
   * A promise to set the current time of the video.
   *
   * @promise SetCurrentTimePromise
   * @fulfill {number} The actual current time that was set.
   * @reject {RangeError} the time was less than 0 or greater than the
   *         video’s duration.
   */ /**
   * Set the current playback position in seconds. If the player was
   * paused, it will remain paused. Likewise, if the player was playing,
   * it will resume playing once the video has buffered.
   *
   * You can provide an accurate time and the player will attempt to seek
   * to as close to that time as possible. The exact time will be the
   * fulfilled value of the promise.
   *
   * @param {number} currentTime
   * @return {SetCurrentTimePromise}
   */ setCurrentTime(currentTime) {
        return this.set('currentTime', currentTime);
    }
    /**
   * A promise to get the duration of the video.
   *
   * @promise GetDurationPromise
   * @fulfill {number} The duration in seconds.
   */ /**
   * Get the duration of the video in seconds. It will be rounded to the
   * nearest second before playback begins, and to the nearest thousandth
   * of a second after playback begins.
   *
   * @return {GetDurationPromise}
   */ getDuration() {
        return this.get('duration');
    }
    /**
   * A promise to get the ended state of the video.
   *
   * @promise GetEndedPromise
   * @fulfill {boolean} Whether or not the video has ended.
   */ /**
   * Get the ended state of the video. The video has ended if
   * `currentTime === duration`.
   *
   * @return {GetEndedPromise}
   */ getEnded() {
        return this.get('ended');
    }
    /**
   * A promise to get the loop state of the player.
   *
   * @promise GetLoopPromise
   * @fulfill {boolean} Whether or not the player is set to loop.
   */ /**
   * Get the loop state of the player.
   *
   * @return {GetLoopPromise}
   */ getLoop() {
        return this.get('loop');
    }
    /**
   * A promise to set the loop state of the player.
   *
   * @promise SetLoopPromise
   * @fulfill {boolean} The loop state that was set.
   */ /**
   * Set the loop state of the player. When set to `true`, the player
   * will start over immediately once playback ends.
   *
   * @param {boolean} loop
   * @return {SetLoopPromise}
   */ setLoop(loop) {
        return this.set('loop', loop);
    }
    /**
   * A promise to set the muted state of the player.
   *
   * @promise SetMutedPromise
   * @fulfill {boolean} The muted state that was set.
   */ /**
   * Set the muted state of the player. When set to `true`, the player
   * volume will be muted.
   *
   * @param {boolean} muted
   * @return {SetMutedPromise}
   */ setMuted(muted) {
        return this.set('muted', muted);
    }
    /**
   * A promise to get the muted state of the player.
   *
   * @promise GetMutedPromise
   * @fulfill {boolean} Whether or not the player is muted.
   */ /**
   * Get the muted state of the player.
   *
   * @return {GetMutedPromise}
   */ getMuted() {
        return this.get('muted');
    }
    /**
   * A promise to get the paused state of the player.
   *
   * @promise GetLoopPromise
   * @fulfill {boolean} Whether or not the video is paused.
   */ /**
   * Get the paused state of the player.
   *
   * @return {GetLoopPromise}
   */ getPaused() {
        return this.get('paused');
    }
    /**
   * A promise to get the playback rate of the player.
   *
   * @promise GetPlaybackRatePromise
   * @fulfill {number} The playback rate of the player on a scale from 0 to 2.
   */ /**
   * Get the playback rate of the player on a scale from `0` to `2`.
   *
   * @return {GetPlaybackRatePromise}
   */ getPlaybackRate() {
        return this.get('playbackRate');
    }
    /**
   * A promise to set the playbackrate of the player.
   *
   * @promise SetPlaybackRatePromise
   * @fulfill {number} The playback rate was set.
   * @reject {RangeError} The playback rate was less than 0 or greater than 2.
   */ /**
   * Set the playback rate of the player on a scale from `0` to `2`. When set
   * via the API, the playback rate will not be synchronized to other
   * players or stored as the viewer's preference.
   *
   * @param {number} playbackRate
   * @return {SetPlaybackRatePromise}
   */ setPlaybackRate(playbackRate) {
        return this.set('playbackRate', playbackRate);
    }
    /**
   * A promise to get the played property of the video.
   *
   * @promise GetPlayedPromise
   * @fulfill {Array} Played Timeranges converted to an Array.
   */ /**
   * Get the played property of the video.
   *
   * @return {GetPlayedPromise}
   */ getPlayed() {
        return this.get('played');
    }
    /**
   * A promise to get the qualities available of the current video.
   *
   * @promise GetQualitiesPromise
   * @fulfill {Array} The qualities of the video.
   */ /**
   * Get the qualities of the current video.
   *
   * @return {GetQualitiesPromise}
   */ getQualities() {
        return this.get('qualities');
    }
    /**
   * A promise to get the current set quality of the video.
   *
   * @promise GetQualityPromise
   * @fulfill {string} The current set quality.
   */ /**
   * Get the current set quality of the video.
   *
   * @return {GetQualityPromise}
   */ getQuality() {
        return this.get('quality');
    }
    /**
   * A promise to set the video quality.
   *
   * @promise SetQualityPromise
   * @fulfill {number} The quality was set.
   * @reject {RangeError} The quality is not available.
   */ /**
   * Set a video quality.
   *
   * @param {string} quality
   * @return {SetQualityPromise}
   */ setQuality(quality) {
        return this.set('quality', quality);
    }
    /**
   * A promise to get the remote playback availability.
   *
   * @promise RemotePlaybackAvailabilityPromise
   * @fulfill {boolean} Whether remote playback is available.
   */ /**
   * Get the availability of remote playback.
   *
   * @return {RemotePlaybackAvailabilityPromise}
   */ getRemotePlaybackAvailability() {
        return this.get('remotePlaybackAvailability');
    }
    /**
   * A promise to get the current remote playback state.
   *
   * @promise RemotePlaybackStatePromise
   * @fulfill {string} The state of the remote playback: connecting, connected, or disconnected.
   */ /**
   * Get the current remote playback state.
   *
   * @return {RemotePlaybackStatePromise}
   */ getRemotePlaybackState() {
        return this.get('remotePlaybackState');
    }
    /**
   * A promise to get the seekable property of the video.
   *
   * @promise GetSeekablePromise
   * @fulfill {Array} Seekable Timeranges converted to an Array.
   */ /**
   * Get the seekable property of the video.
   *
   * @return {GetSeekablePromise}
   */ getSeekable() {
        return this.get('seekable');
    }
    /**
   * A promise to get the seeking property of the player.
   *
   * @promise GetSeekingPromise
   * @fulfill {boolean} Whether or not the player is currently seeking.
   */ /**
   * Get if the player is currently seeking.
   *
   * @return {GetSeekingPromise}
   */ getSeeking() {
        return this.get('seeking');
    }
    /**
   * A promise to get the text tracks of a video.
   *
   * @promise GetTextTracksPromise
   * @fulfill {VimeoTextTrack[]} The text tracks associated with the video.
   */ /**
   * Get an array of the text tracks that exist for the video.
   *
   * @return {GetTextTracksPromise}
   */ getTextTracks() {
        return this.get('textTracks');
    }
    /**
   * A promise to get the audio tracks of a video.
   *
   * @promise GetAudioTracksPromise
   * @fulfill {VimeoAudioTrack[]} The audio tracks associated with the video.
   */ /**
   * Get an array of the audio tracks that exist for the video.
   *
   * @return {GetAudioTracksPromise}
   */ getAudioTracks() {
        return this.get('audioTracks');
    }
    /**
   * A promise to get the enabled audio track of a video.
   *
   * @promise GetAudioTrackPromise
   * @fulfill {VimeoAudioTrack} The enabled audio track.
   */ /**
   * Get the enabled audio track for a video.
   *
   * @return {GetAudioTrackPromise}
   */ getEnabledAudioTrack() {
        return this.get('enabledAudioTrack');
    }
    /**
   * Get the main audio track for a video.
   *
   * @return {GetAudioTrackPromise}
   */ getDefaultAudioTrack() {
        return this.get('defaultAudioTrack');
    }
    /**
   * A promise to get the embed code for the video.
   *
   * @promise GetVideoEmbedCodePromise
   * @fulfill {string} The `<iframe>` embed code for the video.
   */ /**
   * Get the `<iframe>` embed code for the video.
   *
   * @return {GetVideoEmbedCodePromise}
   */ getVideoEmbedCode() {
        return this.get('videoEmbedCode');
    }
    /**
   * A promise to get the id of the video.
   *
   * @promise GetVideoIdPromise
   * @fulfill {number} The id of the video.
   */ /**
   * Get the id of the video.
   *
   * @return {GetVideoIdPromise}
   */ getVideoId() {
        return this.get('videoId');
    }
    /**
   * A promise to get the title of the video.
   *
   * @promise GetVideoTitlePromise
   * @fulfill {number} The title of the video.
   */ /**
   * Get the title of the video.
   *
   * @return {GetVideoTitlePromise}
   */ getVideoTitle() {
        return this.get('videoTitle');
    }
    /**
   * A promise to get the native width of the video.
   *
   * @promise GetVideoWidthPromise
   * @fulfill {number} The native width of the video.
   */ /**
   * Get the native width of the currently‐playing video. The width of
   * the highest‐resolution available will be used before playback begins.
   *
   * @return {GetVideoWidthPromise}
   */ getVideoWidth() {
        return this.get('videoWidth');
    }
    /**
   * A promise to get the native height of the video.
   *
   * @promise GetVideoHeightPromise
   * @fulfill {number} The native height of the video.
   */ /**
   * Get the native height of the currently‐playing video. The height of
   * the highest‐resolution available will be used before playback begins.
   *
   * @return {GetVideoHeightPromise}
   */ getVideoHeight() {
        return this.get('videoHeight');
    }
    /**
   * A promise to get the vimeo.com url for the video.
   *
   * @promise GetVideoUrlPromise
   * @fulfill {number} The vimeo.com url for the video.
   * @reject {PrivacyError} The url isn’t available because of the video’s privacy setting.
   */ /**
   * Get the vimeo.com url for the video.
   *
   * @return {GetVideoUrlPromise}
   */ getVideoUrl() {
        return this.get('videoUrl');
    }
    /**
   * A promise to get the volume level of the player.
   *
   * @promise GetVolumePromise
   * @fulfill {number} The volume level of the player on a scale from 0 to 1.
   */ /**
   * Get the current volume level of the player on a scale from `0` to `1`.
   *
   * Most mobile devices do not support an independent volume from the
   * system volume. In those cases, this method will always return `1`.
   *
   * @return {GetVolumePromise}
   */ getVolume() {
        return this.get('volume');
    }
    /**
   * A promise to set the volume level of the player.
   *
   * @promise SetVolumePromise
   * @fulfill {number} The volume was set.
   * @reject {RangeError} The volume was less than 0 or greater than 1.
   */ /**
   * Set the volume of the player on a scale from `0` to `1`. When set
   * via the API, the volume level will not be synchronized to other
   * players or stored as the viewer’s preference.
   *
   * Most mobile devices do not support setting the volume. An error will
   * *not* be triggered in that situation.
   *
   * @param {number} volume
   * @return {SetVolumePromise}
   */ setVolume(volume) {
        return this.set('volume', volume);
    }
    /** @typedef {import('timing-object').ITimingObject} TimingObject */ /** @typedef {import('./lib/timing-src-connector.types').TimingSrcConnectorOptions} TimingSrcConnectorOptions */ /** @typedef {import('./lib/timing-src-connector').TimingSrcConnector} TimingSrcConnector */ /**
   * Connects a TimingObject to the video player (https://webtiming.github.io/timingobject/)
   *
   * @param {TimingObject} timingObject
   * @param {TimingSrcConnectorOptions} options
   *
   * @return {Promise<TimingSrcConnector>}
   */ async setTimingSrc(timingObject, options) {
        if (!timingObject) throw new TypeError('A Timing Object must be provided.');
        await this.ready();
        const connector = new $faa91f5616b3e685$var$TimingSrcConnector(this, timingObject, options);
        $faa91f5616b3e685$var$postMessage(this, 'notifyTimingObjectConnect');
        connector.addEventListener('disconnect', ()=>$faa91f5616b3e685$var$postMessage(this, 'notifyTimingObjectDisconnect'));
        return connector;
    }
}
// Setup embed only if this is not a server runtime
if (!$faa91f5616b3e685$var$isServerRuntime) {
    $faa91f5616b3e685$var$screenfull = $faa91f5616b3e685$var$initializeScreenfull();
    $faa91f5616b3e685$var$initializeEmbeds();
    $faa91f5616b3e685$var$resizeEmbeds();
    $faa91f5616b3e685$var$initAppendVideoMetadata();
    $faa91f5616b3e685$var$checkUrlTimeParam();
    $faa91f5616b3e685$var$updateDRMEmbeds();
}
var $faa91f5616b3e685$export$2e2bcd8739ae039 = $faa91f5616b3e685$var$Player;

});

parcelRegister("5IiZx", function(module, exports) {
/*! js-cookie v3.0.5 | MIT */ (function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    'use strict';
    /* eslint-disable no-var */ function assign(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)target[key] = source[key];
        }
        return target;
    }
    /* eslint-enable no-var */ /* eslint-disable no-var */ var defaultConverter = {
        read: function(value) {
            if (value[0] === '"') value = value.slice(1, -1);
            return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
        },
        write: function(value) {
            return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
        }
    };
    /* eslint-enable no-var */ /* eslint-disable no-var */ function init(converter, defaultAttributes) {
        function set(name, value, attributes) {
            if (typeof document === 'undefined') return;
            attributes = assign({}, defaultAttributes, attributes);
            if (typeof attributes.expires === 'number') attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
            if (attributes.expires) attributes.expires = attributes.expires.toUTCString();
            name = encodeURIComponent(name).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
            var stringifiedAttributes = '';
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += '; ' + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
            }
            return document.cookie = name + '=' + converter.write(value, name) + stringifiedAttributes;
        }
        function get(name) {
            if (typeof document === 'undefined' || arguments.length && !name) return;
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split('; ') : [];
            var jar = {};
            for(var i = 0; i < cookies.length; i++){
                var parts = cookies[i].split('=');
                var value = parts.slice(1).join('=');
                try {
                    var found = decodeURIComponent(parts[0]);
                    jar[found] = converter.read(value, found);
                    if (name === found) break;
                } catch (e) {}
            }
            return name ? jar[name] : jar;
        }
        return Object.create({
            set: set,
            get: get,
            remove: function(name, attributes) {
                set(name, '', assign({}, attributes, {
                    expires: -1
                }));
            },
            withAttributes: function(attributes) {
                return init(this.converter, assign({}, this.attributes, attributes));
            },
            withConverter: function(converter) {
                return init(assign({}, this.converter, converter), this.attributes);
            }
        }, {
            attributes: {
                value: Object.freeze(defaultAttributes)
            },
            converter: {
                value: Object.freeze(converter)
            }
        });
    }
    var api = init(defaultConverter, {
        path: '/'
    });
    /* eslint-enable no-var */ return api;
});

});



parcelRequire("j3CK3");
})();
//# sourceMappingURL=index.js.map
